/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s) {
    "use strict";
    function o(t, e) {
        let i;
        return function () {
            if (t) {
                const s = () => t.apply(this, arguments);
                (clearTimeout(i), (i = setTimeout(s, e)));
            }
        };
    }
    (!(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process)
                return (
                    (process.env = Object.assign({}, process.env)),
                    void Object.assign(process.env, t)
                );
        } catch (t) { }
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.sizes = {
            mobile: 480,
            small: 768,
            large: 1024,
            widescreen: 1440,
        }),
        (window.theme.keyboardKeys = {
            TAB: "Tab",
            ENTER: "Enter",
            NUMPADENTER: "NumpadEnter",
            ESCAPE: "Escape",
            SPACE: "Space",
            LEFTARROW: "ArrowLeft",
            RIGHTARROW: "ArrowRight",
        }),
        (window.theme.focusable =
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    const n = "body",
        r = "[data-main]",
        a = "[data-site-header]",
        l = "[data-prevent-transparent-header]",
        c = "supports-transparent-header",
        h = "site-header--transparent",
        d = "is-first-section-transparent",
        u = "data-transparent",
        p = () => {
            const t = document.querySelector(n),
                e = t.querySelector(a);
            if (!e) return;
            const i = "true" === e.getAttribute(u),
                s = t.querySelector(r).children[0];
            if (!s) return;
            const o = s.querySelector(`${l}:first-of-type`);
            window.isHeaderTransparent = i && s.classList.contains(c) && !o;
            CSS.supports("(selector(:has(*)))") ||
                (t.classList.toggle(d, window.isHeaderTransparent),
                    e.classList.toggle(h, window.isHeaderTransparent));
        },
        m = ".section-footer--parallax",
        g = "[data-section-type]",
        v = ":scope > [data-wave]",
        y = ".wavy:not(.site-footer)",
        f = ".parallax-shadow:not(.site-footer)",
        b = "wavy",
        w = "parallax-shadow",
        S = "section-footer--parallax",
        E = "data-parallax-wavy",
        L = (t) => {
            const e = t,
                i = document.querySelectorAll(y),
                s = document.querySelectorAll(f);
            (i.forEach((t) => {
                t.classList.remove(b);
                [...t.querySelectorAll(v)].map((t) => t.remove());
            }),
                s.forEach((t) => {
                    t.classList.remove(w);
                    [...t.querySelectorAll(v)].map((t) => t.remove());
                }));
            const o = document.querySelectorAll(m);
            if (o.length > 0) {
                const t = o[0].querySelector(g);
                t.hasAttribute(E) && t.classList.add(b);
            }
            e.classList.contains(S) ||
                document.dispatchEvent(new CustomEvent("theme:footer:unload"));
        };
    let k = D();
    const A = {
        body: "body",
        main: "[data-main]",
        collectionFilters: "[data-collection-filters]",
        footer: '[data-section-type*="footer"]',
        header: "[data-header-height]",
        stickyHeader: '[data-site-header][data-position="fixed"]',
        announcementBar: "[data-announcement-bar]",
        collectionStickyBar: "[data-collection-sticky-bar]",
        logoTextLink: "[data-logo-text-link]",
    },
        C = {
            templateCollection: "template-collection",
            templateSearch: "template-search",
            supportsTransparentHeader: "supports-transparent-header",
        };
    function q() {
        var t, e;
        const i = {};
        return (
            (i.windowHeight = Math.min(window.screen.height, window.innerHeight)),
            (i.footerHeight = x(A.footer)),
            (i.headerHeight = x(A.header)),
            (i.stickyHeaderHeight = H() ? window.stickyHeaderHeight : 0),
            (i.headerInitialHeight =
                parseInt(
                    (null === (t = document.querySelector(A.header)) || void 0 === t
                        ? void 0
                        : t.dataset.height) ||
                    (null === (e = document.querySelector(A.header)) || void 0 === e
                        ? void 0
                        : e.offsetHeight),
                ) || 0),
            (i.announcementBarHeight = x(A.announcementBar)),
            (i.collectionStickyBarHeight = x(A.collectionStickyBar)),
            i
        );
    }
    function T() {
        (document.addEventListener("theme:resize", I),
            P(),
            document.dispatchEvent(new CustomEvent("theme:vars"), { bubbles: !1 }));
    }
    function P() {
        F();
    }
    function I() {
        F(!0);
    }
    function F(t = !1) {
        const e = document.querySelector(A.body),
            i = document.querySelector(A.collectionFilters),
            s = null !== document.querySelector(A.logoTextLink);
        let {
            windowHeight: o,
            headerHeight: n,
            headerInitialHeight: r,
            announcementBarHeight: a,
            footerHeight: l,
            collectionStickyBarHeight: c,
        } = q();
        s &&
            (n = (function () {
                (document.documentElement.style.setProperty("--header-height", "auto"),
                    document.documentElement.style.setProperty(
                        "--header-sticky-height",
                        "auto",
                    ));
                const t = document.querySelector(A.header).offsetHeight;
                return (
                    requestAnimationFrame(() => {
                        (document.documentElement.style.setProperty(
                            "--header-height",
                            `${t}px`,
                        ),
                            document.documentElement.style.setProperty(
                                "--header-sticky-height",
                                `${t}px`,
                            ));
                    }),
                    t
                );
            })());
        const h =
            window.isHeaderTransparent &&
                document
                    .querySelector(A.main)
                    .firstElementChild.classList.contains(C.supportsTransparentHeader)
                ? o - a
                : o - r - a;
        let d = H() ? o - window.stickyHeaderHeight : o;
        const u = e.classList.contains(C.templateCollection),
            p = e.classList.contains(C.templateSearch),
            m = (u && i) || (p && i);
        if (
            (document.documentElement.style.setProperty("--footer-height", `${l}px`),
                document.documentElement.style.setProperty("--content-full", `${h}px`),
                document.documentElement.style.setProperty(
                    "--content-min",
                    o - n - l + "px",
                ),
                document.documentElement.style.setProperty(
                    "--collection-sticky-bar-height",
                    `${c}px`,
                ),
                m && (d = o),
                !t)
        )
            return void document.documentElement.style.setProperty(
                "--full-height",
                `${d}px`,
            );
        const g = D();
        g !== k &&
            (document.documentElement.style.setProperty("--full-height", `${d}px`),
                (k = g));
    }
    function x(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0;
    }
    function H() {
        return document.querySelector(A.stickyHeader);
    }
    function D() {
        return window.matchMedia("(orientation: portrait)").matches
            ? "portrait"
            : window.matchMedia("(orientation: landscape)").matches
                ? "landscape"
                : void 0;
    }
    const M = {
        overflowBackground: "[data-overflow-background]",
        overflowFrame: "[data-overflow-frame]",
        overflowContent: "[data-overflow-content]",
        overflowContainer: "[data-overflow-container]",
        overflowWrapper: "[data-overflow-wrapper]",
    };
    function O(t, e) {
        let i = 0;
        e.forEach((t) => {
            i = t.offsetHeight > i ? t.offsetHeight : i;
        });
        const s = t.querySelectorAll(M.overflowBackground);
        [t, ...s].forEach((t) => {
            t.style.setProperty("min-height", `calc(${i}px + var(--header-height))`);
        });
    }
    function B(t) {
        if (window.innerWidth < window.theme.sizes.small) {
            return void t.querySelectorAll(M.overflowFrame).forEach((t) => {
                const e = t.querySelectorAll(M.overflowContent);
                O(t, e);
            });
        }
        let e = 0;
        const i = t.querySelectorAll(M.overflowFrame);
        t.querySelectorAll(M.overflowContent).forEach((t) => {
            t.offsetHeight > e && (e = t.offsetHeight);
        });
        ([...i, ...t.querySelectorAll(M.overflowBackground)].forEach((t) => {
            t.style.setProperty("min-height", `${e}px`);
        }),
            t.style.setProperty("min-height", `${e}px`));
    }
    function _(t) {
        const e = t.querySelectorAll(M.overflowContainer);
        e &&
            e.forEach((t) => {
                const e = t.querySelectorAll(M.overflowContent);
                (O(t, e),
                    document.addEventListener("theme:resize", () => {
                        O(t, e);
                    }));
            });
        const i = t.querySelectorAll(M.overflowWrapper);
        i &&
            i.forEach((t) => {
                (B(t),
                    document.addEventListener("theme:resize", () => {
                        B(t);
                    }));
            });
    }
    function $() {
        (document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
            window.lastWindowWidth !== window.innerWidth &&
            (document.dispatchEvent(
                new CustomEvent("theme:resize:width", { bubbles: !0 }),
            ),
                (window.lastWindowWidth = window.innerWidth)));
    }
    window.lastWindowWidth = window.innerWidth;
    let z = window.pageYOffset,
        R = null,
        V = null,
        N = null,
        W = null,
        U = 0;
    const j = {
        quickViewVisible: "js-quick-view-visible",
        cartDrawerOpen: "js-drawer-open-cart",
    };
    function G(e) {
        setTimeout(() => {
            (U && clearTimeout(U),
                t.disablePageScroll(e.detail, {
                    allowTouchMove: (t) => "TEXTAREA" === t.tagName,
                }),
                document.documentElement.setAttribute("data-scroll-locked", ""));
        });
    }
    function K(t) {
        const e = t.detail;
        e ? (U = setTimeout(Q, e)) : Q();
    }
    function Q() {
        document.body.classList.contains(j.quickViewVisible) ||
            document.body.classList.contains(j.cartDrawerOpen) ||
            (t.clearQueueScrollLocks(),
                t.enablePageScroll(),
                document.documentElement.removeAttribute("data-scroll-locked"));
    }
    const X = (t, e = "", i) => {
        const s = i || document.createElement("div");
        return (
            s.classList.add(e),
            s.setAttribute("data-scroll-lock-scrollable", ""),
            t.parentNode.insertBefore(s, t),
            s.appendChild(t)
        );
    };
    function Y(t) {
        t.querySelectorAll("table").forEach((t) => {
            X(t, "table-wrapper");
        });
    }
    const J = { loading: "is-loading", imgIn: "img-in" },
        Z = { img: "img.is-loading", section: "[data-section-type]" };
    function tt(t) {
        t.querySelectorAll(Z.img).forEach((t) => {
            if (t.complete) {
                (t.classList.remove(J.loading),
                    t.parentNode.classList.remove(J.loading));
                const e = t.closest(Z.section);
                e && e.classList.add(J.imgIn);
            }
        });
    }
    const et = "img",
        it = "template",
        st = ".shopify-section",
        ot = "[data-deferred-content]",
        nt = "[data-product-image]",
        rt = "srcset",
        at = "data-loaded",
        lt = "data-deferred-container";
    let ct = class extends HTMLElement {
        connectedCallback() {
            0 != this.deferredTriggers.length
                ? this.deferredTriggers.forEach((t) => {
                    t.addEventListener(
                        "mouseenter",
                        () => {
                            this.hasAttribute(at) || this.loadTemplate();
                        },
                        { once: !0 },
                    );
                })
                : this.container.addEventListener(
                    "mouseenter",
                    () => {
                        this.hasAttribute(at) || this.loadTemplate();
                    },
                    { once: !0 },
                );
        }
        loadTemplate() {
            var t;
            const e = document.createElement("div"),
                i = this.querySelector(it);
            if (
                !i ||
                !(null == i || null === (t = i.content) || void 0 === t
                    ? void 0
                    : t.firstElementChild)
            )
                return;
            e.appendChild(i.content.firstElementChild.cloneNode(!0));
            const s = e.querySelector(ot);
            if (!s) return;
            (this.append(s), this.setAttribute(at, !0));
            s.querySelectorAll(et).length > 0 && this.reloadSrcset(this);
        }
        reloadSrcset(t) {
            t &&
                t.querySelectorAll(et).forEach((t) => {
                    if (!t.parentNode.matches(nt)) {
                        const e = t.getAttribute(rt);
                        (t.setAttribute(rt, ""), t.setAttribute(rt, e));
                    }
                });
        }
        constructor() {
            (super(),
                (this.container = this),
                this.hasAttribute(lt) &&
                (this.container =
                    this.closest(this.getAttribute(lt)) || this.closest(st)),
                (this.deferredTriggers = this.container.querySelectorAll(
                    this.dataset.deferredTriggers,
                )));
        }
    };
    const ht = {
        inputSearch: 'input[type="search"]',
        inputType: 'input[name="type"]',
        form: "form",
        allVisibleElements: '[role="option"]',
        ariaSelected: '[aria-selected="true"]',
        selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
        popularSearches: "[data-popular-searches]",
        popdownBody: "[data-popdown-body]",
        mainInputSearch: "[data-main-input-search]",
        predictiveSearchResults: "[data-predictive-search-results]",
        predictiveSearch: "predictive-search",
        searchForm: "search-form",
    },
        dt = "is-searched",
        ut = "template-search";
    let pt = class extends HTMLElement {
        getQuery() {
            return this.input.value.trim();
        }
        onFocus() {
            this.currentSearchTerm = this.getQuery();
        }
        onChange() {
            (this.classList.toggle(dt, !this.isFormCleared()),
                (this.searchTerm = this.getQuery()));
        }
        isFormCleared() {
            return 0 === this.input.value.length;
        }
        submit() {
            this.form.submit();
        }
        reset() {
            this.input.val = "";
        }
        onFormSubmit(t) {
            (this.getQuery().length && !this.querySelector(ht.selectedLink)) ||
                t.preventDefault();
        }
        onKeydown(t) {
            ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
        }
        onKeyup(t) {
            switch (
            (!this.getQuery().length && this.predictiveSearch && this.close(!0),
                t.preventDefault(),
                t.code)
            ) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        switchOption(t) {
            const e = "up" === t,
                i =
                    this.classList.contains(dt) && this.predictiveSearchResults
                        ? this.predictiveSearchResults
                        : this.popularSearches;
            if (!i) return;
            this.selectedElement = i.querySelector(ht.ariaSelected);
            const s = Array.from(i.querySelectorAll(ht.allVisibleElements)).filter(
                (t) => null !== t.offsetParent,
            );
            let o = 0;
            if (e && !this.selectedElement) return;
            let n = -1,
                r = 0;
            for (; -1 === n && r <= s.length;)
                (s[r] === this.selectedElement && (n = r), r++);
            (!e && this.selectedElement
                ? (o = n === s.length - 1 ? 0 : n + 1)
                : e && (o = 0 === n ? s.length - 1 : n - 1),
                o !== n &&
                ((this.activeElement = s[o]), this.handleFocusableDescendants()));
        }
        selectOption() {
            const t = this.querySelector(ht.selectedOption);
            t && t.click();
        }
        handleFocusableDescendants(t = !1) {
            const e = this.selectedElement
                ? this.selectedElement
                : this.querySelector(ht.ariaSelected);
            var i;
            if ((e && e.setAttribute("aria-selected", !1), !this.activeElement || t))
                return (
                    (this.selectedElement = null),
                    null === (i = this.activeElement) ||
                    void 0 === i ||
                    i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-expanded", !1),
                    void this.input.setAttribute("aria-activedescendant", "")
                );
            (this.activeElement.setAttribute("aria-selected", !0),
                this.input.setAttribute(
                    "aria-activedescendant",
                    this.activeElement.id,
                ));
        }
        constructor() {
            var t;
            (super(),
                (this.input = this.querySelector(ht.inputSearch)),
                (this.form = this.querySelector(ht.form)),
                (this.popdownBody = this.closest(ht.popdownBody)),
                (this.popularSearches =
                    null === (t = this.popdownBody) || void 0 === t
                        ? void 0
                        : t.querySelector(ht.popularSearches)),
                (this.predictiveSearchResults = this.querySelector(
                    ht.predictiveSearchResults,
                )),
                (this.predictiveSearch = this.matches(ht.predictiveSearch)),
                (this.searchForm = this.matches(ht.searchForm)),
                (this.selectedElement = null),
                (this.activeElement = null),
                (this.searchTerm = ""),
                (this.currentSearchTerm = ""),
                (this.isSearchPage = document.body.classList.contains(ut)),
                this.input.addEventListener(
                    "input",
                    o((t) => {
                        this.onChange(t);
                    }, 300).bind(this),
                ),
                this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener(
                    "submit",
                    this.onFormSubmit.bind(this),
                ),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this)),
                this.isSearchPage &&
                ((this.mainInputType = document.querySelector(
                    `${ht.mainInputSearch} ${ht.inputType}`,
                )),
                    (this.inputType = this.querySelector(ht.inputType)),
                    (this.inputType.value = this.mainInputType.value)));
        }
    };
    customElements.define("search-form", pt);
    const mt = "predictive-search",
        gt = "#shopify-section-api-predictive-search",
        vt = "[data-predictive-search-results]",
        yt = "[data-predictive-search-status]",
        ft = "[data-predictive-search-live-region-count-value]",
        bt = "[data-search-results-wrapper]",
        wt = "reset",
        St = "data-aos-anchor",
        Et = "aria-hidden",
        Lt = "open",
        kt = "loading",
        At = "data-loading-text",
        Ct = "results";
    customElements.define(
        "predictive-search",
        class extends pt {
            connectedCallback() {
                this.predictiveSearchResults.addEventListener("transitionend", (t) => {
                    t.target !== this.predictiveSearchResults ||
                        this.getQuery().length ||
                        (this.classList.remove(wt),
                            requestAnimationFrame(() => this.clearResultsHTML()));
                });
            }
            onChange() {
                (super.onChange(),
                    this.classList.remove(wt),
                    this.searchTerm.length
                        ? requestAnimationFrame(() =>
                            this.getSearchResults(this.searchTerm),
                        )
                        : this.classList.add(wt));
            }
            onFocus() {
                (super.onFocus(),
                    this.currentSearchTerm.length &&
                    (this.searchTerm !== this.currentSearchTerm
                        ? this.onChange()
                        : "true" === this.getAttribute(Ct)
                            ? this.open()
                            : this.getSearchResults(this.searchTerm)));
            }
            getSearchResults(t) {
                const e = t.replace(" ", "-").toLowerCase(),
                    i = parseInt(window.theme.settings.suggestionsResultsLimit);
                let s = "query";
                ((s += window.theme.settings.suggestArticles ? ",article" : ""),
                    (s += window.theme.settings.suggestCollections ? ",collection" : ""),
                    (s += window.theme.settings.suggestProducts ? ",product" : ""),
                    (s += window.theme.settings.suggestPages ? ",page" : ""),
                    this.setLiveRegionLoadingState(),
                    this.cachedResults[e]
                        ? this.renderSearchResults(this.cachedResults[e])
                        : fetch(
                            `${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(t)}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`,
                            { signal: this.abortController.signal },
                        )
                            .then((t) => {
                                if (!t.ok) {
                                    var e = new Error(t.status);
                                    throw (this.close(), e);
                                }
                                return t.text();
                            })
                            .then((t) => {
                                const i = new DOMParser()
                                    .parseFromString(t, "text/html")
                                    .querySelector(gt).innerHTML;
                                (this.allPredictiveSearchInstances.forEach((t) => {
                                    t.cachedResults[e] = i;
                                }),
                                    this.renderSearchResults(i));
                            })
                            .catch((t) => {
                                if (20 !== (null == t ? void 0 : t.code))
                                    throw (this.close(), t);
                            }));
            }
            switchOption(t) {
                (super.switchOption(t),
                    this.statusElement && (this.statusElement.textContent = ""));
            }
            setLiveRegionLoadingState() {
                ((this.statusElement = this.statusElement || this.querySelector(yt)),
                    (this.loadingText = this.loadingText || this.getAttribute(At)),
                    this.setLiveRegionText(this.loadingText),
                    this.setAttribute(kt, !0));
            }
            setLiveRegionText(t) {
                (this.statusElement.setAttribute(Et, "false"),
                    (this.statusElement.textContent = t),
                    setTimeout(() => {
                        this.statusElement.setAttribute(Et, "true");
                    }, 1e3));
            }
            renderSearchResults(t) {
                this.predictiveSearchResults.innerHTML = t;
                const e = this.predictiveSearchResults.parentElement.id,
                    i = this.predictiveSearchResults.querySelector(bt),
                    s = i.id;
                ((i.id = `${s}--${e}`),
                    i.setAttribute(St, `#${i.id}`),
                    this.setAttribute(Ct, !0),
                    this.setLiveRegionResults(),
                    this.open());
            }
            setLiveRegionResults() {
                (this.removeAttribute(kt),
                    this.setLiveRegionText(this.querySelector(ft).textContent));
            }
            open() {
                this.setAttribute(Lt, !0);
            }
            close(t = !1) {
                this.closeResults(t);
            }
            closeResults(t = !1) {
                (t &&
                    (this.reset(), this.removeAttribute(Ct), this.classList.remove(wt)),
                    this.removeAttribute(kt),
                    this.removeAttribute(Lt));
            }
            clearResultsHTML() {
                this.predictiveSearchResults.innerHTML = "";
            }
            constructor() {
                (super(),
                    (this.abortController = new AbortController()),
                    (this.allPredictiveSearchInstances = document.querySelectorAll(mt)),
                    (this.predictiveSearchResults = this.querySelector(vt)),
                    (this.cachedResults = {}));
            }
        },
    );
    let qt = class extends HTMLElement {
        constructor() {
            (super(),
                document.addEventListener("DOMContentLoaded", () => {
                    document.documentElement.classList.remove("page-loading");
                }));
        }
    };
    const Tt = {
        aos: "[data-aos]:not(.aos-animate)",
        aosAnchor: "[data-aos-anchor]",
        animatable: "[data-aos], [data-aos-anchor]",
        watchMutations:
            '[id^="api-cart-items-"], [data-collection-filters], [data-collection-products], #AjaxinateLoop',
        skeletonLoading: ".skeleton-loading",
    },
        Pt = { aosAnimate: "aos-animate", isLoading: "is-loading" },
        It = {
            aos: "data-aos",
            aosAnchor: "data-aos-anchor",
            aosIntersection: "data-aos-intersection",
            aosDebounce: "data-aos-debounce",
            aosCustomInit: "data-aos-custom-init",
            aosWatchAnchors: "data-aos-watch-anchors",
            aosTrigger: "data-aos-trigger",
        },
        Ft = 0.1,
        xt = 0;
    let Ht = new Set();
    function Dt(t) {
        t.length &&
            (t.forEach((t) => {
                const e = t.dataset.aosAnchor;
                let i;
                ("" != e && (i = document.querySelector(e)),
                    i && !Ht.has(t) && Ht.add(i));
            }),
                Ht.forEach((t) => {
                    Mt.observe(t);
                }));
    }
    const Mt = new IntersectionObserver(
        (t, e) => {
            t.forEach((t) => {
                const i = t.target,
                    s = t.intersectionRatio,
                    o = t.isIntersecting;
                let n,
                    r = Ft;
                i.hasAttribute(It.aosIntersection) &&
                    (r = Number(i.getAttribute(It.aosIntersection)));
                let a = xt;
                (i.hasAttribute(It.aosDebounce) &&
                    (a = Number(i.getAttribute(It.aosDebounce))),
                    o &&
                    s > r &&
                    (0 !== a
                        ? (n && clearTimeout(n), (n = setTimeout(() => Ot(i), a)))
                        : Ot(i),
                        e.unobserve(i),
                        Ht.delete(i)));
            });
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1],
        },
    );
    function Ot(t) {
        if (!t) return;
        Bt(t);
        const e = t.closest(Tt.skeletonLoading);
        if (
            (e &&
                e.querySelectorAll("img").forEach((t) => {
                    t.classList.contains(Pt.isLoading) &&
                        t.setAttribute("loading", "eager");
                }),
                t.hasAttribute(It.aosTrigger))
        ) {
            const e = t.getAttribute(It.aosTrigger);
            document
                .querySelectorAll(`[${It.aosAnchor}="${e}"]`)
                .forEach((t) => Bt(t));
        }
        let i = t.querySelectorAll(Tt.aos);
        if (t.hasAttribute(It.aosWatchAnchors)) {
            i = [...i].filter((e) => {
                const i =
                    !!e.hasAttribute(It.aosAnchor) && e.getAttribute(It.aosAnchor);
                if (i && `#${t.id}` === i) return e;
            });
        }
        i.forEach((e) => {
            e.hasAttribute(It.aosCustomInit)
                ? t.dispatchEvent(
                    new CustomEvent("theme:target:animate", { bubbles: !0, detail: e }),
                )
                : Bt(e);
        });
    }
    function Bt(t) {
        requestAnimationFrame(() => t.classList.add(Pt.aosAnimate));
    }
    function _t() {
        (Dt(document.querySelectorAll(Tt.aosAnchor)),
            (function () {
                const t = (t) => t instanceof HTMLElement;
                new MutationObserver((e) => {
                    for (const i of e) {
                        if ("childList" === !i.type) return;
                        const e = i.target,
                            s = [...i.addedNodes],
                            o = [...i.removedNodes],
                            n =
                                e.matches(Tt.watchMutations) ||
                                s.some((e) => !!t(e) && e.matches(Tt.watchMutations)) ||
                                o.some((e) => !!t(e) && e.matches(Tt.watchMutations)),
                            r =
                                e.matches(Tt.animatable) ||
                                s.some((e) => !!t(e) && e.matches(Tt.animatable)),
                            a = null !== e.querySelector(`[${It.aosAnchor}="#${e.id}"]`);
                        (r || a || n) && Dt(e.querySelectorAll(Tt.aosAnchor));
                    }
                }).observe(document.body, {
                    attributes: !1,
                    childList: !0,
                    subtree: !0,
                });
            })());
    }
    ((window.requestIdleCallback =
        window.requestIdleCallback ||
        function (t) {
            var e = Date.now();
            return setTimeout(function () {
                t({
                    didTimeout: !1,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - e));
                    },
                });
            }, 1);
        }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            }),
        window.addEventListener("resize", o($, 50)),
        (function () {
            let t;
            (window.addEventListener(
                "scroll",
                function () {
                    (t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.pageYOffset;
                                (t > z
                                    ? ((V = !0), (R = !1))
                                    : t < z
                                        ? ((V = !1), (R = !0))
                                        : ((R = null), (V = null)),
                                    (z = t),
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll", {
                                            detail: { up: R, down: V, position: t },
                                            bubbles: !1,
                                        }),
                                    ),
                                    R &&
                                    !N &&
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll:up", {
                                            detail: { position: t },
                                            bubbles: !1,
                                        }),
                                    ),
                                    V &&
                                    !W &&
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll:down", {
                                            detail: { position: t },
                                            bubbles: !1,
                                        }),
                                    ),
                                    (W = V),
                                    (N = R));
                            })();
                        })));
                },
                { passive: !0 },
            ),
                window.addEventListener("theme:scroll:lock", G),
                window.addEventListener("theme:scroll:unlock", K));
        })(),
        "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className =
                document.documentElement.className.replace(
                    "no-touch",
                    "supports-touch",
                )),
                (window.theme.touch = !0))
            : (window.theme.touch = !1),
        document.addEventListener(
            "load",
            (t) => {
                if (
                    "img" == t.target.tagName.toLowerCase() &&
                    t.target.classList.contains(J.loading)
                ) {
                    (t.target.classList.remove(J.loading),
                        t.target.parentNode.classList.remove(J.loading));
                    const e = t.target.closest(Z.section);
                    e && e.classList.add(J.imgIn);
                }
            },
            !0,
        ));
    const $t = o(() => {
        p();
    }, 300);
    (window.addEventListener("DOMContentLoaded", () => {
        (T(),
            _(document),
            Y(document),
            tt(document),
            window.theme.settings.animationsEnabled && _t());
    }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            (window.dispatchEvent(new Event("resize"), { bubbles: !0 }),
                _(e),
                Y(e),
                T(),
                $t(),
                L(e),
                window.theme.settings.animationsEnabled && _t());
        }),
        document.addEventListener("shopify:section:reorder", (t) => {
            const e = t.target;
            ($t(), L(e));
        }),
        document.addEventListener("shopify:section:unload", (t) => {
            const e = t.target;
            ($t(), L(e));
        }),
        customElements.get("deferred-loading") ||
        customElements.define("deferred-loading", ct),
        customElements.get("loading-overlay") ||
        customElements.define("loading-overlay", qt),
        (function () {
            function t(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect();
                return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
            }
            function e(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect(),
                    o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
                    n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
                return o && n;
            }
            window.visibilityHelper = {
                isElementTotallyVisible: t,
                isElementPartiallyVisible: e,
                inViewportPartially: function (t, i) {
                    function s() {
                        var s = e(t);
                        s != o && ((o = s), "function" == typeof i && i(s, t));
                    }
                    var o = e(t);
                    (window.addEventListener("load", s),
                        window.addEventListener("resize", s),
                        window.addEventListener("scroll", s));
                },
                inViewportTotally: function (e, i) {
                    function s() {
                        var s = t(e);
                        s != o && ((o = s), "function" == typeof i && i(s, e));
                    }
                    var o = t(e);
                    (window.addEventListener("load", s),
                        window.addEventListener("resize", s),
                        window.addEventListener("scroll", s));
                },
            };
        })(),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered =
            window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances =
            window.Shopify.theme.sections.instances || []));
    const zt = window.Shopify.theme.sections.registered,
        Rt = window.Shopify.theme.sections.instances,
        Vt = { id: "data-section-id", type: "data-section-type" };
    let Nt = class {
        getStack() {
            return this.callStack;
        }
        constructor(t = null, e = []) {
            ((this.type = t),
                (this.components = (function (t) {
                    if ((void 0 !== t && "object" != typeof t) || null === t)
                        throw new TypeError(
                            "Theme Sections: The components object provided is not a valid",
                        );
                    return t;
                })(e)),
                (this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: [],
                }),
                e.forEach((t) => {
                    for (const [e, i] of Object.entries(t)) {
                        const t = this.callStack[e];
                        Array.isArray(t) && "function" == typeof i
                            ? t.push(i)
                            : (console.warn(
                                `Unregisted function: '${e}' in component: '${this.type}'`,
                            ),
                                console.warn(i));
                    }
                }));
        }
    },
        Wt = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach((t) => {
                    const i = { id: this.id, type: this.type, container: this.container };
                    e ? t.call(i, e) : t.call(i);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(t) {
                this.callFunctions("onSelect", t);
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t);
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t);
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t);
            }
            onReorder(t) {
                this.callFunctions("onReorder", t);
            }
            constructor(t, e) {
                ((this.container = (function (t) {
                    if (!(t instanceof Element))
                        throw new TypeError(
                            "Theme Sections: Attempted to load section. The section container provided is not a DOM element.",
                        );
                    if (null === t.getAttribute(Vt.id))
                        throw new Error(
                            "Theme Sections: The section container provided does not have an id assigned to the " +
                            Vt.id +
                            " attribute.",
                        );
                    return t;
                })(t)),
                    (this.id = t.getAttribute(Vt.id)),
                    (this.type = e.type),
                    (this.callStack = e.getStack()));
                try {
                    this.onLoad();
                } catch (t) {
                    (console.warn(`Error in section: ${this.id}`),
                        console.warn(this),
                        console.warn(t));
                }
            }
        };
    function Ut(t, e) {
        if ("string" != typeof t)
            throw new TypeError(
                "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered",
            );
        if (void 0 !== zt[t])
            throw new Error(
                'Theme Sections: A section of type "' +
                t +
                '" has already been registered. You cannot register the same section type twice',
            );
        Array.isArray(e) || (e = [e]);
        const i = new Nt(t, e);
        return ((zt[t] = i), zt);
    }
    function jt(t, e) {
        ((t = Qt(t)),
            void 0 === e && (e = document.querySelectorAll("[" + Vt.type + "]")),
            (e = Xt(e)),
            t.forEach(function (t) {
                const i = zt[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return (
                            !(Gt(e).length > 0) &&
                            null !== e.getAttribute(Vt.type) &&
                            (e.getAttribute(Vt.type) !== t || (Rt.push(new Wt(e, i)), !1))
                        );
                    }));
            }));
    }
    function Gt(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            Xt(t).forEach(function (t) {
                e = e.concat(
                    Rt.filter(function (e) {
                        return e.container === t;
                    }),
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            Qt(t).forEach(function (t) {
                e = e.concat(
                    Rt.filter(function (e) {
                        return e.type === t;
                    }),
                );
            });
        }
        return e;
    }
    function Kt(t) {
        for (var e, i = 0; i < Rt.length; i++)
            if (Rt[i].id === t) {
                e = Rt[i];
                break;
            }
        return e;
    }
    function Qt(t) {
        return (
            "*" === t
                ? (t = Object.keys(zt))
                : "string" == typeof t
                    ? (t = [t])
                    : t.constructor === Wt
                        ? (t = [t.prototype.type])
                        : Array.isArray(t) &&
                        t[0].constructor === Wt &&
                        (t = t.map(function (t) {
                            return t.type;
                        })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function Xt(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                    ? (t = [])
                    : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + Vt.id + '="' + e + '"]');
            (!0 === window.Shopify.visualPreviewMode &&
                null === i &&
                (i = t.target.querySelector(`[${Vt.id}]`)),
                null !== i && jt(i.getAttribute(Vt.type), i));
        }),
            document.addEventListener("shopify:section:reorder", function (t) {
                var e = t.detail.sectionId,
                    i = t.target.querySelector("[" + Vt.id + '="' + e + '"]');
                "object" == typeof Gt(i)[0] &&
                    Gt(i).forEach(function (t) {
                        t.onReorder();
                    });
            }),
            document.addEventListener("shopify:section:unload", function (t) {
                var e = t.detail.sectionId,
                    i = t.target.querySelector("[" + Vt.id + '="' + e + '"]');
                "object" == typeof Gt(i)[0] &&
                    Gt(i).forEach(function (t) {
                        var e = Rt.map(function (t) {
                            return t.id;
                        }).indexOf(t.id);
                        (Rt.splice(e, 1), t.onUnload());
                    });
            }),
            document.addEventListener("shopify:section:select", function (t) {
                var e = Kt(t.detail.sectionId);
                "object" == typeof e && e.onSelect(t);
            }),
            document.addEventListener("shopify:section:deselect", function (t) {
                var e = Kt(t.detail.sectionId);
                "object" == typeof e && e.onDeselect(t);
            }),
            document.addEventListener("shopify:block:select", function (t) {
                var e = Kt(t.detail.sectionId);
                "object" == typeof e && e.onBlockSelect(t);
            }),
            document.addEventListener("shopify:block:deselect", function (t) {
                var e = Kt(t.detail.sectionId);
                "object" == typeof e && e.onBlockDeselect(t);
            }));
    const Yt = (t, e) => {
        let i, s;
        return function o(...n) {
            const r = Date.now();
            ((s = clearTimeout(s)),
                !i || r - i >= e
                    ? (t.apply(null, n), (i = r))
                    : (s = setTimeout(o.bind(null, ...n), e - (r - i))));
        };
    };
    function Jt(t) {
        ((this.status = t.status || null),
            (this.headers = t.headers || null),
            (this.json = t.json || null),
            (this.body = t.body || null));
    }
    Jt.prototype = Error.prototype;
    const Zt = "[data-collapsible-single]",
        te = "[data-collapsible-trigger]",
        ee = "[data-collapsible-content]",
        ie = "is-expanded",
        se = "aria-expanded",
        oe = "aria-controls",
        ne = "data-collapsible-trigger-mobile",
        re = "data-collapsible-transition-override",
        ae = 500,
        le = {};
    let ce = class {
        init() {
            this.triggers.forEach((t) => {
                (t.addEventListener("click", this.collapsibleToggleEvent),
                    t.addEventListener("keyup", this.collapsibleToggleEvent));
            });
        }
        collapsibleToggle(t) {
            t.preventDefault();
            const e = t.target.matches(te) ? t.target : t.target.closest(te),
                i = e.getAttribute(oe),
                s = document.getElementById(i),
                o = e.hasAttribute(ne),
                n = e.classList.contains(ie),
                r = t.code === theme.keyboardKeys.SPACE,
                a = t.code === theme.keyboardKeys.ESCAPE,
                l = window.innerWidth < theme.sizes.small;
            (this.isTransitioning && !this.transitionOverride) ||
                ((!t.code || r || a) &&
                    ((!n && a) ||
                        (o && !l) ||
                        ((this.isTransitioning = !0),
                            (e.disabled = !0),
                            this.single &&
                            this.triggers.forEach((t) => {
                                const i = t.classList.contains(ie);
                                if (e == t || !i) return;
                                const s = t.getAttribute(oe),
                                    o = document.getElementById(s);
                                requestAnimationFrame(() => {
                                    this.closeItem(o, t);
                                });
                            }),
                            n
                                ? requestAnimationFrame(() => {
                                    this.closeItem(s, e);
                                })
                                : requestAnimationFrame(() => {
                                    this.openItem(s, e);
                                }))));
        }
        openItem(t, e) {
            let i = t.querySelector(ee).offsetHeight;
            (this.setDropdownHeight(t, i, e, !0),
                e.classList.add(ie),
                e.setAttribute(se, !0),
                e.dispatchEvent(
                    new CustomEvent("theme:form:sticky", {
                        bubbles: !0,
                        detail: { element: "accordion" },
                    }),
                ));
        }
        closeItem(t, e) {
            let i = t.querySelector(ee).offsetHeight;
            (requestAnimationFrame(() => {
                ((i = 0), this.setDropdownHeight(t, i, e, !1), e.classList.remove(ie));
            }),
                this.setDropdownHeight(t, i, e, !1),
                e.classList.remove(ie),
                e.setAttribute(se, !1));
        }
        setDropdownHeight(t, e, i, s) {
            ((t.style.height = `${e}px`),
                t.setAttribute(se, s),
                t.classList.toggle(ie, s),
                this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
                0 == e &&
                (this.resetHeightTimer = setTimeout(() => {
                    t.style.height = "";
                }, ae)),
                s
                    ? (this.resetHeightTimer = setTimeout(() => {
                        ((t.style.height = "auto"), (this.isTransitioning = !1));
                    }, ae))
                    : (this.isTransitioning = !1),
                setTimeout(() => {
                    i.disabled = !1;
                }, ae));
        }
        onUnload() {
            this.triggers.forEach((t) => {
                (t.removeEventListener("click", this.collapsibleToggleEvent),
                    t.removeEventListener("keyup", this.collapsibleToggleEvent));
            });
        }
        constructor(t) {
            ((this.container = t),
                (this.single = this.container.querySelector(Zt)),
                (this.triggers = this.container.querySelectorAll(te)),
                (this.resetHeightTimer = 0),
                (this.isTransitioning = !1),
                (this.transitionOverride = this.container.hasAttribute(re)),
                (this.collapsibleToggleEvent = (t) =>
                    Yt(this.collapsibleToggle(t), 1250)),
                this.init());
        }
    };
    const he = {
        onLoad() {
            le[this.id] = new ce(this.container);
        },
        onUnload() {
            le[this.id].onUnload();
        },
    },
        de = "[data-quantity-holder]",
        ue = "[data-quantity-field]",
        pe = "[data-quantity-button]",
        me = "[data-quantity-minus]",
        ge = "[data-quantity-plus]",
        ve = "read-only",
        ye = "is-disabled";
    let fe = class {
        init() {
            ((this.quantity = this.holder.querySelector(de)),
                this.quantity &&
                ((this.field = this.quantity.querySelector(ue)),
                    (this.buttons = this.quantity.querySelectorAll(pe)),
                    (this.increaseButton = this.quantity.querySelector(ge)),
                    (this.quantityValue = Number(this.field.value || 0)),
                    (this.cartItemID = this.field.getAttribute("data-id")),
                    (this.maxValue =
                        Number(this.field.getAttribute("max")) > 0
                            ? Number(this.field.getAttribute("max"))
                            : null),
                    (this.minValue =
                        Number(this.field.getAttribute("min")) > 0
                            ? Number(this.field.getAttribute("min"))
                            : 0),
                    (this.disableIncrease = this.disableIncrease.bind(this)),
                    (this.emptyField = !1),
                    (this.updateQuantity = this.updateQuantity.bind(this)),
                    (this.decrease = this.decrease.bind(this)),
                    (this.increase = this.increase.bind(this)),
                    this.disableIncrease(),
                    this.quantity.classList.contains(ve) ||
                    (this.changeValueOnClick(), this.changeValueOnInput())));
        }
        changeValueOnClick() {
            this.buttons.forEach((t) => {
                t.addEventListener("click", (t) => {
                    (t.preventDefault(),
                        (this.quantityValue = Number(this.field.value || 0)));
                    const e = t.target,
                        i = e.matches(me) || e.closest(me),
                        s = e.matches(ge) || e.closest(ge);
                    (i && this.decrease(), s && this.increase(), this.updateQuantity());
                });
            });
        }
        changeValueOnInput() {
            this.field.addEventListener("input", () => {
                ((this.quantityValue = this.field.value), this.updateQuantity());
            });
        }
        updateQuantity() {
            (this.maxValue < this.quantityValue &&
                null !== this.maxValue &&
                (this.quantityValue = this.maxValue),
                this.minValue > this.quantityValue &&
                (this.quantityValue = this.minValue),
                (this.field.value = this.quantityValue),
                this.disableIncrease(),
                document.dispatchEvent(new CustomEvent("theme:cart:update")),
                this.quantityUpdateCart && this.updateCart());
        }
        decrease() {
            this.quantityValue > this.minValue
                ? this.quantityValue--
                : (this.quantityValue = 0);
        }
        increase() {
            this.quantityValue++;
        }
        disableIncrease() {
            this.increaseButton.classList.toggle(
                ye,
                this.quantityValue >= this.maxValue && null !== this.maxValue,
            );
        }
        updateCart() {
            if ("" === this.quantityValue) return;
            const t = new CustomEvent("theme:cart:update", {
                bubbles: !0,
                detail: { id: this.cartItemID, quantity: this.quantityValue },
            });
            this.holder.dispatchEvent(t);
        }
        constructor(t, e = !1) {
            ((this.holder = t), (this.quantityUpdateCart = e));
        }
    };
    const be = {
        state: { firstFocusable: null, lastFocusable: null, trigger: null },
        trapFocus: function (t) {
            var e = Array.from(
                t.container.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])',
                ),
            ).filter(function (t) {
                var e = t.offsetWidth,
                    i = t.offsetHeight;
                return (
                    0 !== e &&
                    0 !== i &&
                    "none" !== getComputedStyle(t).getPropertyValue("display")
                );
            });
            ((e = e.filter(function (t) {
                return !t.classList.contains("deferred-media__poster");
            })),
                (this.state.firstFocusable = e[0]),
                (this.state.lastFocusable = e[e.length - 1]),
                t.elementToFocus ||
                (t.elementToFocus = this.state.firstFocusable || t.container),
                this._setupHandlers(),
                document.addEventListener("focusin", this._onFocusInHandler),
                document.addEventListener("focusout", this._onFocusOutHandler),
                t.container.setAttribute("tabindex", "-1"),
                t.elementToFocus.focus());
        },
        removeTrapFocus: function (t) {
            const e = !document.body.classList.contains("no-outline");
            (t && t.container && t.container.removeAttribute("tabindex"),
                document.removeEventListener("focusin", this._onFocusInHandler),
                this.state.trigger && e && this.state.trigger.focus());
        },
        _manageFocus: function (t) {
            t.code === theme.keyboardKeys.TAB &&
                (t.target !== this.state.lastFocusable ||
                    t.shiftKey ||
                    (t.preventDefault(), this.state.firstFocusable.focus()),
                    t.target === this.state.firstFocusable &&
                    t.shiftKey &&
                    (t.preventDefault(), this.state.lastFocusable.focus()));
        },
        _onFocusOut: function () {
            document.removeEventListener("keydown", this._manageFocusHandler);
        },
        _onFocusIn: function (t) {
            (t.target !== this.state.lastFocusable &&
                t.target !== this.state.firstFocusable) ||
                document.addEventListener("keydown", this._manageFocusHandler);
        },
        _setupHandlers: function () {
            (this._onFocusInHandler ||
                (this._onFocusInHandler = this._onFocusIn.bind(this)),
                this._onFocusOutHandler ||
                (this._onFocusOutHandler = this._onFocusIn.bind(this)),
                this._manageFocusHandler ||
                (this._manageFocusHandler = this._manageFocus.bind(this)));
        },
    };
    const we = {};
    function Se(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return we[t.url]
                ? we[t.url]
                : (function (t, e) {
                    const i = new Promise((i, s) => {
                        "text" === e
                            ? fetch(t)
                                .then((t) => t.text())
                                .then((t) => {
                                    i(t);
                                })
                                .catch((t) => {
                                    s(t);
                                })
                            : (function (t, e, i) {
                                let s = document.getElementsByTagName("head")[0],
                                    o = !1,
                                    n = document.createElement("script");
                                ((n.src = t),
                                    (n.onload = n.onreadystatechange =
                                        function () {
                                            o ||
                                                (this.readyState &&
                                                    "loaded" != this.readyState &&
                                                    "complete" != this.readyState)
                                                ? i()
                                                : ((o = !0), e());
                                        }),
                                    s.appendChild(n));
                            })(
                                t,
                                function () {
                                    i();
                                },
                                function () {
                                    s();
                                },
                            );
                    });
                    return ((we[t] = i), i);
                })(t.url, t.type);
        if (t.json)
            return we[t.json]
                ? Promise.resolve(we[t.json])
                : window
                    .fetch(t.json)
                    .then((t) => t.json())
                    .then((e) => ((we[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return we[e]
                ? we[e]
                : (function (t) {
                    const e = "".concat(t.name, t.version),
                        i = new Promise((e, i) => {
                            try {
                                window.Shopify.loadFeatures([
                                    {
                                        name: t.name,
                                        version: t.version,
                                        onLoad: (t) => {
                                            !(function (t, e, i) {
                                                i ? e(i) : t();
                                            })(e, i, t);
                                        },
                                    },
                                ]);
                            } catch (t) {
                                i(t);
                            }
                        });
                    return ((we[e] = i), i);
                })(t);
        }
        return Promise.reject();
    }
    ((window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1));
    const Ee = "[data-video-id]",
        Le = "loaded",
        ke = "data-enable-sound",
        Ae = "data-enable-background",
        Ce = "data-enable-autoplay",
        qe = "data-enable-loop",
        Te = "data-video-id",
        Pe = "data-video-type";
    const Ie = {
        videoIframe: "[data-video-id]",
        videoWrapper: ".video-wrapper",
        youtubeWrapper: "[data-youtube-wrapper]",
    },
        Fe = "data-section-id",
        xe = "data-enable-sound",
        He = "data-check-player-visibility",
        De = "data-video-id",
        Me = "data-video-type",
        Oe = "loaded",
        Be = [];
    const _e = "[data-notification-form]",
        $e = "[data-notification]",
        ze = "[data-popup-close]",
        Re = "pswp--success",
        Ve = "notification-popup-visible";
    function Ne(t) {
        const i = e.data(t);
        i &&
            (i.on("dragStart", (t, e) => {
                document.ontouchmove = function (t) {
                    t.preventDefault();
                };
            }),
                i.on("dragEnd", (t, e) => {
                    document.ontouchmove = function (t) {
                        return !0;
                    };
                }));
    }
    const We = "html5",
        Ue = "youtube",
        je = "vimeo",
        Ge = "[data-deferred-media]",
        Ke = "[data-deferred-media-button]",
        Qe = "[data-product-single-media-wrapper]",
        Xe = "[data-video]",
        Ye = ".media--hidden",
        Je = "media--hidden",
        Ze = "loaded",
        ti = "data-section-id",
        ei = "data-autoplay-video",
        ii = "data-media-id";
    let si = class {
        init() {
            this.container.querySelectorAll(Xe).forEach((t) => {
                const e = t.querySelector(Ke);
                (e && e.addEventListener("click", this.loadContent.bind(this, t)),
                    this.autoplayVideo && this.loadContent(t));
            });
        }
        loadContent(t) {
            if (t.querySelector(Ge).getAttribute(Ze)) return;
            const e = document.createElement("div");
            e.appendChild(
                t.querySelector("template").content.firstElementChild.cloneNode(!0),
            );
            const i = t.dataset.mediaId,
                s = e.querySelector("video, iframe"),
                o = this.hostFromVideoElement(s),
                n = t.querySelector(Ge);
            (n.appendChild(s),
                n.setAttribute("loaded", !0),
                (this.players[i] = {
                    mediaId: i,
                    sectionId: this.id,
                    container: t,
                    element: s,
                    host: o,
                    ready: () => {
                        this.createPlayer(i);
                    },
                }));
            const r = this.players[i];
            switch (r.host) {
                case We:
                    this.loadVideo(r, We);
                    break;
                case je:
                    window.isVimeoAPILoaded
                        ? this.loadVideo(r, je)
                        : Se({ url: "https://player.vimeo.com/api/player.js" }).then(() =>
                            this.loadVideo(r, je),
                        );
                    break;
                case Ue:
                    window.isYoutubeAPILoaded
                        ? this.loadVideo(r, Ue)
                        : Se({ url: "https://www.youtube.com/iframe_api" }).then(() =>
                            this.loadVideo(r, Ue),
                        );
            }
        }
        hostFromVideoElement(t) {
            if ("VIDEO" === t.tagName) return We;
            if ("IFRAME" === t.tagName) {
                if (
                    /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                        t.src,
                    )
                )
                    return Ue;
                if (t.src.includes("vimeo.com")) return je;
            }
            return null;
        }
        loadVideo(t, e) {
            t.host === e && t.ready();
        }
        createPlayer(t) {
            const e = this.players[t];
            switch (e.host) {
                case We:
                    (e.element.addEventListener("play", () => {
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                            bubbles: !0,
                        });
                    }),
                        e.element.addEventListener("pause", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                                bubbles: !0,
                            });
                        }),
                        this.autoplayVideo && this.observeVideo(e, t));
                    break;
                case je:
                    ((e.player = new Vimeo.Player(e.element)),
                        e.player.play(),
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                            bubbles: !0,
                        }),
                        (window.isVimeoAPILoaded = !0),
                        e.player.on("play", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                                bubbles: !0,
                            });
                        }),
                        e.player.on("pause", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                                bubbles: !0,
                            });
                        }),
                        this.autoplayVideo && this.observeVideo(e, t));
                    break;
                case Ue:
                    if (e.host == Ue && e.player) return;
                    YT.ready(() => {
                        const i = e.container.dataset.videoId;
                        ((e.player = new YT.Player(e.element, {
                            videoId: i,
                            events: {
                                onReady: (t) => {
                                    (t.target.playVideo(),
                                        e.container.dispatchEvent(
                                            new CustomEvent("theme:media:play"),
                                            { bubbles: !0 },
                                        ));
                                },
                                onStateChange: (t) => {
                                    (1 == t.data &&
                                        e.container.dispatchEvent(
                                            new CustomEvent("theme:media:play"),
                                            { bubbles: !0 },
                                        ),
                                        2 == t.data &&
                                        e.container.dispatchEvent(
                                            new CustomEvent("theme:media:pause"),
                                            { bubbles: !0 },
                                        ),
                                        0 == t.data &&
                                        e.container.dispatchEvent(
                                            new CustomEvent("theme:media:pause"),
                                            { bubbles: !0 },
                                        ));
                                },
                            },
                        })),
                            (window.isYoutubeAPILoaded = !0),
                            this.autoplayVideo && this.observeVideo(e, t));
                    });
            }
            (e.container.addEventListener("theme:media:visible", (t) =>
                this.onVisible(t),
            ),
                e.container.addEventListener("theme:media:hidden", (t) =>
                    this.onHidden(t),
                ),
                e.container.addEventListener("xrLaunch", (t) => this.onHidden(t)));
        }
        observeVideo(t) {
            new IntersectionObserver(
                (e, i) => {
                    e.forEach((e) => {
                        const i = 0 == e.intersectionRatio,
                            s = !t.element.closest(Ye);
                        i ? this.pauseVideo(t) : s && this.playVideo(t);
                    });
                },
                { rootMargin: "200px", threshold: [0, 0.25, 0.75, 1] },
            ).observe(t.element);
        }
        playVideo(t) {
            (t.player && t.player.playVideo
                ? t.player.playVideo()
                : t.element && t.element.play
                    ? t.element.play()
                    : t.player && t.player.play && t.player.play(),
                t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                    bubbles: !0,
                }));
        }
        pauseVideo(t) {
            if (t.player && t.player.pauseVideo)
                "1" == t.player.playerInfo.playerState && t.player.pauseVideo();
            else if (t.player && t.player.pause) t.player.pause();
            else if (t.element && !t.element.paused) {
                var e;
                if ("function" == typeof t.element.pause)
                    null === (e = t.element) || void 0 === e || e.pause();
            }
        }
        onHidden(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.pauseVideo(i);
            }
        }
        onVisible(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                (setTimeout(() => {
                    this.playVideo(i);
                }, 50),
                    this.pauseContainerMedia(e));
            }
        }
        pauseOtherMedia(t, e) {
            const i = `[${ii}="${t}"]`,
                s = e.querySelectorAll(`${Qe}:not(${i})`);
            s.length &&
                s.forEach((t) => {
                    (t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                        bubbles: !0,
                    }),
                        t.classList.add(Je));
                });
        }
        constructor(t) {
            ((this.container = t),
                (this.id = this.container.getAttribute(ti)),
                (this.autoplayVideo = "true" === this.container.getAttribute(ei)),
                (this.players = {}),
                (this.pauseContainerMedia = (t, e = this.container) =>
                    this.pauseOtherMedia(t, e)),
                this.init());
        }
    };
    function oi(t, e, i = [], s = !1) {
        const o = new FormData(t),
            n = new URLSearchParams(o);
        if (!e) return n.toString();
        const r = new FormData(e),
            a = new URLSearchParams(r),
            l = [];
        for (const t of o.entries()) "" === t[1] && l.push(t[0]);
        for (const t of r.entries()) "" === t[1] && l.push(t[0]);
        for (let t = 0; t < l.length; t++) {
            const e = l[t];
            (n.has(e) && n.delete(e), a.has(e) && a.delete(e));
        }
        for (const t of n.keys()) a.has(t) && a.delete(t);
        if (i.length > 0)
            for (let t = 0; t < i.length; t++) {
                const e = i[t];
                (n.has(e) && n.delete(e), a.has(e) && a.delete(e));
            }
        return (
            s && (a.has("type") && a.delete("type"), n.set("type", s)),
            `${n.toString()}&${a.toString()}`
        );
    }
    const ni = "[data-custom-scrollbar]",
        ri = "[data-custom-scrollbar-items]",
        ai = "[data-custom-scrollbar-thumb]",
        li = ".current";
    let ci = class {
        calculateTrack(t) {
            if (!t)
                return (
                    this.scrollbar.style.setProperty("--thumb-scale", 0),
                    void this.scrollbar.style.setProperty("--thumb-position", "0px")
                );
            const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
                i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
            (this.scrollbar.style.setProperty("--thumb-scale", e),
                this.scrollbar.style.setProperty(
                    "--thumb-position",
                    this.trackWidth * i + "px",
                ));
        }
        calculateScrollbar() {
            if (this.scrollbarItems.children.length) {
                const t = [...this.scrollbarItems.children];
                ((this.trackWidth = 0),
                    t.forEach((t) => {
                        this.trackWidth +=
                            t.getBoundingClientRect().width +
                            parseInt(window.getComputedStyle(t).marginRight);
                    }),
                    this.scrollbar.style.setProperty(
                        "--track-width",
                        `${this.trackWidth}px`,
                    ));
            }
        }
        onScrollbarChange(t) {
            t &&
                t.detail &&
                t.detail.element &&
                this.container.contains(t.detail.element) &&
                this.calculateTrack(t.detail.element);
        }
        events() {
            (document.addEventListener("theme:resize:width", this.calcScrollbarEvent),
                document.addEventListener(
                    "theme:custom-scrollbar:change",
                    this.onScrollbarChangeEvent,
                ));
        }
        unload() {
            (document.removeEventListener(
                "theme:resize:width",
                this.calcScrollbarEvent,
            ),
                document.removeEventListener(
                    "theme:custom-scrollbar:change",
                    this.onScrollbarChangeEvent,
                ));
        }
        constructor(t) {
            ((this.container = t),
                (this.scrollbarItems = t.querySelector(ri)),
                (this.scrollbar = t.querySelector(ni)),
                (this.scrollbarThumb = t.querySelector(ai)),
                (this.trackWidth = 0),
                (this.calcScrollbarEvent = () => this.calculateScrollbar()),
                (this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
                this.scrollbar &&
                this.scrollbarItems &&
                (this.events(),
                    this.calculateScrollbar(),
                    this.scrollbarItems.children.length &&
                    this.calculateTrack(this.scrollbarItems.querySelector(li))));
        }
    };
    const hi = "[data-tooltip]",
        di = "[data-tooltip-container]",
        ui = "[data-tooltip-arrow]",
        pi = "[data-aos]",
        mi = "tooltip-default",
        gi = "is-animating",
        vi = "is-visible",
        yi = "is-hiding",
        fi = "data-aos",
        bi = "data-tooltip",
        wi = "data-tooltip-container",
        Si = "data-tooltip-stop-mouseenter",
        Ei = {};
    let Li = class {
        init() {
            if (!document.querySelector(di)) {
                const t = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text label-typography"></div></div>`,
                    e = document.createElement("div");
                ((e.className = `${this.rootClass} ${this.isAnimatingClass}`),
                    e.setAttribute(wi, ""),
                    (e.innerHTML = t),
                    document.body.appendChild(e));
            }
            (this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
                this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
                this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
                document.addEventListener("theme:tooltip:close", this.removePinEvent));
            const t = document.querySelector(di);
            theme.settings.animationsEnabled &&
                this.animatedContainer &&
                ("hero" === this.animatedContainer.getAttribute(fi)
                    ? this.animatedContainer.addEventListener("animationend", () => {
                        t.classList.remove(gi);
                    })
                    : this.animatedContainer.addEventListener("transitionend", (e) => {
                        "transform" === e.propertyName && t.classList.remove(gi);
                    }));
        }
        addPin(t = !1) {
            const e = document.querySelector(di),
                i = e.querySelector(ui);
            if (e && ((t && !this.tooltip.hasAttribute(Si)) || !t)) {
                const t = e.querySelector(`.${this.rootClass}__inner`);
                e.querySelector(`.${this.rootClass}__text`).textContent = this.label;
                const s = t.offsetWidth,
                    o = this.tooltip.getBoundingClientRect(),
                    n = o.top,
                    r = o.width,
                    a = n + o.height + window.scrollY;
                let l = o.left - s / 2 + r / 2,
                    c = "50%";
                const h = l + s - window.innerWidth;
                (h > 0 && (l -= h),
                    l < 0 && ((c = `calc(50% + ${l}px)`), (l = 0)),
                    (i.style.left = c),
                    (e.style.transform = `translate(${l}px, ${a}px)`),
                    e.classList.remove(yi));
                const d = (i) => {
                    i.target === t &&
                        (("transform" !== i.propertyName && "opacity" !== i.propertyName) ||
                            requestAnimationFrame(
                                () => (e.style.transform = "translate(0, -100%)"),
                            ),
                            e.removeEventListener("transitionend", d));
                };
                (e.addEventListener("transitionend", d),
                    e.classList.add(vi),
                    document.addEventListener("theme:scroll", this.removePinEvent));
            }
        }
        removePin(t, e = !1, i = !1) {
            const s = document.querySelector(di),
                o = s.classList.contains(vi);
            s &&
                ((e && !this.tooltip.hasAttribute(Si)) || !e) &&
                (o &&
                    (i || t.detail.hideTransition) &&
                    (s.classList.add(yi),
                        this.hideTransitionTimeout &&
                        clearTimeout(this.hideTransitionTimeout),
                        (this.hideTransitionTimeout = setTimeout(() => {
                            s.classList.remove(yi);
                        }, this.transitionSpeed))),
                    s.classList.remove(vi),
                    document.removeEventListener("theme:scroll", this.removePinEvent));
        }
        unload() {
            (this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
                this.tooltip.removeEventListener(
                    "mouseleave",
                    this.removePinMouseEvent,
                ),
                this.tooltip.removeEventListener(
                    "theme:tooltip:init",
                    this.addPinEvent,
                ),
                document.removeEventListener(
                    "theme:tooltip:close",
                    this.removePinEvent,
                ),
                document.removeEventListener("theme:scroll", this.removePinEvent));
        }
        constructor(t) {
            ((this.tooltip = t),
                this.tooltip.hasAttribute(bi) &&
                ((this.rootClass = mi),
                    (this.isAnimatingClass = gi),
                    (this.label = this.tooltip.getAttribute(bi)),
                    (this.transitionSpeed = 200),
                    (this.hideTransitionTimeout = 0),
                    (this.animatedContainer = this.tooltip.closest(pi)),
                    (this.addPinEvent = () => this.addPin()),
                    (this.addPinMouseEvent = () => this.addPin(!0)),
                    (this.removePinEvent = (t) => Yt(this.removePin(t), 50)),
                    (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
                    this.init()));
        }
    };
    const ki = {
        onLoad() {
            Ei[this.id] = [];
            this.container.querySelectorAll(hi).forEach((t) => {
                Ei[this.id].push(new Li(t));
            });
        },
        onUnload() {
            Ei[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    },
        Ai = "[data-range-slider]",
        Ci = "[data-range-left]",
        qi = "[data-range-right]",
        Ti = "[data-range-line]",
        Pi = "[data-range-holder]",
        Ii = "data-se-min",
        Fi = "data-se-max",
        xi = "data-se-min-value",
        Hi = "data-se-max-value",
        Di = "data-se-step",
        Mi = "data-range-filter-update",
        Oi = "[data-field-price-min]",
        Bi = "[data-field-price-max]",
        _i = "is-initialized";
    function $i() {
        this.entries = [];
    }
    function zi(t, e) {
        Ri(t);
        var i = (function (t, e) {
            (Ri(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name"))
                        throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name)
                        throw new TypeError(
                            "Invalid value type passed for name of option " +
                            t[0].name +
                            ". Value should be string.",
                        );
                })(e));
            var i = [];
            return (
                e.forEach(function (e) {
                    for (var s = 0; s < t.options.length; s++) {
                        if (
                            (t.options[s].name || t.options[s]).toLowerCase() ===
                            e.name.toLowerCase()
                        ) {
                            i[s] = e.value;
                            break;
                        }
                    }
                }),
                i
            );
        })(t, e);
        return (function (t, e) {
            (Ri(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0])
                        throw new Error(t + "is not a valid array of options.");
                })(e));
            var i = t.variants.filter(function (t) {
                return e.every(function (e, i) {
                    return t.options[i] === e;
                });
            });
            return i[0] || null;
        })(t, i);
    }
    function Ri(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object)
            throw new Error(t + " is empty.");
    }
    (($i.prototype.add = function (t, e, i) {
        (this.entries.push({ element: t, event: e, fn: i }),
            t.addEventListener(e, i));
    }),
        ($i.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return (t.element.removeEventListener(t.event, t.fn), !1);
            });
        }));
    var Vi = '[name="id"]',
        Ni = '[name="selling_plan"]',
        Wi = '[name^="options"]',
        Ui = '[name="quantity"]',
        ji = '[name^="properties"]';
    const Gi = { color: "ash" },
        Ki = "[data-swatch]",
        Qi = "[data-product-block]",
        Xi = "[data-product-image-hover]",
        Yi = "[data-button-quick-view]",
        Ji = "[data-grid-image]",
        Zi = "[data-grid-link]",
        ts = "[data-swatches-more]",
        es = "[data-section-type]",
        is = "[data-swatches-container]",
        ss = "[data-swatches-label]",
        os = "[data-swatches-button]",
        ns = "[data-option-position]",
        rs = "[data-slider]",
        as = "product__media--featured-visible",
        ls = "product__media__hover-img--visible",
        cs = "swatch__link--no-image",
        hs = "no-outline",
        ds = "is-visible",
        us = "selector-wrapper--large",
        ps = "data-swatch",
        ms = "data-swatch-handle",
        gs = "data-swatch-label",
        vs = "data-swatch-image",
        ys = "data-swatch-image-id",
        fs = "data-swatch-variant",
        bs = "data-variant-id",
        ws = "data-variant-secondary-id";
    let Ss = {};
    const Es = {};
    let Ls = class {
        init() {
            (this.setStyles(),
                this.variant && this.outer && this.handleClicks(),
                !this.image && this.swatchLink && this.swatchLink.classList.add(cs));
        }
        setStyles() {
            (this.colorMatch &&
                this.colorMatch.hex &&
                this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                this.colorMatch &&
                this.colorMatch.path &&
                this.element.style.setProperty(
                    "background-image",
                    `url(${this.colorMatch.path})`,
                ));
        }
        handleClicks() {
            (this.swatchLink.addEventListener("click", (t) => {
                const e = !document.body.classList.contains(hs),
                    i = this.swatchLink.getAttribute(fs);
                e || (t.preventDefault(), this.updateImagesAndLinksOnEvent(i));
            }),
                this.swatchLink.addEventListener("keyup", (t) => {
                    const e = !document.body.classList.contains(hs),
                        i = this.swatchLink.getAttribute(fs);
                    (t.code !== theme.keyboardKeys.ENTER &&
                        t.code !== theme.keyboardKeys.NUMPADENTER) ||
                        e ||
                        (t.preventDefault(),
                            this.swatchLink.dispatchEvent(
                                new Event("mouseenter", { bubbles: !0 }),
                            ),
                            this.updateImagesAndLinksOnEvent(i));
                }));
        }
        updateImagesAndLinksOnEvent(t) {
            (this.updateLinks(), this.replaceImages(t));
        }
        updateLinks() {
            ((this.linkElements = this.outer.querySelectorAll(Zi)),
                (this.quickView = this.outer.querySelector(Yi)),
                this.linkElements.length &&
                this.linkElements.forEach((t) => {
                    const e =
                        ((i = t.getAttribute("href")),
                            (s = this.variant),
                            /variant=/.test(i)
                                ? i.replace(/(variant=)[^&]+/, "$1" + s)
                                : /\?/.test(i)
                                    ? i.concat("&variant=").concat(s)
                                    : i.concat("?variant=").concat(s));
                    var i, s;
                    t.setAttribute("href", e);
                }),
                this.quickView &&
                "quick_buy" === theme.settings.quickBuy &&
                this.quickView.setAttribute(bs, this.variant));
        }
        replaceImages(t) {
            const e = this.outer.querySelector(`[${ws}="${t}"]`),
                i = this.outer.querySelector(`[${bs}="${t}"]`),
                s = [...this.outer.querySelectorAll(Ji)].find((t) =>
                    t.classList.contains(as),
                );
            if (i && this.imageId) {
                if (!e || !s) return;
                const t = () => {
                    (requestAnimationFrame(() => {
                        (s.classList.remove(as),
                            i.classList.add(as),
                            requestAnimationFrame(() => {
                                e.classList.remove(as);
                            }));
                    }),
                        e.removeEventListener("animationend", t));
                };
                (requestAnimationFrame(() => {
                    e.classList.add(as);
                }),
                    e.addEventListener("animationend", t));
            }
            ("image" === theme.settings.productGridHover &&
                (this.hoverImages = this.outer.querySelectorAll(Xi)),
                this.hoverImages.length > 1 &&
                this.hoverImages.forEach((t) => {
                    (t.classList.remove(ls),
                        t.getAttribute(bs) === this.variant
                            ? t.classList.add(ls)
                            : this.hoverImages[0].classList.add(ls));
                }));
        }
        constructor(t) {
            ((this.element = t),
                (this.swatchLink = this.element.nextElementSibling),
                (this.colorString = t.getAttribute(ps)),
                (this.image = this.element.getAttribute(vs)),
                (this.imageId = this.element.getAttribute(ys)),
                (this.variant = this.element.getAttribute(fs)),
                (this.outer = this.element.closest(Qi)),
                (this.hoverImages = []));
            const e = new (class {
                getColor() {
                    return this.match;
                }
                init() {
                    return Se({ json: theme.assets.swatches })
                        .then((t) => this.matchColors(t, this.settings.color))
                        .catch((t) => {
                            (console.log("failed to load swatch colors script"),
                                console.log(t));
                        });
                }
                matchColors(t, e) {
                    let i = "#E5E5E5",
                        s = null;
                    const o = theme.assets.base || "/",
                        n = e.toLowerCase().replace(/\s/g, ""),
                        r = t.colors;
                    if (r) {
                        let t = null;
                        if (
                            r.filter((e, i) => {
                                if (
                                    Object.keys(e)
                                        .toString()
                                        .toLowerCase()
                                        .replace(/\s/g, "") === n
                                )
                                    return ((t = i), e);
                            }).length &&
                            null !== t
                        ) {
                            const e = Object.values(r[t])[0];
                            ((i = e),
                                (e.includes(".jpg") ||
                                    e.includes(".jpeg") ||
                                    e.includes(".png") ||
                                    e.includes(".svg")) &&
                                ((s = `${o}${e}`), (i = "#888888")));
                        }
                    }
                    return { color: this.settings.color, path: s, hex: i };
                }
                constructor(t = {}) {
                    ((this.settings = { ...Gi, ...t }), (this.match = this.init()));
                }
            })({ color: this.colorString });
            e.getColor().then((t) => {
                ((this.colorMatch = t), this.init());
            });
        }
    },
        ks = class extends HTMLElement {
            init() {
                ((this.swatchElements = this.querySelectorAll(Ki)),
                    this.swatchElements.forEach((t) => {
                        new Ls(t);
                    }),
                    this.handleShowMore());
            }
            handleShowMore() {
                ((this.initialHeight = this.offsetHeight),
                    (this.expandedHeight = this.initialHeight));
                const t = this.closest(es),
                    e = this.querySelector(ts);
                e &&
                    (null == e ||
                        e.addEventListener("click", () => {
                            this.classList.add(ds);
                        }),
                        null == t ||
                        t.addEventListener("touchstart", (t) => {
                            this.contains(t.target) ||
                                (this.classList.remove(ds),
                                    this.dispatchEvent(new Event("mouseleave", { bubbles: !0 })));
                        }),
                        this.addEventListener("mouseenter", () => {
                            const t = (e) => {
                                this.expandedHeight = this.offsetHeight;
                                const i = e.target.closest(rs);
                                (this.expandedHeight > this.initialHeight &&
                                    i &&
                                    requestAnimationFrame(() =>
                                        i.dispatchEvent(
                                            new CustomEvent("theme:slider:resize", { bubbles: !1 }),
                                        ),
                                    ),
                                    this.removeEventListener("animationstart", t));
                            };
                            this.addEventListener("animationstart", t);
                        }),
                        this.addEventListener("mouseleave", () => {
                            const t = (e) => {
                                const i = e.target.closest(rs);
                                (this.expandedHeight > this.initialHeight &&
                                    i &&
                                    requestAnimationFrame(() =>
                                        i.dispatchEvent(
                                            new CustomEvent("theme:slider:resize", { bubbles: !1 }),
                                        ),
                                    ),
                                    this.removeEventListener("animationstart", t));
                            };
                            this.addEventListener("animationstart", t);
                        }));
            }
            constructor() {
                (super(),
                    (this.handle = this.getAttribute(ms)),
                    (this.label = this.getAttribute(gs).trim().toLowerCase()),
                    (function (t) {
                        const e = `${theme.routes.root}products/${t}.js`;
                        return window
                            .fetch(e)
                            .then((t) => t.json())
                            .catch((t) => {
                                console.error(t);
                            });
                    })(this.handle).then((t) => {
                        ((this.product = t),
                            (this.colorOption = t.options.find(
                                (t) => t.name.toLowerCase() === this.label || null,
                            )),
                            this.colorOption &&
                            ((this.swatches = this.colorOption.values), this.init()));
                    }));
            }
        },
        As = class {
            checkSwatchesHeight(t) {
                const e = t.querySelector(ss),
                    i = t.querySelector(os),
                    s = parseInt(
                        window.getComputedStyle(t).getPropertyValue("padding-top"),
                    ),
                    o = parseInt(
                        window.getComputedStyle(e).getPropertyValue("margin-bottom"),
                    ),
                    n = parseInt(
                        window.getComputedStyle(i).getPropertyValue("margin-bottom"),
                    ),
                    r = t.closest(ns);
                (r.classList.remove(us),
                    t.offsetHeight - s >
                    e.offsetHeight + o + 2 * i.offsetHeight + 2 * n &&
                    (t.style.setProperty(
                        "--swatches-max-height",
                        `${t.offsetHeight}px`,
                    ),
                        r.classList.add(us)));
            }
            onUnload() {
                this.swatchesContainers.forEach((t) => {
                    document.removeEventListener(
                        "theme:resize:width",
                        this.checkSwatchesHeightOnResize,
                    );
                });
            }
            constructor(t) {
                ((this.container = t),
                    (this.swatchesContainers = this.container.querySelectorAll(is)),
                    this.swatchesContainers.forEach((t) => {
                        ((this.checkSwatchesHeightOnResize = () =>
                            this.checkSwatchesHeight(t)),
                            this.checkSwatchesHeight(t),
                            document.addEventListener(
                                "theme:resize:width",
                                this.checkSwatchesHeightOnResize,
                            ));
                    }));
            }
        };
    const Cs = (t) => {
        Ss = [];
        t.querySelectorAll(Ki).forEach((t) => {
            Ss.push(new Ls(t));
        });
    },
        qs = {
            onLoad() {
                Cs(this.container);
            },
        },
        Ts = {
            onLoad() {
                Es[this.id] = new As(this.container);
            },
            onUnload() {
                Es[this.id].onUnload();
            },
        },
        Ps = "[data-slider]",
        Is = "[data-product-media-container]",
        Fs = "[data-product-media-slideshow]",
        xs = "[data-product-media-slideshow-slide]",
        Hs = "[data-product-slideshow-progress]",
        Ds = ".flickity-button",
        Ms = "[data-product]",
        Os = "[data-popup-close]",
        Bs = "fill",
        _s = "js-quick-view-visible",
        $s = {};
    let zs = class {
        productGridSlideshow() {
            const t = this.container.querySelectorAll(Fs),
                i = this.container.querySelectorAll(Is);
            (t.length &&
                t.forEach((t) => {
                    const i = t.closest(Is),
                        s = i.querySelector(Hs),
                        o = t.querySelectorAll(xs).length,
                        n = 2200,
                        r = !this.sliders.length;
                    let a = new e.data(t),
                        l = 0,
                        c = xs;
                    !a.isActive &&
                        o > 1 &&
                        ((a = new e(t, {
                            draggable: r,
                            cellSelector: c,
                            contain: !0,
                            wrapAround: !0,
                            imagesLoaded: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pauseAutoPlayOnHover: !1,
                            selectedAttraction: 0.2,
                            friction: 1,
                            on: {
                                ready: () => {
                                    this.container.style.setProperty(
                                        "--autoplay-speed",
                                        "2200ms",
                                    );
                                },
                                change: () => {
                                    (l && clearTimeout(l),
                                        s.classList.remove(Bs),
                                        s.offsetWidth,
                                        requestAnimationFrame(() => {
                                            s.classList.add(Bs);
                                        }),
                                        (l = setTimeout(() => {
                                            s.classList.remove(Bs);
                                        }, n)));
                                },
                                dragEnd: () => {
                                    a.playPlayer();
                                },
                            },
                        })),
                            window.theme.touch ||
                            (i.addEventListener("mouseenter", () => {
                                (s.classList.add(Bs),
                                    l && clearTimeout(l),
                                    (l = setTimeout(() => {
                                        s.classList.remove(Bs);
                                    }, n)),
                                    (a.options.autoPlay = n),
                                    a.playPlayer());
                            }),
                                i.addEventListener("mouseleave", () => {
                                    (a.stopPlayer(), l && clearTimeout(l), s.classList.remove(Bs));
                                })));
                }),
                i.length &&
                i.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.target.matches(Ds) && t.preventDefault();
                    });
                }));
        }
        popupClose() {
            const t = document.querySelector(Ms);
            if (t) {
                t.querySelector(Os).dispatchEvent(new Event("click"));
            }
        }
        onBlockSelect() {
            this.body.classList.contains(_s) && this.popupClose();
        }
        onDeselect() {
            this.body.classList.contains(_s) && this.popupClose();
        }
        onUnload() {
            this.body.classList.contains(_s) && this.popupClose();
        }
        constructor(t) {
            ((this.container = t),
                (this.body = document.body),
                (this.sliders = this.container.querySelectorAll(Ps)),
                "slideshow" !== theme.settings.productGridHover ||
                window.theme.touch ||
                this.productGridSlideshow(),
                new pc(this.container));
        }
    };
    const Rs = {
        onLoad() {
            $s[this.id] = new zs(this.container);
        },
        onBlockSelect() {
            $s[this.id].onBlockSelect();
        },
        onDeselect() {
            $s[this.id].onDeselect();
        },
        onUnload() {
            $s[this.id].onUnload();
        },
    },
        Vs = "#AjaxinateLoop",
        Ns = "#AjaxinatePagination",
        Ws = "data-ajaxinate-id",
        Us = "is-loaded";
    let js = {},
        Gs = class {
            init() {
                (this.loadMoreFix(),
                    (this.ajaxinateContainer = this.container.querySelectorAll(Vs)),
                    this.ajaxinateContainer.forEach((t) => {
                        const e = `${Vs}[${Ws}="${t.dataset.ajaxinateId}"]`,
                            i = `${Ns}[${Ws}="${t.dataset.ajaxinateId}"]`;
                        if (t.children.length > 0) {
                            const o = new s({
                                container: e,
                                pagination: i,
                                method: "scroll",
                            });
                            (t.classList.add(Us), this.endlessScroll.push(o));
                        }
                    }));
            }
            update(t) {
                this.ajaxinateContainer = this.container.querySelectorAll(Vs);
                const e = (e) => e.settings.container === t,
                    i = this.endlessScroll.find(e);
                if (i) {
                    const t = this.endlessScroll.findIndex(e);
                    (this.endlessScroll.splice(t, 1),
                        (i.settings.method = "scroll"),
                        i.destroy());
                }
                const o = [...this.ajaxinateContainer].find(
                    (e) => `${Vs}[${Ws}="${e.dataset.ajaxinateId}"]` === t,
                );
                if (!o) return;
                const n = `${Vs}[${Ws}="${o.dataset.ajaxinateId}"]`,
                    r = `${Ns}[${Ws}="${o.dataset.ajaxinateId}"]`;
                if (!(o.children.length > 0)) return;
                const a = new s({ container: n, pagination: r, method: "scroll" });
                (o.classList.add(Us), this.endlessScroll.push(a));
            }
            loadMoreFix() {
                s.prototype.loadMore = function () {
                    ((this.request = new XMLHttpRequest()),
                        (this.request.onreadystatechange = function () {
                            if (!this.request.responseXML) return;
                            if (
                                4 === !this.request.readyState ||
                                200 === !this.request.status
                            )
                                return;
                            const t = this.request.responseXML.querySelector(
                                this.settings.container,
                            ),
                                e = this.request.responseXML.querySelector(
                                    this.settings.pagination,
                                );
                            (this.containerElement.insertAdjacentHTML(
                                "beforeend",
                                t.innerHTML,
                            ),
                                null == e
                                    ? this.removePaginationElement()
                                    : ((this.paginationElement.innerHTML = e.innerHTML),
                                        this.settings.callback &&
                                        "function" == typeof this.settings.callback &&
                                        this.settings.callback(this.request.responseXML),
                                        this.initialize()));
                        }.bind(this)),
                        this.request.open("GET", this.nextPageUrl, !0),
                        (this.request.responseType = "document"),
                        this.request.send());

                    //TEIK ADDED - Hide judge.me rating bade for page infinite onload
                    function hideZeroRatingBadges() {
                        const zeroRatingBadges = document.querySelectorAll('.jdgm-prev-badge[data-average-rating="0.00"]');

                        console.log(`[Judge.me debug] Found ${zeroRatingBadges.length} .jdgm-prev-badge elements with 0.00 rating`);

                        zeroRatingBadges.forEach((el, index) => {
                            console.log(`[Judge.me debug] Processing badge #${index + 1}`, el);

                            const parent = el.closest('.jdgm-widget.jdgm-preview-badge');
                            if (parent) {
                                parent.classList.add('jdgm-hidden');
                                parent.style.display = 'none'; // Optional: remove this line if you only want to use the class
                                console.log('[Judge.me debug] Set display: none and added class jdgm-hidden to parent');
                            } else {
                                console.warn('[Judge.me debug] Parent .jdgm-widget.jdgm-preview-badge not found for:', el);
                            }
                        });
                    }

                    // Initial run (in case any badges are already on the page)
                    hideZeroRatingBadges();

                    // Observe for new badges added dynamically
                    const observer = new MutationObserver((mutationsList) => {
                        for (const mutation of mutationsList) {
                            mutation.addedNodes.forEach((node) => {
                                if (
                                    node.nodeType === 1 &&
                                    node.matches &&
                                    node.matches('.jdgm-prev-badge[data-average-rating="0.00"]')
                                ) {
                                    console.log('[Judge.me debug] MutationObserver found new 0.00 badge:', node);
                                    hideZeroRatingBadges(); // Re-run for new badges
                                }

                                // In case they are deeply nested:
                                if (node.nodeType === 1 && node.querySelectorAll) {
                                    const nestedBadges = node.querySelectorAll('.jdgm-prev-badge[data-average-rating="0.00"]');
                                    if (nestedBadges.length > 0) {
                                        console.log(`[Judge.me debug] MutationObserver found ${nestedBadges.length} nested 0.00 badges`);
                                        hideZeroRatingBadges();
                                    }
                                }
                            });
                        }
                    });

                    observer.observe(document.body, {
                        childList: true,
                        subtree: true,
                    });

                    // END TEIK
                };
            }
            unload() {
                this.endlessScroll.length > 0 &&
                    (this.endlessScroll.forEach((t) => {
                        ((t.settings.method = "scroll"), t.destroy());
                    }),
                        this.ajaxinateContainer.forEach((t) => t.classList.remove(Us)));
            }
            constructor(t) {
                ((this.container = t),
                    (this.endlessScroll = []),
                    theme.settings.enableInfinityScroll && this.init());
            }
        };
    const Ks = {
        onLoad() {
            js = new Gs(this.container);
        },
        onUnload: function () {
            "function" == typeof js.unload && js.unload();
        },
    },
        Qs = 300,
        Xs = "[data-toggle-filters]",
        Ys = "[data-close-filters]",
        Js = "[data-open-filters]",
        Zs = "[data-collection-wrapper]",
        to = "[data-collapsible-trigger]",
        eo = "[data-sort-toggle]",
        io = "[data-collection-sort-options]",
        so = "[data-input-sort]",
        oo = "[data-collection-filters]",
        no = "[data-collection-filters-list]",
        ro = "[data-collection-sticky-bar]",
        ao = "[data-collection-filter]",
        lo = "[data-collection-filter-tag]",
        co = "[data-collection-filter-tag-button]",
        ho = "[data-collection-filters-form]",
        uo = "[data-filter-reset-button]",
        po = "[data-filter-tag-reset-button]",
        mo = '[data-section-type="popups"]',
        go = "[data-collection-products]",
        vo = "[data-products-count]",
        yo = "[data-field-price-min]",
        fo = "[data-field-price-max]",
        bo = "[data-se-min-value]",
        wo = "[data-se-max-value]",
        So = "data-se-min-value",
        Eo = "data-se-max-value",
        Lo = "data-se-min",
        ko = "data-se-max",
        Ao = "[data-tooltip]",
        Co = "[data-tooltip-container]",
        qo = "[data-show-more]",
        To = "[data-show-more-actions]",
        Po = "[data-show-more-container]",
        Io = "[data-show-more-trigger]",
        Fo = "[data-search-performed]",
        xo = "[data-search-form]",
        Ho = "[data-custom-scrollbar]",
        Do = "is-active",
        Mo = "is-expanded",
        Oo = "is-visible",
        Bo = "is-loading",
        _o = "popup--visible",
        $o = "collection__filters--visible",
        zo = "collection__sort__option-wrapper--visible",
        Ro = "data-filter-active",
        Vo = "data-prevent-scroll-lock",
        No = "data-filters-default-state",
        Wo = "tabindex",
        Uo = "aria-expanded",
        jo = "data-current-type",
        Go = {};
    let Ko = class {
        initFacetedFilters() {
            "tag" != this.filterMode &&
                "group" != this.filterMode &&
                this.enableFilters &&
                (this.rangeSlider = new (class {
                    init() {
                        if (
                            ((this.slider = this.container.querySelector(Ai)), !this.slider)
                        )
                            return;
                        ((this.resizeFilters = o(this.reset.bind(this), 50)),
                            (this.onMoveEvent = (t) => this.onMove(t)),
                            (this.onStopEvent = (t) => this.onStop(t)),
                            (this.onStartEvent = (t) => this.onStart(t)),
                            (this.startX = 0),
                            (this.x = 0),
                            (this.touchLeft = this.slider.querySelector(Ci)),
                            (this.touchRight = this.slider.querySelector(qi)),
                            (this.lineSpan = this.slider.querySelector(Ti)),
                            (this.min = parseFloat(this.slider.getAttribute(Ii))),
                            (this.max = parseFloat(this.slider.getAttribute(Fi))),
                            (this.step = 0),
                            (this.normalizeFact = 20));
                        let t = this.min;
                        this.slider.hasAttribute(xi) &&
                            (t = parseFloat(this.slider.getAttribute(xi)));
                        let e = this.max;
                        (this.slider.hasAttribute(Hi) &&
                            (e = parseFloat(this.slider.getAttribute(Hi))),
                            t < this.min && (t = this.min),
                            e > this.max && (e = this.max),
                            t > e && (t = e),
                            this.slider.getAttribute(Di) &&
                            (this.step = Math.abs(
                                parseFloat(this.slider.getAttribute(Di)),
                            )),
                            this.reset(),
                            window.addEventListener("theme:resize", this.resizeFilters),
                            (this.maxX =
                                this.slider.offsetWidth - this.touchRight.offsetWidth),
                            (this.selectedTouch = null),
                            (this.initialValue =
                                this.lineSpan.offsetWidth - this.normalizeFact),
                            this.setMinValue(t),
                            this.setMaxValue(e),
                            this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                            this.touchRight.addEventListener("mousedown", this.onStartEvent),
                            this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
                                passive: !0,
                            }),
                            this.touchRight.addEventListener(
                                "touchstart",
                                this.onStartEvent,
                                { passive: !0 },
                            ),
                            this.slider.classList.add(_i));
                    }
                    reset() {
                        ((this.touchLeft.style.left = "0px"),
                            (this.touchRight.style.left =
                                this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                            (this.lineSpan.style.marginLeft = "0px"),
                            (this.lineSpan.style.width =
                                this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                            (this.startX = 0),
                            (this.x = 0),
                            (this.maxX =
                                this.slider.offsetWidth - this.touchRight.offsetWidth),
                            (this.initialValue =
                                this.lineSpan.offsetWidth - this.normalizeFact));
                    }
                    setMinValue(t) {
                        const e = (t - this.min) / (this.max - this.min);
                        ((this.touchLeft.style.left =
                            Math.ceil(
                                e *
                                (this.slider.offsetWidth -
                                    (this.touchLeft.offsetWidth + this.normalizeFact)),
                            ) + "px"),
                            (this.lineSpan.style.marginLeft =
                                this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width =
                                this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.slider.setAttribute(xi, t));
                    }
                    setMaxValue(t) {
                        const e = (t - this.min) / (this.max - this.min);
                        ((this.touchRight.style.left =
                            Math.ceil(
                                e *
                                (this.slider.offsetWidth -
                                    (this.touchLeft.offsetWidth + this.normalizeFact)) +
                                this.normalizeFact,
                            ) + "px"),
                            (this.lineSpan.style.marginLeft =
                                this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width =
                                this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.slider.setAttribute(Hi, t));
                    }
                    onStart(t) {
                        t.preventDefault();
                        let e = t;
                        (t.touches && (e = t.touches[0]),
                            t.currentTarget === this.touchLeft
                                ? (this.x = this.touchLeft.offsetLeft)
                                : t.currentTarget === this.touchRight &&
                                (this.x = this.touchRight.offsetLeft),
                            (this.startX = e.pageX - this.x),
                            (this.selectedTouch = t.currentTarget),
                            document.addEventListener("mousemove", this.onMoveEvent),
                            document.addEventListener("mouseup", this.onStopEvent),
                            document.addEventListener("touchmove", this.onMoveEvent, {
                                passive: !0,
                            }),
                            document.addEventListener("touchend", this.onStopEvent, {
                                passive: !0,
                            }));
                    }
                    onMove(t) {
                        let e = t;
                        (t.touches && (e = t.touches[0]),
                            (this.x = e.pageX - this.startX),
                            this.selectedTouch === this.touchLeft
                                ? (this.x >
                                    this.touchRight.offsetLeft -
                                    this.selectedTouch.offsetWidth +
                                    10
                                    ? (this.x =
                                        this.touchRight.offsetLeft -
                                        this.selectedTouch.offsetWidth +
                                        10)
                                    : this.x < 0 && (this.x = 0),
                                    (this.selectedTouch.style.left = this.x + "px"))
                                : this.selectedTouch === this.touchRight &&
                                (this.x <
                                    this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                                    ? (this.x =
                                        this.touchLeft.offsetLeft +
                                        this.touchLeft.offsetWidth -
                                        10)
                                    : this.x > this.maxX && (this.x = this.maxX),
                                    (this.selectedTouch.style.left = this.x + "px")),
                            (this.lineSpan.style.marginLeft =
                                this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width =
                                this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.calculateValue(),
                            this.slider.getAttribute("on-change") &&
                            new Function("min, max", this.slider.getAttribute("on-change"))(
                                this.slider.getAttribute(xi),
                                this.slider.getAttribute(Hi),
                            ),
                            this.onChange(
                                this.slider.getAttribute(xi),
                                this.slider.getAttribute(Hi),
                            ));
                    }
                    onStop(t) {
                        (document.removeEventListener("mousemove", this.onMoveEvent),
                            document.removeEventListener("mouseup", this.onStopEvent),
                            document.removeEventListener("touchmove", this.onMoveEvent, {
                                passive: !0,
                            }),
                            document.removeEventListener("touchend", this.onStopEvent, {
                                passive: !0,
                            }),
                            (this.selectedTouch = null),
                            this.calculateValue(),
                            this.onChanged(
                                this.slider.getAttribute(xi),
                                this.slider.getAttribute(Hi),
                            ));
                    }
                    onChange(t, e) {
                        const i = this.slider.closest(Pi);
                        if (i) {
                            const s = i.querySelector(Oi),
                                o = i.querySelector(Bi);
                            s && o && ((s.value = parseInt(t)), (o.value = parseInt(e)));
                        }
                    }
                    onChanged(t, e) {
                        this.slider.hasAttribute(Mi) &&
                            this.slider.dispatchEvent(
                                new CustomEvent("theme:filter:range-update", { bubbles: !0 }),
                            );
                    }
                    calculateValue() {
                        const t =
                            (this.lineSpan.offsetWidth - this.normalizeFact) /
                            this.initialValue;
                        let e = this.lineSpan.offsetLeft / this.initialValue,
                            i = e + t;
                        if (
                            ((e = e * (this.max - this.min) + this.min),
                                (i = i * (this.max - this.min) + this.min),
                                0 !== this.step)
                        ) {
                            let t = Math.floor(e / this.step);
                            ((e = this.step * t),
                                (t = Math.floor(i / this.step)),
                                (i = this.step * t));
                        }
                        (this.selectedTouch === this.touchLeft &&
                            this.slider.setAttribute(xi, e),
                            this.selectedTouch === this.touchRight &&
                            this.slider.setAttribute(Hi, i));
                    }
                    unload() {
                        (document.removeEventListener(
                            "theme:filters:init",
                            this.initListener,
                        ),
                            window.removeEventListener("theme:resize", this.resizeFilters));
                    }
                    constructor(t) {
                        ((this.container = t),
                            this.init(),
                            (this.initListener = () => this.init()),
                            document.addEventListener(
                                "theme:filters:init",
                                this.initListener,
                            ));
                    }
                })(this.container));
        }
        initTooltips() {
            var t, e;
            ((this.tooltips = this.container.querySelectorAll(Ao)),
                window.innerWidth < theme.sizes.small) &&
                (this.tooltips =
                    null === (e = this.productGrid) || void 0 === e
                        ? void 0
                        : e.querySelectorAll(Ao));
            (null === (t = this.tooltips) ||
                void 0 === t ||
                t.forEach((t) => {
                    new Li(t);
                }),
                this.handleVisibleTooltips());
        }
        handleVisibleTooltips() {
            if (this.tooltips.length > 0) {
                const t = document.querySelector(Co);
                t.classList.contains(Oo) && t.classList.remove(Oo);
            }
        }
        updateRange() {
            const t = this.filtersForm.querySelector(bo),
                e = this.filtersForm.querySelector(wo),
                i = this.filtersForm.querySelector(yo),
                s = this.filtersForm.querySelector(fo);
            if (t.hasAttribute(So) && e.hasAttribute(Eo)) {
                const o = parseFloat(i.placeholder, 10),
                    n = parseFloat(s.placeholder, 10),
                    r = parseFloat(t.getAttribute(So), 10),
                    a = parseFloat(e.getAttribute(Eo), 10);
                (o === r && n === a) ||
                    ((i.value = parseInt(r)),
                        (s.value = parseInt(a)),
                        this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
            }
        }
        onSubmitHandler(t) {
            t.preventDefault();
            const e = new FormData(this.filtersForm),
                i = new URLSearchParams(e),
                s = [];
            let o = "";
            this.isSearchPage &&
                ((this.searchForm = this.container.querySelector(xo)),
                    (this.currentType = this.container.getAttribute(jo)));
            const n = this.filtersForm.querySelector(bo),
                r = this.filtersForm.querySelector(wo),
                a = this.filtersForm.querySelector(yo),
                l = this.filtersForm.querySelector(fo);
            if (n && r && a && l && n.hasAttribute(Lo) && r.hasAttribute(ko)) {
                const t = parseFloat(n.getAttribute(Lo), 10),
                    e = parseFloat(r.getAttribute(ko), 10),
                    o = a.value ? parseFloat(a.value, 10) : t,
                    c = l.value ? parseFloat(l.value, 10) : e;
                o <= t &&
                    c >= e &&
                    (s.push("filter.v.price.gte"),
                        s.push("filter.v.price.lte"),
                        i.delete("filter.v.price.gte"),
                        i.delete("filter.v.price.lte"));
            }
            if (((o = i.toString()), this.isSearchPage)) {
                o = oi(this.searchForm, this.filtersForm, s);
                let t = "";
                ("all" === this.currentType && (t = "&type=product"),
                    o.indexOf("&type=product") > -1 && (t = ""),
                    (o += t));
            }
            this.renderSection(o, t);
        }
        onHistoryChange(t) {
            var e;
            if (!this.filters) return;
            let i =
                (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) ||
                "";
            if (this.isSearchPage) {
                t.state || (i = window.location.search);
                if (!(i.indexOf("type=product") > -1)) return;
            }
            this.renderSection(i, null, !1);
        }
        renderSection(t, e, i = !0) {
            this.startLoading();
            const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
                o = (t) => t.url === s;
            (this.filterData.some(o)
                ? this.renderSectionFromCache(o, e)
                : this.renderSectionFromFetch(s, e),
                i && this.updateURLHash(t));
        }
        renderSectionFromFetch(t) {
            fetch(t)
                .then((t) => t.text())
                .then((e) => {
                    const i = e;
                    ((this.filterData = [...this.filterData, { html: i, url: t }]),
                        (this.inputSort = this.container.querySelectorAll(so)),
                        this.renderFilters(i),
                        this.bindFilterButtonsEvents(),
                        this.hideFiltersOnMobile(),
                        this.renderProductGrid(i),
                        this.updateProductsCount(i),
                        this.finishLoading(),
                        this.mobileFiltersScrollLock(),
                        this.handleSearchPageActiveTab());
                });
        }
        renderSectionFromCache(t, e) {
            const i = this.filterData.find(t).html;
            (this.renderFilters(i, e),
                this.hideFiltersOnMobile(),
                this.renderProductGrid(i),
                this.updateProductsCount(i),
                this.finishLoading(),
                this.mobileFiltersScrollLock(),
                this.handleSearchPageActiveTab());
        }
        handleSearchPageActiveTab() {
            this.isSearchPage &&
                ((this.scrollable = this.container.querySelector(Ho)),
                    this.scrollable &&
                    !this.customScrollbar &&
                    (this.customScrollbar = new ci(this.container)));
        }
        // renderProductGrid(t) {
        //     const e = new DOMParser()
        //         .parseFromString(t, "text/html")
        //         .querySelector(go);
        //     e &&
        //         ((this.productGrid.innerHTML = e.innerHTML),
        //             this.initProductGridEvents(theme.settings.enableInfinityScroll),
        //             this.filterShowMore());
        // }
        // TEIK UPDATED FILTER HERE FOR JUDGE.ME STAR BADGE
        renderProductGrid(t) {
            const e = new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector(go);

            if (e) {
                this.productGrid.innerHTML = e.innerHTML;
                this.initProductGridEvents(theme.settings.enableInfinityScroll);
                this.filterShowMore();

                // ✅ Update Judge.me review badge
                const badges = document.querySelectorAll('.jdgm-prev-badge');
                badges.forEach((badge) => {
                    const score = badge.querySelector('.jdgm-prev-badge__stars')?.dataset.score;
                    const reviewCount = badge.dataset.numberOfReviews;
                    const wrapper = badge.closest('.jdgm-widget.jdgm-preview-badge');

                    if (reviewCount === "0" && wrapper) {
                        wrapper.style.display = "none";
                        return;
                    }

                    if (score && reviewCount && wrapper) {
                        const textSpan = badge.querySelector('.jdgm-prev-badge__text');
                        if (textSpan) {
                            textSpan.textContent = `${parseFloat(score).toFixed(1)} (${reviewCount} reviews)`;
                            wrapper.style.display = "";
                        }
                    }
                });

                // 🧱 Rebuild Macy layout
                if (typeof window.destroyMacy === 'function') {
                    window.destroyMacy();
                }

                // Wait a moment to let DOM settle, then init Macy again
                setTimeout(() => {
                    const container = document.querySelector('.teik-testing');

                    console.log("🔍 Found Macy container:", container);

                    if (container && window.innerWidth <= 768 && typeof window.initMacy === 'function') {
                        console.log('🔁 Reinitializing Macy...');
                        window.initMacy();
                    } else {
                        console.warn("⚠️ Cannot reinit Macy — init function missing or not on mobile.");
                    }
                }, 300);
            }
        }
        // END
        updateProductsCount(t) {
            const e = new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector(vo);
            e && (this.productsCount.innerHTML = e.innerHTML);
        }
        renderFilters(t) {
            const e = new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector(oo);
            e &&
                ((this.filters.innerHTML = e.innerHTML),
                    (this.filtersForm = document.querySelector(ho)),
                    this.bindFilterButtonsEvents(),
                    this.bindToggleButtonsEvents(),
                    Cs(this.container),
                    (this.collapsible = new ce(this.container)),
                    document.dispatchEvent(
                        new CustomEvent("theme:filters:init", { bubbles: !0 }),
                    ));
        }
        updateURLHash(t) {
            history.pushState(
                { searchParams: t },
                "",
                `${window.location.pathname}${t && "?".concat(t)}`,
            );
        }
        bindFilterButtonsEvents() {
            (this.inputSort.length > 0 &&
                this.inputSort.forEach((t) => {
                    t.addEventListener("change", this.updateCollectionFormSortEvent);
                }),
                this.filtersForm &&
                (this.filtersForm.addEventListener(
                    "input",
                    this.debouncedSubmitEvent.bind(this),
                ),
                    this.filtersForm.addEventListener(
                        "theme:filter:range-update",
                        this.updateRangeEvent,
                    )),
                this.collectionSortOptions &&
                this.collectionSortOptions.addEventListener(
                    "keyup",
                    this.onTabHandlerEvent,
                ),
                "tag" != this.filterMode &&
                "group" != this.filterMode &&
                this.enableFilters &&
                this.container.querySelectorAll(uo).forEach((t) => {
                    t.addEventListener("click", this.onFilterResetClick, { once: !0 });
                }));
        }
        onFilterResetClick(t) {
            (t.preventDefault(),
                this.renderSection(
                    new URL(t.currentTarget.href).searchParams.toString(),
                ));
        }
        bindToggleButtonsEvents() {
            var t;
            (this.container.querySelectorAll(Xs).forEach((t) => {
                t.addEventListener("click", this.onFilterToggleClick);
            }),
                this.container.querySelectorAll(Ys).forEach((t) => {
                    t.addEventListener("click", this.hideFiltersDrawer);
                }),
                this.container.querySelectorAll(Js).forEach((t) => {
                    t.addEventListener("click", this.showFiltersDrawer);
                }),
                null === (t = this.container.querySelector(Zs)) ||
                void 0 === t ||
                t.addEventListener("keyup", this.onKeyUpHandler));
        }
        onTabHandler(t) {
            if (
                t.code === theme.keyboardKeys.SPACE ||
                t.code === theme.keyboardKeys.ENTER ||
                t.code === theme.keyboardKeys.NUMPADENTER
            ) {
                const e = t.target.previousElementSibling.value;
                (this.filtersForm.querySelectorAll(so).forEach((t) => {
                    (t.checked && (t.checked = !1), t.value === e && (t.checked = !0));
                }),
                    this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })),
                    t.target.dispatchEvent(new Event("click", { bubbles: !0 })));
            }
        }
        onKeyUpHandler(t) {
            t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
        }
        onFilterToggleClick(t) {
            (t.preventDefault(), P());
            this.filters.classList.contains($o)
                ? this.hideFiltersDrawer()
                : this.showFiltersDrawer();
        }
        sortDropdownToggle() {
            this.collectionSortOptions &&
                this.collectionSortOptions.classList.toggle(zo);
        }
        bodyClick(t) {
            if (!this.collectionSortOptions) return;
            const e = this.sortToggle.contains(t.target);
            this.collectionSortOptions.classList.contains(zo) &&
                !e &&
                this.sortDropdownToggle();
        }
        updateCollectionFormSort(t) {
            const e = t.target,
                i = e.value,
                s = e.closest(io);
            (this.container.querySelectorAll(so).forEach((t) => {
                t.value === i && (t.checked = !0);
            }),
                null !== s &&
                this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
        }
        showFiltersDrawer() {
            ((this.a11y.state.trigger = document.querySelector(Xs)),
                this.a11y.trapFocus({ container: this.filters }),
                this.mobileFiltersScrollLock());
        }
        mobileFiltersScrollLock() {
            if (window.innerWidth < theme.sizes.small) {
                const t = document.querySelector(no);
                (this.filters.classList.contains($o) || this.filters.classList.add($o),
                    document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t }),
                    ));
            }
        }
        hideFiltersOnMobile() {
            const t = this.container.querySelectorAll(`${to}:not(${Io})`);
            window.innerWidth < theme.sizes.small &&
                requestAnimationFrame(() => {
                    t.forEach((t) => {
                        const e = "true" === t.getAttribute(Ro);
                        t.classList.contains(Mo) &&
                            !e &&
                            t.dispatchEvent(new Event("click"));
                    });
                });
        }
        showFiltersOnDesktop() {
            const t = this.container.querySelectorAll(`${to}:not(${Io})`),
                e = this.container.getAttribute(No),
                i = "first-open" === e,
                s = "open" === e,
                o = "closed" === e,
                n = this.enableSorting ? 1 : 0;
            t.forEach((t, e) => {
                const r = t.classList.contains(Mo),
                    a = "true" === t.getAttribute(Ro),
                    l = a && !r && s;
                (a && !l) ||
                    (((o && r) ||
                        (i && !r && e === n) ||
                        (i && r && e !== n) ||
                        (s && !r) ||
                        l) &&
                        t.dispatchEvent(new Event("click")));
            });
        }
        hideFiltersDrawer() {
            let t = this.filters.classList.contains($o),
                e = this.container.classList.contains(Bo);
            (t && (this.filters.classList.remove($o), this.a11y.removeTrapFocus()),
                e ||
                document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Qs }),
                ));
        }
        filtersResizeEvents() {
            window.innerWidth >= theme.sizes.small
                ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer())
                : this.hideFiltersOnMobile();
        }
        filterShowMore() {
            ((this.showMore = this.container.querySelectorAll(qo)),
                0 !== this.showMore.length &&
                this.showMore.forEach((t) => {
                    const e = t.querySelector(to),
                        i = t.querySelector(To);
                    if (!i) return;
                    const s = i.querySelector(Io),
                        o = i.querySelector(Po),
                        n = o.querySelectorAll(window.theme.focusable);
                    ("true" === o.getAttribute(Uo) ||
                        n.forEach((t) => {
                            t.setAttribute(Wo, "-1");
                        }),
                        s.addEventListener("keyup", (t) => {
                            (t.code !== theme.keyboardKeys.SPACE &&
                                t.code !== theme.keyboardKeys.ENTER &&
                                t.code !== theme.keyboardKeys.NUMPADENTER) ||
                                this.updateShowMoreFocusableElements(t, n);
                        }),
                        s.addEventListener("click", (t) => {
                            this.updateShowMoreFocusableElements(t, n);
                        }),
                        e.addEventListener("keyup", (t) => {
                            (t.code !== theme.keyboardKeys.SPACE &&
                                t.code !== theme.keyboardKeys.ENTER &&
                                t.code !== theme.keyboardKeys.NUMPADENTER) ||
                                this.updateCollapsedContainerFocusableElements(e, s, n);
                        }),
                        e.addEventListener("click", () => {
                            this.updateCollapsedContainerFocusableElements(e, s, n);
                        }));
                }));
        }
        updateCollapsedContainerFocusableElements(t, e, i) {
            requestAnimationFrame(() => {
                const s = "true" === t.getAttribute(Uo),
                    o = "true" === e.getAttribute(Uo);
                i.forEach((t) => {
                    (!s && o && t.setAttribute(Wo, "-1"),
                        s && o && t.removeAttribute(Wo));
                });
            });
        }
        updateShowMoreFocusableElements(t, e) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    const i = "true" === t.target.getAttribute(Uo);
                    e.forEach((t, e) => {
                        if (i) return (t.removeAttribute(Wo), void (0 === e && t.focus()));
                        t.setAttribute(Wo, "-1");
                    });
                });
            });
        }
        initTagFilters() {
            ("tag" != this.filterMode && "group" != this.filterMode) ||
                !this.enableFilters ||
                ((this.tags = this.container.dataset.tags.split("+").filter((t) => t)),
                    this.bindFilterTagButtonsEvents(),
                    this.bindSortChangeEvent());
        }
        renderTagFiltersProducts(t) {
            (this.startLoading(),
                "object" == typeof this.endlessCollection &&
                this.endlessCollection.unload(),
                fetch(t)
                    .then((t) => t.text())
                    .then((e) => {
                        const i = e,
                            s = new DOMParser().parseFromString(i, "text/html"),
                            o = s.querySelector(go).innerHTML,
                            n = s.querySelector(oo).innerHTML;
                        ((this.productGrid.innerHTML = o),
                            (this.filters.innerHTML = n),
                            (this.inputSort = this.container.querySelectorAll(so)),
                            (this.filtersForm = document.querySelector(ho)),
                            (this.filterData = [...this.filterData, { html: i, url: t }]),
                            (this.alreadyClicked = !1),
                            this.bindFilterTagButtonsEvents(),
                            this.bindFilterButtonsEvents(),
                            this.bindSortChangeEvent(),
                            this.bindToggleButtonsEvents(),
                            this.initProductGridEvents(theme.settings.enableInfinityScroll),
                            this.updateProductsCount(i),
                            this.mobileFiltersScrollLock(),
                            this.hideFiltersOnMobile(),
                            Cs(this.container),
                            (this.collapsible = new ce(this.container)),
                            this.filterShowMore(),
                            history.replaceState &&
                            window.history.pushState({ path: t }, "", t));
                    })
                    .catch((t) => {
                        (this.finishLoading(), console.log(`Error: ${t}`));
                    }));
        }
        bindFilterTagButtonsEvents() {
            (this.container.querySelectorAll(co).forEach((t) => {
                t.addEventListener("click", this.onFilterTagButtonClick.bind(this));
            }),
                this.container.querySelectorAll(po).forEach((t) => {
                    t.addEventListener("click", this.onFilterTagClearClick);
                }),
                this.container.querySelectorAll(uo).forEach((t) => {
                    t.addEventListener("click", this.onFilterTagResetClick);
                }));
        }
        bindSortChangeEvent() {
            this.container.querySelectorAll(so).forEach((t) => {
                t.addEventListener("input", this.debouncedSortEvent.bind(this));
            });
        }
        onFilterTagButtonClick(t) {
            if ((t.preventDefault(), this.alreadyClicked)) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget,
                i = e.dataset.tag;
            if (e.parentNode.classList.contains(Do)) {
                let t = this.tags.indexOf(i);
                (e.parentNode.classList.remove(Do), t > -1 && this.tags.splice(t, 1));
            } else (e.parentNode.classList.add(Do), this.tags.push(i));
            let s =
                this.collectionHandle +
                "/" +
                this.tags.join("+") +
                "?sort_by=" +
                this.getSortValue();
            (this.container.querySelector(ao).classList.remove(Mo),
                this.container.querySelector(ao).setAttribute(Uo, !1),
                this.container.setAttribute("data-tags", "[" + this.tags + "]"),
                this.renderTagFiltersProducts(s));
        }
        onFilterTagClearClick(t) {
            if ((t.preventDefault(), this.alreadyClicked)) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget.dataset.tag,
                i = this.tags.indexOf(e);
            i > -1 && this.tags.splice(i, 1);
            const s =
                this.collectionHandle +
                "/" +
                this.tags.join("+") +
                "?sort_by=" +
                this.getSortValue();
            (this.container.setAttribute("data-tags", "[" + this.tags + "]"),
                this.renderTagFiltersProducts(s));
        }
        onSortChange() {
            let t =
                this.collectionHandle +
                "/" +
                this.tags.join("+") +
                "?sort_by=" +
                this.getSortValue();
            this.renderTagFiltersProducts(t);
        }
        getSortValue() {
            let t = "";
            return (
                this.inputSort.forEach((e) => {
                    e.checked && (t = e.value);
                }),
                t
            );
        }
        onFilterTagResetClick(t) {
            if ((null == t || t.preventDefault(), this.alreadyClicked)) return;
            ((this.alreadyClicked = !0),
                this.container.querySelectorAll(lo).forEach((t) => {
                    t.classList.remove(Do);
                }),
                this.container.querySelectorAll(ao).forEach((t) => {
                    (t.classList.remove(Mo), t.setAttribute(Uo, !1));
                }),
                (this.tags = []),
                this.container.setAttribute("data-tags", ""));
            let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(e);
        }
        getProductsOffsetTop() {
            return (
                this.productGrid.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                this.filtersStickyBar.offsetHeight
            );
        }
        getStickyBarOffsetTop() {
            return (
                this.filtersStickyBar.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top
            );
        }
        initProductGridEvents(t) {
            if (t)
                return (this.initInfinityScroll(), void this.initProductGridEvents(!1));
            ((this.productGridEvents = new zs(this.container)),
                this.initTooltips(),
                setTimeout(() => {
                    this.finishLoading();
                }, 1.5 * Qs));
        }
        initInfinityScroll() {
            if (this.isSearchPage) {
                if (!this.enableFilters) return;
                document.dispatchEvent(
                    new CustomEvent("theme:tab:ajaxinate", {
                        bubbles: !0,
                        detail: "product",
                    }),
                );
            } else
                ("object" == typeof this.endlessCollection &&
                    this.endlessCollection.unload(),
                    (this.endlessCollection = new Gs(this.container)),
                    0 !== this.endlessCollection.endlessScroll.length &&
                    (this.endlessCollection.endlessScroll[0].settings.callback = () =>
                        this.initProductGridEvents(!1)));
        }
        startLoading() {
            (this.container.classList.add(Bo),
                window.innerWidth >= theme.sizes.small &&
                document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", { bubbles: !0 }),
                ));
            let t = this.getProductsOffsetTop();
            window.scrollTo({ top: t, left: 0, behavior: "smooth" });
        }
        finishLoading() {
            const t = document.querySelectorAll(`${mo} .${_o}`),
                e = t.length > 0;
            if ((this.container.classList.remove(Bo), e)) {
                let e = 0;
                ([...t].forEach((t) => {
                    t.hasAttribute(Vo) && (e += 1);
                }),
                    e === t.length &&
                    document.dispatchEvent(
                        new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0,
                            detail: Qs,
                        }),
                    ));
            } else
                window.innerWidth >= theme.sizes.small &&
                    document.dispatchEvent(
                        new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Qs }),
                    );
        }
        onDeselect() {
            this.productGridEvents && this.productGridEvents.onDeselect();
        }
        onUnload() {
            ("object" == typeof this.endlessCollection &&
                this.endlessCollection.unload(),
                this.productGridEvents && this.productGridEvents.onUnload(),
                this.collapsible && this.collapsible.onUnload(),
                this.rangeSlider && this.rangeSlider.unload(),
                this.filters &&
                document.removeEventListener("theme:resize:width", this.resizeEvent),
                document.removeEventListener("click", this.bodyClickEvent),
                this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
                this.finishLoading());
        }
        constructor(t) {
            var e;
            ((this.container = t),
                (this.sectionId = t.dataset.sectionId),
                (this.enableFilters = "true" === t.dataset.enableFilters),
                (this.enableSorting = "true" === t.dataset.enableSorting),
                (this.filterMode = t.dataset.filterMode),
                (this.collectionHandle = this.container.dataset.collection),
                (this.isSearchPage = null != t.closest(Fo)),
                (this.productGrid = this.container.querySelector(go)),
                (this.productsCount = this.container.querySelector(vo)),
                (this.groupTagFilters = this.container.querySelectorAll(ao)),
                (this.filters = this.container.querySelector(oo)),
                (this.filterTriggers = this.container.querySelectorAll(to)),
                (this.filtersStickyBar = this.container.querySelector(ro)),
                (this.filtersForm = this.container.querySelector(ho)),
                (this.inputSort = this.container.querySelectorAll(so)),
                (this.sortToggle = this.container.querySelector(eo)),
                (this.collectionSortOptions = this.container.querySelector(io)),
                (this.a11y = be),
                (this.filterData = []),
                (this.rangeSlider = null),
                (this.sortDropdownEvent = () => this.sortDropdownToggle()),
                (this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
                (this.updateCollectionFormSortEvent = (t) =>
                    this.updateCollectionFormSort(t)),
                (this.bodyClickEvent = (t) => this.bodyClick(t)),
                (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
                (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
                (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
                (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
                (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
                (this.updateRangeEvent = this.updateRange.bind(this)),
                (this.debouncedSubmitEvent = o((t) => {
                    this.onSubmitHandler(t);
                }, 500)),
                (this.debouncedSortEvent = o((t) => {
                    this.onSortChange(t);
                }, 500)),
                (this.productGridEvents = {}),
                this.filters &&
                ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
                    (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
                    (this.resizeEvent = o(() => {
                        this.filtersResizeEvents();
                    }, 500)),
                    this.filtersResizeEvents(),
                    document.addEventListener("theme:resize:width", this.resizeEvent)),
                this.initTagFilters(),
                this.initFacetedFilters(),
                this.bindToggleButtonsEvents(),
                this.bindFilterButtonsEvents(),
                this.initProductGridEvents(theme.settings.enableInfinityScroll),
                Cs(this.container),
                (this.collapsible = new ce(this.container)),
                P(),
                window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                null === (e = this.sortToggle) ||
                void 0 === e ||
                e.addEventListener("click", this.sortDropdownEvent),
                document.addEventListener("click", this.bodyClickEvent),
                this.filterShowMore());
        }
    };
    const Qo = {
        onLoad() {
            Go[this.id] = new Ko(this.container);
        },
        onDeselect() {
            Go[this.id].onDeselect();
        },
        onUnload() {
            Go[this.id].onUnload();
        },
    },
        Xo = "[data-aos]",
        Yo = "[data-tabs-link]",
        Jo = "[data-tab]",
        Zo = "[data-tab-ref]",
        tn = "[data-custom-scrollbar]",
        en = "[data-custom-scrollbar-holder]",
        sn = "[data-slider]",
        on = "[data-tabs-contents]",
        nn = "[data-search-form]",
        rn = "[data-all-types-container]",
        an = "[data-collection-filters-form]",
        ln = "[data-current-page]",
        cn = "[data-tooltip]",
        hn = "[data-collection-products]",
        dn = "#AjaxinateLoop",
        un = "current",
        pn = "hide",
        mn = "alt",
        gn = "aos-animate",
        vn = "is-loaded",
        yn = "data-tabs-link",
        fn = "data-tab",
        bn = "data-tab-ref",
        wn = "data-start-index",
        Sn = "data-search-performed",
        En = "data-type",
        Ln = "data-current-type",
        kn = "data-all-types",
        An = "data-current-page",
        Cn = "data-ajaxinate-id",
        qn = {};
    let Tn = class {
        assignSearchPageArguments() {
            this.isSearchPage &&
                ((this.searchForm = this.container.querySelector(nn)),
                    (this.searchFormData = new FormData(this.searchForm)),
                    (this.searchTerm = encodeURIComponent(this.searchFormData.get("q"))),
                    (this.currentType = this.container.getAttribute(Ln)),
                    (this.sectionId = this.container.dataset.sectionId),
                    (this.searchForAllTypes = "true" === this.container.getAttribute(kn)),
                    (this.fetchURL = ""),
                    (this.searchParams = ""),
                    (this.cachedResults = {}),
                    this.handleTabsHistory(),
                    this.infiniteScrollListener(),
                    this.initInfinityScroll(this.currentType));
        }
        init() {
            const t = this.container.querySelectorAll(Yo),
                e = this.container.querySelector(
                    `[${yn}="${this.container.hasAttribute(wn) ? this.container.getAttribute(wn) : 0}"]`,
                ),
                i = this.container.querySelector(
                    `[${fn}="${this.container.hasAttribute(wn) ? this.container.getAttribute(wn) : 0}"]`,
                );
            (null == i || i.classList.add(un),
                null == e || e.classList.add(un),
                this.checkVisibleTabsLinks(),
                t.forEach((t) => {
                    this.handleTabsNavListeners(t);
                }));
        }
        handleTabsHistory() {
            (window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                (this.openTabFromHistoryEvent = (t) => this.openTabFromHistory(t)),
                this.tabsLink.forEach((t) => {
                    t.addEventListener(
                        "theme:tab:open-from-history",
                        this.openTabFromHistoryEvent,
                    );
                }));
        }
        handleTabsNavListeners(t) {
            const e = t.getAttribute(yn),
                i = this.container.querySelector(`[${fn}="${e}"]`);
            i &&
                (t.addEventListener("click", (e) => {
                    (this.isSearchPage && this.handleURLSearchParams(e, !0),
                        this.tabChange(t, i));
                }),
                    t.addEventListener("keyup", (e) => {
                        (e.code !== theme.keyboardKeys.SPACE &&
                            e.code !== theme.keyboardKeys.ENTER &&
                            e.code !== theme.keyboardKeys.NUMPADENTER) ||
                            (this.isSearchPage && this.handleURLSearchParams(e, !0),
                                this.tabChange(t, i));
                    }));
        }
        openTabFromHistory(t) {
            const e = t.target,
                i = this.container.querySelector(t.detail.element).getAttribute(yn),
                s = this.container.querySelector(`[${fn}="${i}"]`);
            s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s));
        }
        handleURLSearchParams(t, e = !0) {
            const i = t.target.matches(Yo) ? t.target : t.target.closest(Yo),
                s = i.getAttribute(En),
                o = i.getAttribute(yn),
                n = this.container.querySelector(`[${fn}="${o}"]`).querySelector(ln),
                r = document.querySelector(an);
            let a = n ? `&page=${n.getAttribute(An)}` : "";
            if (
                ((this.searchParams = oi(this.searchForm, r, [], s)), "product" === s)
            ) {
                const t = this.searchParams.replace("&type=product", "");
                this.searchParams = `${t}&type=product`;
            } else this.searchParams = `q=${this.searchTerm}&type=${s}`;
            (theme.settings.enableInfinityScroll ||
                "" === a ||
                (this.searchParams += a),
                (this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
                e &&
                history.pushState(
                    { searchParams: this.searchParams },
                    "",
                    `${window.location.pathname}${this.searchParams && "?".concat(this.searchParams)}`,
                ));
        }
        tabChangeFetchContent(t, e) {
            const i = t.getAttribute(En),
                s = t.getAttribute(yn),
                o = this.container.querySelector(`[${fn}="${s}"]`),
                n = this.currentType === i;
            if (this.cachedResults[s] || n)
                return (
                    "product" !== i ||
                    this.searchFilters ||
                    (this.searchFilters = new Ko(this.container)),
                    void requestAnimationFrame(() => {
                        (this.handleActiveTabClasses(t, e),
                            this.scrollToCurrentTabLink(t),
                            this.triggerTabAnimations(e),
                            this.checkVisibleTabsLinks(),
                            this.updateAjaxify(e, i));
                    })
                );
            fetch(this.fetchURL)
                .then((t) => {
                    if (!t.ok) {
                        throw new Error(t.status);
                    }
                    return t.text();
                })
                .then((n) => {
                    const r = new DOMParser()
                        .parseFromString(n, "text/html")
                        .querySelector(`[${fn}="${s}"]`).innerHTML;
                    var a;
                    this.searchForAllTypes &&
                        (null === (a = this.container.querySelector(rn)) ||
                            void 0 === a ||
                            a.remove());
                    ((this.cachedResults[s] = r),
                        (o.innerHTML = r),
                        "product" !== i ||
                        this.searchFilters ||
                        (this.searchFilters = new Ko(this.container)),
                        requestAnimationFrame(() => {
                            (this.handleActiveTabClasses(t, e),
                                this.scrollToCurrentTabLink(t),
                                this.triggerTabAnimations(e),
                                this.checkVisibleTabsLinks(),
                                this.initInfinityScroll(i));
                        }));
                })
                .catch((t) => {
                    throw t;
                });
        }
        onHistoryChange(t) {
            var e;
            const i =
                (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) ||
                window.location.search,
                s = i.indexOf("type=product") > -1,
                o = i.indexOf("type=article") > -1,
                n = i.indexOf("type=page") > -1,
                r = s || o || n,
                a = this.container.querySelector(`${Yo}[${En}="product"]`),
                l = this.container.querySelector(`${Yo}[${En}="article"]`),
                c = this.container.querySelector(`${Yo}[${En}="page"]`);
            r
                ? (s &&
                    (null == a ||
                        a.dispatchEvent(
                            new CustomEvent("theme:tab:open-from-history", {
                                bubbles: !0,
                                detail: { element: `[${En}="product"]` },
                            }),
                        )),
                    o &&
                    (null == l ||
                        l.dispatchEvent(
                            new CustomEvent("theme:tab:open-from-history", {
                                bubbles: !0,
                                detail: { element: `[${En}="article"]` },
                            }),
                        )),
                    n &&
                    (null == c ||
                        c.dispatchEvent(
                            new CustomEvent("theme:tab:open-from-history", {
                                bubbles: !0,
                                detail: { element: `[${En}="page"]` },
                            }),
                        )))
                : (window.location = i);
        }
        initCustomScrollbar() {
            this.scrollable &&
                !this.customScrollbar &&
                (this.customScrollbar = new ci(this.container));
        }
        infiniteScrollListener() {
            theme.settings.enableInfinityScroll &&
                ((this.ajaxifyFromFiltersEvent = (t) => this.ajaxifyFromFilters(t)),
                    document.addEventListener(
                        "theme:tab:ajaxinate",
                        this.ajaxifyFromFiltersEvent,
                    ));
        }
        ajaxifyFromFilters(t) {
            this.initInfinityScroll(t.detail);
        }
        initInfinityScroll(t) {
            if (!theme.settings.enableInfinityScroll) return;
            if (0 === this.container.querySelectorAll(dn).length) return;
            const e = this.container.querySelector(`${Jo}.${un}`),
                i = null == e ? void 0 : e.querySelector(dn),
                s = null == i ? void 0 : i.classList.contains(vn);
            e
                ? (!i &&
                    this.endlessCollection &&
                    this.updateAjaxinateInstancesSettings(t),
                    i && !s && this.initAjaxyfy(t))
                : this.initAjaxyfy(t);
        }
        updateAjaxinateInstancesSettings(t) {
            setTimeout(() => {
                if (0 === this.endlessCollection.endlessScroll.length) return;
                [...this.endlessCollection.endlessScroll].forEach((t) => {
                    const e = t.containerElement,
                        i = [...this.tab].find((t) => t.classList.contains(un));
                    !(null !== e.closest(`${Jo}.${un}`)) &&
                        i &&
                        (t.settings.method = "click");
                });
                const e = () => this.initProductGridEvents();
                if ("product" === t || "all" === t) {
                    const t = (t) =>
                        t.settings.container.indexOf("resultsProducts") > -1 ||
                        t.settings.container.indexOf("allTypes") > -1,
                        i = [...this.endlessCollection.endlessScroll].find(t);
                    if (!i) return;
                    i.settings.callback = e;
                }
            });
        }
        initAjaxyfy(t) {
            if ("object" != typeof this.endlessCollection)
                return (
                    (this.endlessCollection = new Gs(this.container)),
                    void this.updateAjaxinateInstancesSettings(t)
                );
            this.endlessCollection.endlessScroll.length > 0 &&
                (this.endlessCollection.unload(),
                    (this.endlessCollection = new Gs(this.container)),
                    this.updateAjaxinateInstancesSettings(t));
        }
        updateAjaxify(t, e) {
            var i;
            if (
                0 ===
                (null === (i = this.endlessCollection) || void 0 === i
                    ? void 0
                    : i.endlessScroll.length)
            )
                return;
            const s = t.querySelector(dn),
                o = `${dn}[${Cn}="${null == s ? void 0 : s.dataset.ajaxinateId}"]`;
            s &&
                (this.endlessCollection.update(o),
                    this.updateAjaxinateInstancesSettings(e));
        }
        initProductGridEvents() {
            ((this.productGridEvents = new zs(this.container)), this.initTooltips());
        }
        initTooltips() {
            var t, e;
            ((this.tooltips = this.container.querySelectorAll(cn)),
                (this.productGrid = this.container.querySelector(hn)),
                window.innerWidth < theme.sizes.small) &&
                (this.tooltips =
                    null === (e = this.productGrid) || void 0 === e
                        ? void 0
                        : e.querySelectorAll(cn));
            null === (t = this.tooltips) ||
                void 0 === t ||
                t.forEach((t) => {
                    new Li(t);
                });
        }
        tabChange(t, e) {
            t.classList.contains(un) ||
                (this.isSearchPage
                    ? this.tabChangeFetchContent(t, e)
                    : (this.handleActiveTabClasses(t, e),
                        this.scrollToCurrentTabLink(t),
                        this.triggerTabAnimations(e),
                        this.handleTabSliders(e),
                        this.checkVisibleTabsLinks()));
        }
        handleActiveTabClasses(t, e) {
            var i;
            const s = this.container.querySelector(`${Jo}.${un}`),
                o = this.container.querySelector(`${Yo}.${un}`);
            (null == s || s.classList.remove(un),
                null == o || o.classList.remove(un),
                t.classList.add(un),
                e.classList.add(un),
                t.classList.contains(pn) && e.classList.add(pn),
                null === (i = this.tabRef) ||
                void 0 === i ||
                i.forEach((t) => {
                    const i = t.classList.contains(un),
                        s = t.getAttribute(bn) === e.getAttribute(fn);
                    t.classList.toggle(un, !i && s);
                }));
        }
        scrollToCurrentTabLink(t) {
            const e = t.closest(en) ? t.closest(en) : t.parentElement,
                i = parseInt(
                    window.getComputedStyle(e).getPropertyValue("padding-left"),
                );
            (e.scrollTo({
                top: 0,
                left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i,
                behavior: "smooth",
            }),
                t.dispatchEvent(
                    new CustomEvent("theme:custom-scrollbar:change", {
                        bubbles: !0,
                        detail: { element: t },
                    }),
                ));
        }
        triggerTabAnimations(t) {
            "false" != theme.settings.animationsEnabled &&
                (this.tabsContents.querySelectorAll(Xo).forEach((t) => {
                    t.classList.remove(gn);
                }),
                    this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
                    (this.animateElementsTimer = setTimeout(() => {
                        t.querySelectorAll(Xo).forEach((t) => {
                            t.classList.add(gn);
                        });
                    }, 150)));
        }
        handleInactiveTabsAnimations() {
            this.tab.forEach((t) => {
                t.classList.contains(un) ||
                    t.querySelectorAll(Xo).forEach((t) => {
                        requestAnimationFrame(() => t.classList.remove(gn));
                    });
            });
        }
        handleTabSliders(t) {
            const e = t.querySelector(sn);
            e &&
                e.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !1 }));
        }
        checkVisibleTabsLinks() {
            const t = this.container.querySelectorAll(Yo),
                e = this.container.querySelectorAll(`${Yo}.${pn}`);
            t.length - e.length < 2
                ? this.container.classList.add(mn)
                : this.container.classList.remove(mn);
        }
        onBlockSelect(t) {
            const e = t.target;
            e &&
                (e.dispatchEvent(new Event("click")),
                    e.parentNode.scrollTo({
                        top: 0,
                        left: e.offsetLeft - e.clientWidth,
                        behavior: "smooth",
                    }));
        }
        onUnload() {
            (this.customScrollbar && this.customScrollbar.unload(),
                this.isSearchPage &&
                theme.settings.enableInfinityScroll &&
                document.removeEventListener(
                    "theme:tab:ajaxinate",
                    this.ajaxifyFromFiltersEvent,
                ),
                document.removeEventListener(
                    "theme:scroll",
                    this.inactiveTabsAnimationsCallback,
                ));
        }
        constructor(t) {
            ((this.container = t),
                (this.tabsContents = t.querySelector(on)),
                (this.animateElementsTimer = null),
                (this.isSearchPage = null != t.closest(`[${Sn}="true"]`)),
                this.container &&
                ((this.scrollable = this.container.querySelector(tn)),
                    (this.tabRef = this.container.querySelectorAll(Zo)),
                    (this.tabsLink = this.container.querySelectorAll(Yo)),
                    (this.tab = this.container.querySelectorAll(Jo)),
                    this.assignSearchPageArguments(),
                    this.init(),
                    this.initCustomScrollbar(),
                    this.isSearchPage || this.initTooltips(),
                    (this.inactiveTabsAnimationsCallback = o(
                        () => this.handleInactiveTabsAnimations(),
                        200,
                    )),
                    document.addEventListener(
                        "theme:scroll",
                        this.inactiveTabsAnimationsCallback,
                    ),
                    this.container.addEventListener("mouseenter", () => {
                        this.handleInactiveTabsAnimations();
                    })));
        }
    };
    const Pn = {
        onLoad() {
            qn[this.id] = new Tn(this.container);
        },
        onBlockSelect(t) {
            qn[this.id].onBlockSelect(t);
        },
        onUnload() {
            qn[this.id].onUnload();
        },
    },
        In = "[data-drawer]",
        Fn = "[data-drawer-toggle]",
        xn = "[data-scroll]",
        Hn = "[data-quick-view-item]",
        Dn = "is-open",
        Mn = "js-drawer-open",
        On = "js-drawer-open--size",
        Bn = "cv-h",
        _n = "site-header",
        $n = "product-single",
        zn = "aria-expanded",
        Rn = "aria-controls";
    let Vn = {},
        Nn = class {
            initListeners() {
                (this.drawerToggleButtons.forEach((t) => {
                    t.addEventListener("click", this.drawerToggleEvent);
                }),
                    this.drawers.forEach((t) => {
                        (t.addEventListener("keyup", this.keyPressCloseEvent),
                            (this.collapsible = new ce(t)),
                            (this.tabs = new Tn(t)));
                    }),
                    document.addEventListener("click", this.drawerCloseEvent),
                    document.addEventListener(
                        "theme:drawer:closing",
                        this.drawerCloseEvent,
                    ));
            }
            toggle(t) {
                t.preventDefault();
                const e = document.querySelector(`#${t.target.getAttribute(Rn)}`);
                if (!e) return;
                e.classList.contains(Dn) ? this.close() : this.open(t);
            }
            open(t) {
                const e = t.target,
                    i = document.querySelector(`#${t.target.getAttribute(Rn)}`);
                if (!i) return;
                const s = i.querySelector(xn) || i;
                (document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: s }),
                ),
                    document.dispatchEvent(new CustomEvent("theme:drawer:open"), {
                        bubbles: !0,
                    }),
                    this.body.classList.add(Mn),
                    this.container.classList.contains($n) && this.body.classList.add(On),
                    i.classList.add(Dn),
                    i.classList.remove(Bn),
                    e.setAttribute(zn, !0),
                    setTimeout(() => {
                        ((this.a11y.state.trigger = e),
                            this.a11y.trapFocus({ container: i }));
                    }));
            }
            close() {
                if (!this.body.classList.contains(Mn)) return;
                const t = document.querySelector(`${In}.${Dn}`);
                (this.drawerToggleButtons.forEach((t) => {
                    t.setAttribute(zn, !1);
                }),
                    this.a11y.removeTrapFocus({ container: t }),
                    t.classList.remove(Dn));
                const e = (i) => {
                    i.target === t &&
                        (requestAnimationFrame(() => {
                            (t.classList.add(Bn),
                                document.dispatchEvent(new CustomEvent("theme:drawer:close"), {
                                    bubbles: !0,
                                }),
                                document.dispatchEvent(
                                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 }),
                                ));
                        }),
                            t.removeEventListener("transitionend", e));
                };
                (t.addEventListener("transitionend", e),
                    this.body.classList.remove(Mn),
                    this.body.classList.remove(On));
            }
            onUnload() {
                (this.close(),
                    this.drawerToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.drawerToggleEvent);
                    }),
                    this.drawers.forEach((t) => {
                        t.removeEventListener("keyup", this.keyPressCloseEvent);
                    }),
                    document.removeEventListener("click", this.drawerCloseEvent),
                    document.removeEventListener(
                        "theme:drawer:closing",
                        this.drawerCloseEvent,
                    ),
                    this.collapsible && this.collapsible.onUnload(),
                    this.tabs && this.tabs.onUnload());
            }
            constructor(t) {
                ((this.container = t),
                    (this.body = document.body),
                    (this.drawers = this.container.querySelectorAll(In)),
                    (this.drawerToggleButtons = this.container.querySelectorAll(Fn)),
                    (this.a11y = be),
                    (this.drawerToggleEvent = Yt((t) => {
                        this.toggle(t);
                    }, 150)),
                    (this.keyPressCloseEvent = Yt((t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.close(t);
                    }, 150)),
                    (this.drawerCloseEvent = (t) => {
                        const e = document.querySelector(`${In}.${Dn}`);
                        let i = !1;
                        if (!e) return;
                        "click" === t.type && (i = t.target.matches(Fn));
                        const s = !!e && e.contains(t.target),
                            o = e.closest(Hn),
                            n = !!o && o.contains(t.target);
                        i || s || n || this.close();
                    }),
                    this.initListeners());
            }
        };
    const Wn = {
        onLoad() {
            (this.container.classList.contains(_n) &&
                (this.container = this.container.parentNode),
                (Vn[this.id] = new Nn(this.container)));
        },
        onUnload() {
            Vn[this.id].onUnload();
        },
    },
        Un = (t, e = !1, i = "block") => {
            t && (e ? t.style.removeProperty("display") : (t.style.display = i));
        },
        jn = (t) => {
            t && (t.style.display = "none");
        },
        Gn = (t) => {
            const { stickyHeaderHeight: e } = q();
            window.scrollTo({
                top: t + Math.round(window.scrollY) - e,
                left: 0,
                behavior: "smooth",
            });
        },
        Kn = "[data-store-availability-list]",
        Qn = {
            close: ".js-modal-close",
            open: ".js-modal-open-store-availability-modal",
            openClass: "modal--is-active",
            openBodyClass: "modal--is-visible",
            closeModalOnClick: !1,
            scrollIntoView: !1,
        };
    const Xn = "body",
        Yn = "[data-store-availability-modal]",
        Jn = "[data-store-availability-modal-open]",
        Zn = "[data-store-availability-modal-close]",
        tr = "[data-store-availability-modal-product__title]",
        er = "store-availabilities-modal--active";
    const ir = "[data-product-form]",
        sr = "[data-option-position]",
        or = '[name^="options"], [data-popout-option]',
        nr = "sold-out",
        rr = "unavailable",
        ar = "data-option-position",
        lr = "data-value";
    const cr = 1,
        hr = "data-notification-popup",
        dr = {
            history: !1,
            focus: !1,
            mainClass: "pswp--notification pswp--not-close-btn",
            closeOnVerticalDrag: !1,
        };
    let ur = class {
        init() {
            const t = [{ html: this.notificationPopupHtml }];
            ((this.a11y.state.trigger = this.button), new Kl(t, dr, cr));
        }
        constructor(t) {
            ((this.button = t),
                (this.a11y = be),
                (this.notificationPopupHtml = this.button.getAttribute(hr)),
                "" !== this.notificationPopupHtml.trim() && this.init());
        }
    };
    const pr = "[data-product]",
        mr = "[data-product-form]",
        gr = "[data-add-to-cart]",
        vr = "[data-add-to-cart-text]",
        yr = "[data-buy-it-now]",
        fr = "[data-compare-price]",
        br = "[data-form-wrapper]",
        wr = "[data-site-header]",
        Sr = "[data-product-select]",
        Er = "preorder",
        Lr = "[data-price-wrapper]",
        kr = "[data-price-off]",
        Ar = "[data-price-off-type]",
        Cr = "[data-price-off-amount]",
        qr = "[data-product-slide]",
        Tr = "[data-product-image]",
        Pr = "[data-product-single-media-slider]",
        Ir = "[data-product-json]",
        Fr = "[data-product-price]",
        xr = "[data-product-unit-price]",
        Hr = "[data-product-base]",
        Dr = "[data-product-unit]",
        Mr = "[data-subscription-watch-price]",
        Or = "[data-subscription-selectors]",
        Br = "[data-toggles-group]",
        _r = "data-group-toggle",
        $r = "[data-plan-description]",
        zr = "[data-remaining-count]",
        Rr = "[data-remaining-wrapper]",
        Vr = "[data-product-remaining-json]",
        Nr = "[data-store-availability-container]",
        Wr = "[data-upsell-btn]",
        Ur = ".shopify-section",
        jr = "[data-quick-view-item]",
        Gr = "[data-notification-button-text]",
        Kr = "[data-swatches-container]",
        Qr = "[data-swatches-more]",
        Xr = "[data-option-position]",
        Yr = ".shopify-payment-button__button",
        Jr = '[role="button"], [type="submit"], form',
        Zr = "[disabled]",
        ta = "hidden",
        ea = "variant--soldout",
        ia = "variant--unavailabe",
        sa = "product__price--sale",
        oa = "product__price--hidden",
        na = "count-is-low",
        ra = "count-is-in",
        aa = "count-is-out",
        la = "count-is-unavailable",
        ca = "selector-wrapper--visible",
        ha = "data-image-id",
        da = "data-tall-layout",
        ua = "data-enable-history-state",
        pa = "data-notification-popup",
        ma = "data-swatch-variant",
        ga = "disabled";
    let va = {},
        ya = class {
            init() {
                let t = null;
                const e = this.container.querySelector(Ir);
                (e && (t = e.innerHTML),
                    t
                        ? ((this.productJSON = JSON.parse(t)),
                            this.linkForm(),
                            (this.sellout = new (class {
                                init() {
                                    this.update();
                                }
                                update() {
                                    (this.getCurrentState(),
                                        this.optionElements.forEach((t) => {
                                            const e = t.value || t.getAttribute(lr),
                                                i = t.closest(sr);
                                            if (!i) return;
                                            const s = i.getAttribute(ar),
                                                o = parseInt(s, 10) - 1;
                                            let n = [...this.selections];
                                            n[o] = e;
                                            const r = this.productJSON.variants.find((t) => {
                                                let e = !0;
                                                for (let i = 0; i < n.length; i++)
                                                    t.options[i] !== n[i] && (e = !1);
                                                return e;
                                            });
                                            (t.parentElement.classList.remove(nr, rr),
                                                void 0 === r
                                                    ? t.parentElement.classList.add(rr)
                                                    : !1 === (null == r ? void 0 : r.available) &&
                                                    t.parentElement.classList.add(nr));
                                        }));
                                }
                                getCurrentState() {
                                    for (var t of ((this.formData = new FormData(this.form)),
                                        (this.selections = []),
                                        this.formData.entries()))
                                        t[0].includes("options[") && this.selections.push(t[1]);
                                }
                                constructor(t, e) {
                                    ((this.container = t),
                                        (this.productJSON = e),
                                        (this.form = this.container.querySelector(ir)),
                                        (this.formData = new FormData(this.form)),
                                        (this.optionElements = this.container.querySelectorAll(or)),
                                        this.productJSON && this.form && this.init());
                                }
                            })(this.container, this.productJSON)))
                        : console.error("Missing product JSON"));
            }
            observeContainer() {
                ((this.mutationObserver = new MutationObserver((t) => {
                    for (const i of t) {
                        var e;
                        if ("childList" === i.type && i.target.closest(yr))
                            if ((this.updateButtonsHeight(), !i.target.querySelector(Zr)))
                                (null === (e = this.mutationObserver) ||
                                    void 0 === e ||
                                    e.disconnect(),
                                    (this.mutationObserver = null));
                    }
                })),
                    this.mutationObserver.observe(this.container, {
                        childList: !0,
                        subtree: !0,
                    }));
            }
            updateButtonsHeight() {
                ((this.shopifyPaymentButton = this.container.querySelector(Yr)),
                    (this.paymentButton = this.buyItNow.querySelectorAll(`${Jr}`)),
                    this.shopifyPaymentButton &&
                    (this.shopifyPaymentButton.hasAttribute(ga) ||
                        (this.shopifyPaymentButton.setAttribute(
                            "style",
                            "min-height: auto !important;",
                        ),
                            this.addToCartButton.setAttribute("style", "min-height: auto;"),
                            this.paymentButton.forEach((t) =>
                                t.setAttribute("style", "min-height: auto !important;"),
                            ),
                            requestAnimationFrame(() => {
                                ((this.compareHeights = []),
                                    this.paymentButton.forEach((t) =>
                                        this.compareHeights.push(t.offsetHeight),
                                    ),
                                    this.compareHeights.push(
                                        this.shopifyPaymentButton.offsetHeight,
                                    ),
                                    this.compareHeights.push(this.addToCartButton.offsetHeight),
                                    o(this.setButtonsStyles(), 400));
                            }))));
            }
            setButtonsStyles() {
                0 !== this.compareHeights.length &&
                    ((this.maxHeight = Math.max(...this.compareHeights)),
                        requestAnimationFrame(() => {
                            (this.addToCartButton.setAttribute(
                                "style",
                                `min-height: ${this.maxHeight}px;`,
                            ),
                                this.shopifyPaymentButton.setAttribute(
                                    "style",
                                    `min-height: ${this.maxHeight}px !important; height: auto !important;`,
                                ),
                                this.paymentButton.forEach((t) =>
                                    t.setAttribute(
                                        "style",
                                        `min-height: ${this.maxHeight}px !important; height: auto !important;`,
                                    ),
                                ));
                        }));
            }
            linkForm() {
                this.productForm = new (class {
                    destroy() {
                        this._listeners.removeAll();
                    }
                    options() {
                        return this._serializeInputValues(this.optionInputs, function (t) {
                            return (
                                (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]),
                                t
                            );
                        });
                    }
                    variant() {
                        const t = this.options();
                        return t.length ? zi(this.product, t) : this.product.variants[0];
                    }
                    plan(t) {
                        let e = { allocation: null, group: null, detail: null };
                        const i = new FormData(this.form).get("selling_plan");
                        return (
                            i &&
                            t &&
                            (e.allocation = t.selling_plan_allocations.find(function (t) {
                                return t.selling_plan_id.toString() === i.toString();
                            })),
                            e.allocation &&
                            (e.group = this.product.selling_plan_groups.find(function (t) {
                                return (
                                    t.id.toString() ===
                                    e.allocation.selling_plan_group_id.toString()
                                );
                            })),
                            e.group &&
                            (e.detail = e.group.selling_plans.find(function (t) {
                                return t.id.toString() === i.toString();
                            })),
                            e && e.allocation && e.detail && e.allocation ? e : null
                        );
                    }
                    properties() {
                        return this._serializeInputValues(
                            this.propertyInputs,
                            function (t) {
                                return (
                                    (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]),
                                    t
                                );
                            },
                        );
                    }
                    quantity() {
                        return this.quantityInputs[0]
                            ? Number.parseInt(this.quantityInputs[0].value, 10)
                            : 1;
                    }
                    getFormState() {
                        const t = this.variant();
                        return {
                            options: this.options(),
                            variant: t,
                            properties: this.properties(),
                            quantity: this.quantity(),
                            plan: this.plan(t),
                        };
                    }
                    _setIdInputValue(t) {
                        (t && t.id
                            ? (this.variantElement.value = t.id.toString())
                            : (this.variantElement.value = ""),
                            this.variantElement.dispatchEvent(new Event("change")));
                    }
                    _onSubmit(t, e) {
                        ((e.dataset = this.getFormState()),
                            t.onFormSubmit && t.onFormSubmit(e));
                    }
                    _onOptionChange(t) {
                        this._setIdInputValue(t.dataset.variant);
                    }
                    _onFormEvent(t) {
                        return void 0 === t
                            ? Function.prototype.bind()
                            : function (e) {
                                ((e.dataset = this.getFormState()),
                                    this._setIdInputValue(e.dataset.variant),
                                    t(e));
                            }.bind(this);
                    }
                    _initInputs(t, e) {
                        return Array.prototype.slice
                            .call(this.element.querySelectorAll(t))
                            .map(
                                function (t) {
                                    return (
                                        this._listeners.add(t, "change", this._onFormEvent(e)),
                                        t
                                    );
                                }.bind(this),
                            );
                    }
                    _serializeInputValues(t, e) {
                        return t.reduce(function (t, i) {
                            return (
                                (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
                                t.push(e({ name: i.name, value: i.value })),
                                t
                            );
                        }, []);
                    }
                    _validateProductObject(t) {
                        if ("object" != typeof t)
                            throw new TypeError(t + " is not an object.");
                        if (void 0 === t.variants[0].options)
                            throw new TypeError(
                                "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route",
                            );
                        return t;
                    }
                    constructor(t, e, i) {
                        ((this.element = t),
                            (this.form =
                                "FORM" == this.element.tagName
                                    ? this.element
                                    : this.element.querySelector("form")),
                            (this.product = this._validateProductObject(e)),
                            (this.variantElement = this.element.querySelector(Vi)),
                            (i = i || {}),
                            (this._listeners = new $i()),
                            this._listeners.add(
                                this.element,
                                "submit",
                                this._onSubmit.bind(this, i),
                            ),
                            (this.optionInputs = this._initInputs(Wi, i.onOptionChange)),
                            (this.planInputs = this._initInputs(Ni, i.onPlanChange)),
                            (this.quantityInputs = this._initInputs(Ui, i.onQuantityChange)),
                            (this.propertyInputs = this._initInputs(ji, i.onPropertyChange)));
                    }
                })(this.productForm, this.productJSON, {
                    onOptionChange: this.onOptionChange.bind(this),
                    onPlanChange: this.onPlanChange.bind(this),
                });
                const t = this.productForm.getFormState();
                if (
                    (this.pushState(t, !0),
                        this.subsToggleListeners(),
                        this.swatchesContainer)
                ) {
                    this.observeSwatch(t);
                    const e = this.swatchesContainer.closest(Xr),
                        i = e.querySelector(Qr);
                    null == i ||
                        i.addEventListener("click", (t) => {
                            (t.preventDefault(),
                                e.classList.contains(ca)
                                    ? e.classList.remove(ca)
                                    : e.classList.add(ca));
                        });
                }
            }
            onOptionChange(t) {
                (this.pushState(t.dataset), this.updateProductImage(t));
            }
            onPlanChange(t) {
                this.subPrices && this.pushState(t.dataset);
            }
            pushState(t, e = !1) {
                var i;
                ((this.productState = this.setProductState(t)),
                    this.updateAddToCartState(t),
                    this.updateProductPrices(t),
                    this.updateSaleText(t),
                    this.updateSubscriptionText(t),
                    this.fireHookEvent(t),
                    this.updateRemaining(t),
                    null === (i = this.sellout) || void 0 === i || i.update(t),
                    this.enableHistoryState && !e && this.updateHistoryState(t),
                    this.storeAvailability &&
                    (t.variant
                        ? this.storeAvailability.updateContent(
                            t.variant.id,
                            this.productForm.product.title,
                        )
                        : this.storeAvailability.clearContent()));
            }
            updateAddToCartState(t) {
                const e = t.variant,
                    i = this.container.querySelectorAll(Lr),
                    s = this.container.querySelectorAll(gr),
                    o = this.container.querySelectorAll(vr),
                    n = this.container.querySelectorAll(br),
                    r = this.container.querySelector(yr);
                let a = theme.strings.add_to_cart;
                (this.productJSON.tags.includes(Er) && (a = theme.strings.preorder),
                    null == i ||
                    i.forEach((t) => {
                        t.classList.toggle(oa, !e);
                    }),
                    null == s ||
                    s.forEach((t) => {
                        var i;
                        if (t.matches(Wr)) return;
                        if (((t.disabled = !0), null == r || r.classList.add(ta), !e))
                            return;
                        if (
                            ((t.disabled = !1),
                                e.available && (null == r || r.classList.remove(ta)),
                                !t.hasAttribute(pa))
                        )
                            return;
                        const s = t.id.replace("AddToCart", "NotificationForm"),
                            o = this.sessionStorage.getItem("notification_form_id");
                        let n = !1,
                            a = e.id,
                            l = e.title;
                        if (o) {
                            const t = o.substring(0, o.lastIndexOf("--")),
                                e = o.split("--").slice(-1)[0];
                            ((n = s === t),
                                n &&
                                ((this.latestVariantId = a),
                                    (this.latestVariantTitle = l),
                                    (a = Number(e)),
                                    this.productJSON.variants.forEach((t) => {
                                        t.id === a && (l = t.title);
                                    })));
                        }
                        let c = t.getAttribute(pa);
                        const h =
                            null ===
                                (i = new DOMParser()
                                    .parseFromString(c, "text/html")
                                    .querySelector(Gr)) || void 0 === i
                                ? void 0
                                : i.innerHTML;
                        if ("" != this.latestVariantId && "" != this.latestVariantTitle) {
                            var d;
                            ((c = c.replaceAll(this.latestVariantId, a)),
                                (c = c.replaceAll(
                                    `<p class='product__notification__subtitle'>${this.latestVariantTitle}</p>`,
                                    `<p class='product__notification__subtitle'>${l}</p>`,
                                )));
                            const t =
                                null ===
                                    (d = new DOMParser()
                                        .parseFromString(c, "text/html")
                                        .querySelector(Gr)) || void 0 === d
                                    ? void 0
                                    : d.innerHTML;
                            c = c.replace(t, h);
                        }
                        (t.setAttribute(pa, c),
                            n && (this.scrollToForm(this.product.closest(Ur)), new ur(t)),
                            (this.latestVariantId = a),
                            (this.latestVariantTitle = l));
                    }),
                    null == o ||
                    o.forEach((t) => {
                        if (e) {
                            if (e.available) t.innerHTML = a;
                            else if (
                                ((t.innerHTML = theme.strings.sold_out),
                                    t.parentNode.hasAttribute(pa))
                            ) {
                                if (t.closest(jr)) return;
                                t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`;
                            }
                        } else t.innerHTML = theme.strings.unavailable;
                    }),
                    null == n ||
                    n.forEach((t) => {
                        if (!e) return (t.classList.add(ia), void t.classList.remove(ea));
                        const i = t.querySelector(Sr);
                        if ((i && (i.value = e.id), !e.available))
                            return (t.classList.add(ea), void t.classList.remove(ia));
                        t.classList.remove(ea, ia);
                    }));
            }
            updateHistoryState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = window.location.href;
                if (e && s.includes("/product")) {
                    const t = new window.URL(s),
                        o = t.searchParams;
                    (o.set("variant", e.id),
                        i && i.detail && i.detail.id && this.productState.hasPlan
                            ? o.set("selling_plan", i.detail.id)
                            : o.delete("selling_plan"),
                        (t.search = o.toString()));
                    const n = t.toString();
                    window.history.replaceState({ path: n }, "", n);
                }
            }
            updateRemaining(t) {
                const e = t.variant,
                    i = [ra, aa, la, na];
                if (e && this.remainingWrapper && this.remainingJSON) {
                    const t = this.remainingJSON[e.id];
                    (("out" === t || t < 1) &&
                        (this.remainingWrapper.classList.remove(...i),
                            this.remainingWrapper.classList.add(aa)),
                        ("in" === t || t >= this.remainingMaxInt) &&
                        (this.remainingWrapper.classList.remove(...i),
                            this.remainingWrapper.classList.add(ra)),
                        ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
                        (this.remainingWrapper.classList.remove(...i),
                            this.remainingWrapper.classList.add(na),
                            this.remainingCount && (this.remainingCount.innerHTML = t)));
                } else
                    !e &&
                        this.remainingWrapper &&
                        (this.remainingWrapper.classList.remove(...i),
                            this.remainingWrapper.classList.add(la));
            }
            getBaseUnit(t) {
                return 1 === t.unit_price_measurement.reference_value
                    ? t.unit_price_measurement.reference_unit
                    : t.unit_price_measurement.reference_value +
                    t.unit_price_measurement.reference_unit;
            }
            subsToggleListeners() {
                this.container.querySelectorAll(Br).forEach((t) => {
                    t.addEventListener(
                        "change",
                        function (t) {
                            const e = t.target.value.toString(),
                                i = this.container.querySelector(`[${_r}="${e}"]`),
                                s = this.container.querySelectorAll(`[${_r}]`);
                            if (i) {
                                i.classList.remove(ta);
                                const t = i.querySelector('[name="selling_plan"]');
                                ((t.checked = !0), t.dispatchEvent(new Event("change")));
                            }
                            s.forEach((t) => {
                                if (t !== i) {
                                    t.classList.add(ta);
                                    t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                        ((t.checked = !1), t.dispatchEvent(new Event("change")));
                                    });
                                }
                            });
                        }.bind(this),
                    );
                });
            }
            updateSaleText(t) {
                this.productState.planSale
                    ? this.updateSaleTextSubscription(t)
                    : this.productState.onSale
                        ? this.updateSaleTextStandard(t)
                        : this.priceOffWrap && this.priceOffWrap.classList.add(ta);
            }
            updateSaleTextStandard(t) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML =
                    window.theme.strings.sale_badge_text || "sale";
                const e = t.variant;
                if (
                    window.theme.settings.savingBadgeType &&
                    "percentage" === window.theme.settings.savingBadgeType
                ) {
                    const t = (e.compare_at_price - e.price) / e.compare_at_price,
                        i = Math.floor(100 * t);
                    this.priceOffAmount.innerHTML = `${i}%`;
                } else {
                    const t = e.compare_at_price - e.price;
                    this.priceOffAmount.innerHTML = i.formatMoney(t, theme.moneyFormat);
                }
                this.priceOffWrap.classList.remove(ta);
            }
            updateSaleTextSubscription(t) {
                const e = t.variant,
                    s = this.productForm.product.selling_plan_groups.find(
                        (t) => t.id === e.selling_plan_allocations[0].selling_plan_group_id,
                    ),
                    o = t.plan
                        ? t.plan.detail.price_adjustments[0]
                        : s.selling_plans[0].price_adjustments[0],
                    n = o.value || 0,
                    r =
                        "percentage" === o.value_type
                            ? `${n}%`
                            : i.formatMoney(e.price - n, theme.moneyFormat);
                ((this.priceOffType.innerHTML =
                    window.theme.strings.subscription || "subscripton"),
                    (this.priceOffAmount.innerHTML = r),
                    this.priceOffWrap.classList.remove(ta));
            }
            updateSubscriptionText(t) {
                t.plan && this.planDecription && null !== t.plan.detail.description
                    ? ((this.planDecription.innerHTML = t.plan.detail.description),
                        this.planDecription.classList.remove(ta))
                    : this.planDecription && this.planDecription.classList.add(ta);
            }
            updateProductPrices(t) {
                const e = t.variant,
                    s = t.plan;
                (this.container.querySelectorAll(Lr).forEach((t) => {
                    const o = t.querySelector(fr),
                        n = t.querySelector(Fr);
                    let r = "",
                        a = "";
                    if (
                        (this.productState.available &&
                            ((r = e.compare_at_price), (a = e.price)),
                            this.productState.hasPlan)
                    ) {
                        a = s
                            ? s.allocation.price
                            : e.selling_plan_allocations[0].per_delivery_price;
                    }
                    if (this.productState.planSale) {
                        const t = s
                            ? s.allocation.price
                            : e.selling_plan_allocations[0].per_delivery_price;
                        ((r = s
                            ? s.allocation.compare_at_price
                            : e.selling_plan_allocations[0].compare_at_price),
                            (a = t));
                    }
                    (o &&
                        (this.productState.onSale || this.productState.planSale
                            ? (o.classList.remove(ta), n.classList.add(sa))
                            : (o.classList.add(ta), n.classList.remove(sa)),
                            (o.innerHTML = theme.settings.currency_code_enable
                                ? i.formatMoney(r, theme.moneyWithCurrencyFormat)
                                : i.formatMoney(r, theme.moneyFormat))),
                        (n.innerHTML =
                            0 === a
                                ? window.theme.strings.free
                                : theme.settings.currency_code_enable
                                    ? i.formatMoney(a, theme.moneyWithCurrencyFormat)
                                    : i.formatMoney(a, theme.moneyFormat)));
                }),
                    this.hasUnitPricing && this.updateProductUnits(t));
            }
            updateProductUnits(t) {
                const e = t.variant,
                    s = t.plan;
                let o = null;
                if (
                    (e && e.unit_price && (o = e.unit_price),
                        s &&
                        (null == s ? void 0 : s.allocation) &&
                        (null == s ? void 0 : s.allocation.unit_price) &&
                        (o = s.allocation.unit_price),
                        !s &&
                        e.selling_plan_allocations &&
                        e.selling_plan_allocations.length > 0)
                ) {
                    o = e.selling_plan_allocations[0].unit_price;
                }
                if (o) {
                    const t = this.getBaseUnit(e),
                        s =
                            0 === o
                                ? window.theme.strings.free
                                : i.formatMoney(o, theme.moneyFormat);
                    ((this.container.querySelector(xr).innerHTML = s),
                        (this.container.querySelector(Hr).innerHTML = t),
                        Un(this.container.querySelector(Dr)));
                } else jn(this.container.querySelector(Dr));
            }
            fireHookEvent(t) {
                const e = t.variant;
                this.container.dispatchEvent(
                    new CustomEvent("theme:variant:change", {
                        detail: { variant: e },
                        bubbles: !0,
                    }),
                );
            }
            setProductState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = {
                        available: !0,
                        soldOut: !1,
                        onSale: !1,
                        showUnitPrice: !1,
                        requiresPlan: !1,
                        hasPlan: !1,
                        planPerDelivery: !1,
                        planSale: !1,
                    };
                if (e) {
                    const t = e.requires_selling_plan || !1;
                    (e.available || (s.soldOut = !0),
                        e.compare_at_price > e.price && (s.onSale = !0),
                        e.unit_price && (s.showUnitPrice = !0),
                        this.product &&
                        this.product.requires_selling_plan &&
                        (s.requiresPlan = !0),
                        i &&
                        this.subPrices &&
                        ((s.hasPlan = !0),
                            i.allocation.per_delivery_price !== i.allocation.price &&
                            (s.planPerDelivery = !0),
                            e.price > i.allocation.price && (s.planSale = !0)),
                        !i &&
                        t &&
                        ((s.hasPlan = !0),
                            e.selling_plan_allocations[0].per_delivery_price !==
                            e.selling_plan_allocations[0].price && (s.planPerDelivery = !0),
                            e.price > e.selling_plan_allocations[0].price &&
                            (s.planSale = !0)));
                } else s.available = !1;
                return s;
            }
            updateProductImage(t) {
                const i = t.dataset.variant;
                if (!i || !(null == i ? void 0 : i.featured_media)) return;
                const s = this.container.querySelector(
                    `${Tr}[${ha}="${i.featured_media.id}"]`,
                ),
                    o = null == s ? void 0 : s.closest(qr);
                if (o) {
                    const t = parseInt([...o.parentElement.children].indexOf(o)),
                        n = this.container.querySelector(Pr),
                        r = e.data(n);
                    if (r && r.isActive) {
                        const t = n.querySelector(`[data-id="${i.featured_media.id}"]`);
                        if (t) {
                            const e = parseInt([...t.parentNode.children].indexOf(t));
                            r.select(e);
                        }
                        return;
                    }
                    if (this.tallLayout) {
                        const e = s.getBoundingClientRect().top;
                        if (0 === t && e + window.scrollY > window.pageYOffset) return;
                        (document.dispatchEvent(
                            new CustomEvent("theme:tooltip:close", {
                                bubbles: !1,
                                detail: { hideTransition: !1 },
                            }),
                        ),
                            Gn(e));
                    }
                }
            }
            observeSwatch(t) {
                const e = this.swatchesContainer.querySelector(
                    `[${ma}*="${t.variant.id}"]`,
                );
                (this.swatchesContainer.closest(Xr).classList.remove(ca),
                    new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                0 == t.intersectionRatio &&
                                    this.swatchesContainer.closest(Xr).classList.add(ca);
                            });
                        },
                        { root: this.container, threshold: [0.95, 1] },
                    ).observe(e));
            }
            scrollToForm(t) {
                var e;
                const i =
                    null === (e = document.querySelector(wr)) || void 0 === e
                        ? void 0
                        : e.dataset.height;
                visibilityHelper.isElementPartiallyVisible(t) ||
                    visibilityHelper.isElementTotallyVisible(t) ||
                    setTimeout(() => {
                        const e = t.getBoundingClientRect().top - i;
                        window.scrollTo({ top: e, left: 0, behavior: "smooth" });
                    }, 400);
            }
            onUnload() {
                (this.productForm && this.productForm.destroy(),
                    this.hasPaymentButton &&
                    window.removeEventListener(
                        "theme:resize:width",
                        this.onResizeCallback,
                    ));
            }
            constructor(t) {
                if (
                    ((this.container = t),
                        (this.product = this.container.querySelector(pr)),
                        (this.productForm = this.container.querySelector(mr)),
                        (this.tallLayout = "true" === this.container.getAttribute(da)),
                        (this.addToCartButton = this.container.querySelector(gr)),
                        (this.buyItNow = this.container.querySelector(yr)),
                        (this.hasPaymentButton = null !== this.buyItNow),
                        !this.product || !this.productForm)
                ) {
                    return void new fe(this.container).init();
                }
                ((this.storeAvailabilityContainer = this.container.querySelector(Nr)),
                    (this.enableHistoryState =
                        "true" === this.container.getAttribute(ua)),
                    (this.hasUnitPricing = this.container.querySelector(Dr)),
                    (this.subSelectors = this.container.querySelector(Or)),
                    (this.subPrices = this.container.querySelector(Mr)),
                    (this.priceOffWrap = this.container.querySelector(kr)),
                    (this.priceOffAmount = this.container.querySelector(Cr)),
                    (this.priceOffType = this.container.querySelector(Ar)),
                    (this.planDecription = this.container.querySelector($r)),
                    (this.swatchesContainer = this.container.querySelector(Kr)),
                    (this.latestVariantId = ""),
                    (this.latestVariantTitle = ""),
                    (this.sellout = null),
                    (this.sessionStorage = window.sessionStorage),
                    (this.remainingWrapper = this.container.querySelector(Rr)),
                    this.remainingWrapper &&
                    ((this.remainingMaxInt = parseInt(
                        this.remainingWrapper.dataset.remainingMax,
                        10,
                    )),
                        (this.remainingCount = this.container.querySelector(zr)),
                        (this.remainingJSONWrapper = this.container.querySelector(Vr)),
                        (this.remainingJSON = null),
                        this.remainingJSONWrapper &&
                        "" !== this.remainingJSONWrapper.innerHTML &&
                        (this.remainingJSON = JSON.parse(
                            this.remainingJSONWrapper.innerHTML,
                        ))),
                    this.storeAvailabilityContainer &&
                    (this.storeAvailability = new (class {
                        updateContent(t, e) {
                            this._fetchStoreAvailabilities(t, e);
                        }
                        clearContent() {
                            this.container.innerHTML = "";
                        }
                        _initModal() {
                            return new (class {
                                init() {
                                    (this.openElement.addEventListener(
                                        "click",
                                        this.open.bind(this),
                                    ),
                                        this.modal
                                            .querySelector(this.config.close)
                                            .addEventListener("click", this.closeModal.bind(this)));
                                }
                                open(t) {
                                    let e = !1;
                                    if (
                                        (t ? t.preventDefault() : (e = !0),
                                            this.modalIsOpen && !e)
                                    )
                                        return void this.closeModal();
                                    (this.modal.classList.add(this.config.openClass),
                                        this.nodes.parents.forEach((t) => {
                                            t.classList.add(this.config.openBodyClass);
                                        }),
                                        (this.modalIsOpen = !0));
                                    const i = document.querySelector(Kn);
                                    (document.dispatchEvent(
                                        new CustomEvent("theme:scroll:lock", {
                                            bubbles: !0,
                                            detail: i,
                                        }),
                                    ),
                                        this.config.scrollIntoView && this.scrollIntoView(),
                                        this.bindEvents(),
                                        this.a11y.trapFocus({ container: this.modal }));
                                }
                                closeModal() {
                                    if (this.modalIsOpen) {
                                        (document.activeElement.blur(),
                                            this.modal.classList.remove(this.config.openClass));
                                        var t = this;
                                        (this.nodes.parents.forEach(function (e) {
                                            e.classList.remove(t.config.openBodyClass);
                                        }),
                                            (this.modalIsOpen = !1),
                                            this.openElement.focus(),
                                            this.unbindEvents(),
                                            this.a11y.removeTrapFocus({ container: this.modal }),
                                            document.dispatchEvent(
                                                new CustomEvent("theme:scroll:unlock", {
                                                    bubbles: !0,
                                                    detail: 400,
                                                }),
                                            ));
                                    }
                                }
                                bindEvents() {
                                    ((this.keyupHandler = this.keyupHandler.bind(this)),
                                        (this.clickHandler = this.clickHandler.bind(this)),
                                        document.body.addEventListener(
                                            "keyup",
                                            this.keyupHandler,
                                        ),
                                        document.body.addEventListener(
                                            "click",
                                            this.clickHandler,
                                        ));
                                }
                                unbindEvents() {
                                    (document.body.removeEventListener(
                                        "keyup",
                                        this.keyupHandler,
                                    ),
                                        document.body.removeEventListener(
                                            "click",
                                            this.clickHandler,
                                        ));
                                }
                                keyupHandler(t) {
                                    t.code === theme.keyboardKeys.ESCAPE && this.closeModal();
                                }
                                clickHandler(t) {
                                    !this.config.closeModalOnClick ||
                                        this.modal.contains(t.target) ||
                                        t.target.matches(this.config.open) ||
                                        this.closeModal();
                                }
                                scrollIntoView() {
                                    this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
                                }
                                constructor(t, e) {
                                    if (
                                        ((this.modal = document.getElementById(t)), !this.modal)
                                    )
                                        return !1;
                                    ((this.nodes = {
                                        parents: [document.querySelector("html"), document.body],
                                    }),
                                        (this.config = Object.assign(Qn, e)),
                                        (this.modalIsOpen = !1),
                                        (this.focusOnOpen = this.config.focusOnOpen
                                            ? document.getElementById(this.config.focusOnOpen)
                                            : this.modal),
                                        (this.openElement = document.querySelector(
                                            this.config.open,
                                        )),
                                        (this.a11y = be),
                                        this.init());
                                }
                            })("StoreAvailabilityModal", {
                                close: Zn,
                                open: Jn,
                                closeModalOnClick: !0,
                                openClass: er,
                                scrollIntoView: !1,
                            });
                        }
                        _fetchStoreAvailabilities(t, e) {
                            const i = "/variants/" + t + "/?section_id=store-availability";
                            this.clearContent();
                            const s = this;
                            fetch(i)
                                .then(function (t) {
                                    return t.text();
                                })
                                .then(function (t) {
                                    const i = document.querySelector(Xn);
                                    let o = i.querySelector(Yn);
                                    (o && o.remove(),
                                        (s.container.innerHTML = t),
                                        (s.container.innerHTML =
                                            s.container.firstElementChild.innerHTML),
                                        "" !== s.container.firstElementChild.innerHTML.trim()
                                            ? s.container.querySelector(Jn) &&
                                            ((s.modal = s._initModal()),
                                                s._updateProductTitle(e),
                                                (o = s.container.querySelector(Yn)),
                                                o && i.appendChild(o))
                                            : s.clearContent());
                                });
                        }
                        _updateProductTitle(t) {
                            this.container.querySelector(tr).textContent = t;
                        }
                        constructor(t) {
                            this.container = t;
                        }
                    })(this.storeAvailabilityContainer)));
                (new fe(this.container).init(),
                    this.init(),
                    this.hasPaymentButton &&
                    ((this.mutationObserver = null),
                        (this.onResizeCallback = () => this.updateButtonsHeight()),
                        this.observeContainer(),
                        window.addEventListener(
                            "theme:resize:width",
                            this.onResizeCallback,
                        )));
            }
        };
    const fa = {
        onLoad() {
            va[this.id] = new ya(this.container);
        },
        onUnload() {
            va[this.id].onUnload();
        },
    },
        ba = "form",
        wa = "[data-popout]",
        Sa = "[data-popout-list]",
        Ea = "[data-popout-toggle]",
        La = "[data-popout-input]",
        ka = "[data-popout-option]",
        Aa = "[data-popout-text]",
        Ca = "[aria-current]",
        qa = "[data-product-image]",
        Ta = "[data-product-grid-item]",
        Pa = "select-popout__list--visible",
        Ia = "select-popout--alt",
        Fa = "--current",
        xa = "is-visible",
        Ha = "aria-current",
        Da = "aria-expanded",
        Ma = "data-value",
        Oa = "data-popout-prevent",
        Ba = "data-quantity-field",
        _a = "data-quick-view-item";
    let $a = {},
        za = class {
            unload() {
                (this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        (t.removeEventListener(
                            "theme:popout:click",
                            this.popupOptionsClickEvent,
                        ),
                            t.removeEventListener(
                                "click",
                                this._connectOptionsDispatchEvent,
                            ));
                    }),
                    this.popoutToggle.removeEventListener(
                        "click",
                        this.popupToggleClickEvent,
                    ),
                    this.popoutToggle.removeEventListener(
                        "focusout",
                        this.popupToggleFocusoutEvent,
                    ),
                    this.popoutList.removeEventListener(
                        "focusout",
                        this.popupListFocusoutEvent,
                    ),
                    this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
                    document.removeEventListener("theme:cart:update", this.updatePopout),
                    document.body.removeEventListener("click", this.bodyClick));
            }
            popupToggleClick(t) {
                const e = "true" === t.currentTarget.getAttribute(Da);
                if (this.popoutList.closest(Ta)) {
                    const t = this.popoutList.closest(Ta).querySelector(qa);
                    t && t.classList.toggle(xa, !e);
                }
                (t.currentTarget.setAttribute(Da, !e),
                    this.popoutList.classList.toggle(Pa));
            }
            popupToggleFocusout(t) {
                if (!t.relatedTarget) return;
                const e = this.popout.contains(t.relatedTarget),
                    i = t.relatedTarget.hasAttribute(_a);
                e || i || this._hideList();
            }
            popupListFocusout(t) {
                const e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(Pa) && !e && this._hideList();
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(ka).attributes.href.value) {
                    t.preventDefault();
                    let e = "";
                    if (
                        (t.currentTarget.getAttribute(Ma) &&
                            (e = t.currentTarget.getAttribute(Ma)),
                            (this.popoutInput.value = e),
                            this.popoutPrevent)
                    ) {
                        (this.popoutInput.dispatchEvent(new Event("change")),
                            !t.detail.preventTrigger &&
                            this.popoutInput.hasAttribute(Ba) &&
                            this.popoutInput.dispatchEvent(new Event("input")));
                        const i = this.popoutList.querySelector(`[class*="${Fa}"]`);
                        let s = Fa;
                        if (i && i.classList.length)
                            for (const t of i.classList)
                                if (t.includes(Fa)) {
                                    s = t;
                                    break;
                                }
                        const o = this.popoutList.querySelector(`.${s}`);
                        o &&
                            (o.classList.remove(`${s}`),
                                t.currentTarget.parentElement.classList.add(`${s}`));
                        const n = this.popoutList.querySelector(Ca);
                        (n &&
                            (n.removeAttribute(Ha), t.currentTarget.setAttribute(Ha, "true")),
                            "" !== e && (this.popoutText.textContent = e),
                            this.popupToggleFocusout(t),
                            this.popupListFocusout(t));
                    } else this._submitForm(e);
                }
            }
            updatePopout() {
                const t = this.popoutList.querySelector(
                    `[${Ma}="${this.popoutInput.value}"]`,
                );
                t
                    ? (t.dispatchEvent(
                        new CustomEvent("theme:popout:click", {
                            cancelable: !0,
                            bubbles: !0,
                            detail: { preventTrigger: !0 },
                        }),
                    ),
                        t.parentElement.nextSibling || this.popout.classList.add(Ia))
                    : this.popout.classList.add(Ia);
            }
            popoutKeyup(t) {
                t.code === theme.keyboardKeys.ESCAPE &&
                    (this._hideList(), this.popoutToggle.focus());
            }
            bodyClick(t) {
                const e = this.popout.contains(t.target);
                this.popoutList.classList.contains(Pa) && !e && this._hideList();
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
            }
            _connectOptions() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        (t.addEventListener(
                            "theme:popout:click",
                            this.popupOptionsClickEvent,
                        ),
                            t.addEventListener("click", this._connectOptionsDispatchEvent));
                    });
            }
            _connectOptionsDispatch(t) {
                const e = new CustomEvent("theme:popout:click", {
                    cancelable: !0,
                    bubbles: !0,
                    detail: { preventTrigger: !1 },
                });
                t.target.dispatchEvent(e) || t.preventDefault();
            }
            _onFocusOut() {
                (this.popoutToggle.addEventListener(
                    "focusout",
                    this.popupToggleFocusoutEvent,
                ),
                    this.popoutList.addEventListener(
                        "focusout",
                        this.popupListFocusoutEvent,
                    ),
                    this.popout.addEventListener("keyup", this.popoutKeyupEvent),
                    document.body.addEventListener("click", this.bodyClick));
            }
            _submitForm() {
                const t = this.popout.closest(ba);
                t && t.submit();
            }
            _hideList() {
                (this.popoutList.classList.remove(Pa),
                    this.popoutToggle.setAttribute(Da, !1));
            }
            constructor(t) {
                ((this.popout = t),
                    (this.popoutList = this.popout.querySelector(Sa)),
                    (this.popoutToggle = this.popout.querySelector(Ea)),
                    (this.popoutText = this.popout.querySelector(Aa)),
                    (this.popoutInput = this.popout.querySelector(La)),
                    (this.popoutOptions = this.popout.querySelectorAll(ka)),
                    (this.popoutPrevent = "true" === this.popout.getAttribute(Oa)),
                    (this.popupToggleFocusoutEvent = (t) => this.popupToggleFocusout(t)),
                    (this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
                    (this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
                    (this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
                    (this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
                    (this._connectOptionsDispatchEvent = (t) =>
                        this._connectOptionsDispatch(t)),
                    (this.bodyClick = this.bodyClick.bind(this)),
                    (this.updatePopout = this.updatePopout.bind(this)),
                    this._connectOptions(),
                    this._connectToggle(),
                    this._onFocusOut(),
                    this.popoutInput &&
                    this.popoutInput.hasAttribute(Ba) &&
                    document.addEventListener("theme:cart:update", this.updatePopout));
            }
        };
    const Ra = {
        onLoad() {
            $a[this.id] = [];
            this.container.querySelectorAll(wa).forEach((t) => {
                $a[this.id].push(new za(t));
            });
        },
        onUnload() {
            $a[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    },
        Va = "[data-add-to-cart]",
        Na = "[data-deferred-media]",
        Wa = "[data-deferred-media-button]",
        Ua = "[data-popup-close]",
        ja = "[data-popout]",
        Ga = "[data-quick-view-inner]",
        Ka = "[data-quick-view-item-holder]",
        Qa = "[data-product]",
        Xa = "[data-product-form]",
        Ya = "[data-product-single-media-slider]",
        Ja = "[data-product-single-media-wrapper]",
        Za = "[data-model]",
        tl = "[data-product-json]",
        el = "[data-quick-view-foot-inner]",
        il = "[data-shop-the-look-thumb]",
        sl = "[data-tooltip]",
        ol = "[data-drawer-toggle]",
        nl = "has-media-active",
        rl = "is-active",
        al = "is-loading",
        ll = "media--hidden",
        cl = "no-outline",
        hl = "notification-popup-visible",
        dl = "popup-quick-view--animate-in",
        ul = "popup-quick-view--animate-out",
        pl = "popup-quick-view--animated",
        ml = "popup-quick-view",
        gl = "js-quick-view-visible",
        vl = "js-quick-view-from-cart",
        yl = "js-drawer-open",
        fl = "id",
        bl = "data-media-id",
        wl = "data-section-id",
        Sl = "loaded",
        El = "tabindex",
        Ll = "data-quick-view-onboarding",
        kl = "data-hotspot",
        Al = "data-hotspot-ref",
        Cl = "AddToCartForm--",
        ql = "AddToCart--";
    const Tl = 400,
        Pl = ".pswp",
        Il = ".pswp__custom-close",
        Fl = "iframe, video",
        xl = ".pswp__custom-iframe",
        Hl = ".pswp__thumbs",
        Dl = ".pswp__button, .pswp__caption-close",
        Ml = "is-current",
        Ol = "pswp--custom-loader",
        Bl = "pswp--custom-opening",
        _l = "pswp__loader",
        $l = "pswp--open",
        zl = "pswp__button--close",
        Rl = "pswp--notification",
        Vl = "popup-quick-view",
        Nl = "js-drawer-open-cart",
        Wl = "popup-quick-view--animate-out",
        Ul = "data-pswp-option-classes",
        jl = "data-video-type",
        Gl = `<div class="${_l}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
    let Kl = class {
        init() {
            (document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", { bubbles: !0 }),
            ),
                this.pswpElement.classList.add(Bl),
                this.initLoader(),
                Se({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((t) => console.error(t)));
        }
        initLoader() {
            if (
                this.pswpElement.classList.contains(Ol) &&
                "" !== this.options &&
                this.options.mainClass
            ) {
                this.pswpElement.setAttribute(Ul, this.options.mainClass);
                let t = document.createElement("div");
                ((t.innerHTML = Gl),
                    (t = t.firstChild),
                    this.pswpElement.appendChild(t));
            } else this.pswpElement.setAttribute(Ul, "");
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            (this.pswpElement.classList.remove(Bl),
                (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
                this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
                this.popup.listen("imageLoadComplete", this.loadingStateCallback),
                this.popup.listen("beforeChange", this.setCurrentThumbCallback),
                this.popup.listen("close", this.onCloseCallback),
                this.popup.init(),
                this.initPopupCallback());
        }
        loadingState(t) {
            t === this.options.index &&
                this.pswpElement.classList.contains(Ol) &&
                this.pswpElement.classList.remove(Ol);
        }
        initPopupCallback() {
            (this.isVideo && this.hideUnusedButtons(),
                this.initVideo(),
                this.thumbsActions(),
                this.a11y.trapFocus({ container: this.pswpElement }),
                this.pswpElement.classList.contains(Vl) &&
                new (class {
                    initTooltips() {
                        ((this.tooltips = this.pswpElement.querySelectorAll(sl)),
                            this.tooltips.forEach((t) => {
                                new Li(t);
                            }));
                    }
                    initPopouts() {
                        var t;
                        ((this.popoutElements = this.pswpElement.querySelectorAll(ja)),
                            (this.popouts = {}),
                            null === (t = this.popoutElements) ||
                            void 0 === t ||
                            t.forEach((t, e) => {
                                this.popouts[e] = new za(t);
                            }));
                    }
                    handleDraggable(t, e) {
                        t && ((t.options.draggable = Boolean(e)), t.updateDraggable());
                    }
                    initItems(t, e) {
                        (this.addFormSuffix(t),
                            this.initProductSlider(t, e),
                            this.initProductVideo(t),
                            this.initProductModel(t),
                            this.initShopifyXrLaunch(t),
                            Cs(t),
                            this.pswpElement.querySelectorAll(ol).length && new Nn(t),
                            Y(t));
                        const i = new ya(t.parentNode);
                        (this.productForms.push(i),
                            Shopify.PaymentButton && Shopify.PaymentButton.init(),
                            t.classList.remove(al));
                    }
                    init() {
                        (document.addEventListener(
                            "submit",
                            this.prevent3dModelSubmitEvent,
                        ),
                            this.popupCloseButtons.forEach((t) => {
                                (t.addEventListener("keyup", (t) => {
                                    (t.code !== theme.keyboardKeys.ENTER &&
                                        t.code !== theme.keyboardKeys.NUMPADENTER &&
                                        t.code !== theme.keyboardKeys.SPACE) ||
                                        this.closePopup(t);
                                }),
                                    t.addEventListener("click", (t) => {
                                        this.closePopup(t);
                                    }));
                            }),
                            this.pswpElement.addEventListener(
                                "click",
                                this.outerCloseEvent,
                            ),
                            document.dispatchEvent(
                                new CustomEvent("theme:popup:open", { bubbles: !0 }),
                            ),
                            this.popup.listen("preventDragEvent", (t, e, i) => {
                                i.prevent = !1;
                            }),
                            this.pswpElement.addEventListener("mousedown", () => {
                                this.popup.framework.unbind(
                                    window,
                                    "pointermove pointerup pointercancel",
                                    this.popup,
                                );
                            }),
                            this.popup.listen("initialZoomInEnd", () => {
                                (document.body.classList.add(gl),
                                    this.a11y.trapFocus({ container: this.quickViewInner }));
                            }),
                            this.pswpElement.addEventListener(
                                "animationend",
                                this.closeOnAnimationEndEvent,
                            ),
                            this.popup.listen("destroy", () => {
                                (this.flkty.length > 0 &&
                                    requestAnimationFrame(() => {
                                        this.flkty.forEach((t) => t.pausePlayer());
                                    }),
                                    document.body.classList.remove(gl),
                                    document.removeEventListener(
                                        "keyup",
                                        this.closeOnEscapeEvent,
                                    ),
                                    document.addEventListener("keyup", this.closeOnEscapeEvent),
                                    this.pswpElement.removeEventListener(
                                        "click",
                                        this.outerCloseEvent,
                                    ),
                                    this.pswpElement.removeEventListener(
                                        "animationend",
                                        this.closeOnAnimationEndEvent,
                                    ),
                                    document.removeEventListener(
                                        "submit",
                                        this.prevent3dModelSubmitEvent,
                                    ),
                                    this.deferredMedias.forEach((t) => {
                                        t.removeAttribute(Sl);
                                        const e = t.closest(Ja);
                                        (e.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                                            bubbles: !0,
                                        }),
                                            e.classList.add(ll));
                                    }));
                            }),
                            document.addEventListener("keyup", this.closeOnEscapeEvent),
                            document.addEventListener("theme:cart:added", () => {
                                this.pswpElement.classList.contains(ml) &&
                                    this.pswpElement.classList.add(ul);
                            }),
                            this.animateInQuickview(),
                            this.initShopTheLookListeners());
                    }
                    initShopTheLookListeners() {
                        var t;
                        null === (t = this.buttonsShopTheLookThumb) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                    const e = t.target.matches(il)
                                        ? t.target
                                        : t.target.closest(il),
                                        i = this.pswpElement.querySelector(
                                            `[${kl}="${e.getAttribute(Al)}"]`,
                                        );
                                    !e.classList.contains(rl) &&
                                        i &&
                                        (this.flkty.length > 0 &&
                                            requestAnimationFrame(() => {
                                                this.flkty.forEach((t) => {
                                                    t.resize();
                                                    const e = this.quickViewInner.querySelectorAll(Ja);
                                                    e.length &&
                                                        e.forEach((t) => {
                                                            (t.dispatchEvent(
                                                                new CustomEvent("theme:media:hidden"),
                                                                { bubbles: !0 },
                                                            ),
                                                                t.classList.add(ll));
                                                        });
                                                });
                                            }),
                                            i.classList.add(rl),
                                            this.quickViewItemHolders.forEach((t) => {
                                                t !== i && t.classList.remove(rl);
                                            }));
                                });
                            });
                    }
                    prevent3dModelSubmit(t) {
                        t.submitter.closest(Na) &&
                            t.submitter.closest(Xa) &&
                            t.preventDefault();
                    }
                    closeQuickviewOnMobile() {
                        window.innerWidth < window.theme.sizes.large &&
                            document.body.classList.contains(gl) &&
                            this.popup.close();
                    }
                    animateInQuickview() {
                        (this.pswpElement.classList.add(dl),
                            this.quickViewFoot.addEventListener("animationend", (t) => {
                                this.handleAnimatedState(t);
                            }),
                            this.pswpElement.addEventListener("animationend", (t) => {
                                this.handleAnimatedState(t, !0);
                            }));
                    }
                    handleAnimatedState(t, e = !1) {
                        if ("quickViewAnimateInUp" == t.animationName) {
                            if (e && window.innerWidth >= window.theme.sizes.small) return;
                            (this.pswpElement.classList.add(pl),
                                this.pswpElement.classList.remove(dl),
                                document.body.classList.remove(vl),
                                tt(this.pswpElement));
                        }
                    }
                    closePopup(t) {
                        (null == t || t.preventDefault(),
                            document.body.classList.contains(yl) &&
                            document.dispatchEvent(
                                new CustomEvent("theme:drawer:closing", { bubbles: !0 }),
                            ),
                            this.pswpElement.classList.add(ul),
                            this.swatchesContainer.onUnload());
                    }
                    closeOnAnimationEnd(t) {
                        ("quickViewAnimateOutRight" != t.animationName &&
                            "quickViewAnimateOutDown" != t.animationName) ||
                            (this.popup.template.classList.remove(ul, pl),
                                this.popup.close(),
                                this.productForms.length > 0 &&
                                this.productForms.forEach((t) => t.onUnload()));
                    }
                    closeOnEscape(t) {
                        const e = document.body.classList.contains(gl),
                            i = document.body.classList.contains(hl);
                        t.code === theme.keyboardKeys.ESCAPE &&
                            e &&
                            !i &&
                            this.closePopup(t);
                    }
                    initProductSlider(t, i) {
                        const s = t.querySelector(Ya),
                            o = t.querySelectorAll(Ja);
                        if (o.length > 1) {
                            const n = new e(s, {
                                wrapAround: !0,
                                cellAlign: "left",
                                pageDots: !1,
                                prevNextButtons: !0,
                                adaptiveHeight: !1,
                                pauseAutoPlayOnHover: !1,
                                selectedAttraction: 0.2,
                                friction: 1,
                                autoPlay: !1,
                                on: {
                                    ready: () => {
                                        (s.setAttribute(El, "-1"),
                                            requestAnimationFrame(() => {
                                                n.resize();
                                            }));
                                    },
                                    settle: () => {
                                        const e = n.selectedElement,
                                            i = e.getAttribute(bl);
                                        (e.setAttribute(El, "0"),
                                            n.cells.forEach((t) => {
                                                t.element !== e && t.element.setAttribute(El, "-1");
                                            }),
                                            this.switchMedia(t, i));
                                    },
                                },
                            });
                            (this.flkty.push(n),
                                o.length &&
                                o.forEach((t) => {
                                    (t.addEventListener("theme:media:play", () => {
                                        (this.handleDraggable(this.flkty[i], !1),
                                            t.closest(Ya).classList.add(nl));
                                    }),
                                        t.addEventListener("theme:media:pause", () => {
                                            (this.handleDraggable(this.flkty[i], !0),
                                                t.closest(Ya).classList.remove(nl));
                                        }));
                                }),
                                Ne(s));
                        }
                    }
                    switchMedia(t, e) {
                        const i = this.quickViewInner.querySelectorAll(Ja),
                            s = t.querySelector(`${Ja}[${bl}="${e}"]`),
                            o = !document.body.classList.contains(cl);
                        (i.length &&
                            i.forEach((t) => {
                                (t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                                    bubbles: !0,
                                }),
                                    t.classList.add(ll));
                            }),
                            o && s.focus(),
                            s.closest(Ya).classList.remove(nl),
                            s.classList.remove(ll),
                            s.dispatchEvent(new CustomEvent("theme:media:visible"), {
                                bubbles: !0,
                            }));
                        const n = s.querySelector(Na);
                        n &&
                            "true" !== n.getAttribute(Sl) &&
                            s.querySelector(Wa).dispatchEvent(new Event("click"));
                    }
                    initProductVideo(t) {
                        const e = new si(t);
                        this.videos.push(e);
                    }
                    initProductModel(t) {
                        const e = t.getAttribute(wl),
                            i = t.querySelectorAll(Za);
                        i.length &&
                            i.forEach((t) => {
                                theme.ProductModel.init(t, e);
                            });
                    }
                    initShopifyXrLaunch(t) {
                        document.addEventListener("shopify_xr_launch", () => {
                            t.querySelector(`${Za}:not(.${ll})`).dispatchEvent(
                                new CustomEvent("xrLaunch"),
                            );
                        });
                    }
                    addFormSuffix(t) {
                        const e = `${t.getAttribute(wl)}-${JSON.parse(t.querySelector(tl).innerHTML).handle}`,
                            i = t.querySelector(Xa),
                            s = t.querySelector(Va);
                        (i.setAttribute(fl, Cl + e), s.setAttribute(fl, ql + e));
                    }
                    constructor(t, e) {
                        ((this.popup = t),
                            (this.pswpElement = e),
                            (this.quickViewFoot = this.pswpElement.querySelector(el)),
                            (this.quickViewInner = this.pswpElement.querySelector(Ga)),
                            (this.product = this.pswpElement.querySelectorAll(Qa)),
                            (this.flkty = []),
                            (this.videos = []),
                            (this.productForms = []),
                            (this.deferredMedias = this.pswpElement.querySelectorAll(Na)),
                            (this.buttonsShopTheLookThumb =
                                this.pswpElement.querySelectorAll(il)),
                            (this.quickViewItemHolders =
                                this.pswpElement.querySelectorAll(Ka)),
                            (this.popupCloseButtons =
                                this.quickViewInner.querySelectorAll(Ua)),
                            (this.a11y = be),
                            (this.prevent3dModelSubmitEvent = (t) =>
                                this.prevent3dModelSubmit(t)),
                            (this.closeOnAnimationEndEvent = (t) =>
                                this.closeOnAnimationEnd(t)),
                            (this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
                            (this.outerCloseEvent = (t) => {
                                if (!this.quickViewInner.contains(t.target)) {
                                    const e = this.quickViewInner.nextElementSibling;
                                    if (e && e.contains(t.target)) return;
                                    this.closePopup(t);
                                }
                            }),
                            this.product.forEach((t, e) => {
                                t.hasAttribute(Ll) || this.initItems(t, e);
                            }),
                            this.init(),
                            this.initTooltips(),
                            this.initPopouts(),
                            (this.swatchesContainer = new As(this.pswpElement)));
                    }
                })(this.popup, this.pswpElement),
                this.pswpElement.classList.contains(Rl) &&
                new (class {
                    init() {
                        this.popup.listen("preventDragEvent", (t, e, i) => {
                            i.prevent = !1;
                        });
                        const t =
                            -1 !== window.location.search.indexOf("?customer_posted=true");
                        this.notificationForm = this.pswpElement.querySelector(_e);
                        const e = this.pswpElement.querySelector(ze);
                        (document.body.classList.add(Ve),
                            this.pswpElement.addEventListener("mousedown", () => {
                                this.popup.framework.unbind(
                                    window,
                                    "pointermove pointerup pointercancel",
                                    this.popup,
                                );
                            }),
                            t && this.pswpElement.classList.add(Re),
                            this.notificationForm.addEventListener("submit", (t) =>
                                this.notificationSubmitEvent(t),
                            ),
                            this.pswpElement.addEventListener(
                                "click",
                                this.outerCloseEvent,
                            ),
                            e.addEventListener("click", () => {
                                this.popup.close();
                            }),
                            this.popup.listen("destroy", () => {
                                (this.notificationRemoveStorage(),
                                    this.pswpElement.removeEventListener(
                                        "click",
                                        this.outerCloseEvent,
                                    ),
                                    document.body.classList.remove(Ve));
                            }));
                    }
                    notificationSubmitEvent(t) {
                        this.notificationStopSubmit &&
                            (t.preventDefault(),
                                this.notificationRemoveStorage(),
                                this.notificationWriteStorage(),
                                (this.notificationStopSubmit = !1),
                                this.notificationForm.submit());
                    }
                    notificationWriteStorage() {
                        void 0 !== this.sessionStorage &&
                            this.sessionStorage.setItem(
                                "notification_form_id",
                                this.notificationForm.id,
                            );
                    }
                    notificationRemoveStorage() {
                        this.sessionStorage.removeItem("notification_form_id");
                    }
                    constructor(t, e) {
                        ((this.popup = t),
                            (this.pswpElement = e),
                            (this.notificationForm = null),
                            (this.notificationStopSubmit = !0),
                            (this.sessionStorage = window.sessionStorage));
                        const i = this.pswpElement.querySelector($e);
                        ((this.outerCloseEvent = (t) => {
                            i.contains(t.target) || this.popup.close();
                        }),
                            this.init());
                    }
                })(this.popup, this.pswpElement),
                (this.closePopup = () => {
                    this.pswpElement.classList.contains(Vl)
                        ? this.pswpElement.classList.add(Wl)
                        : this.popup.close();
                }),
                this.closeBtn &&
                this.closeBtn.addEventListener("click", this.closePopup),
                document.addEventListener("theme:cart:added", this.closePopup));
        }
        dispatchPopupInitEvent() {
            this.triggerBtn &&
                this.triggerBtn.dispatchEvent(
                    new CustomEvent("theme:popup:init", { bubbles: !0 }),
                );
        }
        initVideo() {
            const t = this.pswpElement.querySelector(xl);
            if (t) {
                const e = t.getAttribute(jl);
                ((this.isVideo = !0),
                    "youtube" == e
                        ? new (class {
                            init() {
                                window.isYoutubeAPILoaded
                                    ? this.loadYoutubePlayer()
                                    : Se({ url: "https://www.youtube.com/iframe_api" }).then(
                                        () => this.loadYoutubePlayer(),
                                    );
                            }
                            loadYoutubePlayer() {
                                const t = {
                                    height: "720",
                                    width: "1280",
                                    playerVars: this.videoOptionsVars,
                                    events: {
                                        onReady: (t) => {
                                            const e = t.target.getIframe().id;
                                            ("true" ===
                                                document.querySelector(`#${e}`).getAttribute(xe)
                                                ? t.target.unMute()
                                                : t.target.mute(),
                                                t.target.playVideo(),
                                                this.checkPlayerVisibilityFlag &&
                                                (this.checkPlayerVisibility(e),
                                                    window.addEventListener(
                                                        "scroll",
                                                        Yt(() => {
                                                            this.checkPlayerVisibility(e);
                                                        }, 150),
                                                    )));
                                        },
                                        onStateChange: (t) => {
                                            (0 == t.data && t.target.playVideo(),
                                                1 == t.data &&
                                                t.target
                                                    .getIframe()
                                                    .parentElement.classList.add(Oe));
                                        },
                                    },
                                };
                                ((t.videoId = this.videoID),
                                    this.videoID.length &&
                                    YT.ready(() => {
                                        Be[this.playerID] = new YT.Player(this.playerID, t);
                                    }),
                                    (window.isYoutubeAPILoaded = !0));
                            }
                            checkPlayerVisibility(t) {
                                let e;
                                if ("string" == typeof t) e = t;
                                else {
                                    if (null == t.data) return;
                                    e = t.data.id;
                                }
                                const i = document.getElementById(e + "-container");
                                if (!i) return;
                                const s = Be[e],
                                    o = i.getBoundingClientRect();
                                let n =
                                    visibilityHelper.isElementPartiallyVisible(i) ||
                                    visibilityHelper.isElementTotallyVisible(i);
                                (o.top < 0 && i.clientHeight + o.top >= 0 && (n = !0),
                                    n && s && "function" == typeof s.playVideo
                                        ? s.playVideo()
                                        : !n &&
                                        s &&
                                        "function" == typeof s.pauseVideo &&
                                        s.pauseVideo());
                            }
                            onUnload() {
                                const t = "youtube-" + this.container.getAttribute(Fe);
                                Be[t] && Be[t].destroy();
                            }
                            constructor(t) {
                                ((this.container = t),
                                    (this.player = this.container.querySelector(
                                        Ie.videoIframe,
                                    )),
                                    this.player &&
                                    ((this.videoOptionsVars = {}),
                                        (this.videoID = this.player.getAttribute(De)),
                                        (this.videoType = this.player.getAttribute(Me)),
                                        "youtube" == this.videoType &&
                                        ((this.checkPlayerVisibilityFlag =
                                            "true" === this.player.getAttribute(He)),
                                            (this.playerID = this.player.querySelector(
                                                Ie.youtubeWrapper,
                                            )
                                                ? this.player.querySelector(Ie.youtubeWrapper).id
                                                : this.player.id),
                                            this.player.hasAttribute(Ie.dataHideOptions) &&
                                            (this.videoOptionsVars = {
                                                cc_load_policy: 0,
                                                iv_load_policy: 3,
                                                modestbranding: 1,
                                                playsinline: 1,
                                                autohide: 0,
                                                controls: 0,
                                                branding: 0,
                                                showinfo: 0,
                                                rel: 0,
                                                fs: 0,
                                                wmode: "opaque",
                                            }),
                                            this.init(),
                                            this.container.addEventListener(
                                                "touchstart",
                                                function (t) {
                                                    if (
                                                        t.target.matches(Ie.videoWrapper) ||
                                                        t.target.closest(Ie.videoWrapper)
                                                    ) {
                                                        const e = t.target.querySelector(
                                                            Ie.videoIframe,
                                                        ).id;
                                                        Be[e].playVideo();
                                                    }
                                                },
                                                { passive: !0 },
                                            ))));
                            }
                        })(t.parentElement)
                        : "vimeo" == e &&
                        new (class {
                            init() {
                                this.loadVimeoPlayer();
                            }
                            loadVimeoPlayer() {
                                const t = "https://vimeo.com/" + this.videoID;
                                let e = "";
                                const i = this.player,
                                    s = {
                                        url: t,
                                        background: this.enableBackground,
                                        muted: this.disableSound,
                                        autoplay: this.enableAutoplay,
                                        loop: this.enableLoop,
                                    };
                                for (let t in s)
                                    e +=
                                        encodeURIComponent(t) +
                                        "=" +
                                        encodeURIComponent(s[t]) +
                                        "&";
                                fetch(`https://vimeo.com/api/oembed.json?${e}`)
                                    .then((t) => t.json())
                                    .then(function (t) {
                                        ((i.innerHTML = t.html),
                                            setTimeout(function () {
                                                i.parentElement.classList.add(Le);
                                            }, 1e3));
                                    })
                                    .catch(function () {
                                        console.log("error");
                                    });
                            }
                            constructor(t) {
                                ((this.container = t),
                                    (this.player = this.container.querySelector(Ee)),
                                    this.player &&
                                    ((this.videoID = this.player.getAttribute(Te)),
                                        (this.videoType = this.player.getAttribute(Pe)),
                                        (this.enableBackground =
                                            "true" === this.player.getAttribute(Ae)),
                                        (this.disableSound =
                                            "false" === this.player.getAttribute(ke)),
                                        (this.enableAutoplay =
                                            "false" !== this.player.getAttribute(Ce)),
                                        (this.enableLoop =
                                            "false" !== this.player.getAttribute(qe)),
                                        "vimeo" == this.videoType && this.init()));
                            }
                        })(t.parentElement));
            }
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.firstChild &&
                (this.popupThumbsContainer.addEventListener("wheel", (t) =>
                    this.stopDisabledScroll(t),
                ),
                    this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
                        this.stopDisabledScroll(t),
                    ),
                    this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
                        this.stopDisabledScroll(t),
                    ),
                    (this.popupThumbs = this.pswpElement.querySelectorAll(`${Hl} > *`)),
                    this.popupThumbs.forEach((t, e) => {
                        t.addEventListener("click", (i) => {
                            (i.preventDefault(),
                                t.parentElement.querySelector(`.${Ml}`).classList.remove(Ml),
                                t.classList.add(Ml),
                                this.popup.goTo(e));
                        });
                    }));
        }
        hideUnusedButtons() {
            this.pswpElement.querySelectorAll(Dl).forEach((t) => {
                t.classList.contains(zl) || (t.style.display = "none");
            });
        }
        stopDisabledScroll(t) {
            t.stopPropagation();
        }
        onClose() {
            const t = this.pswpElement.querySelector(Fl);
            if (
                (t && t.parentNode.removeChild(t),
                    this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
            )
                for (; this.popupThumbsContainer.firstChild;)
                    this.popupThumbsContainer.removeChild(
                        this.popupThumbsContainer.firstChild,
                    );
            this.pswpElement.setAttribute(Ul, "");
            const e = this.pswpElement.querySelector(`.${_l}`);
            (e && this.pswpElement.removeChild(e),
                document.body.classList.contains(Nl) || this.a11y.removeTrapFocus(),
                document.removeEventListener("theme:cart:added", this.closePopup),
                setTimeout(() => {
                    const t = this.recentlyOpenedPopupsCount(),
                        e = document.body.classList.contains(Nl);
                    0 !== t ||
                        e ||
                        document.dispatchEvent(
                            new CustomEvent("theme:scroll:unlock", { bubbles: !0 }),
                        );
                }, Tl));
        }
        recentlyOpenedPopupsCount() {
            let t = 0;
            return (
                this.pswpElements.forEach((e) => {
                    e.classList.contains($l) && (t += 1);
                }),
                t
            );
        }
        setCurrentThumb() {
            if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
                return;
            const t = this.pswpElement.querySelector(`${Hl} > .${Ml}`);
            if ((t && t.classList.remove(Ml), !this.popupThumbs)) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            (e.classList.add(Ml), this.scrollThumbs(e));
        }
        scrollThumbs(t) {
            const e =
                this.popupThumbsContainer.scrollLeft +
                this.popupThumbsContainer.offsetWidth,
                i = t.offsetLeft;
            if (e <= i + t.offsetWidth || e > i) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({
                    top: 0,
                    left: i - e,
                    behavior: "smooth",
                });
            }
        }
        constructor(t, e = "", i = 0, s = null) {
            ((this.items = t),
                (this.triggerBtn = s),
                (this.pswpElements = document.querySelectorAll(Pl)),
                (this.pswpElement = this.pswpElements[i]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.popupThumbsContainer = this.pswpElement.querySelector(Hl)),
                (this.closeBtn = this.pswpElement.querySelector(Il)));
            ((this.options =
                "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
                (this.onCloseCallback = () => this.onClose()),
                (this.dispatchPopupInitEventCallback = () =>
                    this.dispatchPopupInitEvent()),
                (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
                (this.loadingStateCallback = (t) => this.loadingState(t)),
                (this.a11y = be),
                this.init());
        }
    };
    const Ql = 0,
        Xl = "[data-button-quick-view]",
        Yl = "[data-quick-view-items-template]",
        Jl = "[data-cart-drawer]",
        Zl = "[data-shop-the-look-quick-view-button]",
        tc = "[data-shop-the-look-thumb]",
        ec = "[data-quick-view-item-holder]",
        ic = "is-loading",
        sc = "is-active",
        oc = "js-quick-view-from-cart",
        nc = "popup-quick-view pswp--not-close-btn",
        rc = "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn",
        ac = "data-handle",
        lc = "data-variant-id",
        cc = "data-shop-the-look-quick-view",
        hc = "data-hotspot",
        dc = "data-initialized",
        uc = {
            history: !1,
            focus: !1,
            mainClass: nc,
            showHideOpacity: !1,
            closeOnVerticalDrag: !1,
            closeOnScroll: !1,
            modal: !1,
            escKey: !1,
        };
    let pc = class {
        popupInit(t) {
            var e, i;
            const s = this.loadPhotoswipe.pswpElement.querySelector(
                `[${hc}="${t.getAttribute(hc)}"]`,
            ),
                o = this.loadPhotoswipe.pswpElement.querySelectorAll(ec);
            (s.classList.add(sc),
                o.forEach((t) => {
                    t !== s && t.classList.remove(sc);
                }),
                this.toggleQuickViewButtonsLoadingClasses(!0),
                this.toggleQuickViewThumbsLoadingClasses(!0));
            const n = (t) => {
                ("quickViewAnimateInUp" === t.animationName &&
                    requestAnimationFrame(() => {
                        this.toggleQuickViewThumbsLoadingClasses(!1);
                    }),
                    "quickViewAnimateOutDown" === t.animationName &&
                    this.loadPhotoswipe.pswpElement.removeEventListener(
                        "animationend",
                        n,
                    ));
            };
            (this.loadPhotoswipe.pswpElement.addEventListener("animationend", n),
                null === (e = this.loadPhotoswipe) ||
                void 0 === e ||
                null === (i = e.popup) ||
                void 0 === i ||
                i.listen("destroy", () => {
                    (this.toggleQuickViewButtonsLoadingClasses(!1),
                        this.toggleQuickViewThumbsLoadingClasses(!1));
                }));
        }
        toggleQuickViewButtonsLoadingClasses(t = !0) {
            var e, i;
            t
                ? null === (i = this.buttonsQuickView) ||
                void 0 === i ||
                i.forEach((t) => {
                    t.classList.add(ic);
                })
                : null === (e = this.buttonsQuickView) ||
                void 0 === e ||
                e.forEach((t) => {
                    t.classList.remove(ic);
                });
        }
        toggleQuickViewThumbsLoadingClasses(t = !0) {
            var e, i, s;
            ((this.buttonsShopTheLookThumb =
                null === (e = this.loadPhotoswipe) || void 0 === e
                    ? void 0
                    : e.pswpElement.querySelectorAll(tc)),
                t)
                ? null === (s = this.buttonsShopTheLookThumb) ||
                void 0 === s ||
                s.forEach((t) => {
                    t.classList.add(ic);
                })
                : null === (i = this.buttonsShopTheLookThumb) ||
                void 0 === i ||
                i.forEach((t) => {
                    t.classList.remove(ic);
                });
        }
        initPhotoswipe(t) {
            t.preventDefault();
            const e = t.target.matches(Xl) ? t.target : t.target.closest(Xl),
                i = window.innerWidth < theme.sizes.small;
            let s = "",
                o = !1;
            if (e.hasAttribute(cc)) {
                if (!i) return;
                o = !0;
            }
            ((uc.mainClass = nc),
                e.classList.add(ic),
                e.closest(Jl) && document.body.classList.add(oc),
                (this.a11y.state.trigger = e),
                e.hasAttribute(lc) && (s = `&variant=${e.getAttribute(lc)}`));
            const n = `${theme.routes.root}products/${e.getAttribute(ac)}?section_id=api-quickview${s}`;
            if (o) {
                ((uc.mainClass = rc),
                    this.buttonsQuickView.forEach((t) => {
                        t.classList.add(ic);
                    }));
                const t = new XMLSerializer(),
                    i = this.container
                        .querySelector(Yl)
                        .content.firstElementChild.cloneNode(!0),
                    s = t.serializeToString(i);
                this.loadPhotoswipeWithTemplate(s, e);
            } else this.loadPhotoswipeFromFetch(n, e);
        }
        loadPhotoswipeWithTemplate(t, e) {
            const i = [{ html: t }];
            this.loadPhotoswipe = new Kl(i, uc, Ql, e);
        }
        loadPhotoswipeFromFetch(t, e) {
            fetch(t)
                .then((t) => t.text())
                .then((t) => {
                    const i = [{ html: t }];
                    this.loadPhotoswipe = new Kl(i, uc, Ql, e);
                })
                .catch((t) => console.log("error: ", t));
        }
        constructor(t) {
            var e, i;
            ((this.container = t),
                (this.a11y = be),
                (this.buttonsQuickView = this.container.querySelectorAll(Xl)),
                (this.buttonsShopTheLookQuickView =
                    this.container.querySelectorAll(Zl)),
                (this.popupInitCallback = (t) => this.popupInit(t)),
                null === (e = this.buttonsQuickView) ||
                void 0 === e ||
                e.forEach((t) => {
                    t.hasAttribute(dc) ||
                        (t.addEventListener("click", (t) => this.initPhotoswipe(t)),
                            t.addEventListener("theme:popup:init", () => {
                                (t.classList.remove(ic),
                                    t.hasAttribute(cc) && this.popupInitCallback(t));
                            }),
                            t.setAttribute(dc, ""));
                }),
                null === (i = this.buttonsShopTheLookQuickView) ||
                void 0 === i ||
                i.forEach((t) => {
                    t.addEventListener("click", () => {
                        var t;
                        null === (t = this.buttonsQuickView[0]) ||
                            void 0 === t ||
                            t.dispatchEvent(new Event("click"));
                    });
                }));
        }
    };
    const mc = {
        cartDrawerEnabled: "drawer" === window.theme.settings.cartType,
        timers: { addProductTimeout: 1e3 },
        animations: { data: "data-aos", method: "fade-up" },
    },
        gc = {
            outerSection: "[data-section-id]",
            aos: "[data-aos]",
            additionalCheckoutButtons: "[data-additional-checkout-button]",
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiUpsellItems: "[data-api-upsell-items]",
            apiCartPrice: "[data-api-cart-price]",
            buttonAddToCart: "[data-add-to-cart]",
            upsellButtonByHandle: "[data-handle]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "[data-cart-drawer]",
            cartDrawerTemplate: "[data-cart-drawer-template]",
            cartDrawerToggle: "[data-cart-drawer-toggle]",
            cartDrawerBody: "[data-cart-drawer-body]",
            cartErrors: "[data-cart-errors]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartItemRemove: "[data-item-remove]",
            cartItemsQty: "[data-cart-items-qty]",
            cartTotal: "[data-cart-total]",
            cartTotalPrice: "[data-cart-total-price]",
            cartMessage: "[data-cart-message]",
            cartMessageDefault: "[data-message-default]",
            cartPage: "[data-cart-page]",
            cartProgress: "[data-cart-message-progress]",
            emptyMessage: "[data-empty-message]",
            buttonHolder: "[data-foot-holder]",
            item: "[data-cart-item]",
            itemsHolder: "[data-items-holder]",
            itemsWrapper: "[data-items-wrapper]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            upsellHolder: "[data-upsell-holder]",
            errorMessage: "[data-error-message]",
            termsErrorMessage: "[data-terms-error-message]",
            pairProductsHolder: "[data-pair-products-holder]",
            pairProducts: "[data-pair-products]",
            priceHolder: "[data-cart-price-holder]",
            leftToSpend: "[data-left-to-spend]",
            quickBuyForm: "[data-quickbuy-form]",
            qtyInput: "[data-quantity-field]",
            productMediaContainer: "[data-product-media-container]",
            formWrapper: "[data-form-wrapper]",
            productForm: "[data-product-form]",
            popupQuickView: ".popup-quick-view",
            popupClose: "[data-popup-close]",
            error: "[data-error]",
            quickViewOnboarding: "[data-quick-view-onboarding]",
            flickityEnabled: ".flickity-enabled",
        },
        vc = "hidden",
        yc = "is-hidden",
        fc = "js-drawer-open-cart",
        bc = "is-open",
        wc = "is-visible",
        Sc = "is-expanded",
        Ec = "is-loading",
        Lc = "is-disabled",
        kc = "is-success",
        Ac = "cart__toggle--has-items",
        Cc = "variant--soldout",
        qc = "is-removed",
        Tc = "aos-animate",
        Pc = "is-updated",
        Ic = "no-outline",
        Fc = "product-grid-item__image--error",
        xc = "cv-h",
        Hc = "data-limit",
        Dc = "data-cart-message",
        Mc = "data-cart-total",
        Oc = "aria-expanded",
        Bc = "disabled",
        _c = "value",
        $c = "data-id",
        zc = "data-item",
        Rc = "data-item-index",
        Vc = "data-item-title",
        Nc = "data-atc-trigger",
        Wc = "data-notification-popup",
        Uc = "data-recipient-errors";
    let jc = {},
        Gc = class {
            init() {
                var t;
                ((this.cartToggleButtons = document.querySelectorAll(
                    gc.cartDrawerToggle,
                )),
                    (this.cartPage = document.querySelector(gc.cartPage)),
                    (this.cartDrawer = document.querySelector(gc.cartDrawer)),
                    (this.cart = this.cartDrawer || this.cartPage),
                    (this.cartCount = this.getCartItemCount()),
                    this.assignArguments(),
                    (this.recipientErrors =
                        "true" ===
                        (null === (t = this.form) || void 0 === t
                            ? void 0
                            : t.getAttribute(Uc))),
                    (this.flktyUpsell = null),
                    (this.form = null),
                    (this.collapsible = null),
                    (this.a11y = be),
                    (this.build = this.build.bind(this)),
                    (this.addToCart = this.addToCart.bind(this)),
                    (this.updateCart = this.updateCart.bind(this)),
                    (this.openCartDrawer = this.openCartDrawer.bind(this)),
                    (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                    (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                    (this.formSubmitHandler = Yt(this.formSubmitHandler.bind(this), 50)),
                    (this.closeCartError = () => {
                        this.cartErrorHolder.classList.remove(Sc);
                    }),
                    (this.cartDrawerCloseEvent = null),
                    (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                    (this.isCartPage = Boolean(this.cart && null === this.cartDrawer)),
                    (this.toggleClassesOnContainers =
                        this.toggleClassesOnContainers.bind(this)),
                    (this.totalItems = 0),
                    (this.isCartDrawerOpen = !1),
                    (this.isCartDrawerLoaded = !1),
                    (this.cartDiscounts = 0),
                    (this.cartDrawerEnabled = mc.cartDrawerEnabled),
                    (this.cartUpdateFailed = !1),
                    this.cartEvents(),
                    this.cartAddEvent(),
                    this.cartDrawerToggleEvents(),
                    this.initQuantity(),
                    this.buttonHolder && (this.collapsible = new ce(this.buttonHolder)),
                    this.isCartPage && this.renderPairProducts(),
                    document.addEventListener("theme:popup:open", this.closeCartDrawer));
            }
            assignArguments() {
                ((this.outerSection = this.cart.closest(gc.outerSection)),
                    (this.cartDrawerBody = document.querySelector(gc.cartDrawerBody)),
                    (this.emptyMessage = document.querySelector(gc.emptyMessage)),
                    (this.buttonHolder = document.querySelector(gc.buttonHolder)),
                    (this.itemsHolder = document.querySelector(gc.itemsHolder)),
                    (this.cartItemsQty = document.querySelector(gc.cartItemsQty)),
                    (this.itemsWrapper = document.querySelector(gc.itemsWrapper)),
                    (this.items = document.querySelectorAll(gc.item)),
                    (this.cartTotal = document.querySelector(gc.cartTotal)),
                    (this.cartTotalPrice = document.querySelector(gc.cartTotalPrice)),
                    (this.cartMessage = document.querySelectorAll(gc.cartMessage)),
                    (this.cartOriginalTotal = document.querySelector(
                        gc.cartOriginalTotal,
                    )),
                    (this.cartErrorHolder = document.querySelector(gc.cartErrors)),
                    (this.cartCloseErrorMessage = document.querySelector(
                        gc.cartCloseError,
                    )),
                    (this.pairProductsHolder = document.querySelector(
                        gc.pairProductsHolder,
                    )),
                    (this.pairProducts = document.querySelector(gc.pairProducts)),
                    (this.priceHolder = document.querySelector(gc.priceHolder)),
                    (this.upsellHolders = document.querySelectorAll(gc.upsellHolder)),
                    (this.cartTermsCheckbox = document.querySelector(
                        gc.cartTermsCheckbox,
                    )),
                    (this.cartCheckoutButtonWrapper = document.querySelector(
                        gc.cartCheckoutButtonWrapper,
                    )),
                    (this.cartCheckoutButton = document.querySelector(
                        gc.cartCheckoutButton,
                    )),
                    (this.cartForm = document.querySelector(gc.cartForm)),
                    (this.cartItemCount = 0),
                    (this.subtotal = window.theme.subtotal),
                    (this.button = null));
                const { headerInitialHeight: t, announcementBarHeight: e } = q();
                ((this.headerInitialHeight = t),
                    (this.announcementBarHeight = e),
                    this.cartMessage.length > 0 &&
                    (this.cartFreeLimitShipping =
                        100 *
                        Number(this.cartMessage[0].getAttribute(Hc)) *
                        window.Shopify.currency.rate),
                    this.updateProgress());
            }
            initQuantity() {
                var t;
                ((this.items = document.querySelectorAll(gc.item)),
                    null === (t = this.items) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        (new fe(t, !0).init(), this.cartUpdateEvent(t));
                    }));
            }
            cartUpdateEvent(t) {
                t.addEventListener("theme:cart:update", (e) => {
                    this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                });
            }
            cartEvents() {
                const t = document.querySelectorAll(gc.cartItemRemove);
                ((this.totalItems = t.length),
                    null == t ||
                    t.forEach((t) => {
                        const e = t.closest(gc.item);
                        t.addEventListener("click", (i) => {
                            (i.preventDefault(),
                                t.classList.contains(Lc) ||
                                this.updateCart(
                                    { id: e.getAttribute($c), quantity: 0 },
                                    e,
                                ));
                        });
                    }),
                    this.cartCloseErrorMessage &&
                    (this.cartCloseErrorMessage.removeEventListener(
                        "click",
                        this.closeCartError,
                    ),
                        this.cartCloseErrorMessage.addEventListener(
                            "click",
                            this.closeCartError,
                        )),
                    this.cartTermsCheckbox &&
                    (this.cartTermsCheckbox.removeEventListener(
                        "change",
                        this.formSubmitHandler,
                    ),
                        this.cartCheckoutButtonWrapper.removeEventListener(
                            "click",
                            this.formSubmitHandler,
                        ),
                        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                        this.cartTermsCheckbox.addEventListener(
                            "change",
                            this.formSubmitHandler,
                        ),
                        this.cartCheckoutButtonWrapper.addEventListener(
                            "click",
                            this.formSubmitHandler,
                        ),
                        this.cartForm.addEventListener("submit", this.formSubmitHandler)));
            }
            cartAddEvent() {
                document.addEventListener("click", (t) => {
                    const e = t.target,
                        i = null == e ? void 0 : e.matches(gc.buttonAddToCart),
                        s = null == e ? void 0 : e.closest(gc.buttonAddToCart);
                    if (i || s) {
                        var o, n, r;
                        (t.preventDefault(),
                            (this.button = i ? e : s),
                            (this.form = e.closest("form")),
                            (this.recipientErrors =
                                "true" ===
                                (null === (o = this.form) || void 0 === o
                                    ? void 0
                                    : o.getAttribute(Uc))),
                            (this.formWrapper = this.button.closest(gc.formWrapper)));
                        const a =
                            null === (n = this.formWrapper) || void 0 === n
                                ? void 0
                                : n.classList.contains(Cc),
                            l = this.button.hasAttribute(Bc),
                            c = this.button.closest(gc.quickViewOnboarding),
                            h = this.button.hasAttribute(Nc),
                            d = this.button.hasAttribute(Wc),
                            u =
                                null === (r = this.form) || void 0 === r
                                    ? void 0
                                    : r.querySelector('[type="file"]');
                        if (l || u || c) return;
                        if (a && d) return void new ur(this.button);
                        h && (this.a11y.state.trigger = this.button);
                        const p = new FormData(this.form);
                        (this.addToCart(p),
                            document.dispatchEvent(
                                new CustomEvent("theme:cart:add", {
                                    bubbles: !0,
                                    detail: { selector: e },
                                }),
                            ));
                    }
                });
            }
            getCart() {
                if (this.cartDrawer && !this.isCartDrawerLoaded) {
                    const t = !1;
                    this.renderCartDrawer(t);
                }
                fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                    .then(this.handleErrors)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector(gc.apiContent);
                        this.build(i);
                    })
                    .catch((t) => console.log(t));
            }
            addToCart(t) {
                (this.cartDrawerEnabled &&
                    this.button &&
                    (this.button.classList.add(Ec), this.button.setAttribute(Bc, !0)),
                    fetch(theme.routes.cart_add_url, {
                        method: "POST",
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                            Accept: "application/javascript",
                        },
                        body: t,
                    })
                        .then((t) => t.json())
                        .then((t) => {
                            if (
                                ((this.button.disabled = !0), this.addLoadingClass(), t.status)
                            )
                                return (
                                    this.addToCartError(t),
                                    this.removeLoadingClass(),
                                    void this.scrollToCartTop()
                                );
                            (this.hideAddToCartErrorMessage(),
                                this.cartDrawerEnabled
                                    ? this.getCart()
                                    : (window.location = theme.routes.cart_url));
                        })
                        .catch((t) => console.log(t)));
            }
            updateCart(t = {}, e = null) {
                let i = t.quantity;
                (null !== e && (i ? e.classList.add(Ec) : e.classList.add(qc)),
                    this.disableCartButtons(),
                    this.addLoadingClass());
                const s = this.cart.querySelector(`[${zc}="${t.id}"]`) || e,
                    o = (null == s ? void 0 : s.hasAttribute(Rc))
                        ? parseInt(s.getAttribute(Rc))
                        : 0,
                    n = (null == s ? void 0 : s.hasAttribute(Vc))
                        ? s.getAttribute(Vc)
                        : null;
                if (0 === o) return;
                const r = { line: o, quantity: i };
                fetch(theme.routes.cart_change_url, {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(r),
                })
                    .then((t) => {
                        if (400 === t.status) {
                            const e = new Error(t.status);
                            throw (
                                this.cartDrawerEnabled
                                    ? this.getCart()
                                    : (window.location = theme.routes.cart_url),
                                e
                            );
                        }
                        return t.text();
                    })
                    .then((t) => {
                        if (JSON.parse(t).errors)
                            return (
                                (this.cartUpdateFailed = !0),
                                this.updateErrorText(n),
                                this.toggleErrorMessage(),
                                this.resetLineItem(e),
                                this.enableCartButtons(),
                                this.removeLoadingClass(),
                                void this.scrollToCartTop()
                            );
                        this.getCart();
                    })
                    .catch((t) => {
                        (console.log(t),
                            this.enableCartButtons(),
                            this.removeLoadingClass());
                    });
            }
            resetLineItem(t) {
                const e = t.querySelector(gc.qtyInput),
                    i = e.getAttribute("value");
                ((e.value = i), t.classList.remove(Ec));
            }
            disableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${gc.cartItemRemove}`);
                (t.length &&
                    t.forEach((t) => {
                        (t.classList.add(Lc), t.blur(), (t.disabled = !0));
                    }),
                    e.length &&
                    e.forEach((t) => {
                        t.setAttribute(Bc, !0);
                    }));
            }
            enableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${gc.cartItemRemove}`);
                (t.length &&
                    t.forEach((t) => {
                        (t.classList.remove(Lc), (t.disabled = !1));
                    }),
                    e.length &&
                    e.forEach((t) => {
                        t.removeAttribute(Bc);
                    }));
            }
            updateErrorText(t) {
                this.cartErrorHolder.querySelector(gc.errorMessage).innerText = t;
            }
            toggleErrorMessage() {
                if (this.cartErrorHolder) {
                    if (
                        (this.cartErrorHolder.classList.toggle(Sc, this.cartUpdateFailed),
                            this.cartUpdateFailed)
                    ) {
                        const t = this.cartErrorHolder.querySelector(gc.cartCloseError);
                        this.focusOnErrorMessage(this.cartErrorHolder, t);
                    }
                    this.cartUpdateFailed = !1;
                }
            }
            handleErrors(t) {
                return t.ok
                    ? t
                    : t.json().then(function (e) {
                        throw new Jt({
                            status: t.statusText,
                            headers: t.headers,
                            json: e,
                        });
                    });
            }
            addToCartError(t) {
                const e = this.button.closest(gc.quickBuyForm),
                    i = this.button.closest(gc.upsellHolder),
                    s = !document.body.classList.contains(Ic);
                let o = (
                    this.button.closest(gc.productForm)
                        ? this.button.closest(gc.productForm)
                        : this.button.closest(gc.upsellHolder)
                ).querySelector(gc.formErrorsContainer);
                (i && (o = i.querySelector(gc.formErrorsContainer)),
                    this.cartDrawerEnabled &&
                    this.button &&
                    null !== this.button.closest(gc.cartDrawer) &&
                    !this.button.closest(gc.cartDrawer) &&
                    this.closeCartDrawer(),
                    this.button.classList.remove(Ec),
                    this.button.removeAttribute(Bc));
                const n = e
                    ? ""
                    : `\n      <button type="button" class="errors__button-close" data-close-error>\n        ${theme.icons.close}\n      </button>\n    `;
                let r = `${t.message}: ${t.description}`;
                if (
                    (t.message === t.description && (r = t.message),
                        this.recipientErrors &&
                        t.description &&
                        "object" == typeof t.description &&
                        (r = Object.entries(t.description)
                            .map(([t, e]) => `${e}`)
                            .join("<br>")),
                        (o.innerHTML = `\n      <div class="errors" data-error autofocus>\n        ${r}\n        ${n}\n      </div>\n    `),
                        e)
                ) {
                    const t = o.closest(gc.productMediaContainer);
                    (t.classList.add(Fc),
                        o.querySelector(gc.error).addEventListener("animationend", () => {
                            (t.classList.remove(Fc),
                                (o.innerHTML = ""),
                                s || document.activeElement.blur());
                        }));
                } else
                    (o.classList.add(wc),
                        o.addEventListener("transitionend", () => {
                            this.resizeSliders(o);
                        }),
                        this.handleCloseErrorMessages(o));
            }
            handleCloseErrorMessages(t) {
                const e = t.querySelector(gc.formCloseError);
                (null == e ||
                    e.addEventListener("click", (e) => {
                        const i = e.target;
                        (i.matches(gc.formCloseError) || i.closest(gc.formCloseError)) &&
                            (e.preventDefault(),
                                t.classList.remove(wc),
                                t
                                    .querySelector(gc.error)
                                    .addEventListener("transitionend", () => {
                                        ((t.innerHTML = ""), this.resizeSliders(i));
                                    }));
                    }),
                    this.focusOnErrorMessage(t, e));
            }
            focusOnErrorMessage(t, e) {
                !document.body.classList.contains(Ic) &&
                    t.addEventListener("transitionend", () => {
                        requestAnimationFrame(() =>
                            null == e ? void 0 : e.focus({ focusVisible: !0 }),
                        );
                    });
            }
            hideAddToCartErrorMessage() {
                const t = this.button.closest(gc.upsellHolder)
                    ? this.button.closest(gc.upsellHolder)
                    : this.button.closest(gc.productForm),
                    e = null == t ? void 0 : t.querySelector(gc.formErrorsContainer);
                null == e || e.classList.remove(wc);
            }
            resizeSliders(t) {
                const i = t.closest(gc.flickityEnabled);
                if (!i) return;
                const s = e.data(i);
                requestAnimationFrame(() => s.resize());
            }
            renderCartDrawer(t = !0) {
                const e = document.querySelector(gc.cartDrawerTemplate);
                e &&
                    ((this.cartDrawer.innerHTML = e.innerHTML),
                        this.assignArguments(),
                        this.initQuantity(),
                        this.cartEvents(),
                        this.buttonHolder && (this.collapsible = new ce(this.buttonHolder)),
                        (this.cartDrawerToggle = this.cartDrawer.querySelector(
                            gc.cartDrawerToggle,
                        )),
                        this.cartDrawerToggle.addEventListener(
                            "click",
                            this.cartDrawerToggleClickEvent,
                        ),
                        (this.isCartDrawerLoaded = !0),
                        this.renderPairProducts(),
                        document.dispatchEvent(
                            new CustomEvent("theme:cart:loaded", { bubbles: !0 }),
                        ),
                        t && this.openCartDrawer());
            }
            openCartDrawer() {
                this.isCartDrawerOpen ||
                    (this.isCartDrawerLoaded
                        ? (document.dispatchEvent(
                            new CustomEvent("theme:cart:open", { bubbles: !0 }),
                        ),
                            document.dispatchEvent(
                                new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0,
                                    detail: this.cartDrawer,
                                }),
                            ),
                            document.dispatchEvent(
                                new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0,
                                    detail: this.cartDrawerBody,
                                }),
                            ),
                            this.scrollToCartTop(),
                            document.body.classList.add(fc),
                            this.cartDrawer.classList.add(bc),
                            this.cartDrawer.classList.remove(xc),
                            requestAnimationFrame(() => this.animateCartItems("in")),
                            this.cartToggleButtons.forEach((t) => {
                                t.setAttribute(Oc, !0);
                            }),
                            this.a11y.trapFocus({ container: this.cartDrawer }),
                            this.observeAdditionalCheckoutButtons(),
                            (this.isCartDrawerOpen = !0))
                        : this.renderCartDrawer());
            }
            animateCartItems(t = "in") {
                const e = this.cart.querySelectorAll(gc.aos);
                ("in" === t &&
                    e.forEach((t) => requestAnimationFrame(() => t.classList.add(Tc))),
                    "out" === t && e.forEach((t) => t.classList.remove(Tc)));
            }
            closeCartDrawer() {
                if (!this.isCartDrawerOpen) return;
                (document.dispatchEvent(
                    new CustomEvent("theme:cart:close", { bubbles: !0 }),
                ),
                    this.cartErrorHolder.classList.remove(Sc),
                    this.a11y.removeTrapFocus(),
                    this.cartToggleButtons.forEach((t) => {
                        t.setAttribute(Oc, !1);
                    }),
                    document.body.classList.remove(fc),
                    this.cartDrawer.classList.remove(bc),
                    this.itemsHolder.classList.remove(Pc));
                const t = (e) => {
                    e.target === this.cartDrawer &&
                        (this.animateCartItems("out"),
                            this.cartDrawer.removeEventListener("transitionend", t));
                };
                this.cartDrawer.addEventListener("transitionend", t);
                !document.body.classList.contains(Ic) ||
                    requestAnimationFrame(() => {
                        document.activeElement.blur();
                    });
                (document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 }),
                ),
                    (this.isCartDrawerOpen = !1));
            }
            toggleCartDrawer() {
                this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
            }
            cartDrawerToggleEvents() {
                this.cartDrawer &&
                    (this.cartDrawer.addEventListener("keyup", (t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
                    }),
                        (this.cartDrawerToggleClickEvent = (t) => {
                            t.preventDefault();
                            const e = t.target;
                            ("false" === e.getAttribute(Oc) && (this.a11y.state.trigger = e),
                                this.toggleCartDrawer());
                        }),
                        (this.cartDrawerCloseEvent = (t) => {
                            const e = t.target.matches(gc.cartDrawerToggle),
                                i = document.querySelector(gc.cartDrawer).contains(t.target),
                                s = t.target.closest(gc.popupQuickView);
                            e || i || s || this.closeCartDrawer();
                        }),
                        this.cartToggleButtons.forEach((t) => {
                            t.addEventListener("click", this.cartDrawerToggleClickEvent);
                        }),
                        document.addEventListener("mousedown", this.cartDrawerCloseEvent));
            }
            toggleClassesOnContainers() {
                const t = this;
                (this.emptyMessage.classList.toggle(vc, t.hasItemsInCart()),
                    this.buttonHolder.classList.toggle(vc, !t.hasItemsInCart()),
                    this.itemsHolder.classList.toggle(vc, !t.hasItemsInCart()),
                    this.cartItemsQty.classList.toggle(vc, !t.hasItemsInCart()));
            }
            build(t) {
                const e = t.querySelector(gc.apiLineItems),
                    s = t.querySelector(gc.apiUpsellItems),
                    o = Boolean(null === e && null === s),
                    n = t.querySelector(gc.apiCartPrice),
                    r = t.querySelector(gc.cartTotal);
                (this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
                    this.animateCartItems("out"),
                    o
                        ? ((this.itemsHolder.innerHTML = ""),
                            this.pairProductsHolder &&
                            (this.pairProductsHolder.innerHTML = ""))
                        : ((this.itemsHolder.innerHTML = e.innerHTML),
                            this.pairProductsHolder &&
                            (this.pairProductsHolder.innerHTML = s.innerHTML),
                            this.renderPairProducts()),
                    (this.newTotalItems =
                        e && e.querySelectorAll(gc.item).length
                            ? e.querySelectorAll(gc.item).length
                            : 0),
                    (this.subtotal =
                        r && r.hasAttribute(Mc) ? parseInt(r.getAttribute(Mc)) : 0),
                    (this.cartCount = this.getCartItemCount()),
                    this.cartMessage.length > 0 && this.updateProgress(),
                    this.cartToggleButtons.forEach((t) => {
                        (t.classList.remove(Ac),
                            this.newTotalItems > 0 && t.classList.add(Ac));
                    }),
                    this.toggleErrorMessage(),
                    this.updateItemsQuantity(this.cartCount),
                    (this.cartTotalPrice.innerHTML =
                        0 === this.subtotal
                            ? window.theme.strings.free
                            : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
                    this.totalItems !== this.newTotalItems &&
                    ((this.totalItems = this.newTotalItems),
                        this.toggleClassesOnContainers()),
                    (this.isCartDrawerOpen || this.isCartPage) &&
                    this.itemsHolder.classList.add(Pc),
                    this.cartEvents(),
                    this.initQuantity(),
                    this.enableCartButtons(),
                    this.resetButtonClasses(),
                    this.removeLoadingClass(),
                    document.dispatchEvent(
                        new CustomEvent("theme:cart:added", { bubbles: !0 }),
                    ),
                    this.cartDrawer && this.openCartDrawer(),
                    requestAnimationFrame(() => this.animateCartItems("in")));
            }
            getCartItemCount() {
                return this.cart
                    ? Array.from(this.cart.querySelectorAll(gc.qtyInput)).reduce(
                        (t, e) => t + parseInt(e.value),
                        0,
                    )
                    : 0;
            }
            hasItemsInCart() {
                return this.totalItems > 0;
            }
            freeShippingMessageHandle(t) {
                this.cartMessage.length > 0 &&
                    document.querySelectorAll(gc.cartMessage).forEach((e) => {
                        const i =
                            e.hasAttribute(Dc) && "true" === e.getAttribute(Dc) && 0 !== t,
                            s = e.querySelector(gc.cartMessageDefault);
                        (e.classList.toggle(kc, t >= this.cartFreeLimitShipping && i),
                            e.classList.toggle(yc, 0 === t),
                            s.classList.toggle(yc, t >= this.cartFreeLimitShipping));
                    });
            }
            updateProgress() {
                const t = (this.subtotal / this.cartFreeLimitShipping) * 100,
                    e = theme.settings.currency_code_enable
                        ? i.formatMoney(
                            this.cartFreeLimitShipping - this.subtotal,
                            theme.moneyWithCurrencyFormat,
                        )
                        : i.formatMoney(
                            this.cartFreeLimitShipping - this.subtotal,
                            theme.moneyFormat,
                        );
                this.cartMessage.length > 0 &&
                    document.querySelectorAll(gc.cartMessage).forEach((i) => {
                        const s = i.querySelectorAll(gc.cartProgress),
                            o = i.querySelector(gc.leftToSpend);
                        (o && (o.innerHTML = e.replace(".00", "").replace(",00", "")),
                            s.length &&
                            s.forEach((e, i) => {
                                (e.classList.toggle(
                                    yc,
                                    this.subtotal / this.cartFreeLimitShipping >= 1,
                                ),
                                    e.style.setProperty("--progress-width", `${t}%`),
                                    0 === i && e.setAttribute(_c, t));
                            }),
                            this.freeShippingMessageHandle(this.subtotal));
                    });
            }
            renderPairProducts() {
                if (
                    ((this.flktyUpsell = null),
                        (this.pairProductsHolder = document.querySelector(
                            gc.pairProductsHolder,
                        )),
                        (this.pairProducts = document.querySelector(gc.pairProducts)),
                        (this.upsellHolders = document.querySelectorAll(gc.upsellHolder)),
                        null === this.pairProductsHolder ||
                        void 0 === this.pairProductsHolder)
                )
                    return;
                const t = this;
                this.upsellHolders.length > 1
                    ? (this.flktyUpsell = new e(this.pairProducts, {
                        wrapAround: !0,
                        pageDots: !0,
                        adaptiveHeight: !0,
                        prevNextButtons: !1,
                        on: {
                            ready: function () {
                                (new pc(t.cart),
                                    this.reloadCells(),
                                    requestAnimationFrame(() => this.resize()));
                            },
                        },
                    }))
                    : new pc(this.cart);
            }
            updateItemsQuantity(t) {
                let e = theme.strings.cart_items_one,
                    i = theme.strings.cart_items_many;
                ((e = e.split("}}")[1]),
                    (i = i.split("}}")[1]),
                    this.cartItemsQty &&
                    (this.cartItemsQty.textContent = 1 === t ? `${t}` : `${t}`));
            }
            observeAdditionalCheckoutButtons() {
                const t = this.cart.querySelector(gc.additionalCheckoutButtons);
                if (t) {
                    const e = new MutationObserver(() => {
                        (this.a11y.removeTrapFocus(),
                            this.a11y.trapFocus({ container: this.cart }),
                            e.disconnect());
                    });
                    e.observe(t, { subtree: !0, childList: !0 });
                }
            }
            formSubmitHandler() {
                const t = document.querySelector(gc.cartTermsCheckbox).checked,
                    e = document.querySelector(gc.termsErrorMessage);
                if (t)
                    (e.classList.remove(Sc), this.cartCheckoutButton.removeAttribute(Bc));
                else {
                    if (document.querySelector(gc.termsErrorMessage).length > 0) return;
                    ((e.innerText = theme.strings.cart_acceptance_error),
                        this.cartCheckoutButton.setAttribute(Bc, !0),
                        e.classList.add(Sc));
                }
            }
            resetButtonClasses() {
                const t = document.querySelectorAll(gc.buttonAddToCart);
                t &&
                    t.forEach((t) => {
                        t.classList.contains(Ec) &&
                            (t.classList.remove(Ec),
                                t.classList.add(kc),
                                setTimeout(() => {
                                    (t.removeAttribute(Bc), t.classList.remove(kc));
                                }, mc.timers.addProductTimeout));
                    });
            }
            addLoadingClass() {
                this.cartDrawer
                    ? this.cartDrawer.classList.add(Ec)
                    : this.itemsWrapper && this.itemsWrapper.classList.add(Ec);
            }
            removeLoadingClass() {
                this.cartDrawer
                    ? this.cartDrawer.classList.remove(Ec)
                    : this.itemsWrapper && this.itemsWrapper.classList.remove(Ec);
            }
            scrollToCartTop() {
                this.cartDrawer
                    ? this.cartDrawerBody.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "instant",
                    })
                    : window.scrollTo({
                        top:
                            this.outerSection.offsetTop -
                            this.headerInitialHeight -
                            this.announcementBarHeight,
                        left: 0,
                        behavior: "smooth",
                    });
            }
            unload() {
                (this.cartDrawerToggle &&
                    this.cartDrawerToggle.removeEventListener(
                        "click",
                        this.cartDrawerToggleClickEvent,
                    ),
                    this.cartToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
                    null !== this.collapsible && this.collapsible.onUnload());
            }
            constructor() {
                "/password" !== window.location.pathname && this.init();
            }
        };
    Ut("cart-template", {
        onLoad() {
            jc[this.id] = new Gc();
        },
        onUnload() {
            "function" == typeof jc[this.id].unload && jc[this.id].unload();
        },
    });
    const Kc = "is-visible",
        Qc = document.querySelector("[data-scroll-top-button]");
    Qc &&
        (Qc.addEventListener("click", () => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
            document.addEventListener(
                "scroll",
                Yt(() => {
                    Qc.classList.toggle(Kc, window.pageYOffset > window.innerHeight);
                }, 150),
            ));
    const Xc = "details",
        Yc = "[data-popdown-body]",
        Jc = "[data-popdown-close]",
        Zc = "[data-popdown-toggle]",
        th = "[data-search-form-inner]",
        eh = "[data-popular-searches-link]",
        ih = "[data-site-header]",
        sh = "[data-nav]",
        oh = "[data-nav-items-compress]",
        nh = "[data-nav-icons]",
        rh = "[data-mobile-menu]",
        ah = "predictive-search",
        lh = "search-form",
        ch = "data-popdown-in-header",
        hh = "data-popdown-in-page",
        dh = "data-search-performed",
        uh = "aria-activedescendant",
        ph = "aria-expanded",
        mh = "open",
        gh = "role",
        vh = "search-opened",
        yh = "site-header--menu-opened",
        fh = "site-header--compress-",
        bh = "is-open";
    let wh = class extends HTMLElement {
        connectedCallback() {
            (this.isPopdownInHeader &&
                (this.searchFormInner.addEventListener(
                    "transitionend",
                    this.popdownTransitionCallbackEvent,
                ),
                    this.details.addEventListener(
                        "keyup",
                        (t) => "ESCAPE" === t.code.toUpperCase() && this.close(),
                    ),
                    this.details.addEventListener(
                        "toggle",
                        this.detailsToggleCallbackEvent,
                    ),
                    this.popdownClose.addEventListener("click", (t) => this.close(t)),
                    this.popdownToggle.addEventListener("click", (t) =>
                        this.onPopdownToggleClick(t),
                    ),
                    this.popdownToggle.setAttribute(gh, "button")),
                this.isPopdownInPage &&
                (this.popdownClose.addEventListener("click", () =>
                    this.triggerPopdownClose(),
                ),
                    this.searchFormWrapper.addEventListener("focusout", () =>
                        this.onFocusOut(),
                    ),
                    this.searchFormWrapper.input.addEventListener("click", (t) =>
                        this.triggerPopdownOpen(t),
                    )),
                this.popularSearchesLink.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault();
                        const e = t.target.textContent;
                        ((this.searchFormWrapper.input.value = e),
                            this.searchFormWrapper.submit());
                    });
                }));
        }
        onPopdownToggleClick(t) {
            const e = navigator.userAgent.includes("Chrome"),
                i = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            (e && !i && t.target.closest(Xc).setAttribute(mh, ""),
                t.target.closest(Xc).hasAttribute(mh) &&
                (t.preventDefault(), this.close()));
        }
        detailsToggleCallback(t) {
            t.target.hasAttribute(mh) && this.open();
        }
        popdownTransitionCallback(t) {
            t.target === this.searchFormInner &&
                (this.details.classList.contains(bh)
                    ? "transform" === t.propertyName &&
                    this.a11y.trapFocus({ container: this.searchFormInner })
                    : this.onClose());
        }
        onBodyClick(t) {
            var e;
            const i = this.contains(t.target);
            (null === (e = this.header) || void 0 === e
                ? void 0
                : e.classList.contains(yh)) ||
                i ||
                i ||
                this.close();
        }
        onFocusOut() {
            this.predictiveSearch &&
                requestAnimationFrame(() => {
                    this.searchFormWrapper.contains(document.activeElement) ||
                        this.searchFormWrapper.close();
                });
        }
        triggerPopdownOpen(t) {
            const e = this.closest(`[${dh}="false"]`);
            let i = matchMedia("(pointer:coarse)").matches;
            const s = window.innerWidth < theme.sizes.small,
                o = i || s,
                n = null != e;
            if (
                (s && window.Shopify.designMode && (i = !0),
                    this.nav && this.mobileMenu && (o || n))
            ) {
                t.preventDefault();
                const e = this.header.classList.contains(fh);
                let s = this.mobileMenu.querySelector(Zc);
                (i ||
                    (s = e
                        ? this.nav.querySelector(`${oh} ${Zc}`)
                        : this.nav.querySelector(`${nh} ${Zc}`)),
                    setTimeout(() => {
                        null == s || s.dispatchEvent(new Event("click", { bubbles: !0 }));
                    }, 300));
            }
        }
        open() {
            ((this.onBodyClickEvent = (t) => this.onBodyClick(t)),
                this.searchFormWrapper.input.setAttribute(ph, !0),
                document.body.classList.add(vh),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.addEventListener(
                    "theme:resize",
                    this.ensureClosingOnResizeEvent,
                ),
                document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", { bubbles: !0 }),
                ),
                requestAnimationFrame(() => {
                    this.details.classList.add(bh);
                }));
        }
        close(t) {
            (t &&
                t.target === this.popdownClose &&
                "" !== this.searchFormWrapper.input.getAttribute(uh)) ||
                (this.a11y.removeTrapFocus(),
                    this.details.classList.remove(bh),
                    this.predictiveSearch && this.searchFormWrapper.close(),
                    this.searchFormWrapper.handleFocusableDescendants(!0));
        }
        triggerPopdownClose() {
            (this.predictiveSearch && this.searchFormWrapper.close(),
                this.searchFormWrapper.popularSearches &&
                requestAnimationFrame(() => document.activeElement.blur()));
        }
        onClose() {
            (this.details.removeAttribute(mh),
                document.dispatchEvent(
                    new CustomEvent("theme:search:close", { bubbles: !0 }),
                ),
                document.body.classList.remove(vh),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.removeEventListener(
                    "theme:resize",
                    this.ensureClosingOnResizeEvent,
                ),
                document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 }),
                ));
        }
        ensureClosingOnResize() {
            null === this.offsetParent && this.onClose();
        }
        constructor() {
            var t, e, i;
            (super(),
                (this.isPopdownInHeader = this.hasAttribute(ch)),
                (this.isPopdownInPage = this.hasAttribute(hh)),
                (this.popdownBody = this.querySelector(Yc)),
                (this.popdownClose = this.querySelector(Jc)),
                (this.searchFormInner = this.querySelector(th)),
                (this.popularSearchesLink = this.querySelectorAll(eh)),
                (this.searchFormWrapper = this.querySelector(lh)
                    ? this.querySelector(lh)
                    : this.querySelector(ah)),
                (this.predictiveSearch = this.searchFormWrapper.matches(ah)),
                (this.header = document.querySelector(ih)),
                (this.headerSection =
                    null === (t = this.header) || void 0 === t ? void 0 : t.parentNode),
                (this.nav =
                    null === (e = this.header) || void 0 === e
                        ? void 0
                        : e.querySelector(sh)),
                (this.mobileMenu =
                    null === (i = this.headerSection) || void 0 === i
                        ? void 0
                        : i.querySelector(rh)),
                (this.a11y = be),
                (this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
                (this.popdownTransitionCallbackEvent = (t) =>
                    this.popdownTransitionCallback(t)),
                (this.detailsToggleCallbackEvent = (t) =>
                    this.detailsToggleCallback(t)),
                this.isPopdownInHeader &&
                ((this.details = this.querySelector(Xc)),
                    (this.popdownToggle = this.querySelector(Zc))));
        }
    };
    (customElements.define("search-popdown", wh),
        (Shopify.Products = (function () {
            const t = {
                howManyToShow: 4,
                howManyToStoreInMemory: 10,
                wrapperId: "recently-viewed-products",
                section: null,
                onComplete: null,
            };
            let e = [],
                i = null,
                s = null;
            const o = new Date(),
                n = new Date();
            n.setTime(o.getTime() + 7776e6);
            const r = {
                configuration: {
                    expires: n.toGMTString(),
                    path: "/",
                    domain: window.location.hostname,
                    sameSite: "none",
                    secure: !0,
                },
                name: "shopify_recently_viewed",
                write: function (t) {
                    const e = t.join(" ");
                    document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
                },
                read: function () {
                    let t = [],
                        e = null;
                    return (
                        -1 !== document.cookie.indexOf("; ") &&
                        document.cookie
                            .split("; ")
                            .find((t) => t.startsWith(this.name)) &&
                        (e = document.cookie
                            .split("; ")
                            .find((t) => t.startsWith(this.name))
                            .split("=")[1]),
                        null !== e && (t = e.split(" ")),
                        t
                    );
                },
                destroy: function () {
                    document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                },
                remove: function (t) {
                    const e = this.read(),
                        i = e.indexOf(t);
                    -1 !== i && (e.splice(i, 1), this.write(e));
                },
            },
                a = (e, i, o, n) => {
                    i.length && e < t.howManyToShow
                        ? fetch(
                            `${window.theme.routes.root}products/${i[0]}?section_id=api-product-grid-item`,
                        )
                            .then((t) => t.text())
                            .then((t) => {
                                const s = 150 * e,
                                    l = o.id ? `#${o.id}` : "",
                                    c = document.createElement("div");
                                let h = t;
                                if (h.includes("data-unpublished"))
                                    return (r.remove(i[0]), i.shift(), void a(e, i, o, n));
                                ((h = h.includes("||itemAosDelay||")
                                    ? h.replaceAll("||itemAosDelay||", s)
                                    : h),
                                    (h = h.includes("||itemAosAnchor||")
                                        ? h.replaceAll("||itemAosAnchor||", l)
                                        : h),
                                    (c.innerHTML = h),
                                    (o.innerHTML +=
                                        c.querySelector("[data-api-content]").innerHTML),
                                    i.shift(),
                                    e++,
                                    a(e, i, o, n));
                            })
                            .catch(() => {
                                (r.remove(i[0]), i.shift(), a(e, i, o, n));
                            })
                        : ((e, i) => {
                            Un(e, !0);
                            const o = r.read().length;
                            if (
                                Shopify.recentlyViewed &&
                                s &&
                                o &&
                                o < s &&
                                e.children.length
                            ) {
                                let t = [],
                                    i = [],
                                    s = 0;
                                for (const e in Shopify.recentlyViewed) {
                                    s += 1;
                                    const o = Shopify.recentlyViewed[e].split(" "),
                                        n = parseInt(e.split("_")[1]);
                                    ((t = [...t, ...o]),
                                        (r.read().length === n ||
                                            (s === Object.keys(Shopify.recentlyViewed).length &&
                                                !i.length)) &&
                                        (i = [...i, ...o]));
                                }
                                for (let s = 0; s < e.children.length; s++) {
                                    const o = e.children[s];
                                    (t.length && o.classList.remove(...t),
                                        i.length && o.classList.add(...i));
                                }
                            }
                            if (t.onComplete)
                                try {
                                    t.onComplete(e, i);
                                } catch (t) {
                                    console.log(t);
                                }
                        })(o, n);
                };
            return {
                showRecentlyViewed: function (o) {
                    const n = o || {};
                    (Object.assign(t, n),
                        (e = r.read()),
                        (i = document.querySelector(`#${t.wrapperId}`)),
                        (s = t.howManyToShow),
                        (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
                        t.howManyToShow && i && a(0, e, i, t.section));
                },
                getConfig: function () {
                    return t;
                },
                clearList: function () {
                    r.destroy();
                },
                recordRecentlyViewed: function (e) {
                    const i = e || {};
                    Object.assign(t, i);
                    let s = r.read();
                    if (-1 !== window.location.pathname.indexOf("/products/")) {
                        let e = decodeURIComponent(window.location.pathname)
                            .match(
                                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/,
                            )[0]
                            .split("/products/")[1];
                        t.handle && (e = t.handle);
                        const i = s.indexOf(e);
                        (-1 === i
                            ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory)))
                            : (s.splice(i, 1), s.unshift(e)),
                            r.write(s));
                    }
                },
                hasProducts: r.read().length > 0,
            };
        })()),
        (theme.ProductModel = (function () {
            let t = {},
                e = {},
                i = {};
            const s = {
                productMediaWrapper: "[data-product-single-media-wrapper]",
                mediaGroup: "[data-product-single-media-group]",
                productXr: "[data-shopify-xr]",
                mediaId: "data-media-id",
                model3d: "data-shopify-model3d-id",
                modelViewer: "model-viewer",
                modelJson: "#ModelJson-",
                deferredMedia: "[data-deferred-media]",
                deferredMediaButton: "[data-deferred-media-button]",
            },
                o = { isLoading: "is-loading", mediaHidden: "media--hidden" };
            function n(t, n) {
                if (t.querySelector(s.deferredMedia).getAttribute("loaded")) return;
                t.classList.add(o.isLoading);
                const l = document.createElement("div");
                l.appendChild(
                    t.querySelector("template").content.firstElementChild.cloneNode(!0),
                );
                const c = l.querySelector("model-viewer"),
                    h = t.querySelector(s.deferredMedia);
                (h.appendChild(c), h.setAttribute("loaded", !0));
                const d = t.dataset.mediaId,
                    u = c.dataset.modelId,
                    p = t.closest(s.mediaGroup).parentElement.querySelector(s.productXr);
                ((i[n] = { element: p, defaultId: u }),
                    (e[d] = {
                        modelId: u,
                        mediaId: d,
                        sectionId: n,
                        container: t,
                        element: c,
                    }),
                    window.ShopifyXR
                        ? a()
                        : window.Shopify.loadFeatures([
                            { name: "shopify-xr", version: "1.0", onLoad: r },
                            { name: "model-viewer-ui", version: "1.0", onLoad: a },
                        ]));
            }
            function r(e) {
                if (e) console.warn(e);
                else if (window.ShopifyXR) {
                    for (const e in t)
                        if (t.hasOwnProperty(e)) {
                            const i = t[e];
                            if (i.loaded) continue;
                            const o = document.querySelector(`${s.modelJson}${e}`);
                            o &&
                                (window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
                                    (i.loaded = !0));
                        }
                    window.ShopifyXR.setupXRElements();
                } else
                    document.addEventListener("shopify_xr_initialized", function () {
                        r();
                    });
            }
            function a(t) {
                if (t) console.warn(t);
                else
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            const i = e[t];
                            i.modelViewerUi ||
                                ((i.modelViewerUi = new Shopify.ModelViewerUI(i.element)),
                                    l(i));
                        }
            }
            function l(t) {
                const e = i[t.sectionId];
                (t.container.addEventListener("theme:media:visible", function () {
                    (e.element.setAttribute(s.model3d, t.modelId),
                        window.theme.touch ||
                        (t.modelViewerUi.play(),
                            t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                                bubbles: !0,
                            })));
                }),
                    t.container.addEventListener("theme:media:hidden", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.container.addEventListener("xrLaunch", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.element.addEventListener("load", () => {
                        (e.element.setAttribute(s.model3d, t.modelId),
                            t.container.classList.remove(o.isLoading),
                            t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                                bubbles: !0,
                            }));
                    }),
                    t.element.addEventListener(
                        "shopify_model_viewer_ui_toggle_play",
                        function () {
                            (c(t.mediaId),
                                setTimeout(() => {
                                    t.container.dispatchEvent(
                                        new CustomEvent("theme:media:play"),
                                        { bubbles: !0 },
                                    );
                                }, 50));
                        },
                    ),
                    t.element.addEventListener(
                        "shopify_model_viewer_ui_toggle_pause",
                        function () {
                            t.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                                bubbles: !0,
                            });
                        },
                    ),
                    c(t.mediaId));
            }
            function c(t) {
                const e = `[${s.mediaId}="${t}"]`,
                    i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`);
                i.length &&
                    i.forEach((t) => {
                        (t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                            bubbles: !0,
                        }),
                            t.classList.add(o.mediaHidden));
                    });
            }
            return {
                init: function (e, i) {
                    t[i] = { loaded: !1 };
                    const o = e.querySelector(s.deferredMediaButton);
                    o && o.addEventListener("click", n.bind(this, e, i));
                },
                loadContent: n,
                removeSectionModels: function (i) {
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            e[t].sectionId === i && delete e[t];
                        }
                    (delete t[i], delete theme.mediaInstances[i]);
                },
            };
        })()),
        Ut("collection-template", Qo));
    const Sh = ".template-customers-addresses",
        Eh = "[data-form]",
        Lh = "[data-form-new]",
        kh = "[data-button-new]",
        Ah = "[data-button-edit]",
        Ch = "[data-button-delete]",
        qh = "[data-button-cancel]",
        Th = "data-form-edit",
        Ph = "AddressCountryNew",
        Ih = "AddressProvinceNew",
        Fh = "AddressProvinceContainerNew",
        xh = "[data-country-option]",
        Hh = "AddressCountry",
        Dh = "AddressProvince",
        Mh = "AddressProvinceContainer",
        Oh = 'input[type="text"]:not(.optional)',
        Bh = "data-form-id",
        _h = "is-hidden",
        $h = "validation--showup";
    const zh = document.querySelector(Sh);
    zh &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    const t = this.section,
                        e = this.addressNewForm;
                    this.customerAddresses();
                    const i = t.querySelectorAll(kh);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", function (i) {
                                (i.preventDefault(),
                                    t.classList.add(_h),
                                    e.classList.remove(_h));
                            });
                        });
                    const s = t.querySelectorAll(Ah);
                    s.length &&
                        s.forEach((e) => {
                            e.addEventListener("click", function (e) {
                                e.preventDefault();
                                const i = this.getAttribute(Bh);
                                t.querySelector(`[${Th}="${i}"]`).classList.toggle(_h);
                            });
                        });
                    const o = t.querySelectorAll(Ch);
                    o.length &&
                        o.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault();
                                const e = this.getAttribute(Bh);
                                confirm(theme.strings.delete_confirm) &&
                                    Shopify.postLink("/account/addresses/" + e, {
                                        parameters: { _method: "delete" },
                                    });
                            });
                        });
                    const n = t.querySelectorAll(qh);
                    n.length &&
                        n.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                (t.preventDefault(),
                                    this.closest(Eh).classList.add(_h),
                                    document.querySelector(kh).classList.remove(_h));
                            });
                        });
                }
            }
            customerAddresses() {
                (Shopify.CountryProvinceSelector &&
                    new Shopify.CountryProvinceSelector(Ph, Ih, { hideElement: Fh }),
                    this.section.querySelectorAll(xh).forEach((t) => {
                        const e = t.getAttribute(Bh),
                            i = `${Hh}_${e}`,
                            s = `${Dh}_${e}`,
                            o = `${Mh}_${e}`;
                        new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
                    }));
            }
            validate() {
                this.accountForms.forEach((t) => {
                    const e = t.querySelector("form"),
                        i = e.querySelectorAll(Oh);
                    e.addEventListener("submit", (t) => {
                        let e = !1;
                        (i.forEach((t) => {
                            t.value
                                ? t.nextElementSibling.classList.remove($h)
                                : (t.nextElementSibling.classList.add($h), (e = !0));
                        }),
                            e && t.preventDefault());
                    });
                });
            }
            constructor(t) {
                ((this.section = t),
                    (this.addressNewForm = this.section.querySelector(Lh)),
                    (this.accountForms = this.section.querySelectorAll(Eh)),
                    this.init(),
                    this.validate());
            }
        })(zh);
    const Rh = "[data-account-form]",
        Vh = "[data-show-reset]",
        Nh = "[data-hide-reset]",
        Wh = "[data-recover-password]",
        Uh = "[data-login-form]",
        jh = "[data-recover-success]",
        Gh = "[data-recover-success-text]",
        Kh = "#recover",
        Qh = "is-hidden";
    const Xh = document.querySelector(Rh);
    (Xh &&
        new (class {
            init() {
                (window.location.hash == Kh
                    ? this.showRecoverPasswordForm()
                    : this.hideRecoverPasswordForm(),
                    this.success && this.successText.classList.remove(Qh),
                    this.showButton.addEventListener(
                        "click",
                        (t) => {
                            (t.preventDefault(), this.showRecoverPasswordForm());
                        },
                        !1,
                    ),
                    this.hideButton.addEventListener(
                        "click",
                        (t) => {
                            (t.preventDefault(), this.hideRecoverPasswordForm());
                        },
                        !1,
                    ));
            }
            showRecoverPasswordForm() {
                return (
                    this.recover.classList.remove(Qh),
                    this.login.classList.add(Qh),
                    (window.location.hash = Kh),
                    !1
                );
            }
            hideRecoverPasswordForm() {
                return (
                    this.login.classList.remove(Qh),
                    this.recover.classList.add(Qh),
                    (window.location.hash = ""),
                    !1
                );
            }
            constructor(t) {
                ((this.form = t),
                    (this.showButton = t.querySelector(Vh)),
                    (this.hideButton = t.querySelector(Nh)),
                    (this.recover = t.querySelector(Wh)),
                    (this.login = t.querySelector(Uh)),
                    (this.success = t.querySelector(jh)),
                    (this.successText = t.querySelector(Gh)),
                    this.init());
            }
        })(Xh),
        Ut("search-template", [Qo, Pn]));
    const Yh = "[data-ticker-scale]",
        Jh = "[data-ticker-text]",
        Zh = "data-clone",
        td = "data-marquee-speed",
        ed = "ticker--animated",
        id = "ticker--unloaded",
        sd = "ticker__comparitor",
        od = 1.63,
        nd = 100;
    function rd() {
        return (
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth
        );
    }
    function ad() {
        return rd() >= window.theme.sizes.small;
    }
    function ld() {
        return rd() < window.theme.sizes.small;
    }
    const cd = "[data-parallax]",
        hd = "is-disabled",
        dd = "main-content",
        ud = "shopify-section",
        pd = "data-parallax",
        md = "data-parallax-intensity",
        gd = "data-parallax-static",
        vd = "data-parallax-single",
        yd = "data-parallax-disable-on-mobile",
        fd = {};
    let bd = class {
        init() {
            (this.updateParallax(),
                document.addEventListener("theme:scroll", this.scrollEvent),
                document.addEventListener("theme:resize", this.resizeEvent));
        }
        updateParallax() {
            if (this.container.classList.contains(hd)) return;
            if (this.disableOnMobile && ld()) return;
            const t = Math.round(window.scrollY),
                e = t + this.viewportHeight;
            let i = Math.round(this.container.getBoundingClientRect().top + t);
            if ("footer" === this.animation) {
                let e = this.container.parentNode.previousElementSibling;
                (!e ||
                    e.classList.contains(ud) ||
                    e.classList.contains(dd) ||
                    (e = e.previousElementSibling),
                    (i = Math.round(
                        (null == e ? void 0 : e.getBoundingClientRect().bottom) + t,
                    )));
            }
            const s = this.container.offsetHeight;
            if (i < e && !(i + s < t)) {
                const t = e - i;
                ((this.percentage = (100 * (t - s / 2)) / this.viewportHeight),
                    (this.percentageFull = Number(t / s).toFixed(2)),
                    (this.percentageVisible = Number(
                        (100 * t) / (this.viewportHeight + s),
                    ).toFixed(2)),
                    "circle" === this.animation
                        ? this.animateCircleText()
                        : "horizontal" === this.animation ||
                            "vertical" === this.animation ||
                            "diagonal" === this.animation
                            ? this.animateOverlappingImages()
                            : "offset-ltr" === this.animation ||
                                "offset-rtl" === this.animation
                                ? this.offsetX()
                                : "footer" === this.animation && this.animateFooter());
            }
        }
        offsetX() {
            const t = this.container.hasAttribute(gd),
                e = this.container.getAttribute(md) || 100;
            let i = "offset-ltr" === this.animation ? e : 0;
            t && (i = e / 2);
            const s = "offset-ltr" === this.animation ? 1 : -1,
                o = (e * this.percentageVisible) / 100 - i,
                n = Number(o * s).toFixed(2);
            this.container.style.setProperty("--offsetX", `${n}%`);
        }
        updateHeight() {
            const t = matchMedia("(min-width: 1024px)").matches;
            (this.orientation !== D() || t) &&
                ((this.viewportHeight = Math.round(
                    Math.max(
                        document.documentElement.clientHeight,
                        window.innerHeight || 0,
                    ),
                )),
                    (this.containerHeight = this.container.offsetHeight),
                    (this.orientation = D()));
        }
        animateCircleText() {
            const t = ((70 * this.percentage) / 100) * -1;
            this.percentage > 0 &&
                this.container.style.setProperty("--rotate", `${35 + t}deg`);
        }
        animateOverlappingImages() {
            const t = 0.25 * this.container.getAttribute(md),
                e = t / 2,
                i = this.container.hasAttribute(vd),
                s = (t * this.percentage) / 100;
            let o = 0,
                n = 0,
                r = 0,
                a = 0;
            (("horizontal" !== this.animation && "diagonal" !== this.animation) ||
                ((o = -1 * e + s), (r = e - s)),
                ("vertical" !== this.animation && "diagonal" !== this.animation) ||
                ((n = e - s), (a = -1 * e + s)),
                this.container.style.setProperty("--transformX-primary", `${o}%`),
                this.container.style.setProperty("--transformY-primary", `${n}%`),
                i ||
                (this.container.style.setProperty("--transformX-secondary", `${r}%`),
                    this.container.style.setProperty("--transformY-secondary", `${a}%`)));
        }
        animateFooter() {
            const t = this.footerOffset * this.percentageFull,
                e = Number((t / this.footerOffset) * 100).toFixed(2),
                i = new WebKitCSSMatrix(
                    window.getComputedStyle(this.container).transform,
                ),
                s = Number(i.m42).toFixed(2);
            let o = Number(this.footerOffset - t).toFixed(2);
            (this.percentageFull >= 1 && (o = 0),
                s !== o &&
                this.cachedPercentage !== e &&
                (this.container.style.setProperty("--transformY", `${o}`),
                    (this.cachedPercentage = e),
                    (this.cachedPosition = o)));
        }
        unload() {
            (document.removeEventListener("theme:scroll", this.scrollEvent),
                document.removeEventListener("theme:resize", this.resizeEvent));
        }
        constructor(t) {
            ((this.container = t),
                (this.percentage = 0),
                (this.percentageFull = 0),
                (this.animation = this.container.getAttribute(pd)),
                (this.disableOnMobile = this.container.hasAttribute(yd)),
                (this.viewportHeight = Math.max(
                    document.documentElement.clientHeight,
                    window.innerHeight || 0,
                )),
                (this.orientation = D()),
                (this.scrollEvent = () => this.updateParallax()),
                (this.resizeEvent = () => this.updateHeight()),
                requestAnimationFrame(() => {
                    ((this.containerHeight = this.container.offsetHeight),
                        (this.footerOffset = 0.15 * this.containerHeight),
                        (this.cachedPosition = this.footerOffset),
                        (this.cachedPercentage = 0),
                        this.init());
                }));
        }
    };
    const wd = {
        onLoad() {
            fd[this.id] = [];
            this.container.querySelectorAll(cd).forEach((t) => {
                fd[this.id].push(new bd(t));
            });
        },
        onUnload() {
            fd[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    },
        Sd = "[data-announcement]",
        Ed = "[data-announcement-slide]",
        Ld = "[data-ticker-frame]",
        kd = "[data-slide]",
        Ad = "[data-slider]",
        Cd = "[data-static]",
        qd = "[data-ticker-scale]",
        Td = "[data-ticker-text]",
        Pd = "[data-parallax]",
        Id = "data-slide",
        Fd = "data-slider-speed",
        xd = "data-slider-arrows",
        Hd = "data-stop",
        Dd = "style",
        Md = "data-target-referrer",
        Od = "clip-path",
        Bd = "desktop",
        _d = "mobile",
        $d = "ticker--animated",
        zd = "is-disabled",
        Rd = "clipPath",
        Vd = {};
    const Nd = {
        onLoad() {
            Vd[this.id] = [];
            const t = this.container.querySelector(Sd);
            t &&
                Vd[this.id].push(
                    new (class {
                        init() {
                            (this.removeAnnouncement(),
                                this.slider &&
                                (this.initSlider(),
                                    document.addEventListener(
                                        "theme:resize:width",
                                        this.initSlider.bind(this),
                                    )),
                                this.static &&
                                (this.initTickers(), this.tickerAnimationPause()),
                                this.slider ||
                                this.static ||
                                (this.initTickers(!0), this.tickerAnimationPause()),
                                this.updateSVGClipPathIDs());
                        }
                        removeAnnouncement() {
                            for (let t = 0; t < this.slides.length; t++) {
                                const e = this.slides[t];
                                e.hasAttribute(Md) &&
                                    (-1 !== this.locationPath.indexOf(e.getAttribute(Md)) ||
                                        window.Shopify.designMode ||
                                        e.parentNode.removeChild(e));
                            }
                        }
                        initSlider() {
                            const t = this.slider.querySelectorAll(kd),
                                i = this.slider.hasAttribute(xd);
                            if (t) {
                                let t = `${kd}`;
                                ((t =
                                    window.innerWidth < theme.sizes.small
                                        ? `${kd}:not(.${Bd})`
                                        : `${kd}:not(.${_d})`),
                                    null != this.flkty && this.flkty.destroy(),
                                    (this.flkty = new e(this.slider, {
                                        cellSelector: t,
                                        pageDots: !1,
                                        prevNextButtons: i,
                                        wrapAround: !0,
                                        autoPlay: parseInt(this.slider.getAttribute(Fd), 10),
                                        on: {
                                            ready: () => {
                                                setTimeout(() => {
                                                    this.slider.dispatchEvent(
                                                        new CustomEvent("slider-is-loaded", {
                                                            bubbles: !0,
                                                            detail: { slider: this },
                                                        }),
                                                    );
                                                }, 10);
                                            },
                                        },
                                    })),
                                    this.flkty.reposition());
                            }
                            this.slider.addEventListener("slider-is-loaded", () => {
                                (this.initTickers(), this.updateSVGClipPathIDs());
                            });
                        }
                        initTickers(t = !1) {
                            this.barHolder.querySelectorAll(Ld).forEach((e) => {
                                const i = new (class {
                                    listen() {
                                        (document.addEventListener(
                                            "theme:resize:width",
                                            this.resizeEvent,
                                        ),
                                            this.checkWidth());
                                    }
                                    checkWidth() {
                                        const t =
                                            2 *
                                            window
                                                .getComputedStyle(this.frame)
                                                .paddingLeft.replace("px", "");
                                        if (
                                            this.frame.clientWidth - t <
                                            this.comparitor.clientWidth ||
                                            this.stopClone
                                        ) {
                                            if (1 === this.scale.childElementCount) {
                                                if (
                                                    (this.text.classList.add(ed),
                                                        (this.clone = this.text.cloneNode(!0)),
                                                        this.clone.setAttribute(Zh, ""),
                                                        this.scale.appendChild(this.clone),
                                                        this.stopClone)
                                                )
                                                    for (let t = 0; t < 10; t++) {
                                                        const t = this.text.cloneNode(!0);
                                                        (t.setAttribute(Zh, ""), this.scale.appendChild(t));
                                                    }
                                                let t = this.frame.getAttribute(td);
                                                null === t && (t = 100);
                                                const e = od * (100 / parseInt(t, 10)),
                                                    i = (this.text.clientWidth / nd) * e;
                                                this.scale.style.setProperty(
                                                    "--animation-time",
                                                    `${i}s`,
                                                );
                                            }
                                        } else {
                                            this.text.classList.add(ed);
                                            let t = this.scale.querySelector(`[${Zh}]`);
                                            (t && this.scale.removeChild(t),
                                                this.text.classList.remove(ed));
                                        }
                                    }
                                    unload() {
                                        document.removeEventListener(
                                            "theme:resize:width",
                                            this.resizeEvent,
                                        );
                                    }
                                    constructor(t, e = !1) {
                                        ((this.frame = t),
                                            (this.stopClone = e),
                                            (this.scale = this.frame.querySelector(Yh)),
                                            (this.text = this.frame.querySelector(Jh)),
                                            (this.comparitor = this.text.cloneNode(!0)),
                                            this.comparitor.classList.add(sd),
                                            this.frame.appendChild(this.comparitor),
                                            this.scale.classList.remove(id),
                                            (this.resizeEvent = o(() => this.checkWidth(), 100)),
                                            this.listen());
                                    }
                                })(e, t);
                                this.tickers.push(i);
                                const s = e.querySelectorAll(kd);
                                if (0 !== s.length) {
                                    const t = e.querySelectorAll(`${kd}.${_d}`),
                                        i = e.querySelectorAll(`${kd}.${Bd}`);
                                    s.length === t.length
                                        ? e.parentNode.classList.add(_d)
                                        : s.length === i.length && e.parentNode.classList.add(Bd);
                                }
                            });
                        }
                        toggleTicker(t, e) {
                            const i = t.target.closest(qd),
                                s = document.querySelector(`[${Id}="${t.detail.blockId}"]`);
                            (e &&
                                s &&
                                (i.setAttribute(Hd, ""),
                                    i.querySelectorAll(Td).forEach((t) => {
                                        (t.classList.remove($d),
                                            (t.style.transform = `translate3d(${-(s.offsetLeft - parseInt(getComputedStyle(s).marginLeft, 10))}px, 0, 0)`));
                                    })),
                                !e &&
                                s &&
                                (i.querySelectorAll(Td).forEach((t) => {
                                    (t.classList.add($d), t.removeAttribute(Dd));
                                }),
                                    i.removeAttribute(Hd),
                                    this.static &&
                                    document.dispatchEvent(
                                        new CustomEvent("theme:resize:width", { bubbles: !0 }),
                                    )));
                        }
                        tickerAnimationPause() {
                            let t = 0,
                                e = !1;
                            const i = this.barHolder.querySelector(Ed);
                            (i.addEventListener("mouseenter", () => {
                                ((e = !0),
                                    (t = setTimeout(() => {
                                        (e &&
                                            i.querySelectorAll(Td).forEach((t) => {
                                                t.style.animationPlayState = "paused";
                                            }),
                                            clearTimeout(t));
                                    }, 500)));
                            }),
                                i.addEventListener("mouseleave", () => {
                                    ((e = !1),
                                        i.querySelectorAll(Td).forEach((t) => {
                                            t.style.animationPlayState = "running";
                                        }));
                                }));
                        }
                        updateSVGClipPathIDs() {
                            this.barHolder.querySelectorAll(kd).forEach((t, e) => {
                                const i = t.querySelector(Rd);
                                if (i) {
                                    const s = `${i.id}_${e}`;
                                    i.id = s;
                                    const o = t.querySelector(`g[${Od}]`);
                                    o && o.setAttribute(Od, `url(#${s})`);
                                }
                            });
                        }
                        onBlockSelect(t) {
                            const e = parseInt(
                                [...t.target.parentNode.children].indexOf(t.target),
                            );
                            (this.slider &&
                                null !== this.flkty &&
                                (this.flkty.select(e), this.flkty.pausePlayer()),
                                this.slider || this.toggleTicker(t, !0),
                                this.parallax &&
                                (this.parallax.style.setProperty("--offsetX", "0%"),
                                    this.parallax.classList.add(zd)));
                        }
                        onBlockDeselect(t) {
                            (this.slider && null !== this.flkty && this.flkty.unpausePlayer(),
                                this.slider || this.toggleTicker(t, !1),
                                this.parallax &&
                                (this.parallax.classList.remove(zd),
                                    document.dispatchEvent(new CustomEvent("theme:scroll"))));
                        }
                        onUnload() {
                            (document.removeEventListener(
                                "theme:resize:width",
                                this.initSlider.bind(this),
                            ),
                                this.tickers.length > 0 &&
                                this.tickers.forEach((t) => {
                                    t.unload();
                                }));
                        }
                        constructor(t) {
                            ((this.barHolder = t),
                                (this.locationPath = location.href),
                                (this.slides = this.barHolder.querySelectorAll(kd)),
                                (this.slider = this.barHolder.querySelector(Ad)),
                                (this.static = this.barHolder.querySelector(Cd)),
                                (this.parallax = this.barHolder.querySelector(Pd)),
                                (this.tickers = []),
                                (this.flkty = null),
                                this.init());
                        }
                    })(t),
                );
        },
        onBlockSelect(t) {
            Vd[this.id].length &&
                Vd[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
        },
        onBlockDeselect(t) {
            Vd[this.id].length &&
                Vd[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
                });
        },
        onUnload() {
            Vd[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    };
    (Ut("announcement-bar", Nd), Ut("marquee", [Nd, wd]));
    const Wd = "[data-hover-disclosure]",
        Ud = "[data-site-header]",
        jd = "[data-top-link]",
        Gd = "[data-header-background]",
        Kd = "[data-nav-item]",
        Qd = "is-visible",
        Xd = "grandparent",
        Yd = "site-header--menu-opened",
        Jd = "has-scrolled",
        Zd = "site-header--hovered",
        tu = "search-opened",
        eu = "megamenu-opened",
        iu = "data-hover-disclosure-toggle",
        su = "aria-haspopup",
        ou = "aria-expanded",
        nu = "aria-controls";
    let ru = {};
    const au = {
        onLoad() {
            ru[this.id] = [];
            this.container.querySelectorAll(Wd).forEach((t) => {
                ru[this.id].push(
                    new (class {
                        setBackgroundHeight() {
                            ((this.hasScrolled = this.body.classList.contains(Jd)),
                                (this.headerHeight = this.hasScrolled
                                    ? window.stickyHeaderHeight
                                    : this.header.offsetHeight),
                                this.grandparent
                                    ? ((this.dropdown.style.height = "auto"),
                                        (this.dropdownHeight =
                                            this.dropdown.offsetHeight + this.headerHeight))
                                    : (this.dropdownHeight = this.headerHeight),
                                this.background.style.setProperty(
                                    "--header-background-height",
                                    `${this.dropdownHeight}px`,
                                ),
                                window.innerWidth < theme.sizes.small &&
                                this.hideDisclosure());
                        }
                        showDisclosure() {
                            (this.setBackgroundHeight(),
                                document.addEventListener(
                                    "theme:resize",
                                    this.setBackgroundHeightEvent,
                                ),
                                this.trigger.setAttribute(ou, !0),
                                this.trigger.classList.add(Qd),
                                this.header.classList.add(Yd),
                                this.trigger.classList.contains(Xd) &&
                                (this.body.classList.add(eu),
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll:lock", {
                                            bubbles: !0,
                                            detail: this.header,
                                        }),
                                    )),
                                this.updateHeaderHover());
                        }
                        hideDisclosure() {
                            (this.background.style.removeProperty(
                                "--header-background-height",
                            ),
                                document.removeEventListener(
                                    "theme:resize",
                                    this.setBackgroundHeightEvent,
                                ),
                                this.trigger.classList.remove(Qd),
                                this.trigger.setAttribute(ou, !1),
                                this.header.classList.remove(Yd),
                                this.body.classList.remove(eu),
                                this.body.classList.contains(tu) ||
                                document.dispatchEvent(
                                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 }),
                                ));
                        }
                        updateHeaderHover() {
                            requestAnimationFrame(() => {
                                const t = this.header.matches(":hover"),
                                    e = this.header.classList.contains(Zd);
                                t && !e && this.header.classList.add(Zd);
                            });
                        }
                        handleTablets() {
                            this.trigger.addEventListener("touchstart", (t) => {
                                if (!this.trigger.classList.contains(Qd)) {
                                    t.preventDefault();
                                    const e = this.header.querySelectorAll(`.${Qd}${Kd}`);
                                    if (e.length > 0)
                                        return void e.forEach((t) => {
                                            if (t !== this.trigger) {
                                                t.dispatchEvent(
                                                    new Event("mouseleave", { bubbles: !0 }),
                                                );
                                                const e = () => {
                                                    (requestAnimationFrame(() => {
                                                        this.showDisclosure();
                                                    }),
                                                        t.removeEventListener("transitionend", e));
                                                };
                                                t.addEventListener("transitionend", e);
                                            }
                                        });
                                    this.showDisclosure();
                                }
                            });
                        }
                        connectHoverToggle() {
                            (this.trigger.addEventListener("mouseenter", () =>
                                this.showDisclosure(),
                            ),
                                this.link.addEventListener("focus", () =>
                                    this.showDisclosure(),
                                ),
                                this.trigger.addEventListener("mouseleave", () =>
                                    this.hideDisclosure(),
                                ),
                                this.trigger.addEventListener("focusout", (t) => {
                                    this.trigger.contains(t.relatedTarget) ||
                                        this.hideDisclosure();
                                }),
                                this.disclosure.addEventListener("keyup", (t) => {
                                    t.code === theme.keyboardKeys.ESCAPE &&
                                        this.hideDisclosure();
                                }));
                        }
                        onBlockSelect(t) {
                            this.disclosure.contains(t.target) && this.showDisclosure(t);
                        }
                        onBlockDeselect(t) {
                            this.disclosure.contains(t.target) && this.hideDisclosure();
                        }
                        constructor(t) {
                            ((this.disclosure = t),
                                (this.body = document.body),
                                (this.header = t.closest(Ud)),
                                (this.key = this.disclosure.id),
                                (this.trigger = document.querySelector(
                                    `[${iu}='${this.key}']`,
                                )),
                                (this.link = this.trigger.querySelector(jd)),
                                (this.grandparent = this.trigger.classList.contains(Xd)),
                                (this.background = document.querySelector(Gd)),
                                this.trigger.setAttribute(su, !0),
                                this.trigger.setAttribute(ou, !1),
                                this.trigger.setAttribute(nu, this.key),
                                (this.dropdown = this.trigger.querySelector(Wd)),
                                (this.setBackgroundHeightEvent = () =>
                                    this.setBackgroundHeight()),
                                this.connectHoverToggle(),
                                this.handleTablets());
                        }
                    })(t),
                );
            });
        },
        onBlockSelect(t) {
            ru[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            ru[this.id].forEach((e) => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
            });
        },
    },
        lu = "[data-site-header]",
        cu = "[data-announcement-wrapper]",
        hu = "[data-collection-filters]",
        du = "[data-logo-text-link]",
        uu = "[data-collapsible-trigger]",
        pu = "#nav-drawer",
        mu = "[data-drawer]",
        gu = "[data-drawer-toggle]",
        vu = "[data-popdown-toggle]",
        yu = "[data-mobile-menu]",
        fu = "[data-nav]",
        bu = "[data-nav-icons]",
        wu = "[data-nav-item]",
        Su = "[data-nav-link-mobile]",
        Eu = "[data-nav-search-open]",
        Lu = "[data-wrapper]",
        ku = "[data-header-background]",
        Au = "[data-cart-page]",
        Cu = "[data-takes-space]",
        qu = {
            jsDrawerOpenAll: [
                "js-drawer-open",
                "js-drawer-open-cart",
                "js-quick-view-visible",
                "js-quick-view-from-cart",
            ],
            headerTransparent: "site-header--transparent",
            headerHovered: "site-header--hovered",
            headerMenuOpened: "site-header--menu-opened",
            hasScrolled: "has-scrolled",
            hasStickyHeader: "has-sticky-header",
            hideHeader: "hide-header",
            headerCompress: "site-header--compress-",
            isVisible: "is-visible",
            isOpen: "is-open",
            searchOpened: "search-opened",
            noOutline: "no-outline",
            cloneClass: "js__header__clone",
        },
        Tu = "data-nav-alignment",
        Pu = "data-header-sticky",
        Iu = {};
    const Fu = {
        onLoad() {
            Iu[this.id] = new (class {
                updateHeaderHover() {
                    requestAnimationFrame(() => {
                        const t = this.header.matches(":hover"),
                            e = this.header.classList.contains(qu.headerHovered);
                        t && !e && this.header.classList.add(qu.headerHovered);
                    });
                }
                handleTouchstart(t) {
                    const e = this.header.contains(t.target),
                        i = this.header.querySelector(`.${qu.isVisible}${wu}`);
                    !e && i && i.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                }
                handleTextLinkLogos() {
                    if (null === this.logoTextLink) return;
                    const t = this.header.offsetHeight;
                    (document.documentElement.style.setProperty(
                        "--header-height",
                        `${t}px`,
                    ),
                        document.documentElement.style.setProperty(
                            "--header-sticky-height",
                            `${t}px`,
                        ));
                }
                initStickyHeader() {
                    if (
                        ((this.headerSticky = this.header.hasAttribute(Pu)),
                            CSS.supports("(selector(:has(*)))") ||
                            document.body.classList.toggle(
                                qu.hasStickyHeader,
                                this.headerSticky,
                            ),
                            (this.hasScrolled = !1),
                            (this.hasCollectionFilters = document.querySelector(hu)),
                            (this.position = this.header.dataset.position),
                            "fixed" === this.position && !this.hasCollectionFilters)
                    )
                        return (
                            this.headerState(),
                            void document.addEventListener(
                                "theme:scroll",
                                this.headerStateEvent,
                            )
                        );
                    (document.body.classList.remove(qu.hasScrolled),
                        window.isHeaderTransparent &&
                        this.header.classList.add(qu.headerTransparent));
                }
                headerState(t) {
                    const e = parseInt(
                        this.header.dataset.height || this.header.offsetHeight,
                    ),
                        i = document.querySelector(cu),
                        s = e + (i ? i.offsetHeight : 0),
                        o = window.pageYOffset || document.documentElement.scrollTop,
                        n = t && t.detail && t.detail.up;
                    ((this.hasScrolled = o > s),
                        document.body.classList.toggle(qu.hasScrolled, this.hasScrolled));
                    const r = o < s + window.stickyHeaderHeight && n;
                    if (
                        (document.body.classList.toggle(qu.hideHeader, r),
                            window.isHeaderTransparent)
                    ) {
                        const t = !this.hasScrolled || r;
                        this.header.classList.toggle(qu.headerTransparent, t);
                    }
                    if (this.header.classList.contains(qu.headerHovered)) {
                        const t = this.hasScrolled ? window.stickyHeaderHeight : e;
                        this.background.style.setProperty(
                            "--header-background-height",
                            `${t}px`,
                        );
                        const i = this.header.querySelector(`.${qu.isVisible}${wu}`);
                        i && i.dispatchEvent(new Event("mouseenter", { bubbles: !0 }));
                    }
                }
                handleBackgroundEvents() {
                    (this.headerWrapper.addEventListener(
                        "mouseenter",
                        this.updateBackgroundHeightEvent,
                    ),
                        this.headerWrapper.addEventListener(
                            "mouseleave",
                            this.updateBackgroundHeightEvent,
                        ),
                        this.header.addEventListener(
                            "focusout",
                            this.updateBackgroundHeightEvent,
                        ),
                        document.addEventListener(
                            "theme:cart:close",
                            this.updateBackgroundHeightEvent,
                        ),
                        document.addEventListener(
                            "theme:search:close",
                            this.updateBackgroundHeightEvent,
                        ));
                }
                updateBackgroundHeight(t) {
                    const e = matchMedia("(pointer:fine)").matches,
                        i = !document.body.classList.contains(qu.noOutline),
                        s = e && !i;
                    if (!t) return;
                    let o = qu.jsDrawerOpenAll.some((t) =>
                        document.body.classList.contains(t),
                    );
                    (("mouseenter" === t.type || o) &&
                        ((this.headerHeight = this.hasScrolled
                            ? window.stickyHeaderHeight
                            : this.header.offsetHeight),
                            this.header.classList.add(qu.headerHovered),
                            this.header.classList.contains(qu.headerMenuOpened) ||
                            this.background.style.setProperty(
                                "--header-background-height",
                                `${this.headerHeight}px`,
                            )),
                        "mouseenter" !== t.type &&
                        requestAnimationFrame(() => {
                            if (
                                ((o = qu.jsDrawerOpenAll.some((t) =>
                                    document.body.classList.contains(t),
                                )),
                                    o)
                            )
                                return;
                            if ("focusout" === t.type && !e) return;
                            if ("theme:search:close" === t.type && !s) return;
                            if (this.hasScrolled) return;
                            const n = null === document.activeElement.closest(lu),
                                r = document.body.classList.contains(qu.searchOpened),
                                a = this.header.classList.contains(qu.headerMenuOpened);
                            r ||
                                a ||
                                (("focusout" !== t.type || n) &&
                                    (this.header.classList.remove(qu.headerHovered),
                                        this.background.style.setProperty(
                                            "--header-background-height",
                                            "0px",
                                        ),
                                        i || document.activeElement.blur()));
                        }));
                }
                listenWidth() {
                    (document.addEventListener("theme:resize", this.checkWidthEvent),
                        this.checkWidth());
                }
                checkWidth() {
                    window.innerWidth < this.minWidth
                        ? this.header.classList.add(qu.headerCompress)
                        : this.header.classList.remove(qu.headerCompress);
                }
                getMinWidth() {
                    const t =
                        this.headerWrapper.currentStyle ||
                        window.getComputedStyle(this.headerWrapper),
                        e = 2 * parseInt(t.paddingLeft),
                        i = this.header.cloneNode(!0);
                    (i.classList.add(qu.cloneClass), document.body.appendChild(i));
                    const s = i.querySelectorAll(Cu),
                        o = (function (t, e) {
                            let i = [];
                            t.forEach((t) => {
                                i.push(t.clientWidth);
                            });
                            let [s, o, n] = i;
                            if ("left" === e) {
                                const t = s;
                                ((s = o), (o = t));
                            }
                            return ("right" !== e && (s > n ? (n = s) : (s = n)), s + o + n);
                        })(s, this.header.getAttribute(Tu));
                    return (document.body.removeChild(i), o + 20 * s.length + e);
                }
                initMobileNav() {
                    var t;
                    if (
                        ((this.mobileMenu = this.headerSection.querySelector(yu)),
                            (this.navDrawer = this.headerSection.querySelector(pu)),
                            (this.drawerToggle = this.navDrawer.querySelector(gu)),
                            (this.navSearchOpen = this.navDrawer.querySelectorAll(Eu)),
                            null === (t = this.navSearchOpen) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                    const e = this.drawerToggle.closest(`${mu}.${qu.isOpen}`),
                                        i = matchMedia("(pointer:coarse)").matches
                                            ? this.mobileMenu.querySelector(vu)
                                            : this.nav.querySelector(vu);
                                    this.drawerToggle.dispatchEvent(
                                        new Event("click", { bubbles: !0 }),
                                    );
                                    const s = (t) => {
                                        t.target === e &&
                                            (requestAnimationFrame(() =>
                                                i.dispatchEvent(new Event("click", { bubbles: !0 })),
                                            ),
                                                e.removeEventListener("transitionend", s));
                                    };
                                    e.addEventListener("transitionend", s);
                                });
                            }),
                            "link" === theme.settings.mobileMenuBehaviour)
                    )
                        return;
                    const e = this.headerSection.querySelectorAll(Su);
                    e.length &&
                        e.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                const i = t.parentNode.querySelectorAll(uu).length,
                                    s = t.nextElementSibling;
                                i &&
                                    (e.preventDefault(),
                                        s.dispatchEvent(new Event("click"), { bubbles: !0 }));
                            });
                        });
                }
                onUnload() {
                    (document.documentElement.style.removeProperty("--header-height"),
                        document.documentElement.style.removeProperty(
                            "--header-sticky-height",
                        ),
                        this.initStickyHeader(),
                        document.body.classList.remove(...qu.jsDrawerOpenAll),
                        document.removeEventListener("theme:scroll", this.headerStateEvent),
                        document.removeEventListener("theme:resize", this.checkWidthEvent),
                        document.removeEventListener(
                            "theme:cart:close",
                            this.updateBackgroundHeightEvent,
                        ),
                        document.removeEventListener(
                            "theme:search:close",
                            this.updateBackgroundHeightEvent,
                        ),
                        document.body.removeEventListener(
                            "touchstart",
                            this.handleTouchstartEvent,
                        ),
                        document.dispatchEvent(
                            new CustomEvent("theme:scroll:unlock", { bubbles: !0 }),
                        ),
                        "function" == typeof window.cart.unload && window.cart.unload());
                }
                constructor(t) {
                    ((this.container = t),
                        (this.background = document.querySelector(ku)),
                        (this.header = t),
                        (this.headerSection = t.parentNode),
                        (this.headerWrapper = t.querySelector(Lu)),
                        (this.logoTextLink = t.querySelector(du)),
                        (this.nav = t.querySelector(fu)),
                        (this.navIcons = t.querySelector(bu)),
                        (this.headerStateEvent = (t) => this.headerState(t)),
                        (this.handleTouchstartEvent = (t) => this.handleTouchstart(t)),
                        (this.updateBackgroundHeightEvent = (t) =>
                            this.updateBackgroundHeight(t)),
                        p(),
                        (this.minWidth = this.getMinWidth()),
                        (this.checkWidthEvent = () => this.checkWidth()),
                        this.listenWidth(),
                        this.initMobileNav(),
                        this.handleTextLinkLogos(),
                        this.initStickyHeader(),
                        this.handleBackgroundEvents(),
                        document.querySelector(Au) || (window.cart = new Gc()),
                        document.body.addEventListener(
                            "touchstart",
                            this.handleTouchstartEvent,
                            { passive: !0 },
                        ),
                        this.updateHeaderHover());
                }
            })(this.container);
        },
        onUnload() {
            Iu[this.id].onUnload();
        },
    };
    Ut("header", [Fu, au, Wn]);
    const xu = "[data-collapsible-trigger]",
        Hu = "is-expanded";
    Ut("accordions", [
        {
            onBlockSelect(t) {
                const e = t.target.querySelector(xu);
                requestAnimationFrame(() => {
                    e.classList.contains(Hu) || e.dispatchEvent(new Event("click"));
                });
            },
        },
        he,
    ]);
    const Du = "[data-share-button]",
        Mu = "[data-share-button-tooltip]",
        Ou = "is-visible",
        Bu = "is-hiding",
        _u = {};
    const $u = {
        onLoad() {
            _u[this.id] = new (class {
                init() {
                    this.button &&
                        this.button.addEventListener("click", () => {
                            let t = window.location.href;
                            (this.button.dataset.shareLink &&
                                (t = this.button.dataset.shareLink),
                                this.tooltip.classList.contains(Ou) ||
                                navigator.clipboard.writeText(t).then(() => {
                                    (this.tooltip.classList.add(Ou),
                                        setTimeout(() => {
                                            (this.tooltip.classList.add(Bu),
                                                this.tooltip.classList.remove(Ou),
                                                this.hideTransitionTimeout &&
                                                clearTimeout(this.hideTransitionTimeout),
                                                (this.hideTransitionTimeout = setTimeout(() => {
                                                    this.tooltip.classList.remove(Bu);
                                                }, this.transitionSpeed)));
                                        }, 1500));
                                }));
                        });
                }
                constructor(t) {
                    ((this.container = t),
                        (this.button = this.container.querySelector(Du)),
                        (this.tooltip = this.container.querySelector(Mu)),
                        (this.transitionSpeed = 200),
                        (this.hideTransitionTimeout = 0),
                        this.init());
                }
            })(this.container);
        },
    };
    Ut("article", [$u]);
    const zu = "[data-video-play]",
        Ru = "data-video-play";
    const Vu = {
        onLoad() {
            new (class {
                init() {
                    this.videoPlay.length &&
                        this.videoPlay.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                if (t.hasAttribute(Ru) && "" !== t.getAttribute(Ru).trim()) {
                                    e.preventDefault();
                                    const i = [{ html: t.getAttribute(Ru) }],
                                        s = { mainClass: "pswp--video" };
                                    ((this.a11y.state.trigger = t), new Kl(i, s));
                                }
                            });
                        });
                }
                constructor(t) {
                    ((this.container = t),
                        (this.videoPlay = this.container.querySelectorAll(zu)),
                        (this.a11y = be),
                        this.init());
                }
            })(this.container);
        },
    },
        Nu = "[data-site-header]",
        Wu = "[data-main]";
    let Uu = {};
    const ju = {
        onLoad() {
            Uu[this.id] = new (class {
                init() {
                    var t;
                    if ("true" !== this.container.dataset.zoomAnimation) return;
                    const e = this.container,
                        i = document.body.querySelector(Wu).children[0],
                        s = this.container.parentNode === i,
                        o =
                            "true" ==
                            (null === (t = this.header) || void 0 === t
                                ? void 0
                                : t.dataset.transparent),
                        n = () => {
                            var t, i;
                            const n =
                                s & o
                                    ? 0
                                    : parseInt(
                                        (null === (t = this.header) || void 0 === t
                                            ? void 0
                                            : t.dataset.height) ||
                                        (null === (i = this.header) || void 0 === i
                                            ? void 0
                                            : i.offsetHeight),
                                    ),
                                r = e.getBoundingClientRect(),
                                a = e.offsetHeight,
                                l = s ? n - r.top : n - r.top + window.innerHeight;
                            let c = 0.1;
                            s && (c *= 1.5);
                            let h = 1 + (l / a) * c;
                            ((h = h > 1 ? h : 1), e.style.setProperty("--scale", h));
                        };
                    (n(),
                        (this.zoomOnScrollEvent = Yt(n, 5)),
                        new IntersectionObserver(
                            (t) => {
                                t[0].isIntersecting
                                    ? window.addEventListener("scroll", this.zoomOnScrollEvent)
                                    : window.removeEventListener(
                                        "scroll",
                                        this.zoomOnScrollEvent,
                                    );
                            },
                            { root: null, rootMargin: "0px", threshold: 0 },
                        ).observe(e));
                }
                onUnload() {
                    null !== this.zoomOnScrollEvent &&
                        window.removeEventListener("scroll", this.zoomOnScrollEvent);
                }
                constructor(t) {
                    ((this.container = t),
                        (this.header = document.querySelector(Nu)),
                        this.init());
                }
            })(this.container);
        },
        onUnload() {
            Uu[this.id].onUnload();
        },
    },
        Gu = "[data-banner-image]",
        Ku = ".lazy-image",
        Qu = "banner--no-cached-images",
        Xu = "banner--img-loaded",
        Yu = "img-in",
        Ju = {};
    Ut("banner-image", [
        {
            onLoad() {
                Ju[this.id] = new (class {
                    init() {
                        this.handleImageAnimation(!0);
                    }
                    handleImageAnimation(t = !1) {
                        if (!t)
                            return (
                                this.container.classList.remove(Qu),
                                void this.container.classList.remove(Xu)
                            );
                        const e = this.container.querySelector(Gu).querySelectorAll(Ku),
                            i = this.container.classList.contains(Yu);
                        if (e.length && !i) {
                            this.container.classList.add(Qu);
                            const t = (i) => {
                                (requestAnimationFrame(() => this.container.classList.add(Xu)),
                                    e[0].removeEventListener("transitionend", t));
                            };
                            e[0].addEventListener("transitionend", t);
                        }
                    }
                    onReorder() {
                        this.handleImageAnimation(!1);
                    }
                    onUnload() {
                        this.handleImageAnimation(!1);
                    }
                    constructor(t) {
                        ((this.container = t.container), this.init());
                    }
                })(this);
            },
            onReorder(t) {
                Ju[this.id].onReorder(t);
            },
            onUnload(t) {
                Ju[this.id].onUnload(t);
            },
        },
        ju,
        Vu,
    ]);
    const Zu = "[data-scroll-spy]",
        tp = "is-selected",
        ep = "is-full-height",
        ip = "data-scroll-spy",
        sp = "data-scroll-spy-prevent",
        op = "data-scroll-spy-mobile",
        np = "data-scroll-spy-desktop",
        rp = {};
    const ap = {
        onLoad() {
            rp[this.id] = [];
            this.container.querySelectorAll(Zu).forEach((t) => {
                const e = this.container.querySelector(t.getAttribute(ip));
                rp[this.id].push(
                    new (class {
                        init() {
                            (this.onScroll(),
                                document.addEventListener(
                                    "theme:scroll",
                                    this.scrollCallback,
                                ),
                                document.addEventListener(
                                    "theme:resize:width",
                                    this.scrollCallback,
                                ));
                        }
                        isEligible() {
                            return (
                                !this.container.hasAttribute(sp) &&
                                ((ld() && this.anchor.hasAttribute(op)) ||
                                    (ad() && this.anchor.hasAttribute(np)) ||
                                    (!this.anchor.hasAttribute(np) &&
                                        !this.anchor.hasAttribute(op)))
                            );
                        }
                        onScroll() {
                            if (!this.isEligible()) return;
                            ((this.top = this.element.getBoundingClientRect().top),
                                (this.bottom = this.element.getBoundingClientRect().bottom));
                            const t = Math.round(window.innerHeight),
                                e = Math.round(window.scrollY),
                                i = e + t,
                                s = Math.round(this.top + e),
                                o = this.element.offsetHeight;
                            if (!(s < i) || s + o < e) return;
                            (this.anchor.parentNode.offsetHeight <= o
                                ? this.container.style.setProperty(
                                    "--sticky-position",
                                    window.innerHeight / 2 - o / 2 + "px",
                                )
                                : this.container.classList.add(ep),
                                (this.anchorTop = this.anchor.getBoundingClientRect().top),
                                (this.anchorBottom =
                                    this.anchor.getBoundingClientRect().bottom));
                            const n = this.top < this.anchorTop,
                                r = this.bottom < this.anchorBottom;
                            n &&
                                !r &&
                                (this.anchors.forEach((t) => {
                                    t.matches(this.anchorSelector) || t.classList.remove(tp);
                                }),
                                    this.anchor.classList.add(tp));
                        }
                        onUnload() {
                            (document.removeEventListener(
                                "theme:scroll",
                                this.scrollCallback,
                            ),
                                document.removeEventListener(
                                    "theme:resize:width",
                                    this.scrollCallback,
                                ));
                        }
                        constructor(t, e) {
                            ((this.container = t),
                                (this.element = e),
                                this.element &&
                                ((this.anchorSelector = `[${ip}="#${this.element.id}"]`),
                                    (this.anchor = this.container.querySelector(
                                        this.anchorSelector,
                                    )),
                                    (this.anchors = this.container.querySelectorAll(`[${ip}]`)),
                                    this.anchor &&
                                    ((this.scrollCallback = () => this.onScroll()),
                                        this.init())));
                        }
                    })(this.container, e),
                );
            });
        },
        onUnload() {
            rp[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    },
        lp = "[data-banner]",
        cp = "[data-slider-content]",
        hp = "[data-slider-media]",
        dp = "a, button",
        up = "data-index",
        pp = "tabindex",
        mp = "data-slider-single-image",
        gp = "data-scroll-spy-prevent",
        vp = "is-selected",
        yp = "row",
        fp = "columns";
    let bp = {};
    (Ut("banner-with-text-columns", [
        {
            onLoad() {
                bp[this.id] = new (class {
                    listen() {
                        (document.addEventListener(
                            "theme:resize:width",
                            this.onResizeCallback,
                        ),
                            this.links.forEach((t) => {
                                t.addEventListener("focus", () => {
                                    const e = Number(t.closest(lp).getAttribute(up));
                                    window.innerWidth >= theme.sizes.small && this.sync(e);
                                });
                            }),
                            this.banners.forEach((t) => {
                                (t.addEventListener("mouseenter", () => {
                                    const e = Number(t.getAttribute(up));
                                    window.innerWidth >= theme.sizes.small &&
                                        !window.theme.touch &&
                                        this.sync(e);
                                }),
                                    t.addEventListener("pointerup", () => {
                                        const e = Number(t.getAttribute(up));
                                        window.innerWidth >= theme.sizes.small &&
                                            window.theme.touch &&
                                            this.sync(e);
                                    }));
                            }));
                    }
                    handleColumnsLayout() {
                        if (this.sliderContent.children.length <= 1) return;
                        let t = window.innerWidth < window.theme.sizes.small;
                        (this.sliderMedia.children.length > 1 &&
                            ((this.flktyMedia = new e(this.sliderMedia, {
                                draggable: !1,
                                wrapAround: !1,
                                fade: !0,
                                prevNextButtons: !1,
                                adaptiveHeight: !1,
                                pageDots: !1,
                                setGallerySize: !1,
                                on: {
                                    change: (t) => {
                                        this.handleGroupItemsNavigation(t, this.flktyContent);
                                    },
                                },
                            })),
                                Ne(this.sliderMedia)),
                            (this.flktyContent = new e(this.sliderContent, {
                                draggable: t,
                                prevNextButtons: !1,
                                pageDots: !0,
                                cellAlign: "left",
                                adaptiveHeight: !1,
                                imagesLoaded: !0,
                                on: {
                                    ready: () => {
                                        (this.listen(), this.slidesTabIndex());
                                    },
                                    change: (t) => {
                                        (window.innerWidth < theme.sizes.small &&
                                            !this.singleImageEnabled &&
                                            this.flktyMedia.select(t),
                                            this.slidesTabIndex(),
                                            this.handleGroupItemsNavigation(t, this.flktyMedia));
                                    },
                                },
                            })),
                            Ne(this.sliderContent));
                    }
                    handleRowLayout() {
                        if (this.sliderMedia.children.length <= 1 || ld())
                            return (this.updateState(0), void this.listen());
                        this.initMediaSlider();
                    }
                    initMediaSlider() {
                        ((this.flktyMedia = new e(this.sliderMedia, {
                            draggable: !0,
                            wrapAround: !1,
                            fade: !0,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            setGallerySize: !1,
                            on: {
                                ready: () => {
                                    (this.updateState(0), this.listen());
                                },
                                change: (t) => {
                                    this.updateState(t);
                                },
                            },
                        })),
                            Ne(this.sliderMedia));
                    }
                    handleGroupItemsNavigation(t, e = null) {
                        null !== e &&
                            requestAnimationFrame(() => {
                                t !== e.selectedIndex && e.select(t);
                            });
                    }
                    slidesTabIndex() {
                        this.sliderContent &&
                            e.data(this.sliderContent).cells.forEach((t) => {
                                let e = "-1";
                                (t.element.classList.contains(vp) && (e = "0"),
                                    t.element.querySelectorAll(dp).forEach((t) => {
                                        t.setAttribute(pp, e);
                                    }));
                            });
                    }
                    sync(t = 0) {
                        (this.appearance === fp
                            ? this.flktyContent.selectCell(t)
                            : this.updateState(t),
                            this.flktyMedia && this.flktyMedia.selectCell(t));
                    }
                    updateState(t = 0) {
                        this.banners.forEach((e) => {
                            const i = Number(e.getAttribute(up));
                            e.classList.toggle(vp, i === t);
                        });
                    }
                    handleSlidersOnResize() {
                        if (this.appearance === yp) {
                            if (ld() && this.flktyMedia)
                                return (
                                    this.flktyMedia.destroy(),
                                    void (this.flktyMedia = null)
                                );
                            if (ad() && !this.flktyMedia) return void this.initMediaSlider();
                        }
                        (this.flktyContent &&
                            (this.flktyContent.resize(), this.toggleDraggable()),
                            this.flktyMedia && this.flktyMedia.resize());
                    }
                    toggleDraggable() {
                        ((this.flktyContent.options.draggable =
                            window.innerWidth < window.theme.sizes.small),
                            this.flktyContent.updateDraggable());
                    }
                    onBlockSelect(t) {
                        const e = parseInt(
                            [...t.target.parentNode.children].indexOf(t.target),
                        );
                        if ((this.sync(e), this.appearance === yp)) {
                            const t = this.sliderMedia.children[e],
                                i = Math.round(t.getBoundingClientRect().top);
                            (this.container.setAttribute(gp, ""),
                                setTimeout(() => Gn(i), 400),
                                setTimeout(() => this.container.removeAttribute(gp), 1e3));
                        }
                    }
                    onUnload() {
                        document.removeEventListener(
                            "theme:resize:width",
                            this.onResizeCallback,
                        );
                    }
                    constructor(t) {
                        var e;
                        ((this.container = t.container),
                            (this.sliderContent = this.container.querySelector(cp)),
                            (this.singleImageEnabled =
                                null === (e = this.sliderContent) || void 0 === e
                                    ? void 0
                                    : e.hasAttribute(mp)),
                            (this.banners = this.container.querySelectorAll(lp)),
                            (this.links = this.container.querySelectorAll("a")),
                            (this.sliderMedia = this.container.querySelector(hp)),
                            (this.flktyContent = null),
                            (this.flktyMedia = null),
                            (this.onResizeCallback = () => this.handleSlidersOnResize()),
                            (this.appearance = this.container.dataset.appearance),
                            this.appearance === fp
                                ? this.handleColumnsLayout()
                                : this.handleRowLayout());
                    }
                })(this);
            },
            onBlockSelect(t) {
                bp[this.id].onBlockSelect(t);
            },
        },
        ap,
    ]),
        Ut("blog-posts", Ks));
    const wp = "[data-slider]",
        Sp = "[data-slider-item]",
        Ep = "[data-media-container]",
        Lp = "a, button",
        kp = ".flickity-button",
        Ap = "carousel--inactive",
        Cp = "carousel--resize",
        qp = "tabindex",
        Tp = {};
    const Pp = {
        onLoad() {
            Tp[this.id] = new (class {
                initSlider() {
                    (this.slider.classList.remove(Ap),
                        (this.flkty = new e(this.slider, {
                            pageDots: !1,
                            cellAlign: "left",
                            groupCells: !0,
                            contain: !0,
                            on: {
                                ready: () => {
                                    (this.setSliderArrowsPosition(this.slider),
                                        setTimeout(() => {
                                            (this.changeTabIndex(), this.flkty.resize());
                                        }, 0));
                                },
                                change: () => {
                                    this.changeTabIndex();
                                },
                            },
                        })),
                        (e.prototype._createResizeClass = function () {
                            this.element.classList.add(Cp);
                        }),
                        e.createMethods.push("_createResizeClass"));
                    const t = e.prototype.resize;
                    e.prototype.resize = function () {
                        (this.element.classList.remove(Cp),
                            t.call(this),
                            this.element.classList.add(Cp));
                    };
                }
                destroySlider() {
                    (this.slider.classList.add(Ap),
                        null !== this.flkty && (this.flkty.destroy(), (this.flkty = null)));
                }
                checkSlidesSize() {
                    const t =
                        this.container.querySelector(Sp).currentStyle ||
                        window.getComputedStyle(this.container.querySelector(Sp));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e
                        ? this.initSlider()
                        : this.destroySlider();
                }
                changeTabIndex() {
                    const t = this.flkty.selectedIndex;
                    this.flkty.slides.forEach((e, i) => {
                        e.cells.forEach((e) => {
                            e.element.querySelectorAll(Lp).forEach((e) => {
                                e.setAttribute(qp, t === i ? "0" : "-1");
                            });
                        });
                    });
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(Sp);
                    return (
                        e.length &&
                        e.forEach((e) => {
                            t += e.offsetWidth + this.gutter;
                        }),
                        t
                    );
                }
                listen() {
                    this.slider &&
                        (this.checkSlidesSize(),
                            document.addEventListener(
                                "theme:resize:width",
                                this.checkSlidesSizeOnResize,
                            ));
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(kp),
                        i = t.querySelector(Ep);
                    e.length &&
                        i &&
                        e.forEach((t) => {
                            t.style.top = i.offsetHeight / 2 + "px";
                        });
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt(
                            [...t.target.parentNode.children].indexOf(t.target),
                        ),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e =
                            this.slider.currentStyle ||
                            window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener(
                        "theme:resize:width",
                        this.checkSlidesSizeOnResize,
                    );
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.slider = this.container.querySelector(wp)),
                        (this.flkty = null),
                        (this.gutter = 0),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        this.listen());
                }
            })(this);
        },
        onUnload(t) {
            Tp[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Tp[this.id].onBlockSelect(t);
        },
    };
    Ut("columns-with-image", [Pp, Vu]);
    const Ip = "[data-form-message-close]",
        Fp = "[data-form-message]",
        xp = "hide-down",
        Hp = "notification-visible";
    let Dp = {};
    Ut("contact-form", {
        onLoad() {
            Dp[this.id] = new (class {
                hidePopups() {
                    document.body.classList.add(Hp);
                }
                showPopups() {
                    document.body.classList.remove(Hp);
                }
                closeFormMessage() {
                    this.closeButton.addEventListener(
                        "click",
                        this.closeMessage.bind(this),
                    );
                }
                closeMessage(t) {
                    (t.preventDefault(),
                        this.messageWrapper.classList.add(xp),
                        this.showPopups());
                }
                autoHideMessage() {
                    setTimeout(() => {
                        (this.messageWrapper.classList.add(xp), this.showPopups());
                    }, 1e4);
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.closeButton = this.container.querySelector(Ip)),
                        (this.messageWrapper = this.container.querySelector(Fp)),
                        this.messageWrapper &&
                        (this.hidePopups(),
                            this.closeFormMessage(),
                            this.autoHideMessage()));
                }
            })(this);
        },
    });
    const Mp = "time",
        Op = "[data-days]",
        Bp = "[data-hours]",
        _p = "[data-minutes]",
        $p = "[data-seconds]",
        zp = "[data-section-type]",
        Rp = ".shopify-section",
        Vp = "[data-aos]",
        Np = "countdown-timer--show-message",
        Wp = "hide-countdown",
        Up = "aos-animate",
        jp = "countdown",
        Gp = "data-expiration-behavior",
        Kp = "data-leading-zero",
        Qp = "hide",
        Xp = "show-message";
    let Yp = class extends HTMLElement {
        connectedCallback() {
            this.init();
        }
        disconnectedCallback() {
            this.stopTimer();
        }
        init() {
            isNaN(this.endDate) || this.endDate <= Date.now()
                ? this.onComplete()
                : (this.section.classList.contains(jp) && this.onLoad(!0),
                    (this.interval = setInterval(this.update, 1e3)));
        }
        stopTimer() {
            clearInterval(this.interval);
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const i = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= i * this.hoursInMs;
            const s = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= s * this.minutesInMs;
            return {
                days: e,
                hours: i,
                minutes: s,
                seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)),
            };
        }
        formatDigits(t) {
            return (t < 10 && this.leadingZero && (t = "0" + t), t);
        }
        render(t) {
            ((this.days.textContent = t.days),
                (this.hours.textContent = t.hours),
                (this.minutes.textContent = t.minutes),
                (this.seconds.textContent = t.seconds));
        }
        onComplete() {
            (this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
                this.shouldHideOnComplete && this.shopifySection.classList.add(Wp),
                this.shouldShowMessage && this.classList.add(Np));
        }
        triggerAnimations() {
            "false" != theme.settings.animations &&
                this.section.querySelectorAll(Vp).forEach((t) => {
                    this.isAnimated && t.classList.add(Up);
                });
        }
        removeAnimations() {
            this.section.querySelectorAll(Vp).forEach((t) => {
                requestAnimationFrame(() => {
                    t.classList.contains(Up) &&
                        (t.classList.remove(Up), (this.isAnimated = !0));
                });
            });
        }
        onLoad(t) {
            t
                ? this.removeAnimations()
                : ((this.isLoading = !1), this.triggerAnimations());
        }
        update() {
            const t = Date.now(),
                e = this.endDate - t;
            if (e <= 0) return (this.stopTimer(), void this.onComplete());
            const i = this.convertTime(e);
            (this.render(i), this.isLoading && this.onLoad(!1));
        }
        constructor() {
            (super(),
                (this.section = this.closest(zp)),
                (this.shopifySection = this.closest(Rp)),
                (this.expirationBehavior = this.getAttribute(Gp)),
                (this.leadingZero = this.hasAttribute(Kp)),
                (this.time = this.querySelector(Mp)),
                (this.endDate = Date.parse(this.time.dateTime)),
                (this.days = this.querySelector(Op)),
                (this.hours = this.querySelector(Bp)),
                (this.minutes = this.querySelector(_p)),
                (this.seconds = this.querySelector($p)),
                (this.daysInMs = 864e5),
                (this.hoursInMs = this.daysInMs / 24),
                (this.minutesInMs = this.hoursInMs / 60),
                (this.secondsInMs = this.minutesInMs / 60),
                (this.isLoading = !0),
                (this.shouldHideOnComplete = this.expirationBehavior === Qp),
                (this.shouldShowMessage = this.expirationBehavior === Xp),
                (this.isAnimated = !1),
                (this.update = this.update.bind(this)));
        }
    };
    (Ut("countdown", [ju, Vu]),
        customElements.get("countdown-timer") ||
        customElements.define("countdown-timer", Yp));
    const Jp = "[data-video-id]",
        Zp = "[data-video-player]",
        tm = "[data-video-template]",
        em = "[data-video-autoplay]",
        im = "[data-video-wrapper]",
        sm = "[data-video-bg-play]",
        om = "is-loading",
        nm = "is-paused",
        rm = {};
    const am = {
        onLoad() {
            rm[this.id] = [];
            this.container.querySelectorAll(im).forEach((t) => {
                rm[this.id].push(
                    new (class {
                        init() {
                            this.videoId &&
                                (new IntersectionObserver(
                                    (t, e) => {
                                        t.forEach((t) => {
                                            if (t.isIntersecting) {
                                                const i = this.videoTemplate.innerHTML;
                                                ((this.videoPlayer.innerHTML = i),
                                                    (this.video = this.container.querySelector(em)),
                                                    this.videoPlayer.classList.remove(om),
                                                    this.container.classList.add(nm),
                                                    this.listen(),
                                                    e.unobserve(t.target));
                                            }
                                        });
                                    },
                                    {
                                        root: null,
                                        rootMargin: "300px",
                                        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
                                    },
                                ).observe(this.videoPlayer),
                                    this.videoPlayButton.addEventListener("click", (t) => {
                                        var e;
                                        (t.preventDefault(),
                                            null === (e = this.video) || void 0 === e || e.play());
                                    }));
                        }
                        listen() {
                            (this.video.addEventListener("play", () => {
                                this.container.classList.remove(nm);
                            }),
                                this.container.addEventListener(
                                    "touchstart",
                                    () => {
                                        this.video.play();
                                    },
                                    { passive: !0 },
                                ));
                        }
                        constructor(t) {
                            ((this.container = t),
                                (this.videoId = this.container.querySelector(Jp)),
                                (this.videoPlayer = this.container.querySelector(Zp)),
                                (this.videoTemplate = this.container.querySelector(tm)),
                                (this.videoPlayButton = this.container.querySelector(sm)),
                                this.init());
                        }
                    })(t),
                );
            });
        },
    };
    let lm = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") &&
                !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
                -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        read() {
            if (
                -1 !== document.cookie.indexOf("; ") &&
                document.cookie.split("; ").find((t) => t.startsWith(this.name))
            ) {
                return document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        constructor(t, e) {
            ((this.configuration = {
                expires: null,
                path: "/",
                domain: window.location.hostname,
                sameSite: "none",
                secure: !0,
            }),
                (this.name = t),
                (this.value = e));
        }
    };
    const cm = "[data-newsletter-form]",
        hm = "[data-popup]",
        dm = "has-success",
        um = "has-error",
        pm = "newsletter_form_id",
        mm = {};
    const gm = {
        onLoad() {
            mm[this.id] = [];
            this.container.querySelectorAll(cm).forEach((t) => {
                mm[this.id].push(
                    new (class {
                        init() {
                            (this.newsletter.addEventListener(
                                "submit",
                                this.newsletterSubmit,
                            ),
                                this.showMessage());
                        }
                        newsletterSubmitEvent(t) {
                            this.stopSubmit &&
                                (t.preventDefault(),
                                    this.removeStorage(),
                                    this.writeStorage(),
                                    (this.stopSubmit = !1),
                                    this.newsletter.submit());
                        }
                        checkForChallengePage() {
                            this.isChallengePage =
                                window.location.pathname === theme.routes.root + "challenge";
                        }
                        writeStorage() {
                            void 0 !== this.sessionStorage &&
                                this.sessionStorage.setItem(pm, this.newsletter.id);
                        }
                        readStorage() {
                            this.formID = this.sessionStorage.getItem(pm);
                        }
                        removeStorage() {
                            this.sessionStorage.removeItem(pm);
                        }
                        showMessage() {
                            if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                const t = document.getElementById(this.formID),
                                    e =
                                        -1 !==
                                        window.location.search.indexOf("?customer_posted=true"),
                                    i =
                                        -1 !==
                                        window.location.search.indexOf("accepts_marketing");
                                (e
                                    ? (t.classList.remove(um),
                                        t.classList.add(dm),
                                        this.popup &&
                                        ((this.cookie = new lm(
                                            this.popup.dataset.cookieName,
                                            "user_has_closed",
                                        )),
                                            this.cookie.write()))
                                    : i && (t.classList.remove(dm), t.classList.add(um)),
                                    (e || i) && this.scrollToForm(t));
                            }
                        }
                        scrollToForm(t) {
                            const e = t.getBoundingClientRect();
                            visibilityHelper.isElementPartiallyVisible(t) ||
                                visibilityHelper.isElementTotallyVisible(t) ||
                                setTimeout(() => {
                                    window.scrollTo({
                                        top: e.top,
                                        left: 0,
                                        behavior: "smooth",
                                    });
                                }, 400);
                        }
                        onUnload() {
                            this.newsletter.removeEventListener(
                                "submit",
                                this.newsletterSubmit,
                            );
                        }
                        constructor(t) {
                            ((this.newsletter = t),
                                (this.sessionStorage = window.sessionStorage),
                                (this.popup = this.newsletter.closest(hm)),
                                (this.stopSubmit = !0),
                                (this.isChallengePage = !1),
                                (this.formID = null),
                                (this.formIdSuccess = null),
                                this.checkForChallengePage(),
                                (this.newsletterSubmit = (t) =>
                                    this.newsletterSubmitEvent(t)),
                                this.isChallengePage || this.init());
                        }
                    })(t),
                );
            });
        },
        onUnload() {
            mm[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    },
        vm = "[data-product]",
        ym = "[data-slider]",
        fm = "[data-slide]",
        bm = "[data-product-media-container]",
        wm = ".flickity-button",
        Sm = "a, button",
        Em = "tabindex",
        Lm = {};
    const km = {
        onLoad() {
            Lm[this.id] = new (class {
                checkSlider() {
                    window.innerWidth >= theme.sizes.small
                        ? this.productSlider.forEach((t) => {
                            this.initProductSlider(t);
                        })
                        : this.productSlider.forEach((t) => {
                            this.destroyProductSlider(t);
                        });
                }
                initProductSlider(t) {
                    const i = t.querySelectorAll(fm).length,
                        s = t.dataset.slider;
                    i > 1 &&
                        (void 0 !== this.flkty[s] && this.flkty[s].isActive
                            ? this.setSliderArrowsPosition(t)
                            : (this.flkty[s] = new e(t, {
                                prevNextButtons: !0,
                                adaptiveHeight: !0,
                                pageDots: !0,
                                wrapAround: !0,
                                on: {
                                    ready: () => {
                                        this.setSliderArrowsPosition(t);
                                    },
                                    change: (t) => {
                                        this.flkty[s].cells.forEach((e, i) => {
                                            e.element.querySelectorAll(Sm).forEach((e) => {
                                                e.setAttribute(Em, i === t ? "0" : "-1");
                                            });
                                        });
                                    },
                                },
                            })));
                }
                destroyProductSlider(t) {
                    const e = t.dataset.slider;
                    "object" == typeof this.flkty[e] && this.flkty[e].destroy();
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(wm),
                        i = t.querySelector(bm);
                    e.length &&
                        i &&
                        e.forEach((t) => {
                            t.style.top = i.offsetHeight / 2 + "px";
                        });
                }
                resizeSlider(t) {
                    const i = t.target,
                        s = e.data(i) || null;
                    s && s.resize();
                }
                listen() {
                    (this.checkSlider(),
                        document.addEventListener(
                            "theme:resize:width",
                            this.checkSliderOnResize,
                        ),
                        this.productSlider.forEach((t) => {
                            t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
                        }));
                }
                onUnload() {
                    if (this.flkty)
                        for (const t in this.flkty)
                            this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
                    (document.removeEventListener(
                        "theme:resize:width",
                        this.checkSliderOnResize,
                    ),
                        this.productSlider.forEach((t) => {
                            t.removeEventListener(
                                "theme:slider:resize",
                                this.resizeSliderEvent,
                            );
                        }));
                }
                constructor(t) {
                    ((this.container = t),
                        (this.product = this.container.querySelectorAll(vm)),
                        (this.productSlider = this.container.querySelectorAll(ym)),
                        (this.checkSliderOnResize = () => this.checkSlider()),
                        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                        (this.flkty = []),
                        (this.videoObj = []),
                        (this.quickViewObj = []),
                        this.listen());
                }
            })(this.container);
        },
        onUnload(t) {
            Lm[this.id].onUnload(t);
        },
    };
    Ut("custom-content", [km, gm, Vu, ki, am, Rs]);
    const Am = "[data-slider]",
        Cm = "[data-slide]",
        qm = "[data-product-media-container]",
        Tm = "a, button",
        Pm = ".flickity-button",
        Im = "[data-promo]",
        Fm = "[data-product-block]",
        xm = "carousel",
        Hm = "carousel--inactive",
        Dm = "is-last-slide-visible",
        Mm = "featured-collection",
        Om = "collection-promo--full",
        Bm = "collection-promo--two-columns",
        _m = "data-slider-id",
        $m = "data-slider-show-image",
        zm = "tabindex",
        Rm = {};
    let Vm = class {
        initSlider(t) {
            const i = t.getAttribute(_m);
            (t.classList.remove(Hm),
                void 0 !== this.flkty[i] && this.flkty[i].isActive
                    ? this.setSliderArrowsPosition(t)
                    : ((this.flkty[i] = new e(t, {
                        pageDots: !1,
                        cellSelector: Cm,
                        cellAlign: "left",
                        groupCells: !0,
                        contain: !0,
                        wrapAround: !1,
                        adaptiveHeight: !1,
                        on: {
                            ready: () => {
                                (this.setSliderArrowsPosition(t),
                                    setTimeout(() => {
                                        this.changeTabIndex(t);
                                    }, 0));
                            },
                            change: () => {
                                this.changeTabIndex(t);
                            },
                        },
                    })),
                        this.handleLastSlideOverlayOnTablet(t)));
        }
        destroySlider(t) {
            const e = t.getAttribute(_m);
            (t.classList.contains(xm) && t.classList.add(Hm),
                "object" == typeof this.flkty[e] && this.flkty[e].destroy());
        }
        resetSlider(t) {
            const e = t.target,
                i = e.getAttribute(_m);
            "object" == typeof this.flkty[i]
                ? this.flkty[i].select(0, !1, !0)
                : e.scrollTo({ left: 0, behavior: "instant" });
        }
        resizeSlider(t) {
            const i = t.target,
                s = e.data(i) || null;
            s && s.resize();
        }
        checkSlidesSize() {
            this.sliders.length &&
                this.sliders.forEach((t) => {
                    const e = this.columns,
                        i = window.innerWidth >= theme.sizes.large,
                        s =
                            window.innerWidth >= theme.sizes.small &&
                            window.innerWidth < theme.sizes.large;
                    let o = t.querySelectorAll(Cm).length;
                    const n = t.querySelectorAll(Im);
                    (n.length &&
                        i &&
                        n.forEach((t) => {
                            t.classList.contains(Om)
                                ? (o += e - 1)
                                : t.classList.contains(Bm) && (o += 1);
                        }),
                        t.hasAttribute($m) && (o += 1),
                        (i && o > e) || (s && o > 2)
                            ? (this.initSlider(t), this.getTallestProductGridItem(t))
                            : this.destroySlider(t));
                });
        }
        changeTabIndex(t) {
            const e = t.getAttribute(_m),
                i = this.flkty[e].selectedIndex;
            this.flkty[e].slides.forEach((t, e) => {
                t.cells.forEach((t) => {
                    t.element.querySelectorAll(Tm).forEach((t) => {
                        t.setAttribute(zm, i === e ? "0" : "-1");
                    });
                });
            });
        }
        setSliderArrowsPosition(t) {
            const e = t.querySelectorAll(Pm),
                i = t.querySelector(qm);
            e.length &&
                i &&
                e.forEach((t) => {
                    t.style.top = i.offsetHeight / 2 + "px";
                });
        }
        handleLastSlideOverlayOnTablet(t) {
            const e = t.getAttribute(_m);
            this.flkty[e].on("select", () => {
                if (
                    !(
                        window.innerWidth >= theme.sizes.small &&
                        window.innerWidth < theme.sizes.large
                    )
                )
                    return;
                const i = this.flkty[e].selectedIndex,
                    s = this.flkty[e].slides.length - 1 === i;
                t.parentNode.classList.toggle(Dm, s);
            });
        }
        getTallestProductGridItem(t) {
            if (t.querySelectorAll(Im).length) {
                const e = t.querySelectorAll(Fm),
                    i = Math.max(...Array.from(e).map((t) => t.offsetHeight));
                t.style.setProperty("--carousel-promo-height", `${i}px`);
            }
        }
        handleLastSlideOverlayOnMobile() {
            this.sliders.forEach((t) => {
                t.addEventListener("scroll", (e) => {
                    if (!(window.innerWidth < theme.sizes.small)) return;
                    const i = e.target.offsetWidth,
                        s =
                            Array.from(t.children).pop().getBoundingClientRect().left + 80 <
                            i;
                    t.parentNode.classList.toggle(Dm, s);
                });
            });
        }
        listen() {
            this.sliders.length &&
                (this.checkSlidesSize(),
                    document.addEventListener(
                        "theme:resize:width",
                        this.checkSlidesSizeOnResize,
                    ),
                    this.sliders.forEach((t) => {
                        (t.addEventListener("theme:tab:change", this.resetSliderEvent),
                            t.addEventListener("theme:slider:resize", this.resizeSliderEvent));
                    }));
        }
        onBlockSelect(t) {
            const i = t.target.closest(Am),
                s = e.data(i) || null;
            if (!i) return;
            let o = t.target.parentNode,
                n = t.target;
            if (
                (this.container.classList.contains(Mm) &&
                    ((o = o.parentNode), (n = n.parentNode)),
                    null !== s && s.isActive)
            ) {
                const t = parseInt([...o.children].indexOf(n)),
                    e = parseInt(s.slides[0].cells.length),
                    i = Math.floor(t / e);
                s.select(i);
            } else {
                const t = i.currentStyle || window.getComputedStyle(i),
                    e = parseInt(t.paddingLeft),
                    s = n.offsetLeft - e;
                i.scrollTo({ top: 0, left: s, behavior: "smooth" });
            }
        }
        onUnload() {
            if (this.flkty)
                for (const t in this.flkty)
                    this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
            (document.removeEventListener(
                "theme:resize:width",
                this.checkSlidesSizeOnResize,
            ),
                this.sliders.length &&
                this.sliders.forEach((t) => {
                    (t.removeEventListener("theme:tab:change", this.resetSliderEvent),
                        t.removeEventListener(
                            "theme:slider:resize",
                            this.resizeSliderEvent,
                        ));
                }));
        }
        constructor(t) {
            ((this.container = t),
                (this.columns = parseInt(this.container.dataset.columns)),
                (this.sliders = this.container.querySelectorAll(Am)),
                (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                (this.resetSliderEvent = (t) => this.resetSlider(t)),
                (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                (this.flkty = []),
                this.listen(),
                this.handleLastSlideOverlayOnMobile());
        }
    };
    const Nm = {
        onLoad() {
            Rm[this.id] = [];
            this.container.querySelectorAll(Am).forEach((t) => {
                Rm[this.id].push(new Vm(this.container));
            });
        },
        onUnload() {
            Rm[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
        onBlockSelect(t) {
            Rm[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
    };
    (Ut("featured-collection", [Rs, ki, Nm]), Ut("featured-video", [Vu, am]));
    const Wm = "[data-shop-pay-wrapper]",
        Um = "shop-login-button",
        jm = "shop-follow-button",
        Gm = "follow-on-shop-button",
        Km = "heart-icon",
        Qm = "shop-logo",
        Xm = {};
    const Ym = {
        onLoad() {
            Xm[this.id] = new (class {
                init() {
                    if (!this.shopLoginButton || !this.shopPayWrapper) return;
                    const t = this.shopPayWrapper.dataset.bg || "transparent",
                        e = this.shopPayWrapper.dataset.text || "#fff",
                        i = this.shopPayWrapper.dataset.hover || "#fff";
                    ((this.mainButtonStyles = `\n      :host {\n        --bg-color: ${t};\n        --text-color: ${e};\n        --hover-color: ${i};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n        transition: border 0.3s ease;\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
                        (this.svgIconsStyles = `\n      :host {\n        color: ${e};\n      }\n    `),
                        customElements.whenDefined(Um).then((t) => {
                            requestAnimationFrame(() => {
                                const t = this.shopLoginButton.shadowRoot,
                                    e = null == t ? void 0 : t.querySelector(jm),
                                    i = null == e ? void 0 : e.shadowRoot,
                                    s = null == i ? void 0 : i.querySelector(Gm),
                                    o = null == s ? void 0 : s.shadowRoot;
                                o &&
                                    this.overwriteStyles(
                                        o.host.shadowRoot,
                                        this.mainButtonStyles,
                                    );
                                const n = o.querySelector(Km),
                                    r = null == n ? void 0 : n.shadowRoot,
                                    a = o.querySelector(Qm),
                                    l = null == a ? void 0 : a.shadowRoot;
                                (r &&
                                    this.overwriteStyles(
                                        r.host.shadowRoot,
                                        this.svgIconsStyles,
                                    ),
                                    l &&
                                    this.overwriteStyles(
                                        l.host.shadowRoot,
                                        this.svgIconsStyles,
                                    ));
                            });
                        }));
                }
                overwriteStyles(t, e) {
                    let i = document.createElement("style");
                    ((i.innerHTML = e), t.appendChild(i));
                }
                constructor(t) {
                    ((this.container = t),
                        (this.shopPayWrapper = document.querySelector(Wm)),
                        (this.shopLoginButton = document.querySelector(Um)),
                        this.init());
                }
            })(this.container);
        },
    },
        Jm = ":scope > [data-wave]",
        Zm = "[data-main]",
        tg = "[data-collapsible-trigger-mobile]",
        eg = '[data-parallax="footer"]',
        ig = "is-expanded",
        sg = "wavy",
        og = "parallax-shadow",
        ng = "main-content--parallax",
        rg = "section-footer--parallax",
        ag = "main-content",
        lg = "shopify-section",
        cg = "--bg",
        hg = "--footer-bg",
        dg = "data-parallax",
        ug = "data-parallax-wavy",
        pg = "data-parallax-disable-on-safari",
        mg = {};
    Ut("footer", [
        Ra,
        gm,
        he,
        {
            onLoad() {
                mg[this.id] = new (class {
                    init() {
                        const t =
                            /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
                            this.container.hasAttribute(pg);
                        if (
                            this.isViewportSmaller() ||
                            window.innerWidth < theme.sizes.small ||
                            t
                        )
                            return;
                        const e = getComputedStyle(this.container).getPropertyValue(cg);
                        this.parentContainer.style.setProperty(
                            "--footer-parallax-height",
                            "auto",
                        );
                        let i = this.parentContainer.previousElementSibling;
                        if (i) {
                            if (
                                (i.classList.contains(lg) ||
                                    i.classList.contains(ag) ||
                                    (i = i.previousElementSibling),
                                    this.wavyEnabled)
                            ) {
                                [...i.querySelectorAll(Jm)].map((t) => t.remove());
                                const t = this.container.querySelector(Jm);
                                (i.append(t.cloneNode(!0)),
                                    i.classList.add(sg),
                                    this.container.classList.remove(sg));
                            } else i.classList.add(og);
                            i.style.setProperty(hg, e);
                        }
                        (this.parentContainer.style.setProperty(
                            "--footer-parallax-height",
                            `${this.container.clientHeight}px`,
                        ),
                            this.main.classList.add(ng),
                            this.parentContainer.classList.add(rg),
                            (this.footerParallax = new bd(this.container)));
                    }
                    resize() {
                        (this.parentContainer.style.setProperty(
                            "--footer-parallax-height",
                            "auto",
                        ),
                            (this.isViewportSmaller() ||
                                window.innerWidth < theme.sizes.small ||
                                !this.footerParallax) &&
                            this.onUnload(!0),
                            this.parentContainer.style.setProperty(
                                "--footer-parallax-height",
                                `${this.container.clientHeight}px`,
                            ));
                    }
                    isViewportSmaller() {
                        const t = Math.round(
                            Math.max(
                                document.documentElement.clientHeight,
                                window.innerHeight || 0,
                            ),
                        ),
                            e = this.container.clientHeight;
                        let i = 0;
                        return (this.wavyEnabled && (i = 50), t < e + i);
                    }
                    onBlockSelect(t) {
                        const e = t.target.querySelector(tg);
                        requestAnimationFrame(() => {
                            e &&
                                !e.classList.contains(ig) &&
                                e.dispatchEvent(new Event("click"));
                        });
                    }
                    onBlockDeselect(t) {
                        const e = t.target.querySelector(tg);
                        requestAnimationFrame(() => {
                            e &&
                                e.classList.contains(ig) &&
                                e.dispatchEvent(new Event("click"));
                        });
                    }
                    onUnload(t = !1) {
                        (document.removeEventListener("theme:resize", this.resizeEvent),
                            document.removeEventListener(
                                "theme:footer:unload",
                                this.unloadEvent,
                            ),
                            this.footerParallax &&
                            (this.footerParallax.unload(), t && L(this.parentContainer)),
                            (this.footerParallax || t) &&
                            setTimeout(() => {
                                const t = Shopify.theme.sections.instances,
                                    e = document.querySelectorAll(eg),
                                    i = t.filter((t) => t.container === e[0]);
                                (this.main.classList.remove(ng),
                                    this.parentContainer.classList.remove(rg),
                                    i[0] && i[0].onLoad());
                            }));
                    }
                    constructor(t) {
                        ((this.container = t.container),
                            (this.main = document.querySelector(Zm)),
                            (this.footerParallax = null),
                            (this.wavyEnabled = this.container.hasAttribute(ug)),
                            (this.parentContainer = this.container.parentNode),
                            (this.resizeEvent = () => this.resize()),
                            (this.unloadEvent = () => this.onUnload()),
                            this.container.hasAttribute(dg) &&
                            !this.main.classList.contains(ng) &&
                            (this.init(),
                                document.addEventListener("theme:resize", this.resizeEvent),
                                document.addEventListener(
                                    "theme:footer:unload",
                                    this.unloadEvent,
                                )));
                    }
                })(this);
            },
            onBlockSelect(t) {
                mg[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                mg[this.id].onBlockDeselect(t);
            },
            onReorder() {
                mg[this.id].onUnload();
            },
            onUnload() {
                mg[this.id].onUnload();
            },
        },
        Ym,
    ]);
    const gg = "[data-slider]";
    let vg = {};
    Ut("icons-row", {
        onLoad() {
            vg[this.id] = new (class {
                onBlockSelect(t) {
                    const e =
                        this.slider.currentStyle || window.getComputedStyle(this.slider),
                        i = parseInt(e.paddingLeft),
                        s = t.target.offsetLeft - i;
                    this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.slider = this.container.querySelector(gg)));
                }
            })(this);
        },
        onBlockSelect(t) {
            vg[this.id].onBlockSelect(t);
        },
    });
    const yg = "[data-accordion-item]",
        fg = "[data-accordion-button]",
        bg = "is-active",
        wg = "to-animate",
        Sg = "is-animating",
        Eg = {};
    (Ut("image-accordions", {
        onLoad() {
            Eg[this.id] = new (class {
                init() {
                    (this.triggerLoadingAnimation(),
                        this.imageAccordionsItems.forEach((t) => {
                            t.addEventListener(
                                "mouseenter",
                                this.accordionExpandEvent.bind(this, t),
                            );
                        }),
                        this.buttons.forEach((t) => {
                            t.addEventListener(
                                "focusin",
                                this.accordionFocusEvent.bind(this, t),
                            );
                        }));
                }
                triggerLoadingAnimation() {
                    if ("false" == theme.settings.animationsEnabled || ld()) return;
                    const t = (e) => {
                        "expandAccordion" === e.animationName &&
                            (this.accordionExpand(this.imageAccordionsItems[0]),
                                this.container.classList.remove(wg),
                                this.container.classList.remove(Sg),
                                this.container.removeEventListener("animationend", t));
                    },
                        e = (t) => {
                            requestAnimationFrame(() => {
                                t.target === this.container &&
                                    (this.container.classList.add(Sg),
                                        this.container.removeEventListener("transitionend", e));
                            });
                        };
                    (this.container.addEventListener("transitionend", e, {
                        signal: this.controller.signal,
                    }),
                        this.container.addEventListener("animationend", t, {
                            signal: this.controller.signal,
                        }));
                }
                accordionExpand(t) {
                    t.classList.contains(bg) ||
                        (this.imageAccordionsItems.forEach((t) => {
                            t.classList.remove(bg);
                        }),
                            t.classList.add(bg));
                }
                accordionFocus(t) {
                    t.closest(yg).dispatchEvent(new Event("mouseenter"));
                }
                onBlockSelect(t) {
                    const e = t.target;
                    e &&
                        (this.controller.abort(),
                            this.container.classList.remove(wg, Sg),
                            this.accordionExpand(e),
                            ld() &&
                            e.parentNode.scrollTo({
                                top: 0,
                                left: e.offsetLeft,
                                behavior: "smooth",
                            }));
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.controller = new AbortController()),
                        (this.imageAccordionsItems = this.container.querySelectorAll(yg)),
                        (this.buttons = this.container.querySelectorAll(fg)),
                        (this.accordionExpandEvent = (t) => this.accordionExpand(t)),
                        (this.accordionFocusEvent = (t) => this.accordionFocus(t)),
                        this.init());
                }
            })(this);
        },
        onBlockSelect(t) {
            Eg[this.id].onBlockSelect(t);
        },
    }),
        Ut("image-with-text", Vu),
        Ut("list-collections", Nm));
    const Lg = {},
        kg = "[data-slider-gallery]",
        Ag = "[data-slider-info]",
        Cg = "[data-slide-item]";
    Ut("locations", {
        onLoad() {
            Lg[this.id] = new (class {
                initSlider() {
                    const t = this.container.querySelectorAll(Cg).length;
                    let i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null;
                    t <= 1 ||
                        ((i = new e(this.slider, {
                            fade: !0,
                            wrapAround: !0,
                            adaptiveHeight: !0,
                            prevNextButtons: !1,
                            pageDots: !1,
                        })),
                            Ne(this.slider),
                            (s = new e(this.sliderNav, {
                                fade: !0,
                                wrapAround: !0,
                                imagesLoaded: !0,
                                asNavFor: this.slider,
                                prevNextButtons: !0,
                                pageDots: !1,
                            })),
                            s.on("change", () => {
                                i.selectCell(s.selectedIndex);
                            }),
                            i.on("change", () => {
                                s.selectCell(i.selectedIndex);
                            }));
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    (null !== i && i.select(o), null !== s && s.select(o));
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.slider = this.container.querySelector(kg)),
                        (this.sliderNav = this.container.querySelector(Ag)),
                        this.initSlider());
                }
            })(this);
        },
        onBlockSelect(t) {
            Lg[this.id].onBlockSelect(t);
        },
    });
    const qg = {},
        Tg = "[data-slider]",
        Pg = "[data-slide-item]",
        Ig = "[data-pointer]",
        Fg = "[data-product-media-container]",
        xg = "[data-quick-view-item-holder]",
        Hg = ".flickity-button",
        Dg = "a, button",
        Mg = "[data-tooltip]",
        Og = "data-pointer",
        Bg = "data-hotspot",
        _g = "tabindex",
        $g = "product-grid-item__image--hovered",
        zg = "pointer--selected",
        Rg = "is-selected",
        Vg = "is-active",
        Ng = "pswp--open";
    const Wg = {
        onLoad() {
            qg[this.id] = new (class {
                listen() {
                    (this.slider &&
                        (this.checkSlidesSize(),
                            document.addEventListener(
                                "theme:resize:width",
                                this.checkSlidesSizeOnResize,
                            ),
                            this.slider.addEventListener(
                                "theme:slider:resize",
                                this.resizeSliderEvent,
                            )),
                        this.pointers.length > 0 &&
                        this.pointers.forEach((t) => {
                            (t.addEventListener("click", this.pointersInit),
                                t.addEventListener("mouseover", this.pointersOver),
                                t.addEventListener("mouseleave", this.pointersOut));
                        }));
                }
                checkSlidesSize() {
                    const t = window.innerWidth >= theme.sizes.small;
                    (this.initTooltips(),
                        t
                            ? this.slides.length > 2
                                ? this.initSlider()
                                : (this.destroySlider(), this.slidesTabIndex())
                            : !t && this.slides.length > 1
                                ? this.initSlider()
                                : this.destroySlider());
                }
                initTooltips() {
                    ((this.tooltips = this.container.querySelectorAll(Mg)),
                        this.tooltips.forEach((t) => {
                            new Li(t);
                        }));
                }
                initSlider() {
                    null !== this.flkty
                        ? this.setSliderArrowsPosition()
                        : (this.flkty = new e(this.slider, {
                            prevNextButtons: !0,
                            wrapAround: !0,
                            adaptiveHeight: !1,
                            cellAlign: "left",
                            groupCells: !1,
                            contain: !0,
                            on: {
                                ready: () => {
                                    (this.slidesTabIndex(),
                                        this.setSliderArrowsPosition(),
                                        this.dotPointers());
                                },
                                change: () => {
                                    (this.slidesTabIndex(), this.dotPointers());
                                },
                            },
                        }));
                }
                setSliderArrowsPosition() {
                    if (!(window.innerWidth >= theme.sizes.small)) return;
                    const t = this.slider.querySelectorAll(Hg),
                        e = this.slider.querySelector(Fg);
                    t.length &&
                        e &&
                        t.forEach((t) => {
                            t.style.top = e.offsetHeight / 2 + "px";
                        });
                }
                slidesTabIndex() {
                    this.slides.length < 3
                        ? this.slider.querySelectorAll(Dg).forEach((t) => {
                            t.setAttribute(_g, "0");
                        })
                        : e.data(this.slider).cells.forEach((t) => {
                            let e = "-1";
                            (t.element.classList.contains(Rg) && (e = "0"),
                                t.element.querySelectorAll(Dg).forEach((t) => {
                                    t.setAttribute(_g, e);
                                }));
                        });
                }
                destroySlider() {
                    "object" == typeof this.flkty &&
                        null !== this.flkty &&
                        (this.flkty.destroy(), (this.flkty = null));
                }
                resizeSlider(t) {
                    const i = t.target,
                        s = e.data(i) || null;
                    s && s.resize();
                }
                dotPointers(t) {
                    if (0 === this.pointers.length) return;
                    if (
                        (this.pointers.forEach((t) => {
                            t.classList.remove(zg);
                        }),
                            t)
                    ) {
                        var e;
                        const i = t.target.getAttribute(Og);
                        return void (
                            null === (e = this.flkty) ||
                            void 0 === e ||
                            e.select(i)
                        );
                    }
                    const i = null == this.flkty ? 0 : this.flkty.selectedIndex;
                    i >= 0 && this.pointers[i].classList.add(zg);
                }
                dotPointerIn(t) {
                    const e = t.target.getAttribute(Og),
                        i = this.slides[e].querySelector(Fg),
                        s = matchMedia("(pointer:coarse)").matches;
                    (window.innerWidth < theme.sizes.small || s || this.observeImage(i),
                        this.pointers.forEach((t) => {
                            t.style.setProperty("--look-animation", "none");
                        }));
                }
                dotPointerOut(t) {
                    const e = t.target.getAttribute(Og),
                        i = this.slides[e].querySelector(Fg);
                    (i.classList.remove($g),
                        i.dispatchEvent(new Event("mouseleave")),
                        this.observer && this.observer.disconnect(),
                        this.pointers.forEach((t) => {
                            t.style.removeProperty("--look-animation");
                        }));
                }
                observeImage(t) {
                    ((this.observer = new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                const e = t.target;
                                0 == t.intersectionRatio ||
                                    (e.dispatchEvent(new Event("mouseenter")),
                                        e.classList.add($g));
                            });
                        },
                        { root: this.slider, threshold: [0.95, 1] },
                    )),
                        this.observer.observe(t));
                }
                triggerClick(t) {
                    requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
                }
                destroyQuickViewPopup() {
                    var t, e;
                    const i =
                        null === (t = this.quickViewPopup) ||
                            void 0 === t ||
                            null === (e = t.loadPhotoswipe) ||
                            void 0 === e
                            ? void 0
                            : e.pswpElement;
                    i &&
                        i.classList.contains(Ng) &&
                        this.quickViewPopup.loadPhotoswipe.popup.close();
                }
                onBlockSelect(t) {
                    this.debouncedBlockSelectCallback(t);
                }
                debouncedBlockSelect(t) {
                    var e, i;
                    const s =
                        null === (e = this.quickViewPopup) ||
                            void 0 === e ||
                            null === (i = e.loadPhotoswipe) ||
                            void 0 === i
                            ? void 0
                            : i.pswpElement;
                    s
                        ? setTimeout(() => {
                            if (s.classList.contains(Ng)) {
                                const e =
                                    this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(
                                        `[${Bg}="${t.target.getAttribute(Bg)}"]`,
                                    ),
                                    i =
                                        this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(
                                            xg,
                                        );
                                (e.classList.add(Vg),
                                    i.forEach((t) => {
                                        t !== e && t.classList.remove(Vg);
                                    }));
                            } else this.triggerClick(t.target);
                        })
                        : setTimeout(() => this.triggerClick(t.target), 400);
                }
                onUnload() {
                    (this.destroyQuickViewPopup(),
                        document.removeEventListener(
                            "theme:resize:width",
                            this.checkSlidesSizeOnResize,
                        ),
                        this.slider &&
                        this.slider.removeEventListener(
                            "theme:slider:resize",
                            this.resizeSliderEvent,
                        ));
                }
                onDeselect() {
                    this.destroyQuickViewPopup();
                }
                constructor(t) {
                    ((this.container = t),
                        (this.slider = this.container.querySelector(Tg)),
                        (this.slides = this.container.querySelectorAll(Pg)),
                        (this.pointers = this.container.querySelectorAll(Ig)),
                        (this.flkty = null),
                        (this.observer = null),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                        (this.pointersInit = (t) => this.dotPointers(t)),
                        (this.pointersOver = (t) => this.dotPointerIn(t)),
                        (this.pointersOut = (t) => this.dotPointerOut(t)),
                        (this.debouncedBlockSelectCallback = o(
                            (t) => this.debouncedBlockSelect(t),
                            500,
                        )),
                        (this.quickViewPopup = new pc(this.container)),
                        this.listen());
                }
            })(this.container);
        },
        onUnload() {
            qg[this.id].onUnload();
        },
        onBlockSelect(t) {
            qg[this.id].onBlockSelect(t);
        },
        onDeselect() {
            qg[this.id].onDeselect();
        },
    };
    Ut("look", [Wg]);
    const Ug = "[data-grid]";
    (Ut("mosaic", {
        onBlockSelect(t) {
            const e = t.target.closest(Ug),
                i = e.currentStyle || window.getComputedStyle(e),
                s = parseInt(i.paddingLeft),
                o = t.target.offsetLeft - s;
            e.scrollTo({ top: 0, left: o, behavior: "smooth" });
        },
    }),
        Ut("newsletter", gm),
        Ut("overlapping-images", [Vu, wd]));
    const jg = "[data-toggle-admin]",
        Gg = "[data-toggle-newsletter]",
        Kg = "[data-form-admin]",
        Qg = "[data-form-newsletter]";
    let Xg = {};
    Ut("password-template", {
        onLoad() {
            Xg[this.id] = new (class {
                init() {
                    (this.toggleAdmin.addEventListener("click", (t) => {
                        (t.preventDefault(), this.showPasswordForm());
                    }),
                        this.toggleNewsletter.addEventListener("click", (t) => {
                            (t.preventDefault(), this.hidePasswordForm());
                        }),
                        "#login" == window.location.hash || this.adminErrors
                            ? this.showPasswordForm()
                            : this.hidePasswordForm());
                }
                showPasswordForm() {
                    (Un(this.adminForm),
                        jn(this.newsletterForm),
                        (window.location.hash = "#login"));
                }
                hidePasswordForm() {
                    (Un(this.newsletterForm),
                        jn(this.adminForm),
                        (window.location.hash = ""));
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.toggleAdmin = this.container.querySelector(jg)),
                        (this.toggleNewsletter = this.container.querySelector(Gg)),
                        (this.adminForm = this.container.querySelector(Kg)),
                        (this.newsletterForm = this.container.querySelector(Qg)),
                        (this.adminErrors = this.adminForm.querySelector(".errors")),
                        (this.newsletterErrors =
                            this.newsletterForm.querySelector(".errors")),
                        this.init());
                }
            })(this);
        },
    });
    const Yg = "[data-large-promo]",
        Jg = "[data-large-promo-inner]",
        Zg = "[data-tracking-consent]",
        tv = "[data-tracking-consent-inner]",
        ev = "[data-confirm-cookies]",
        iv = "[data-popup-bar]",
        sv = "[data-popup-bar-holder]",
        ov = "[data-popup-bar-toggle]",
        nv = "[data-popup-body]",
        rv = "[data-popup-close]",
        av = "[data-popup-underlay]",
        lv = "[data-newsletter-form]",
        cv = "data-target-referrer",
        hv = "data-prevent-scroll-lock",
        dv = "has-success",
        uv = "has-error",
        pv = "selected",
        mv = "has-block-selected",
        gv = "popup--expanded",
        vv = "popup--visible",
        yv = "mobile",
        fv = "desktop",
        bv = "popup--bar",
        wv = "popup-bar-is-visible";
    let Sv = {},
        Ev = 0,
        Lv = 0,
        kv = [],
        Av = class {
            always() {
                this.showPopup();
            }
            delayed(t = 10) {
                setTimeout(() => {
                    this.showPopup();
                }, 1e3 * t);
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            idle() {
                if (!(!0 === this.checkPopupTarget())) return;
                let t = 0;
                const e = [
                    "mousemove",
                    "mousedown",
                    "click",
                    "touchmove",
                    "touchstart",
                    "touchend",
                    "keydown",
                    "keypress",
                ],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        ((t = setTimeout(() => {
                            ((t = 0), this.showPopup());
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.addEventListener(t, o);
                            }));
                    },
                    o = () => {
                        (t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            s());
                    };
                s();
            }
            showPopup() {
                const t = { id: this.popup.id, body: this.popupBody };
                kv.push(t);
                if (!0 === this.checkPopupTarget()) {
                    if (
                        ((Lv += 1),
                            this.popup.classList.add(vv),
                            this.popup.classList.contains(bv) &&
                            document.body.classList.add(wv),
                            this.a11y.trapFocus({ container: this.popupBody }),
                            this.popup.hasAttribute(hv))
                    )
                        return !1;
                    this.scrollLock();
                }
            }
            checkPopupTarget() {
                const t = this.popup.parentNode.classList.contains(yv),
                    e = this.popup.parentNode.classList.contains(fv);
                return !(
                    (t && window.innerWidth >= theme.sizes.small) ||
                    (e && window.innerWidth < theme.sizes.small)
                );
            }
            scrollLock() {
                document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", {
                        bubbles: !0,
                        detail: this.popupBody,
                    }),
                );
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight &&
                    (this.showPopup(),
                        document.removeEventListener(
                            "theme:scroll",
                            this.showPopupOnScrollEvent,
                        ));
            }
            onUnload() {
                document.removeEventListener(
                    "theme:scroll",
                    this.showPopupOnScrollEvent,
                );
            }
            constructor(t, e) {
                if (
                    ((this.popupContainer = t),
                        (this.popup = e),
                        (this.popupBody = e.querySelector(nv)),
                        (this.delay = t.dataset.popupDelay),
                        (this.isSubmitted =
                            -1 !== window.location.href.indexOf("accepts_marketing") ||
                            -1 !== window.location.href.indexOf("customer_posted=true")),
                        (this.a11y = be),
                        (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
                        ("always" === this.delay || this.isSubmitted) && this.always(),
                        this.delay && this.delay.includes("delayed") && !this.isSubmitted)
                ) {
                    const t = this.delay.includes("_")
                        ? parseInt(this.delay.split("_")[1])
                        : 10;
                    this.delayed(t);
                }
                ("bottom" !== this.delay || this.isSubmitted || this.bottom(),
                    "idle" !== this.delay || this.isSubmitted || this.idle());
            }
        },
        Cv = class {
            constructor(t) {
                if (
                    ((this.popupContainer = t),
                        (this.locationPath = location.href),
                        !this.popupContainer.hasAttribute(cv))
                )
                    return !1;
                -1 !==
                    this.locationPath.indexOf(this.popupContainer.getAttribute(cv)) ||
                    window.Shopify.designMode ||
                    this.popupContainer.parentNode.removeChild(this.popupContainer);
            }
        };
    Ut("popups", [
        {
            onLoad() {
                ((Sv[this.id] = []), window.Shopify.designMode && (Lv = 0));
                const t = this.container.querySelectorAll(Yg);
                t.length &&
                    t.forEach((t) => {
                        Sv[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode
                                            ? this.showPopup()
                                            : new Av(this.popupContainer, this.popup),
                                            this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(dv) &&
                                                    (this.showPopupIfNoCookie(), (Lv -= 1));
                                            }),
                                            this.initClosers());
                                }
                                checkPopupTarget() {
                                    const t = this.popup.parentNode.classList.contains(yv),
                                        e = this.popup.parentNode.classList.contains(fv);
                                    return !(
                                        (t && window.innerWidth >= theme.sizes.small) ||
                                        (e && window.innerWidth < theme.sizes.small)
                                    );
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup();
                                }
                                initClosers() {
                                    (this.close.addEventListener(
                                        "click",
                                        this.closePopup.bind(this),
                                    ),
                                        this.underlay.addEventListener(
                                            "click",
                                            this.closePopup.bind(this),
                                        ),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE &&
                                                this.closePopup(t);
                                        }));
                                }
                                closePopup(t) {
                                    (t.preventDefault(), this.hidePopup(), this.cookie.write());
                                }
                                scrollLock() {
                                    (this.resetScrollUnlock(),
                                        this.a11y.trapFocus({ container: this.popupBody }),
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:lock", {
                                                bubbles: !0,
                                                detail: this.popupBody,
                                            }),
                                        ));
                                }
                                scrollUnlock() {
                                    (this.resetScrollUnlock(),
                                        (Ev = setTimeout(() => {
                                            document.dispatchEvent(
                                                new CustomEvent("theme:scroll:unlock", { bubbles: !0 }),
                                            );
                                        }, 300)));
                                }
                                resetScrollUnlock() {
                                    Ev && clearTimeout(Ev);
                                }
                                showPopup() {
                                    const t = !0 === this.checkPopupTarget(),
                                        e = { id: this.popupId, body: this.popup };
                                    (kv.push(e),
                                        t &&
                                        ((Lv += 1),
                                            this.popup.classList.add(vv),
                                            this.scrollLock()));
                                }
                                hidePopup() {
                                    this.popup.classList.remove(vv);
                                    const t = kv.findIndex((t) => t.id === this.popupId);
                                    if (
                                        ((Lv -= 1),
                                            kv.splice(t, 1),
                                            1 == Lv && document.body.classList.contains(wv))
                                    )
                                        this.scrollUnlock();
                                    else if (Lv < 1)
                                        (this.scrollUnlock(), this.a11y.removeTrapFocus());
                                    else if (kv.length > 0) {
                                        const t = kv[kv.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        !this.popup.classList.contains(vv) &&
                                        (this.popup.classList.add(pv),
                                            this.popupContainer.classList.add(mv),
                                            this.showPopup());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        (this.popup.classList.remove(pv),
                                            this.popupContainer.classList.remove(mv),
                                            this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    (this.popup.classList.remove(pv),
                                        this.popupContainer.classList.remove(mv),
                                        this.hidePopup());
                                }
                                constructor(t) {
                                    ((this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(Jg)),
                                        (this.popupBody = this.popup.querySelector(nv)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(rv)),
                                        (this.underlay = this.popup.querySelector(av)),
                                        (this.form = this.popup.querySelector(lv)),
                                        (this.cookie = new lm(
                                            this.popupContainer.dataset.cookieName,
                                            "user_has_closed",
                                        )),
                                        (this.isTargeted = new Cv(this.popupContainer)),
                                        (this.a11y = be),
                                        this.init());
                                }
                            })(t),
                        );
                    });
                const e = this.container.querySelectorAll(iv);
                e.length &&
                    e.forEach((t) => {
                        Sv[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode
                                            ? this.showPopup()
                                            : new Av(this.popupContainer, this.popup),
                                            this.initPopupToggleButton(),
                                            this.initClosers(),
                                            this.form &&
                                            setTimeout(() => {
                                                (this.form.classList.contains(dv) &&
                                                    this.showPopupIfNoCookie(),
                                                    this.form.classList.contains(uv) &&
                                                    this.toggle.dispatchEvent(new Event("click")));
                                            }));
                                }
                                checkPopupTarget() {
                                    const t = this.popup.parentNode.classList.contains(yv),
                                        e = this.popup.parentNode.classList.contains(fv);
                                    return !(
                                        (t && window.innerWidth >= theme.sizes.small) ||
                                        (e && window.innerWidth < theme.sizes.small)
                                    );
                                }
                                showPopupIfNoCookie() {
                                    (this.showPopup(),
                                        this.toggle.dispatchEvent(new Event("click")));
                                }
                                initPopupToggleButton() {
                                    this.toggle.addEventListener("click", (t) => {
                                        (t.preventDefault(),
                                            this.popup.classList.toggle(gv),
                                            this.popup.classList.contains(gv)
                                                ? this.scrollLock()
                                                : this.scrollUnlock());
                                    });
                                }
                                showPopup() {
                                    const t = { id: this.popupId, body: this.popup };
                                    (kv.push(t),
                                        this.a11y.trapFocus({ container: this.popupBody }),
                                        !0 === this.checkPopupTarget() &&
                                        ((Lv += 1),
                                            document.body.classList.add(wv),
                                            this.popup.classList.add(vv)));
                                }
                                hidePopup() {
                                    (this.popup.classList.remove(vv),
                                        document.body.classList.remove(wv));
                                    const t = kv.findIndex((t) => t.id === this.popupId);
                                    if ((kv.splice(t, 1), Lv >= 1 && (Lv -= 1), Lv < 1))
                                        (this.scrollUnlock(), this.a11y.removeTrapFocus());
                                    else if (kv.length > 0) {
                                        const t = kv[kv.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                initClosers() {
                                    (this.close.addEventListener(
                                        "click",
                                        this.closePopup.bind(this),
                                    ),
                                        this.underlay.addEventListener("click", () =>
                                            this.toggle.dispatchEvent(new Event("click")),
                                        ),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE &&
                                                (this.popup.classList.remove(gv), this.scrollUnlock());
                                        }));
                                }
                                closePopup(t) {
                                    (t.preventDefault(), this.cookie.write(), this.hidePopup());
                                }
                                scrollLock() {
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll:lock", {
                                            bubbles: !0,
                                            detail: this.popupBody,
                                        }),
                                    );
                                }
                                scrollUnlock() {
                                    (this.resetScrollUnlock(),
                                        (Ev = setTimeout(() => {
                                            document.dispatchEvent(
                                                new CustomEvent("theme:scroll:unlock", { bubbles: !0 }),
                                            );
                                        }, 300)));
                                }
                                resetScrollUnlock() {
                                    Ev && clearTimeout(Ev);
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        !this.popup.classList.contains(vv) &&
                                        (this.showPopup(),
                                            this.popup.classList.add(gv),
                                            this.popup.classList.add(pv),
                                            this.popup.parentNode.classList.add(mv),
                                            this.resetScrollUnlock(),
                                            this.scrollLock());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        (this.popup.classList.remove(gv),
                                            this.popup.classList.remove(pv),
                                            this.popup.parentNode.classList.remove(mv),
                                            this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    (this.popup.classList.remove(gv),
                                        this.popup.classList.remove(pv),
                                        this.popup.parentNode.classList.remove(mv),
                                        this.hidePopup());
                                }
                                constructor(t) {
                                    ((this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(sv)),
                                        (this.popupBody = this.popup.querySelector(nv)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(rv)),
                                        (this.underlay = this.popup.querySelector(av)),
                                        (this.toggle = this.popup.querySelector(ov)),
                                        (this.cookie = new lm(
                                            this.popupContainer.dataset.cookieName,
                                            "user_has_closed",
                                        )),
                                        (this.form = this.popup.querySelector(lv)),
                                        (this.isTargeted = new Cv(this.popupContainer)),
                                        (this.a11y = be),
                                        this.init());
                                }
                            })(t),
                        );
                    });
                const i = this.container.querySelectorAll(Zg);
                i.length &&
                    i.forEach((t) => {
                        Sv[this.id].push(
                            new (class {
                                init() {
                                    (this.enableTracking && this.showPopup(), this.clickEvents());
                                }
                                clickEvents() {
                                    (this.close.addEventListener("click", (t) => {
                                        (t.preventDefault(),
                                            window.Shopify.customerPrivacy.setTrackingConsent(
                                                !1,
                                                () => this.hidePopup(),
                                            ));
                                    }),
                                        this.acceptButton.addEventListener("click", (t) => {
                                            (t.preventDefault(),
                                                window.Shopify.customerPrivacy.setTrackingConsent(
                                                    !0,
                                                    () => this.hidePopup(),
                                                ));
                                        }),
                                        document.addEventListener("trackingConsentAccepted", () => {
                                            console.log("trackingConsentAccepted event fired");
                                        }));
                                }
                                showPopup() {
                                    const t = { id: this.popupId, body: this.popup };
                                    (kv.push(t),
                                        this.popup.classList.add(vv),
                                        this.a11y.trapFocus({ container: this.popup }));
                                }
                                hidePopup() {
                                    this.popup.classList.remove(vv);
                                    const t = kv.findIndex((t) => t.id === this.popupId);
                                    if ((kv.splice(t, 1), Lv < 1)) this.a11y.removeTrapFocus();
                                    else if (kv.length > 0) {
                                        const t = kv[kv.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        this.enableTracking &&
                                        !this.popup.classList.contains(vv) &&
                                        (this.showPopup(),
                                            this.popup.classList.add(pv),
                                            this.popup.parentNode.classList.add(mv));
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        (this.popup.classList.remove(pv),
                                            this.popupContainer.classList.remove(mv),
                                            this.hidePopup());
                                }
                                onDeselect() {
                                    (this.popup.classList.remove(pv),
                                        this.popupContainer.classList.remove(mv),
                                        this.hidePopup());
                                }
                                constructor(t) {
                                    ((this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(tv)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(rv)),
                                        (this.acceptButton = this.popup.querySelector(ev)),
                                        (this.enable =
                                            "true" === this.popupContainer.dataset.enable),
                                        (this.a11y = be),
                                        window.Shopify.loadFeatures(
                                            [{ name: "consent-tracking-api", version: "0.1" }],
                                            (t) => {
                                                if (t) throw t;
                                                const e =
                                                    window.Shopify.customerPrivacy.userCanBeTracked(),
                                                    i =
                                                        window.Shopify.customerPrivacy.getTrackingConsent();
                                                ((this.enableTracking =
                                                    !e && "no_interaction" === i && this.enable),
                                                    window.Shopify.designMode &&
                                                    (this.enableTracking = !0),
                                                    this.init());
                                            },
                                        ));
                                }
                            })(t),
                        );
                    });
            },
            onDeselect() {
                Sv[this.id].forEach((t) => {
                    "function" == typeof t.onDeselect && t.onDeselect();
                });
            },
            onBlockSelect(t) {
                Sv[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Sv[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
            onUnload(t) {
                Sv[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload(t);
                });
            },
        },
        gm,
    ]);
    const qv = "[data-press-items]",
        Tv = "[data-logo-slider]",
        Pv = "[data-logo-slide]",
        Iv = "a, button",
        Fv = "data-logo-index",
        xv = "tabindex";
    let Hv = {};
    const Dv = {
        onLoad() {
            Hv[this.id] = new (class {
                checkSlides() {
                    const t = this.container.offsetWidth,
                        i = this.container.querySelectorAll(Pv),
                        s = e.data(this.sliderNav) || null;
                    null !== s &&
                        ((s.options.draggable = !1),
                            (s.options.wrapAround = !1),
                            (s.options.contain = !0),
                            this.getSlidesWidth() > t &&
                            i.length > 2 &&
                            ((s.options.draggable = !0),
                                (s.options.wrapAround = !0),
                                (s.options.contain = !1)),
                            s.resize(),
                            s.updateDraggable());
                }
                getSlidesWidth() {
                    const t = this.container.querySelectorAll(Pv);
                    let e = 0;
                    return (
                        t.length &&
                        t.forEach((t) => {
                            e += t.offsetWidth;
                        }),
                        e
                    );
                }
                initSlider() {
                    let t = e.data(this.slider) || null,
                        i = e.data(this.sliderNav) || null;
                    const s = parseInt(this.container.dataset.duration),
                        o = "true" === this.container.dataset.autoplay && s;
                    ((t = new e(this.slider, {
                        fade: !0,
                        wrapAround: !0,
                        adaptiveHeight: !1,
                        prevNextButtons: !1,
                        pageDots: !1,
                        autoPlay: o,
                    })),
                        (i = new e(this.sliderNav, {
                            draggable: !1,
                            wrapAround: !1,
                            contain: !0,
                            imagesLoaded: !0,
                            asNavFor: this.slider,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            on: {
                                ready: () => {
                                    this.container.querySelectorAll(Pv).forEach((e) => {
                                        e.addEventListener("keyup", (i) => {
                                            if (
                                                i.code === theme.keyboardKeys.ENTER ||
                                                i.code === theme.keyboardKeys.NUMPADENTER ||
                                                i.code === theme.keyboardKeys.SPACE
                                            ) {
                                                const i = Number(e.getAttribute(Fv));
                                                t.selectCell(i);
                                            }
                                        });
                                    });
                                },
                            },
                        })),
                        Ne(this.slider),
                        Ne(this.sliderNav),
                        i.on("change", (e) => {
                            t.selectCell(e);
                        }),
                        t.on("change", (e) => {
                            (i.selectCell(e),
                                t.cells.forEach((t, i) => {
                                    t.element.querySelectorAll(Iv).forEach((t) => {
                                        t.setAttribute(xv, i === e ? "0" : "-1");
                                    });
                                }));
                        }));
                }
                resizeSlider() {
                    const t = e.data(this.slider);
                    t && t.resize();
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    (null !== i && (i.select(o), i.pausePlayer()),
                        null !== s && s.select(o));
                }
                onBlockDeselect() {
                    const t = e.data(this.slider) || null;
                    "true" === this.container.dataset.autoplay &&
                        null !== t &&
                        t.playPlayer();
                }
                onUnload() {
                    document.removeEventListener(
                        "theme:resize:width",
                        this.sliderResizeEvent,
                    );
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.slider = this.container.querySelector(qv)),
                        (this.sliderNav = this.container.querySelector(Tv)),
                        (this.sliderResizeEvent = () => this.checkSlides()),
                        this.initSlider(),
                        this.checkSlides(),
                        window.addEventListener("load", this.resizeSlider.bind(this)),
                        document.addEventListener(
                            "theme:resize:width",
                            this.sliderResizeEvent,
                        ));
                }
            })(this);
        },
        onUnload(t) {
            Hv[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Hv[this.id].onBlockSelect(t);
        },
        onBlockDeselect() {
            Hv[this.id].onBlockDeselect();
        },
    };
    Ut("press", Dv);
    const Mv = "[data-product-single-media-slider]",
        Ov = "[data-product-info]",
        Bv = "[data-header-sticky]",
        _v = "[data-header-height]",
        $v = "is-sticky",
        zv = "data-sticky-enabled";
    window.theme.variables = { productPageSticky: !1 };
    const Rv = {};
    const Vv = {
        onLoad() {
            Rv[this.id] = new (class {
                init() {
                    (this.stickyEnabled &&
                        (this.stickyScrollCheck(),
                            document.addEventListener("theme:resize", this.resizeEvent)),
                        this.initSticky());
                }
                initSticky() {
                    theme.variables.productPageSticky &&
                        ((this.requestAnimationSticky = requestAnimationFrame(() =>
                            this.calculateStickyPosition(),
                        )),
                            this.productInfo.addEventListener("theme:form:sticky", (t) => {
                                (this.removeAnimationFrame(),
                                    (this.requestAnimationSticky = requestAnimationFrame(() =>
                                        this.calculateStickyPosition(t),
                                    )));
                            }),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                }
                scrollEvents(t) {
                    (null !== t.detail &&
                        ((this.scrollTop = t.detail.position),
                            (this.scrollDirectionDown = t.detail.down)),
                        this.requestAnimationSticky ||
                        (this.requestAnimationSticky = requestAnimationFrame(() =>
                            this.calculateStickyPosition(),
                        )));
                }
                resizeEvents() {
                    (this.stickyScrollCheck(),
                        document.removeEventListener("theme:scroll", this.scrollEvent),
                        this.initSticky());
                }
                stickyScrollCheck() {
                    const t =
                        (window.innerWidth ||
                            document.documentElement.clientWidth ||
                            document.body.clientWidth) >= window.theme.sizes.large,
                        e = this.container.querySelector(Ov);
                    if (e)
                        if (t) {
                            const t = this.container.querySelector(Ov),
                                i = this.container.querySelector(Mv);
                            if (!t || !i) return;
                            t.offsetHeight < i.offsetHeight
                                ? ((theme.variables.productPageSticky = !0),
                                    e.classList.add($v))
                                : ((theme.variables.productPageSticky = !1),
                                    e.classList.remove($v));
                        } else
                            ((theme.variables.productPageSticky = !1),
                                e.classList.remove($v));
                }
                calculateStickyPosition(t = null) {
                    const e = Boolean(t && t.detail),
                        i = Boolean(
                            e && t.detail.element && "accordion" === t.detail.element,
                        ),
                        s = this.productInfo.offsetHeight,
                        o = window.innerHeight - s - this.defaultTopBottomSpacings,
                        n = Math.abs(this.scrollTop - this.scrollLastPosition);
                    (this.scrollDirectionDown
                        ? (this.stickyScrollTop -= n)
                        : (this.stickyScrollTop += n),
                        this.stickyFormLoad &&
                        (document.querySelector(Bv) && document.querySelector(_v)
                            ? (this.stickyDefaultTop = parseInt(
                                document.querySelector(_v).getBoundingClientRect().height,
                            ))
                            : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                            (this.stickyScrollTop = this.stickyDefaultTop)),
                        (this.stickyScrollTop = Math.min(
                            Math.max(this.stickyScrollTop, o),
                            this.stickyDefaultTop,
                        )));
                    const r = this.stickyScrollTop - this.currentPoint;
                    ((this.currentPoint = this.stickyFormLoad
                        ? this.stickyScrollTop
                        : this.currentPoint + 0.5 * r),
                        this.productInfo.style.setProperty(
                            "--sticky-top",
                            `${this.currentPoint}px`,
                        ),
                        (this.scrollLastPosition = this.scrollTop),
                        (this.stickyFormLoad = !1),
                        (i && this.onChangeCounter <= 10) ||
                            (i && this.stickyFormLastHeight !== s) ||
                            (this.stickyScrollTop !== this.currentPoint &&
                                this.requestAnimationSticky)
                            ? (i && (this.onChangeCounter += 1),
                                i &&
                                this.stickyFormLastHeight !== s &&
                                (this.onChangeCounter = 11),
                                (this.requestAnimationSticky = requestAnimationFrame(() =>
                                    this.calculateStickyPosition(t),
                                )))
                            : this.requestAnimationSticky && this.removeAnimationFrame(),
                        (this.stickyFormLastHeight = s));
                }
                removeAnimationFrame() {
                    this.requestAnimationSticky &&
                        (cancelAnimationFrame(this.requestAnimationSticky),
                            (this.requestAnimationSticky = null),
                            (this.onChangeCounter = 0));
                }
                onUnload() {
                    (this.stickyEnabled &&
                        document.removeEventListener("theme:resize", this.resizeEvent),
                        theme.variables.productPageSticky &&
                        document.removeEventListener("theme:scroll", this.scrollEvent));
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.stickyEnabled = "true" === this.container.getAttribute(zv)),
                        (this.productInfo = this.container.querySelector(Ov)),
                        (this.stickyScrollTop = 0),
                        (this.scrollLastPosition = 0),
                        (this.stickyDefaultTop = 0),
                        (this.currentPoint = 0),
                        (this.defaultTopBottomSpacings = 30),
                        (this.scrollTop = window.scrollY),
                        (this.scrollDirectionDown = !0),
                        (this.requestAnimationSticky = null),
                        (this.stickyFormLoad = !0),
                        (this.stickyFormLastHeight = null),
                        (this.onChangeCounter = 0),
                        (this.scrollEvent = (t) => this.scrollEvents(t)),
                        (this.resizeEvent = (t) => this.resizeEvents(t)),
                        this.init());
                }
            })(this);
        },
        onUnload() {
            Rv[this.id].onUnload();
        },
    },
        Nv = "[data-product-single-media-group]",
        Wv = "[data-product-single-media-slider]",
        Uv = "[data-zoom-wrapper]",
        jv = "pswp-zoom-gallery",
        Gv = "pswp-zoom-gallery--single",
        Kv = "is-moving",
        Qv = "data-image-width",
        Xv = "data-image-height";
    const Yv = "[data-complementary-products]",
        Jv = "[data-button-quick-view]",
        Zv = "data-url";
    let ty = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(
                ((t, e) => {
                    t[0].isIntersecting &&
                        (e.unobserve(this),
                            this.hasAttribute(Zv) &&
                            "" !== this.getAttribute(Zv) &&
                            fetch(this.getAttribute(Zv))
                                .then((t) => t.text())
                                .then((t) => {
                                    const e = document.createElement("div");
                                    e.innerHTML = t;
                                    const i = e.querySelector(Yv);
                                    (i &&
                                        i.innerHTML.trim().length &&
                                        (this.innerHTML = i.innerHTML),
                                        e.querySelector(Jv) && new pc(this));
                                })
                                .catch((t) => {
                                    console.error(t);
                                }));
                }).bind(this),
                { rootMargin: "0px 0px 400px 0px" },
            ).observe(this);
        }
        constructor() {
            super();
        }
    };
    const ey = "[data-recipient-checkbox]",
        iy = "[data-recipient-email]",
        sy = "[data-recipient-name]",
        oy = "[data-recipient-message]",
        ny = "[data-recipient-send-on]",
        ry = "[data-recipient-control]",
        ay = "[data-recipient-offset]",
        ly = "[data-product-form]",
        cy = "[data-cart-drawer]",
        hy = "js-quick-view-visible";
    let dy = class extends HTMLElement {
        connectedCallback() {
            this.recipientCheckbox &&
                (this.disableInputFields(),
                    this.recipientCheckbox.addEventListener("change", this.onChangeEvent),
                    document.addEventListener("theme:cart:added", this.onCartAddedEvent));
        }
        onChange(t) {
            if (!t.target.checked)
                return (this.clearInputFields(), void this.disableInputFields());
            this.enableInputFields();
        }
        onCartAdded() {
            const t = this.closest(ly).offsetTop,
                e = document.body.classList.contains(hy);
            if (!(!0 === this.recipientCheckbox.checked)) return;
            e || window.scrollTo({ top: t, left: 0, behavior: "smooth" });
            const i = (t) => {
                t.target === this.cartDrawer &&
                    (requestAnimationFrame(() => {
                        ((this.recipientCheckbox.checked = !1),
                            this.recipientCheckbox.dispatchEvent(new Event("change")));
                    }),
                        this.cartDrawer.removeEventListener("transitionend", i));
            };
            this.cartDrawer.addEventListener("transitionend", i);
        }
        inputFields() {
            return [
                this.recipientEmail,
                this.recipientName,
                this.recipientMessage,
                this.recipientSendOn,
            ];
        }
        disableableFields() {
            return [...this.inputFields(), this.recipientOffset];
        }
        clearInputFields() {
            this.inputFields().forEach((t) => (t.value = ""));
        }
        enableInputFields() {
            this.disableableFields().forEach((t) => (t.disabled = !1));
        }
        disableInputFields() {
            this.disableableFields().forEach((t) => (t.disabled = !0));
        }
        disconnectedCallback() {
            (this.recipientCheckbox.removeEventListener("change", this.onChangeEvent),
                document.removeEventListener(
                    "theme:cart:added",
                    this.onCartAddedEvent,
                ));
        }
        constructor() {
            (super(),
                (this.recipientCheckbox = this.querySelector(ey)),
                (this.recipientControl = this.querySelector(ry)),
                (this.recipientControl.disabled = !0),
                (this.recipientEmail = this.querySelector(iy)),
                (this.recipientName = this.querySelector(sy)),
                (this.recipientMessage = this.querySelector(oy)),
                (this.recipientSendOn = this.querySelector(ny)),
                (this.recipientOffset = this.querySelector(ay)),
                this.recipientOffset &&
                (this.recipientOffset.value = new Date().getTimezoneOffset()),
                (this.cartDrawer = document.querySelector(cy)),
                (this.onChangeEvent = (t) => this.onChange(t)),
                (this.onCartAddedEvent = () => this.onCartAdded()));
        }
    };
    const uy = "[data-product-single-media-slider]",
        py = "[data-thumbnail-id]",
        my = "[data-product-single-media-thumbs]",
        gy = "[data-product-single-media-wrapper]",
        vy = "[data-model]",
        yy = ".product-single__thumbnail-link",
        fy = "[data-deferred-media]",
        by = "[data-deferred-media-button]",
        wy = "[data-product-rating]",
        Sy = "#shopify-product-reviews",
        Ey = "a, button",
        Ly = "[data-upsell-holder]",
        ky = "[data-upsell-slider]",
        Ay = "[data-slider]",
        Cy = "[data-product-json]",
        qy = "featured-product",
        Ty = "featured-product--onboarding",
        Py = "has-media-active",
        Iy = "is-selected",
        Fy = "media--hidden",
        xy = "no-outline",
        Hy = "is-moving",
        Dy = "data-media-id",
        My = "data-section-id",
        Oy = "data-thumbnail-id",
        By = "data-tall-layout",
        _y = "loaded",
        $y = "tabindex",
        zy = {};
    const Ry = {
        onLoad() {
            zy[this.id] = new (class {
                productSlider() {
                    (this.checkSlider(),
                        document.addEventListener(
                            "theme:resize:width",
                            this.checkSliderOnResize,
                        ));
                }
                checkSlider() {
                    !this.tallLayout || window.innerWidth < theme.sizes.large
                        ? this.initProductSlider()
                        : this.destroyProductSlider();
                }
                resizeFlickityNav() {
                    null !== this.flktyNav && this.flktyNav.resize();
                }
                initProductSlider() {
                    const t = this.container.querySelector(uy),
                        i = this.container.querySelector(my),
                        s = this.container.querySelectorAll(gy);
                    if (
                        s.length > 1 &&
                        ((this.flkty = new e(t, {
                            wrapAround: !0,
                            pageDots: !1,
                            adaptiveHeight: !0,
                            on: {
                                ready: () => {
                                    (t.setAttribute($y, "-1"),
                                        s.forEach((t) => {
                                            if (!t.classList.contains(Iy)) {
                                                const e = t.querySelectorAll(Ey);
                                                e.length &&
                                                    e.forEach((t) => {
                                                        t.setAttribute($y, "-1");
                                                    });
                                            }
                                        }));
                                },
                                dragStart: () => {
                                    t.classList.add(Hy);
                                },
                                dragMove: () => {
                                    this.isFlickityDragging = !0;
                                },
                                staticClick: () => {
                                    this.isFlickityDragging = !1;
                                },
                                settle: (e) => {
                                    const i = this.flkty.selectedElement.getAttribute(Dy);
                                    (this.flkty.cells.forEach((t, i) => {
                                        const s = t.element.querySelectorAll(Ey);
                                        s.length &&
                                            s.forEach((t) => {
                                                t.setAttribute($y, i === e ? "0" : "-1");
                                            });
                                    }),
                                        this.switchMedia(i),
                                        t.classList.remove(Hy));
                                },
                            },
                        })),
                            s.length &&
                            s.forEach((t) => {
                                (t.addEventListener("theme:media:play", () => {
                                    ((this.flkty.options.draggable = !1),
                                        this.flkty.updateDraggable(),
                                        t.closest(uy).classList.add(Py));
                                }),
                                    t.addEventListener("theme:media:pause", () => {
                                        ((this.flkty.options.draggable = !0),
                                            this.flkty.updateDraggable(),
                                            t.closest(uy).classList.remove(Py));
                                    }));
                            }),
                            Ne(t),
                            null !== i)
                    ) {
                        ((this.flktyNav = new e(i, {
                            asNavFor: t,
                            contain: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            resize: !0,
                            on: {
                                ready: () => {
                                    i.setAttribute($y, "-1");
                                },
                            },
                        })),
                            null !== this.flktyNav &&
                            document.addEventListener(
                                "theme:resize:width",
                                this.flktyNavOnResize,
                            ),
                            Ne(i));
                        const s = this.container.querySelectorAll(yy);
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                });
                            });
                    }
                }
                destroyProductSlider() {
                    null !== this.flkty &&
                        (this.flkty.destroy(),
                            this.flktyNav.destroy(),
                            (this.flkty = null),
                            (this.flktyNav = null));
                }
                initUpsellSlider() {
                    const t = this.container.querySelector(ky);
                    if (this.container.querySelectorAll(Ly).length > 1) {
                        const i = new e(t, {
                            wrapAround: !0,
                            pageDots: !0,
                            adaptiveHeight: !0,
                            prevNextButtons: !1,
                        });
                        i.on("change", (t) => {
                            i.cells.forEach((e, i) => {
                                const s = e.element.querySelectorAll(Ey);
                                s.length &&
                                    s.forEach((e) => {
                                        e.setAttribute($y, i === t ? "0" : "-1");
                                    });
                            });
                        });
                    }
                }
                initFeatureSlider() {
                    this.featureSliders.forEach((t) => {
                        Array.from(t.children).length > 1 &&
                            (this.flktyFeature = new e(t, {
                                wrapAround: !0,
                                pageDots: !0,
                                adaptiveHeight: !0,
                                prevNextButtons: !1,
                            }));
                    });
                }
                handleMediaFocus(t) {
                    if (
                        t.code !== theme.keyboardKeys.ENTER &&
                        t.code !== theme.keyboardKeys.TAB
                    )
                        return;
                    const i = t.currentTarget.getAttribute(Oy),
                        s = this.container.querySelector(`[${Dy}="${i}"]`),
                        o = parseInt([...s.parentNode.children].indexOf(s)),
                        n = this.container.querySelector(uy),
                        r = this.container.querySelector(my),
                        a = e.data(n) || null,
                        l = e.data(r) || null;
                    (a &&
                        a.isActive &&
                        o > -1 &&
                        (t.code === theme.keyboardKeys.ENTER ||
                            t.code === theme.keyboardKeys.NUMPADENTER) &&
                        a.select(o),
                        l && l.isActive && o > -1 && l.select(o));
                }
                switchMedia(t) {
                    const e = document.querySelectorAll(`${gy}`),
                        i = this.container.querySelector(`${gy}[${Dy}="${t}"]`),
                        s = !document.body.classList.contains(xy);
                    (e.length &&
                        e.forEach((t) => {
                            (t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                                bubbles: !0,
                            }),
                                t.classList.add(Fy));
                        }),
                        s && i.focus(),
                        i.closest(uy).classList.remove(Py),
                        i.classList.remove(Fy),
                        i.dispatchEvent(new CustomEvent("theme:media:visible"), {
                            bubbles: !0,
                        }));
                    const o = i.querySelector(fy);
                    o &&
                        "true" !== o.getAttribute(_y) &&
                        i.querySelector(by).dispatchEvent(new Event("click"));
                }
                initMediaSwitch() {
                    const t = this.container.querySelectorAll(py);
                    t.length &&
                        t.forEach((t) => {
                            (t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                }));
                        });
                }
                initProductVideo() {
                    this.videos = new si(this.container);
                }
                initProductModel() {
                    const t = this.container.querySelectorAll(vy);
                    t.length &&
                        t.forEach((t) => {
                            theme.ProductModel.init(t, this.sectionId);
                        });
                }
                initShopifyXrLaunch() {
                    document.addEventListener("shopify_xr_launch", () => {
                        this.container
                            .querySelector(`${vy}:not(.${Fy})`)
                            .dispatchEvent(new CustomEvent("xrLaunch"));
                    });
                }
                onUnload() {
                    (null !== this.flktyNav &&
                        document.removeEventListener(
                            "theme:resize:width",
                            this.flktyNavOnResize,
                        ),
                        document.removeEventListener(
                            "theme:resize:width",
                            this.checkSliderOnResize,
                        ));
                }
                scrollToReviews() {
                    const t = this.container.querySelector(wy);
                    t &&
                        ["click", "keydown"].forEach((e) => {
                            t.addEventListener(e, (t) => {
                                if (
                                    (t.code !== theme.keyboardKeys.ENTER &&
                                        t.code !== theme.keyboardKeys.NUMPADENTER) ||
                                    "click" != t.type
                                ) {
                                    const t = document.querySelector(Sy);
                                    if (!t) return;
                                    t.scrollIntoView({ behavior: "smooth" });
                                }
                            });
                        });
                }
                onBlockSelect(t) {
                    const i = e.data(t.target.closest(Ay)),
                        s = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    i && i.select(s);
                }
                constructor(t) {
                    if (
                        ((this.container = t.container),
                            (this.sectionId = this.container.getAttribute(My)),
                            (this.tallLayout = "true" === this.container.getAttribute(By)),
                            (this.featureSliders = this.container.querySelectorAll(Ay)),
                            (this.flkty = null),
                            (this.flktyNav = null),
                            (this.isFlickityDragging = !1),
                            (this.enableHistoryState = !this.container.classList.contains(qy)),
                            (this.checkSliderOnResize = () => this.checkSlider()),
                            (this.flktyNavOnResize = () => this.resizeFlickityNav()),
                            this.scrollToReviews(),
                            this.initUpsellSlider(),
                            this.initFeatureSlider(),
                            new pc(this.container),
                            this.container.classList.contains(Ty))
                    )
                        return;
                    const e = this.container.querySelector(Cy);
                    if (e && e.innerHTML) {
                        const t = JSON.parse(e.innerHTML).handle;
                        let i = {};
                        (t && (i = { handle: t }),
                            Shopify.Products.recordRecentlyViewed(i));
                    } else Shopify.Products.recordRecentlyViewed();
                    (new (class {
                        init() {
                            this.zoomWrappers.length &&
                                this.zoomWrappers.forEach((t, e) => {
                                    t.addEventListener("click", (i) => {
                                        (i.preventDefault(),
                                            (this.slider && this.slider.classList.contains(Kv)) ||
                                            ((this.a11y.state.trigger = t), this.createZoom(e)));
                                    });
                                });
                        }
                        createZoom(t) {
                            const e = this;
                            let i = [],
                                s = 0;
                            this.zoomWrappers.forEach((o) => {
                                const n = o.getAttribute("href"),
                                    r = parseInt(o.getAttribute(Qv)),
                                    a = parseInt(o.getAttribute(Xv));
                                if (
                                    (i.push({ src: n, w: r, h: a, msrc: n }),
                                        (s += 1),
                                        e.zoomWrappers.length === s)
                                ) {
                                    let e = `${jv}`;
                                    (1 === s && (e = `${jv} ${Gv}`),
                                        new Kl(i, {
                                            barsSize: { top: 60, bottom: 60 },
                                            history: !1,
                                            focus: !1,
                                            index: t,
                                            mainClass: e,
                                            showHideOpacity: !0,
                                            showAnimationDuration: 250,
                                            hideAnimationDuration: 250,
                                            closeOnScroll: !1,
                                            closeOnVerticalDrag: !1,
                                            captionEl: !1,
                                            closeEl: !0,
                                            closeElClasses: ["caption-close"],
                                            tapToClose: !1,
                                            clickToCloseNonZoomable: !1,
                                            maxSpreadZoom: 2,
                                            loop: !0,
                                            spacing: 0,
                                            allowPanToNext: !0,
                                            pinchToClose: !1,
                                        }));
                                }
                            });
                        }
                        constructor(t) {
                            ((this.container = t),
                                (this.mediaContainer = this.container.querySelector(Nv)),
                                (this.slider = this.container.querySelector(Wv)),
                                (this.zoomWrappers = this.container.querySelectorAll(Uv)),
                                (this.zoomEnable =
                                    "true" === this.mediaContainer.dataset.gallery),
                                (this.a11y = be),
                                this.zoomEnable && this.init());
                        }
                    })(this.container),
                        this.productSlider(),
                        this.initMediaSwitch(),
                        this.initProductVideo(),
                        this.initProductModel(),
                        this.initShopifyXrLaunch());
                }
            })(this);
        },
        onUnload: function () {
            zy[this.id].onUnload();
        },
        onBlockSelect(t) {
            zy[this.id].onBlockSelect(t);
        },
    };
    (Ut("product-template", [fa, Ry, qs, Ts, $u, he, ki, Ra, Wn, Vv]),
        Ut("featured-product", [fa, Ry, qs, Ts, $u, he, ki, Ra, Wn, Vv]),
        customElements.get("complementary-products") ||
        customElements.define("complementary-products", ty),
        customElements.get("recipient-form") ||
        customElements.define("recipient-form", dy));
    const Vy = "href",
        Ny = "data-media-id",
        Wy = "data-deferred-media-loaded",
        Uy = "[data-product-content-wrapper]",
        jy = "[data-product-single-media-wrapper]",
        Gy = "[data-model]",
        Ky = "[data-product-link]",
        Qy = "[data-product-single-media-image]",
        Xy = "[data-slider-contents]",
        Yy = "[data-slider-images]",
        Jy = "[data-tab-button]",
        Zy = "[data-tab-item]",
        tf = "[data-circle-text]",
        ef = {
            aosAnimate: "aos-animate",
            tabButtonActive: "products-list__nav__button--active",
            tabItemActive: "products-list__item--active",
            mediaHidden: "media--hidden",
            isDisabled: "is-disabled",
        },
        sf = {};
    Ut("products-list", [
        {
            onLoad() {
                sf[this.id] = new (class {
                    listen() {
                        (this.slidersImages.length > 0 ||
                            this.slidersContents.length > 0) &&
                            document.addEventListener("theme:resize", this.sliderResizeEvent);
                    }
                    resizeSlider() {
                        (this.flktyImages.length > 0 &&
                            requestAnimationFrame(() => {
                                this.flktyImages.forEach((t) => t.resize());
                            }),
                            this.flktyContent.length > 0 &&
                            requestAnimationFrame(() => {
                                this.flktyContent.forEach((t) => t.resize());
                            }));
                    }
                    initButtons() {
                        this.tabButtons.length &&
                            this.tabButtons.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    if (t.classList.contains(ef.tabButtonActive)) return;
                                    const i = t.getAttribute(Vy),
                                        s = this.container.querySelector(i),
                                        o = s.querySelector(jy),
                                        n = o ? o.dataset.mediaId : null,
                                        r = s.querySelector(tf);
                                    (this.tabButtons.forEach((t) => {
                                        t.classList.remove(ef.tabButtonActive);
                                    }),
                                        this.tabItems.forEach((t) => {
                                            const e = t.querySelector(tf);
                                            (t.classList.remove(ef.tabItemActive),
                                                null == e || e.classList.add(ef.isDisabled),
                                                theme.settings.animationsEnabled &&
                                                t
                                                    .querySelectorAll(`.${ef.aosAnimate}`)
                                                    .forEach((t) => {
                                                        (t.classList.remove(ef.aosAnimate),
                                                            setTimeout(() => {
                                                                t.classList.add(ef.aosAnimate);
                                                            }));
                                                    }));
                                        }),
                                        t.classList.add(ef.tabButtonActive),
                                        s.classList.add(ef.tabItemActive),
                                        document.dispatchEvent(new CustomEvent("theme:resize")),
                                        r &&
                                        (r.classList.remove(ef.isDisabled),
                                            document.dispatchEvent(new CustomEvent("theme:scroll"))),
                                        this.handleProductVideos(s, n),
                                        e.preventDefault());
                                });
                            });
                    }
                    initSliders() {
                        (this.slidersImages.forEach((t, i) => {
                            const s = t.closest(Zy).querySelector(Xy),
                                o = new e(t, {
                                    fade: !0,
                                    pageDots: !1,
                                    prevNextButtons: !0,
                                    wrapAround: !0,
                                    adaptiveHeight: !0,
                                    asNavFor: s,
                                    on: {
                                        change: (t) => {
                                            this.flktyContent.length > 0 &&
                                                this.flktyContent[i].select(t);
                                        },
                                    },
                                });
                            (o.on("settle", (e) => {
                                const i = t.querySelectorAll(jy);
                                for (let t = 0; t < i.length; t++)
                                    t === e
                                        ? i[t].querySelector(Qy).removeAttribute("tabindex")
                                        : i[t].querySelector(Qy).setAttribute("tabindex", "-1");
                            }),
                                this.flktyImages.push(o));
                        }),
                            this.slidersContents.forEach((t) => {
                                const i = new e(t, {
                                    fade: !0,
                                    pageDots: !1,
                                    prevNextButtons: !1,
                                    wrapAround: !0,
                                    adaptiveHeight: !0,
                                });
                                (i.on("settle", (e) => {
                                    const i = t.querySelectorAll(Uy);
                                    for (let t = 0; t < i.length; t++)
                                        t === e
                                            ? i[t].querySelectorAll(Ky).forEach((t) => {
                                                t.removeAttribute("tabindex");
                                            })
                                            : i[t].querySelectorAll(Ky).forEach((t) => {
                                                t.setAttribute("tabindex", "-1");
                                            });
                                }),
                                    this.flktyContent.push(i));
                            }));
                    }
                    initProductVideos() {
                        this.tabItems.forEach((t) => {
                            t.classList.contains(ef.tabItemActive) &&
                                this.handleProductVideos(t);
                        });
                    }
                    loadVideos(t, e = null) {
                        new IntersectionObserver(
                            (i, s) => {
                                i.forEach((i) => {
                                    if (i.isIntersecting) {
                                        const o = new si(t);
                                        (this.videos.push(o),
                                            t.setAttribute(Wy, ""),
                                            this.playToggle(e),
                                            s.unobserve(i.target));
                                    }
                                });
                            },
                            {
                                root: null,
                                rootMargin: "300px",
                                threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
                            },
                        ).observe(t);
                    }
                    handleProductVideos(t, e = null) {
                        t.hasAttribute(Wy) ? this.playToggle(e) : this.loadVideos(t, e);
                    }
                    playToggle(t) {
                        this.videos.forEach((e) => {
                            ("function" == typeof e.pauseContainerMedia &&
                                t &&
                                (e.pauseContainerMedia(t, this.container), this.switchMedia(t)),
                                t ||
                                0 !== Object.keys(e.players).length ||
                                this.pauseContainerMedia(this.container));
                        });
                    }
                    switchMedia(t) {
                        const e = this.container.querySelector(`${jy}[${Ny}="${t}"]`);
                        (!document.body.classList.contains(ef.noOutline) && e.focus(),
                            e.classList.remove(ef.mediaHidden),
                            e.dispatchEvent(new CustomEvent("theme:media:visible"), {
                                bubbles: !0,
                            }));
                    }
                    pauseContainerMedia(t) {
                        const e = t.querySelectorAll(jy);
                        0 !== e.length &&
                            e.forEach((t) => {
                                (t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                                    bubbles: !0,
                                }),
                                    t.classList.add(ef.mediaHidden));
                            });
                    }
                    initProductModel() {
                        const t = this.container.querySelectorAll(Gy);
                        t.length &&
                            t.forEach((t) => {
                                theme.ProductModel.init(t, this.sectionId);
                            });
                    }
                    initShopifyXrLaunch() {
                        document.addEventListener("shopify_xr_launch", () => {
                            this.container
                                .querySelector(`${Gy}:not(.${ef.mediaHidden})`)
                                .dispatchEvent(new CustomEvent("xrLaunch"));
                        });
                    }
                    onBlockSelect(t) {
                        t.target.dispatchEvent(new Event("click"));
                    }
                    onUnload() {
                        (this.slidersImages.length > 0 ||
                            this.slidersContents.length > 0) &&
                            document.removeEventListener(
                                "theme:resize",
                                this.sliderResizeEvent,
                            );
                    }
                    constructor(t) {
                        ((this.container = t.container),
                            (this.sectionId = this.container.dataset.sectionId),
                            (this.tabButtons = this.container.querySelectorAll(Jy)),
                            (this.tabItems = this.container.querySelectorAll(Zy)),
                            (this.slidersImages = this.container.querySelectorAll(Yy)),
                            (this.slidersContents = this.container.querySelectorAll(Xy)),
                            (this.videos = []),
                            (this.flktyImages = []),
                            (this.flktyContent = []),
                            (this.sliderResizeEvent = () => this.resizeSlider()),
                            this.initButtons(),
                            this.initSliders(),
                            this.initProductVideos(),
                            this.initProductModel(),
                            this.initShopifyXrLaunch(),
                            this.listen());
                    }
                })(this);
            },
            onUnload() {
                sf[this.id].onUnload();
            },
            onBlockSelect(t) {
                sf[this.id].onBlockSelect(t);
            },
        },
        wd,
    ]);
    const of = "[data-product-block]",
        nf = "[data-related-products]",
        rf = "[data-recent-wrapper]",
        af = "[data-recently-viewed-wrapper]",
        lf = "[data-slider]",
        cf = "[data-slide]",
        hf = "[data-aos]",
        df = "[data-tabs-holder]",
        uf = "[data-tabs-link]",
        pf = "[data-tab]",
        mf = "[data-tooltip]",
        gf = "data-section-id",
        vf = "data-product-id",
        yf = "data-limit",
        ff = "data-minimum",
        bf = "data-tabs-link",
        wf = "data-column-mobile",
        Sf = "hidden",
        Ef = "aos-animate",
        Lf = "mobile--one-whole",
        kf = "mobile--one-half",
        Af = {};
    const Cf = {
        onLoad() {
            Af[this.id] = new (class {
                related() {
                    if (
                        ((this.relatedProducts = this.container.querySelector(nf)),
                            !this.relatedProducts)
                    )
                        return;
                    const t = this.container.getAttribute(gf),
                        e = this.container.getAttribute(vf),
                        i = this.container.getAttribute(yf),
                        s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`;
                    fetch(s)
                        .then((t) => {
                            if (!t.ok) {
                                const e = new Error(t.status);
                                throw (this.hideRelated(), e);
                            }
                            return t.text();
                        })
                        .then((t) => {
                            const e = document.createElement("div");
                            e.innerHTML = t;
                            const i = e.querySelector(nf);
                            i &&
                                i.querySelectorAll(of).length &&
                                ((this.relatedProducts.innerHTML = i.innerHTML),
                                    (this.relatedProductGrid = new zs(this.relatedProducts)),
                                    (this.relatedGridSlider = new Vm(this.container)),
                                    this.initTooltips(this.relatedProducts));
                        });
                }
                recent() {
                    const t = this.container.querySelector(rf),
                        e = t ? parseInt(t.getAttribute(yf)) : 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete: (t, e) => {
                            const i = e.container,
                                s = i.querySelector(rf),
                                o = i.querySelector(af),
                                n = t.querySelectorAll(of),
                                r = s.querySelectorAll(hf),
                                a = s.querySelector(lf),
                                l = s.hasAttribute(ff) ? parseInt(s.getAttribute(ff)) : 1,
                                c = !o && n.length > 0,
                                h = o && n.length >= l,
                                d = a.getAttribute(wf);
                            if (c || h) {
                                ((this.recentProductGrid = new zs(s)),
                                    this.initTooltips(s),
                                    h && i.classList.remove(Sf),
                                    a &&
                                    ((this.recentGridSlider = new Vm(i)),
                                        requestAnimationFrame(() => {
                                            this.recentGridSlider.sliders.forEach((t) => {
                                                (t.dispatchEvent(
                                                    new CustomEvent("theme:slider:resize", {
                                                        bubbles: !0,
                                                    }),
                                                ),
                                                    this.recentGridSlider.setSliderArrowsPosition(t));
                                            });
                                        }),
                                        a.querySelectorAll(cf).forEach((t) => {
                                            2 == d
                                                ? (t.classList.add(kf), t.classList.remove(Lf))
                                                : (t.classList.add(Lf), t.classList.remove(kf));
                                        })));
                                let t = [];
                                s.addEventListener("theme:target:animate", (e) => {
                                    (t.push(e.detail),
                                        t.length === r.length &&
                                        requestAnimationFrame(() =>
                                            r.forEach((t) => t.classList.add(Ef)),
                                        ));
                                });
                            }
                        },
                    });
                }
                hideRelated() {
                    const t = this.relatedProducts.closest(pf),
                        e = this.relatedProducts.closest(df),
                        i = e.querySelector(`[${bf}="${t.dataset.tab}"]`);
                    (t.remove(),
                        i &&
                        (i.remove(),
                            e.querySelector(uf).dispatchEvent(new Event("click")),
                            this.tabs.customScrollbar.unload(),
                            requestAnimationFrame(() => {
                                this.tabs.customScrollbar = new ci(this.tabs.container);
                            })));
                }
                initTooltips(t) {
                    ((this.tooltips = t.querySelectorAll(mf)),
                        this.tooltips.forEach((t) => {
                            new Li(t);
                        }));
                }
                onDeselect() {
                    (this.relatedProductGrid && this.relatedProductGrid.onDeselect(),
                        this.recentProductGrid && this.recentProductGrid.onDeselect());
                }
                onBlockSelect(t) {
                    const e = t.target,
                        i = this.container.querySelectorAll(pf);
                    !e ||
                        i.length < 2 ||
                        (e.dispatchEvent(new Event("click")),
                            e.parentNode.scrollTo({
                                top: 0,
                                left: e.offsetLeft - e.clientWidth,
                                behavior: "smooth",
                            }));
                }
                onUnload() {
                    (this.relatedProductGrid && this.relatedProductGrid.onUnload(),
                        this.relatedGridSlider && this.relatedGridSlider.onUnload(),
                        this.recentProductGrid && this.recentProductGrid.onUnload(),
                        this.recentGridSlider && this.recentGridSlider.onUnload());
                }
                constructor(t) {
                    ((this.section = t),
                        (this.sectionId = t.id),
                        (this.container = t.container),
                        this.related(),
                        this.recent(),
                        (this.tabs = new Tn(this.container)));
                }
            })(this);
        },
        onDeselect() {
            Af[this.id].onDeselect();
        },
        onBlockSelect(t) {
            Af[this.id].onBlockSelect(t);
        },
        onUnload() {
            Af[this.id].onUnload();
        },
    };
    (Ut("related-products", Cf), Ut("recent-products", Cf));
    const qf = {},
        Tf = "[data-slider]",
        Pf = "[data-item]",
        If = "[data-button-show]",
        Ff = "[data-button-hide]",
        xf = "[data-item-products]",
        Hf = "[data-item-products-slider]",
        Df = "[data-item-product]",
        Mf = "a, button",
        Of = "blog-item--active",
        Bf = "blog-item__products--visible",
        _f = "flickity-enabled",
        $f = "is-selected",
        zf = {
            slider: "data-slider",
            slidePosition: "data-slide-position",
            sectionId: "data-section-id",
            tabIndex: "tabindex",
        };
    const Rf = {
        onLoad() {
            qf[this.id] = new (class {
                initSlider() {
                    ((this.flkty = new e(this.slider, {
                        prevNextButtons: !0,
                        pageDots: !1,
                        cellAlign: "left",
                        wrapAround: !1,
                        groupCells: !0,
                        contain: !0,
                        on: {
                            ready: () => {
                                this.handleFocus();
                            },
                        },
                    })),
                        this.flkty.on("change", () => {
                            const t = this.container.querySelectorAll(Pf);
                            (this.handleFocus(),
                                t.length &&
                                t.forEach((t) => {
                                    const e = t.querySelector(xf);
                                    (t.classList.remove(Of),
                                        e && t.querySelector(xf).classList.remove(Bf));
                                }),
                                this.flkty &&
                                !this.flkty.options.draggable &&
                                ((this.flkty.options.draggable = !0),
                                    this.flkty.updateDraggable()));
                        }));
                }
                destroySlider() {
                    null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                checkSlidesSize() {
                    const t =
                        this.container.querySelector(Pf).currentStyle ||
                        window.getComputedStyle(this.container.querySelector(Pf));
                    this.gutter = parseInt(t.marginRight);
                    const e =
                        this.slider.offsetWidth + this.gutter < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e
                        ? this.initSlider()
                        : this.destroySlider();
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(Pf);
                    return (
                        e.length &&
                        e.forEach((e) => {
                            t += e.offsetWidth + this.gutter;
                        }),
                        t
                    );
                }
                bindButtons() {
                    const t = this.container.querySelectorAll(Hf),
                        i = this.container.querySelectorAll(If),
                        s = this.container.querySelectorAll(Ff);
                    (i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                (e.preventDefault(),
                                    this.container.querySelectorAll(Pf).forEach((t) => {
                                        const e = t.querySelector(xf);
                                        (t.classList.remove(Of),
                                            e && (e.classList.remove(Bf), this.changeTabIndex(e)));
                                    }));
                                const i = t.closest(Pf),
                                    s = i.querySelector(xf);
                                if ((i.classList.add(Of), s)) {
                                    (s.classList.add(Bf), this.changeTabIndex(s, "enable"));
                                    const t = s.querySelector(Hf),
                                        e = t.querySelectorAll(Df);
                                    if (t.classList.contains(_f)) {
                                        const i = t
                                            .querySelector(`.${$f}`)
                                            .getAttribute(zf.slidePosition);
                                        e.forEach((t, e) => {
                                            t.setAttribute(zf.tabIndex, e === i ? "0" : "-1");
                                        });
                                    }
                                }
                                (null !== this.flkty &&
                                    ((this.flkty.options.draggable = !1),
                                        this.flkty.updateDraggable()),
                                    (this.a11y.state.trigger = t));
                            });
                        }),
                        s.length &&
                        s.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                e.preventDefault();
                                const i = t.closest(Pf),
                                    s = i.querySelector(xf);
                                (i.classList.remove(Of),
                                    s && (s.classList.remove(Bf), this.changeTabIndex(s)),
                                    null !== this.flkty &&
                                    ((this.flkty.options.draggable = !0),
                                        this.flkty.updateDraggable()),
                                    this.a11y.state.trigger.focus());
                            });
                        }),
                        t.length &&
                        t.forEach((t) => {
                            if (t.querySelectorAll(Df).length > 1) {
                                const i = new e(t, {
                                    prevNextButtons: !0,
                                    contain: !0,
                                    pageDots: !1,
                                    wrapAround: !0,
                                    on: {
                                        change: (t) => {
                                            i.cells.forEach((e, i) => {
                                                e.element.querySelectorAll(Mf).forEach((e) => {
                                                    e.setAttribute(zf.tabIndex, i === t ? "0" : "-1");
                                                });
                                            });
                                        },
                                    },
                                });
                            }
                        }),
                        this.slider.addEventListener("keyup", (t) => {
                            if (t.code === theme.keyboardKeys.ESCAPE) {
                                const e = t.target.hasAttribute(zf.slider)
                                    ? t.target.querySelectorAll(Pf)
                                    : t.target.closest(Tf).querySelectorAll(Pf);
                                (e.length &&
                                    (e.forEach((t) => {
                                        const e = t.querySelector(xf);
                                        (t.classList.remove(Of),
                                            e && (e.classList.remove(Bf), this.changeTabIndex(e)));
                                    }),
                                        this.flkty &&
                                        ((this.flkty.options.draggable = !0),
                                            this.flkty.updateDraggable())),
                                    this.a11y.state.trigger.focus());
                            }
                        }));
                }
                handleFocus() {
                    const t = this.container.querySelectorAll(Pf);
                    t.length &&
                        t.forEach((t) => {
                            const e = t.classList.contains($f),
                                i = t.querySelector(xf);
                            e
                                ? (this.changeTabIndex(t, "enable"),
                                    i && this.changeTabIndex(i))
                                : (this.changeTabIndex(t), i && i.classList.remove(Bf));
                        });
                }
                listen() {
                    (this.slider &&
                        (this.checkSlidesSize(),
                            document.addEventListener(
                                "theme:resize:width",
                                this.checkSlidesSizeOnResize,
                            )),
                        document.addEventListener("mousedown", this.clickOutsideItemEvent));
                }
                changeTabIndex(t, e = "") {
                    const i = "enable" === e ? "0" : "-1";
                    t.querySelectorAll(Mf).forEach((t) => {
                        t.setAttribute(zf.tabIndex, i);
                    });
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt(
                            [...t.target.parentNode.children].indexOf(t.target),
                        ),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e =
                            this.slider.currentStyle ||
                            window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    (document.removeEventListener(
                        "theme:resize:width",
                        this.checkSlidesSizeOnResize,
                    ),
                        document.removeEventListener(
                            "mousedown",
                            this.clickOutsideItemEvent,
                        ));
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.flkty = null),
                        (this.slider = this.container.querySelector(Tf)),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.isFullWidth = this.container.hasAttribute(zf.fullWidth)),
                        (this.gutter = 0),
                        (this.a11y = be),
                        (this.clickOutsideItemEvent = (t) => {
                            if (!t.target.matches(Pf) && !t.target.closest(Pf)) {
                                const t = this.container.querySelectorAll(Pf);
                                t.length &&
                                    t.forEach((t) => {
                                        const e = t.querySelector(xf);
                                        (e && (e.classList.remove(Bf), this.changeTabIndex(e)),
                                            t.classList.remove(Of));
                                    });
                            }
                        }),
                        this.bindButtons(),
                        this.listen());
                }
            })(this);
        },
        onUnload(t) {
            qf[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            qf[this.id].onBlockSelect(t);
        },
    };
    Ut("shoppable-blog", Rf);
    const Vf = "[data-scroll-down]",
        Nf = "[data-site-header]",
        Wf = "[data-slide]",
        Uf = "a, button",
        jf = "[data-slider]",
        Gf = ".lazy-image",
        Kf = "data-style",
        Qf = "data-current-style",
        Xf = "tabindex",
        Yf = "data-slide-position",
        Jf = "site-header--fixed",
        Zf = "slider--no-cached-images",
        tb = "slider--img-loaded",
        eb = "img-in",
        ib = {};
    Ut("slider", [
        {
            onLoad() {
                ib[this.id] = new (class {
                    initSlider() {
                        const t = this.container.querySelectorAll(Wf).length,
                            i = parseInt(this.container.dataset.duration),
                            s = "true" === this.container.dataset.pageDots && t > 1,
                            o = "true" === this.container.dataset.navArrows && t > 1;
                        let n = "true" === this.container.dataset.autoplay;
                        if ((n && (n = i), t > 1))
                            ((this.flkty = new e(this.container, {
                                fade: !0,
                                cellSelector: Wf,
                                autoPlay: n,
                                wrapAround: !0,
                                adaptiveHeight: !0,
                                setGallerySize: !0,
                                imagesLoaded: !0,
                                pageDots: s,
                                prevNextButtons: o,
                                on: {
                                    ready: () => {
                                        const t = this.container
                                            .querySelector(`${Wf}[${Yf}="1"]`)
                                            .getAttribute(Kf);
                                        (this.container.setAttribute(Qf, t),
                                            requestAnimationFrame(this.resizeEvent),
                                            document.addEventListener("theme:vars", this.resizeEvent),
                                            this.handleFirstSlideAnimation(!0));
                                    },
                                    change: (t) => {
                                        const e = this.flkty.selectedElement.getAttribute(Kf);
                                        (this.container.setAttribute(Qf, e),
                                            this.handleFirstSlideAnimation(!1),
                                            this.flkty.cells.forEach((e, i) => {
                                                e.element.querySelectorAll(Uf).forEach((e) => {
                                                    e.setAttribute(Xf, i === t ? "0" : "-1");
                                                });
                                            }));
                                    },
                                },
                            })),
                                Ne(this.container));
                        else if (1 === t) {
                            const t = this.container.querySelector(Wf).getAttribute(Kf);
                            this.container.setAttribute(Qf, t);
                        }
                    }
                    handleFirstSlideAnimation(t = !1) {
                        if (!t)
                            return (
                                this.container.classList.remove(Zf),
                                void this.container.classList.remove(tb)
                            );
                        const e = this.container
                            .querySelectorAll(Wf)[0]
                            .querySelectorAll(Gf),
                            i = this.container.classList.contains(eb);
                        if (e.length && !i) {
                            this.container.classList.add(Zf);
                            const t = (i) => {
                                (requestAnimationFrame(() => this.container.classList.add(tb)),
                                    e[0].removeEventListener("transitionend", t));
                            };
                            e[0].addEventListener("transitionend", t);
                        }
                    }
                    bindScrollButton() {
                        const t = this.container.querySelector(Vf);
                        t &&
                            t.addEventListener("click", (t) => {
                                t.preventDefault();
                                const e = this.header.classList.contains(Jf) ? 60 : 0,
                                    i = parseInt(
                                        Math.ceil(
                                            this.container.offsetTop +
                                            this.container.offsetHeight -
                                            e,
                                        ),
                                    );
                                window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                            });
                    }
                    onBlockSelect(t) {
                        const e = parseInt(
                            [...t.target.parentNode.children].indexOf(t.target),
                        );
                        null !== this.flkty &&
                            (this.flkty.select(e), this.flkty.pausePlayer());
                    }
                    onBlockDeselect(t) {
                        "true" === t.target.closest(jf).dataset.autoplay &&
                            null !== this.flkty &&
                            this.flkty.playPlayer();
                    }
                    onReorder() {
                        (this.handleFirstSlideAnimation(!1),
                            null !== this.flkty && this.flkty.resize());
                    }
                    onUnload() {
                        (this.handleFirstSlideAnimation(!1),
                            null !== this.flkty &&
                            (document.removeEventListener("theme:vars", this.resizeEvent),
                                this.flkty.destroy(),
                                (this.flkty = null)));
                    }
                    constructor(t) {
                        ((this.container = t.container),
                            (this.header = document.querySelector(Nf)),
                            (this.flkty = null),
                            (this.resizeEvent = () => {
                                this.flkty.resize();
                            }),
                            this.initSlider(),
                            this.bindScrollButton());
                    }
                })(this);
            },
            onReorder(t) {
                ib[this.id].onReorder(t);
            },
            onUnload(t) {
                ib[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                ib[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                ib[this.id].onBlockDeselect(t);
            },
        },
        Vu,
        ju,
    ]);
    const sb = "[data-sticky-wrapper]",
        ob = "[data-sticky-aside]",
        nb = "[data-sticky-inner]",
        rb = "[data-sticky-content]",
        ab = "[data-sticky-text]",
        lb = "[data-sticky-text-inner]",
        cb = "[data-sticky-image]",
        hb = "[data-sticky-images]",
        db = ".image-wrapper",
        ub = "[data-sticky-dot]",
        pb = "data-sticky-with-gaps",
        mb = "data-sticky-single-text",
        gb = "data-index",
        vb = 0.5,
        yb = {
            horizontal: "horizontal",
            horizontalReversed: "horizontal-reversed",
            vertical: "vertical",
            verticalReversed: "vertical-reversed",
        },
        fb = {
            maxVisibility: "maximum-visibility-of-each-image-in-viewport",
            middleOfViewport: "image-in-the-middle-of-viewport",
        },
        bb = "is-active",
        wb = {};
    (Ut("sticky-images-and-text", [
        {
            onLoad() {
                wb[this.id] = new (class {
                    init() {
                        (this.getTypeOfIntersecting(),
                            this.observeImagesIntersecting(),
                            this.calculateHeights(),
                            (this.performAnimation = requestAnimationFrame(
                                this.calculateImagesOffsetCallback,
                            )),
                            requestAnimationFrame(() => this.calculateHeights()),
                            document.addEventListener("theme:scroll", this.onScrollCallback),
                            document.addEventListener(
                                "theme:resize:width",
                                this.onResizeCallback,
                            ),
                            this.syncDots());
                    }
                    getTypeOfIntersecting() {
                        ((this.typeOfIntersecting = fb.maxVisibility),
                            (this.fractionOfViewport =
                                this.image[0].offsetHeight / window.innerHeight),
                            this.verticalScroll &&
                            !ld() &&
                            this.fractionOfViewport < 0.6 &&
                            (this.typeOfIntersecting = fb.middleOfViewport));
                    }
                    observeImagesIntersecting() {
                        ((this.observersCollection = new Set()),
                            (this.compareIntersectionRatio = []),
                            (this.maxVisibility = 0),
                            (this.observer = new IntersectionObserver(
                                (t, e) => {
                                    t.forEach((t) => {
                                        const e = t.target.offsetHeight,
                                            i = t.intersectionRatio,
                                            s = t.isIntersecting,
                                            o = {
                                                target: t.target,
                                                intersectionRatio: t.intersectionRatio,
                                            },
                                            n = this.typeOfIntersecting === fb.maxVisibility;
                                        let r = vb;
                                        (this.windowHeight <= e && (r = 0),
                                            n &&
                                            s &&
                                            (this.observersCollection.forEach((e) => {
                                                e.target === t.target &&
                                                    this.observersCollection.delete(e);
                                            }),
                                                this.observersCollection.add(o),
                                                (this.compareIntersectionRatio = [
                                                    ...this.observersCollection,
                                                ].map((t) => t.intersectionRatio)),
                                                (this.maxVisibility = Math.max(
                                                    ...this.compareIntersectionRatio,
                                                ))),
                                            s &&
                                            i > r &&
                                            n &&
                                            this.maxVisibility === i &&
                                            ((this.maxVisibilityItem = [
                                                ...this.observersCollection,
                                            ].find(
                                                (t) => t.intersectionRatio === this.maxVisibility,
                                            )),
                                                (this.activeIndex = Number(
                                                    this.maxVisibilityItem.target.dataset.index,
                                                )),
                                                this.lastActiveIndex !== this.activeIndex &&
                                                (this.sync(),
                                                    (this.lastActiveIndex = this.activeIndex))));
                                    });
                                },
                                {
                                    root: null,
                                    rootMargin: "0px",
                                    threshold: [
                                        0, 0.15, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7,
                                        0.85, 1,
                                    ],
                                },
                            )),
                            this.image.forEach((t) => this.observer.observe(t)));
                    }
                    onScroll() {
                        (this.performAnimation ||
                            (this.performAnimation = requestAnimationFrame(
                                this.calculateImagesOffsetCallback,
                            )),
                            this.typeOfIntersecting === fb.middleOfViewport &&
                            this.image.forEach((t) =>
                                this.checkImagePositionInViewport(t),
                            ));
                    }
                    removeAnimationFrame() {
                        this.performAnimation &&
                            (cancelAnimationFrame(this.performAnimation),
                                (this.performAnimation = null));
                    }
                    checkImagePositionInViewport(t) {
                        if (!t) return;
                        const e = window.innerHeight,
                            i = window.scrollY,
                            s = i + e / 2,
                            o = i + e,
                            n = Math.round(t.getBoundingClientRect().top + i),
                            r = n + t.offsetHeight;
                        n < o &&
                            !(r < i) &&
                            s > n &&
                            r > s &&
                            ((this.activeIndex = Number(t.dataset.index)),
                                this.lastActiveIndex !== this.activeIndex &&
                                (this.sync(), (this.lastActiveIndex = this.activeIndex)));
                    }
                    calculateImagesOffset() {
                        const t =
                            this.aside.getBoundingClientRect().top - this.headerHeight,
                            e = t - this.innerStickyTop;
                        let i = 0,
                            s = 0;
                        const o = this.hasShortImages ? e : t;
                        ((i =
                            o < 0
                                ? (o / this.bottomEndingPoint) * -1 * 100
                                : o >= 0
                                    ? 0
                                    : 100),
                            (s = i > 100 ? 100 : i),
                            (s *= this.image.length - 1),
                            (ld() || this.horizontalScroll) &&
                            this.aside.style.setProperty(
                                "--translateX",
                                `${Number(s * this.direction).toFixed(2)}%`,
                            ),
                            this.lastOffset !== s
                                ? (this.performAnimation = requestAnimationFrame(
                                    this.calculateImagesOffsetCallback,
                                ))
                                : this.performAnimation && this.removeAnimationFrame(),
                            (this.lastOffset = s));
                    }
                    calculateHeights() {
                        let { stickyHeaderHeight: t, windowHeight: e } = q();
                        if (
                            ((this.headerHeight = t || 0),
                                (this.windowHeight = e || window.innerHeight),
                                this.text.length > 0)
                        ) {
                            const t = this.content
                                ? parseInt(
                                    window
                                        .getComputedStyle(this.content)
                                        .getPropertyValue("padding-top"),
                                )
                                : 0,
                                e = this.content
                                    ? parseInt(
                                        window
                                            .getComputedStyle(this.content)
                                            .getPropertyValue("padding-bottom"),
                                    )
                                    : 0,
                                i = [...this.text].map((i) => i.offsetHeight + t + e),
                                s = [...this.textInner].map((t) => t.offsetHeight),
                                o = Math.max(...i),
                                n = Math.max(...s),
                                r = ld() ? n : o,
                                a = i.reduce((t, e) => t + e, 0),
                                l = Math.floor(a / i.length) || this.text[0].offsetHeight;
                            (this.container.style.removeProperty("--average-text-height"),
                                this.container.style.setProperty(
                                    "--average-text-height",
                                    `${l}px`,
                                ),
                                this.container.style.removeProperty("--highest-text"),
                                this.container.style.setProperty("--highest-text", `${r}px`));
                        }
                        ((this.imagesHeight = this.images.offsetHeight),
                            (this.hasShortImages = !1),
                            this.image.length > 0 &&
                            ((this.imgHeight =
                                this.image[0].querySelector(db).offsetHeight),
                                (this.imgPadding = parseInt(
                                    window
                                        .getComputedStyle(this.image[0])
                                        .getPropertyValue("padding-top"),
                                )),
                                this.container.style.removeProperty("--images-height"),
                                this.container.style.setProperty(
                                    "--images-height",
                                    `${this.imagesHeight}px`,
                                ),
                                this.container.style.removeProperty("--img-height"),
                                this.container.style.setProperty(
                                    "--img-height",
                                    `${this.imgHeight + 2 * this.imgPadding}px`,
                                )),
                            (this.asideHeight = this.aside.offsetHeight),
                            (this.asidePadding = parseInt(
                                window
                                    .getComputedStyle(this.aside)
                                    .getPropertyValue("padding-top"),
                            )),
                            (this.breathingSpace =
                                (this.windowHeight - this.imagesHeight) / 2 / 2),
                            (this.innerStickyTop =
                                parseInt(
                                    window.getComputedStyle(this.inner).getPropertyValue("top"),
                                ) -
                                this.headerHeight -
                                this.breathingSpace),
                            (this.gutters =
                                this.withGaps || ld() ? 2 * this.asidePadding : 0),
                            (this.minHeightForEndingPoing = this.imagesHeight + this.gutters),
                            !ld() &&
                            this.horizontalScroll &&
                            ((this.minHeightForEndingPoing =
                                this.windowHeight - this.headerHeight),
                                (this.hasShortImages = this.fractionOfViewport <= 0.6),
                                this.hasShortImages &&
                                (this.minHeightForEndingPoing =
                                    this.imagesHeight -
                                    this.innerStickyTop +
                                    3 * this.breathingSpace)),
                            (this.bottomEndingPoint =
                                this.asideHeight - this.minHeightForEndingPoing));
                    }
                    refreshImagesOffsetValues() {
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                document.dispatchEvent(new CustomEvent("theme:scroll"));
                            });
                        });
                    }
                    onResize() {
                        (this.calculateHeights(),
                            requestAnimationFrame(() => this.calculateHeights()),
                            this.getTypeOfIntersecting(),
                            this.refreshImagesOffsetValues());
                    }
                    sync() {
                        const t = this.singleText ? [] : this.text;
                        [...this.image, ...t, ...this.dot].forEach((t) => {
                            const e = Number(t.getAttribute(gb));
                            t.classList.toggle(bb, e === Number(this.activeIndex));
                        });
                    }
                    syncDots() {
                        this.dot.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                t.preventDefault();
                                const e = Number(t.target.dataset.index),
                                    i = this.image[e],
                                    s = Math.round(
                                        i.getBoundingClientRect().top + window.scrollY,
                                    ),
                                    o = i.offsetHeight;
                                let n =
                                    this.wrapper.offsetTop +
                                    this.images.offsetHeight * e -
                                    this.headerHeight;
                                (this.verticalScroll &&
                                    ad() &&
                                    ((n = s - this.headerHeight),
                                        this.typeOfIntersecting === fb.middleOfViewport &&
                                        (n =
                                            s - window.innerHeight / 2 + o / 2 - this.headerHeight)),
                                    window.scrollTo({ top: n, left: 0, behavior: "smooth" }));
                            });
                        });
                    }
                    onUnload() {
                        (this.image.forEach((t) => this.observer.unobserve(t)),
                            document.removeEventListener(
                                "theme:scroll",
                                this.onScrollCallback,
                            ),
                            document.removeEventListener(
                                "theme:resize:width",
                                this.onResizeCallback,
                            ));
                    }
                    onBlockSelect(t) {
                        const e = Number(t.target.dataset.index),
                            i = Math.round(
                                t.target.getBoundingClientRect().top + window.scrollY,
                            ),
                            s = t.target.offsetHeight;
                        let o =
                            this.wrapper.offsetTop +
                            this.images.offsetHeight * e -
                            this.headerHeight;
                        (this.verticalScroll &&
                            ad() &&
                            ((o = i - this.headerHeight),
                                this.typeOfIntersecting === fb.middleOfViewport &&
                                (o = i - window.innerHeight / 2 + s / 2 - this.headerHeight)),
                            setTimeout(() => {
                                window.scrollTo({ top: o, left: 0, behavior: "smooth" });
                            }, 500));
                    }
                    constructor(t) {
                        ((this.container = t.container),
                            (this.scrollDirection = this.container.dataset.scrollDirection),
                            (this.horizontalScroll =
                                this.scrollDirection === yb.horizontal ||
                                this.scrollDirection === yb.horizontalReversed),
                            (this.verticalScroll =
                                this.scrollDirection === yb.vertical ||
                                this.scrollDirection === yb.verticalReversed),
                            (this.reverseDirection =
                                this.scrollDirection === yb.horizontalReversed ||
                                this.scrollDirection === yb.verticalReversed),
                            (this.direction = this.reverseDirection ? 1 : -1),
                            (this.withGaps = this.container.hasAttribute(pb)),
                            (this.singleText = this.container.hasAttribute(mb)),
                            (this.image = this.container.querySelectorAll(cb)),
                            (this.text = this.container.querySelectorAll(ab)),
                            (this.textInner = this.container.querySelectorAll(lb)),
                            (this.images = this.container.querySelector(hb)),
                            (this.dot = this.container.querySelectorAll(ub)),
                            (this.aside = this.container.querySelector(ob)),
                            (this.inner = this.container.querySelector(nb)),
                            (this.content = this.container.querySelector(rb)),
                            (this.wrapper = this.container.querySelector(sb)),
                            (this.performAnimation = null),
                            (this.lastOffset = 0),
                            (this.activeIndex = 0),
                            (this.lastActiveIndex = this.activeIndex),
                            this.wrapper &&
                            ((this.onScrollCallback = () => this.onScroll()),
                                (this.onResizeCallback = () => this.onResize()),
                                (this.calculateImagesOffsetCallback = () =>
                                    this.calculateImagesOffset()),
                                this.init()));
                    }
                })(this);
            },
            onUnload() {
                wb[this.id].onUnload();
            },
            onBlockSelect(t) {
                wb[this.id].onBlockSelect(t);
            },
        },
        Vu,
    ]),
        Ut("subcollections", Nm),
        Ut("tab-collections", [Rs, Nm, Pn]));
    const Sb = {},
        Eb = "[data-slider]",
        Lb = "[data-item]",
        kb = "flickity-enabled",
        Ab = "data-section-id";
    Ut("testimonials", {
        onLoad() {
            Sb[this.id] = new (class {
                initSlider() {
                    const t = this.slider.querySelectorAll(Lb).length;
                    let i = this.slider.classList.contains(kb);
                    (2 == t && window.innerWidth >= theme.sizes.small) ||
                        1 == t ||
                        window.innerWidth < theme.sizes.small
                        ? i && this.flkty.destroy()
                        : ((this.flkty = new e(this.slider, {
                            cellSelector: Lb,
                            prevNextButtons: !0,
                            pageDots: !1,
                            groupCells: !0,
                            cellAlign: "left",
                            contain: !0,
                            adaptiveHeight: !1,
                        })),
                            this.flkty.resize(),
                            this.flkty.slideableWidth > this.flkty.size.width ||
                            this.flkty.destroy());
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt(
                            [...t.target.parentNode.children].indexOf(t.target),
                        ),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e =
                            this.slider.currentStyle ||
                            window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener(
                        "theme:resize:width",
                        this.sliderResizeEvent,
                    );
                }
                constructor(t) {
                    ((this.container = t.container),
                        (this.sectionId = this.container.getAttribute(Ab)),
                        (this.slider = this.container.querySelector(Eb)),
                        (this.sliderResizeEvent = () => this.initSlider()),
                        (this.flkty = null),
                        this.initSlider(),
                        document.addEventListener(
                            "theme:resize:width",
                            this.sliderResizeEvent,
                        ));
                }
            })(this);
        },
        onUnload(t) {
            Sb[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Sb[this.id].onBlockSelect(t);
        },
    });
    const Cb = "no-outline",
        qb = "[data-skip-content]",
        Tb = 'a[href="#"]';
    (document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${(() => {
            const t = document.createElement("div");
            ((t.style.visibility = "hidden"),
                (t.style.overflow = "scroll"),
                (t.style.msOverflowStyle = "scrollbar"),
                document.body.appendChild(t));
            const e = document.createElement("div");
            t.appendChild(e);
            const i = t.offsetWidth - e.offsetWidth;
            return (t.parentNode.removeChild(t), i);
        })()}px`,
    ),
        document.addEventListener("DOMContentLoaded", function () {
            (jt("*"),
                new (class {
                    init() {
                        ((this.body = document.body),
                            (this.inPageLink = document.querySelector(qb)),
                            (this.linkesWithOnlyHash = document.querySelectorAll(Tb)),
                            (this.isFocused = !1),
                            this.focusHash(),
                            this.bindInPageLinks(),
                            this.clickEvents(),
                            this.focusEvents(),
                            this.focusEventsOff());
                    }
                    clickEvents() {
                        (this.inPageLink &&
                            this.inPageLink.addEventListener("click", (t) => {
                                t.preventDefault();
                            }),
                            this.linkesWithOnlyHash &&
                            this.linkesWithOnlyHash.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                });
                            }));
                    }
                    focusEvents() {
                        document.addEventListener("keyup", (t) => {
                            t.code === theme.keyboardKeys.TAB &&
                                (this.body.classList.remove(Cb), (this.isFocused = !0));
                        });
                    }
                    focusEventsOff() {
                        document.addEventListener("mousedown", () => {
                            (this.body.classList.add(Cb), (this.isFocused = !1));
                        });
                    }
                    forceFocus(t, e) {
                        e = e || {};
                        var i = t.tabIndex;
                        ((t.tabIndex = -1),
                            (t.dataset.tabIndex = i),
                            t.focus(),
                            void 0 !== e.className && t.classList.add(e.className),
                            t.addEventListener("blur", function s(o) {
                                (o.target.removeEventListener(o.type, s),
                                    (t.tabIndex = i),
                                    delete t.dataset.tabIndex,
                                    void 0 !== e.className && t.classList.remove(e.className));
                            }));
                    }
                    focusHash(t) {
                        t = t || {};
                        let e = window.location.hash;
                        void 0 !== theme.settings.newHash &&
                            ((e = theme.settings.newHash), (window.location.hash = `#${e}`));
                        const i = document.getElementById(e.slice(1));
                        if (i && t.ignore && i.matches(t.ignore)) return !1;
                        e && i && this.forceFocus(i, t);
                    }
                    bindInPageLinks(t) {
                        return (
                            (t = t || {}),
                            Array.prototype.slice
                                .call(document.querySelectorAll('a[href^="#"]'))
                                .filter((e) => {
                                    if ("#" === e.hash || "" === e.hash) return !1;
                                    if (t.ignore && e.matches(t.ignore)) return !1;
                                    if (
                                        ((i = e.hash.substr(1)),
                                            null === document.getElementById(i))
                                    )
                                        return !1;
                                    var i,
                                        s = document.querySelector(e.hash);
                                    return (
                                        !!s &&
                                        (e.addEventListener("click", () => {
                                            this.forceFocus(s, t);
                                        }),
                                            !0)
                                    );
                                })
                        );
                    }
                    constructor() {
                        this.init();
                    }
                })(),
                !customElements.get("product-grid-item-swatch") &&
                window.theme.settings.enableColorSwatchesCollection &&
                customElements.define("product-grid-item-swatch", ks));
            "scrollBehavior" in document.documentElement.style ||
                Se({ url: theme.assets.smoothscroll });
        }));
})(
    themeVendor.ScrollLock,
    themeVendor.Flickity,
    themeVendor.themeCurrency,
    themeVendor.ajaxinate,
);
